// This file is auto-generated by @hey-api/openapi-ts

export type Address = {
  addressName?: string | null;
  attentionName?: string | null;
  address1?: string | null;
  address2?: string | null;
  town?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  gln?: string | null;
  phone?: string | null;
  email?: string | null;
  readonly countryIsEU?: boolean;
  geoLat?: number | null;
  geoLong?: number | null;
  readonly countryName?: string | null;
  readonly lined?: string | null;
  readonly linedFormatted?: string | null;
  readonly linedAddress?: string | null;
  readonly linedAddressSplit?: Array<string> | null;
  readonly linedAddressFormatted?: string | null;
  readonly linedAddress2?: string | null;
  readonly linedAddress2Formatted?: string | null;
};

export type AdministrationCacheType = {
  reportPeriods: Array<ReportPeriodEntity> | null;
  companyHeaders: Array<IdName> | null;
};

export type AlternativeUom = {
  uomId?: number;
  name?: string | null;
  multiplier?: number;
  divisor?: number;
  isolated?: boolean;
};

export type AmazonInboundDocument = {
  readonly trn?: string | null;
  stage?:
    | (
        | "PendingPacking"
        | "SendPackingInfo"
        | "TransportConfirmation"
        | "PendingReceive"
        | "Completed"
      )
    | null;
  trnId?: number;
  planId?: string | null;
  planShipmentId?: string | null;
  date?: Date | null;
  status?: "DRAFT" | "CONFIRMED";
  packingStatus?: "PENDING" | "PARTIALLY" | "COMPLETE" | "NA";
  receiveStatus?: ("PENDING" | "PARTIALLY" | "COMPLETE" | "NA") | null;
  shipmentId?: string | null;
  marketplace?: StringIdName;
  itemQtyConfirmed?: number;
  itemQtyPacked?: number;
  itemQtyReceived?: number;
};

export type stage =
  | "PendingPacking"
  | "SendPackingInfo"
  | "TransportConfirmation"
  | "PendingReceive"
  | "Completed";

export const stage = {
  PENDING_PACKING: "PendingPacking",
  SEND_PACKING_INFO: "SendPackingInfo",
  TRANSPORT_CONFIRMATION: "TransportConfirmation",
  PENDING_RECEIVE: "PendingReceive",
  COMPLETED: "Completed",
} as const;

export type status = "DRAFT" | "CONFIRMED";

export const status = {
  DRAFT: "DRAFT",
  CONFIRMED: "CONFIRMED",
} as const;

export type packingStatus = "PENDING" | "PARTIALLY" | "COMPLETE" | "NA";

export const packingStatus = {
  PENDING: "PENDING",
  PARTIALLY: "PARTIALLY",
  COMPLETE: "COMPLETE",
  NA: "NA",
} as const;

export type receiveStatus = "PENDING" | "PARTIALLY" | "COMPLETE" | "NA";

export const receiveStatus = {
  PENDING: "PENDING",
  PARTIALLY: "PARTIALLY",
  COMPLETE: "COMPLETE",
  NA: "NA",
} as const;

export type AmazonInboundDocumentListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<AmazonInboundDocument> | null;
  readonly mightHaveMore: boolean;
};

export type AmazonInboundItemPrepDetail = {
  labelOwner?: ("AMAZON" | "SELLER" | "NONE") | null;
  prepOwner?: ("AMAZON" | "SELLER" | "NONE") | null;
  ownerMatch: boolean;
  prepCategory?:
    | "ADULT"
    | "BABY"
    | "FC_PROVIDED"
    | "FRAGILE"
    | "GRANULAR"
    | "HANGER"
    | "LIQUID"
    | "PERFORATED"
    | "SET"
    | "SHARP"
    | "SMALL"
    | "TEXTILE"
    | "UNKNOWN"
    | "NONE";
};

export type labelOwner = "AMAZON" | "SELLER" | "NONE";

export const labelOwner = {
  AMAZON: "AMAZON",
  SELLER: "SELLER",
  NONE: "NONE",
} as const;

export type prepOwner = "AMAZON" | "SELLER" | "NONE";

export const prepOwner = {
  AMAZON: "AMAZON",
  SELLER: "SELLER",
  NONE: "NONE",
} as const;

export type prepCategory =
  | "ADULT"
  | "BABY"
  | "FC_PROVIDED"
  | "FRAGILE"
  | "GRANULAR"
  | "HANGER"
  | "LIQUID"
  | "PERFORATED"
  | "SET"
  | "SHARP"
  | "SMALL"
  | "TEXTILE"
  | "UNKNOWN"
  | "NONE";

export const prepCategory = {
  ADULT: "ADULT",
  BABY: "BABY",
  FC_PROVIDED: "FC_PROVIDED",
  FRAGILE: "FRAGILE",
  GRANULAR: "GRANULAR",
  HANGER: "HANGER",
  LIQUID: "LIQUID",
  PERFORATED: "PERFORATED",
  SET: "SET",
  SHARP: "SHARP",
  SMALL: "SMALL",
  TEXTILE: "TEXTILE",
  UNKNOWN: "UNKNOWN",
  NONE: "NONE",
} as const;

export type AmazonInboundPlansCreateItem = {
  sellerSku: string;
  quantity: number;
  batches?: Array<AmazonInboundPlansCreateItemBatch> | null;
  labelOwner: "AMAZON" | "SELLER" | "NONE";
  prepOwner: "AMAZON" | "SELLER" | "NONE";
};

export type AmazonInboundPlansCreateItemBatch = {
  batchId: number;
  quantity: number;
};

export type AmazonInboundPlansCreateRequest = {
  name: string;
  shipFromWarehouseId: string;
  items: Array<AmazonInboundPlansCreateItem>;
};

export type AmazonInboundPlansCreateResponse = {
  id: string;
};

export type AmazonInboundPlansCreateResponseResponseDataResponse = {
  data: AmazonInboundPlansCreateResponse;
};

export type AmazonInboundPlansDetail = {
  id: string;
  created: Date;
  lastUpdated: Date;
  name: string;
  sourceAddress: DocumentAddress;
  url: string;
  marketplaces: Array<string>;
  marketplaceId?: number | null;
  trnDocuments?: Array<AmazonInboundPlansTrnDocument> | null;
  shipFromWarehouseId?: string | null;
  planItems: Array<AmazonInboundPlansItem>;
  boxes?: Array<SpApiFulfillmentInboundBox> | null;
  listedItems?: Array<SpApiFulfillmentInboundItem> | null;
  completedStages?: Array<
    "boxingInfo" | "packingOption" | "placementOption"
  > | null;
};

export type AmazonInboundPlansDetailResponseDataResponse = {
  data: AmazonInboundPlansDetail;
};

export type AmazonInboundPlansFeeDescription = {
  description?: string | null;
  fee?: Money;
};

export type AmazonInboundPlansIdRequest = {
  id: string;
};

export type AmazonInboundPlansItem = {
  sellerSku: string;
  sku: string;
  itemTitle: string;
  itemId: string;
  dateBatch: boolean;
  uoms: Array<AmazonInboundPlansItemUom>;
};

export type AmazonInboundPlansItemGroup = {
  id: string | null;
  items?: Array<AmazonInboundPlansItemQuantity> | null;
};

export type AmazonInboundPlansItemQuantity = {
  sellerSku: string;
  sku: string;
  itemTitle: string;
  itemId: string;
  dateBatch: boolean;
  uoms: Array<AmazonInboundPlansItemUom>;
  fnsku: string;
  quantity: number;
};

export type AmazonInboundPlansItemUom = {
  id: number;
  name: string;
  qtyEach: number;
  isDefault: boolean;
  dimensions?: Dimensions;
  weight?: Weight;
};

export type AmazonInboundPlansPackingOption = {
  id: string | null;
  fees?: Array<AmazonInboundPlansFeeDescription> | null;
  discounts?: Array<AmazonInboundPlansFeeDescription> | null;
  groups?: Array<AmazonInboundPlansItemGroup> | null;
  configurations?: string | null;
  status?: "offered" | "accepted";
};

export type status2 = "offered" | "accepted";

export const status2 = {
  OFFERED: "offered",
  ACCEPTED: "accepted",
} as const;

export type AmazonInboundPlansPackingOptionUnpagedListResults = {
  results?: Array<AmazonInboundPlansPackingOption> | null;
};

export type AmazonInboundPlansRenameRequest = {
  planName: string;
};

export type AmazonInboundPlansSubmitPackingGroupBoxRequest = {
  dimensions: Dimensions;
  weight: Weight;
  boxQuantity?: number | null;
  items: Array<AmazonInboundPlansSubmitPackingGroupItemRequest>;
};

export type AmazonInboundPlansSubmitPackingGroupItemRequest = {
  sellerSku: string;
  quantity: number;
  lotNumber?: string | null;
  dateBatch?: Date | null;
};

export type AmazonInboundPlansSubmitPackingGroupRequest = {
  id: string;
  boxes: Array<AmazonInboundPlansSubmitPackingGroupBoxRequest>;
};

export type AmazonInboundPlansSubmitPackingRequest = {
  groups: Array<AmazonInboundPlansSubmitPackingGroupRequest>;
};

export type AmazonInboundPlansSummaryDetail = {
  id: string;
  created: Date;
  lastUpdated: Date;
  name: string;
  sourceAddress: DocumentAddress;
  url: string;
  marketplaces: Array<string>;
  marketplaceId?: number | null;
  trnDocuments?: Array<AmazonInboundPlansTrnDocument> | null;
};

export type AmazonInboundPlansSummaryDetailCursorListResults = {
  results?: Array<AmazonInboundPlansSummaryDetail> | null;
  nextCursor?: string | null;
};

export type AmazonInboundPlansTrnDocument = {
  id: number;
  shipmentId?: string | null;
  packingGroupId?: string | null;
  fbaShipmentId?: string | null;
  type?: "holding" | "shipment";
  boxing?: Array<AmazonInboundPlansTrnDocumentBoxing> | null;
};

export type type = "holding" | "shipment";

export const type = {
  HOLDING: "holding",
  SHIPMENT: "shipment",
} as const;

export type AmazonInboundPlansTrnDocumentBoxing = {
  id: number;
  boxId: string;
  weight?: Weight;
  dimensions?: Dimensions;
  items: Array<AmazonInboundPlansTrnDocumentBoxingItem>;
};

export type AmazonInboundPlansTrnDocumentBoxingItem = {
  sellerSku: string;
  quantity: number;
  dateBatch?: Date | null;
  lotNumber?: string | null;
};

export type AmazonInboundPlansTrnDocumentUnpagedListResults = {
  results?: Array<AmazonInboundPlansTrnDocument> | null;
};

export type AmazonInboundPrepInstructionsDetail = {
  name?: string | null;
  amazonFee?: Money;
};

export type AmazonInboundPrepInstructionsQuantity = {
  quantityEntered: number;
  uom: IdName;
  quantityUnits: number;
  hasPackagingInformation: boolean;
  quantityPerUnit: number;
};

export type AmazonInboundPrepInstructionsRequest = {
  shipToCountryCode: string;
  items: Array<FbaInboundItemPrepInstructionsRequest>;
};

export type AmazonInboundPrepInstructionsResponse = {
  sellerSku: string;
  error?: string | null;
  barcodeInstruction?: string | null;
  prepGuidance?: string | null;
  prepInstructions?: Array<AmazonInboundPrepInstructionsDetail> | null;
  prepDetail?: AmazonInboundItemPrepDetail;
  quantity: AmazonInboundPrepInstructionsQuantity;
};

export type AmazonInboundPrepInstructionsResponseUnpagedListResults = {
  results?: Array<AmazonInboundPrepInstructionsResponse> | null;
};

export type AmazonInboundUpdatePrepDetailsItemRequest = {
  sellerSku: string;
  prepCategory:
    | "ADULT"
    | "BABY"
    | "FC_PROVIDED"
    | "FRAGILE"
    | "GRANULAR"
    | "HANGER"
    | "LIQUID"
    | "PERFORATED"
    | "SET"
    | "SHARP"
    | "SMALL"
    | "TEXTILE"
    | "UNKNOWN"
    | "NONE";
  prepTypes: Array<
    | "ITEM_BLACK_SHRINKWRAP"
    | "ITEM_BLANKSTK"
    | "ITEM_BOXING"
    | "ITEM_BUBBLEWRAP"
    | "ITEM_CAP_SEALING"
    | "ITEM_DEBUNDLE"
    | "ITEM_HANG_GARMENT"
    | "ITEM_LABELING"
    | "ITEM_NO_PREP"
    | "ITEM_POLYBAGGING"
    | "ITEM_RMOVHANG"
    | "ITEM_SETCREAT"
    | "ITEM_SETSTK"
    | "ITEM_SIOC"
    | "ITEM_SUFFOSTK"
    | "ITEM_TAPING"
  >;
};

export type AmazonInboundUpdatePrepDetailsRequest = {
  items: Array<AmazonInboundUpdatePrepDetailsItemRequest>;
};

export type ApiTokenCreateRequest = {
  ipAddress?: Array<string> | null;
  addMyIpAddress?: boolean;
  expires?: Date | null;
};

export type ApiTokenCreateResponse = {
  apiToken: string;
  expires: Date;
  ipAddress?: Array<string> | null;
};

export type ApiTokenCreateResponseResponseData = {
  data?: ApiTokenCreateResponse;
};

export type ApiTokenDetailsResponse = {
  expires: Date;
  ipAddress?: Array<string> | null;
};

export type ApiTokenDetailsResponseResponseData = {
  data?: ApiTokenDetailsResponse;
};

export type ApiTokenUpdateRequest = {
  ipAddress: Array<string>;
};

export type ApiUser = {
  id: string;
  name: string;
  scopes: ApiUserScope;
  apiKey: string;
};

export type ApiUserScope = {
  carrier?: Int32IdName;
  salesRep?: GuidIdName;
  warehousing?: GuidIdName;
  reports?: boolean;
};

export type ApiUserUnpagedListResults = {
  results?: Array<ApiUser> | null;
};

export type AppConfiguration = {
  app: AppDetails;
  configuration: ConfigurationResponse;
};

export type AppConfigurationResponseDataResponse = {
  data: AppConfiguration;
};

export type AppDetails = {
  id: number;
  name: string;
  readonly triggerMinute?: Array<string> | null;
  enabled: boolean;
  warehouseId?: string | null;
  configurationType: string;
  readonly integrationId: string;
};

export type AppDetailsUnpagedListResults = {
  results?: Array<AppDetails> | null;
};

export type AppDetailsUpsert = {
  name: string;
  configuration: ConfigurationRequest;
  cloneId?: number | null;
  enabled: boolean;
  warehouseId?: string | null;
  triggerMinute?: Array<string> | null;
};

export type AppendItemImage = {
  /**
   * Publicly available URL of image
   */
  url: string;
  /**
   * Mark image as private
   */
  markAsPrivate?: boolean;
};

export type AppendItemImageDetailResponse = {
  url?: string | null;
};

export type AppendItemImageRequest = {
  images: Array<AppendItemImage>;
};

export type AppendItemImageResponse = {
  requestUrl?: string | null;
  output?: AppendItemImageDetailResponse;
};

export type AppendItemImageResponseUnpagedListResults = {
  results?: Array<AppendItemImageResponse> | null;
};

export type AppUpdateResponse = {
  latestVersionId?: number;
  latestVersionName?: string | null;
  url?: string | null;
  releaseNotes?: string | null;
  minVersionId?: number;
};

export type AppUpdateResponseResponseData = {
  data?: AppUpdateResponse;
};

export type AsnDetail = {
  asnId?: number;
  po?: string | null;
  vendorReference?: string | null;
  palletCount?: number | null;
  supplierName?: string | null;
};

export type AsnInshpInfo = {
  id?: number;
  readonly documentName?: string | null;
  status?: InboundStatus;
};

export type AsnPoInfo = {
  id?: number;
  readonly documentName?: string | null;
  supplierName?: string | null;
  expectedDate?: Date | null;
  tags?: Array<number> | null;
};

export type AsnResult = {
  contact?: DocumentContactInfo;
  document?: DocumentProperties;
  customFields?: Array<DocumentCustomFieldValue> | null;
  id?: string | null;
  warehouseName?: string | null;
  status?: InboundStatus;
  po?: AsnPoInfo;
  inshp?: AsnInshpInfo;
  totalWeight?: number | null;
  packagesCount?: number | null;
  palletsCount?: number | null;
  packagesVolume?: number;
  asnValue?: MoneyWithLcy;
};

export type AsnResultListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<AsnResult> | null;
  readonly mightHaveMore: boolean;
};

export type AuthenticationRequest = {
  host: string;
  username: string;
  password: string;
  grecaptcha: string;
};

export type AuthenticationResponse = {
  /**
   * Use as Bearer token on Authorization header
   */
  accessToken?: string | null;
  loginName?: string | null;
  settings?: PortalAccountSettings;
};

export type AuthenticationResponseResponseDataResponse = {
  data: AuthenticationResponse;
};

export type AuthenticationTokenRequest = {
  host: string;
  token: string;
};

export type AuthResponseAction = {
  description?: string | null;
  type?: string | null;
};

export type AuthResponseOrganisation = {
  redirect?: string | null;
  organization?: Organisation;
};

export type BaseAuthenticationResponse = {
  /**
   * Use as Bearer token on Authorization header
   */
  accessToken?: string | null;
  name?: string | null;
};

export type BaseAuthFirstRequest = {
  deviceId?: string | null;
  deviceSignature?: string | null;
  scope?: string | null;
  returnUrl?: string | null;
  tid?: string | null;
};

export type BasketSummary = {
  lines?: number;
  items?: number;
};

export type BasketSummaryResponseDataResponse = {
  data: BasketSummary;
};

export type BillItem = {
  docId?: number;
  isCredit?: boolean;
};

export type BinContentItem = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  qty?: number;
  uom?: IdName;
  batch?: ItemBatchInfo;
};

export type BinContentItemListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<BinContentItem> | null;
  readonly mightHaveMore: boolean;
};

export type BulkItemUpsertRequest = {
  items: Array<ItemUpsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
  tagsAdd?: Array<number> | null;
  tagsRemove?: Array<number> | null;
  specsLanguage?: string | null;
  upsertMode?: "UPDATE" | "INSERT" | "UPSERT";
  specsCreate?: boolean;
  imagesSettings?: ItemUpsertImageGlobalSettings;
};

export type upsertMode = "UPDATE" | "INSERT" | "UPSERT";

export const upsertMode = {
  UPDATE: "UPDATE",
  INSERT: "INSERT",
  UPSERT: "UPSERT",
} as const;

export type BySection = {
  salesValueNet?: number;
  salesValueGross?: number;
  orders?: number;
  itemsSold?: number;
  grossProfit?: number;
  grossProfitMarkup?: number;
  grossProfitMargin?: number;
  name?: string | null;
};

export type BySectionUnpagedListResults = {
  results?: Array<BySection> | null;
};

export type CacheListResponse = {
  inventory: InventoryCacheType;
  wms: WmsCacheType;
  administration: AdministrationCacheType;
  marketplace: MarketplaceCacheType;
};

export type CacheListResponseResponseDataResponse = {
  data: CacheListResponse;
};

export type CarrierDocuments = {
  manifests?: Array<CarrierManifestDocument> | null;
  shipments?: Array<CarrierShipment> | null;
};

export type CarrierDocumentsResponseDataResponse = {
  data: CarrierDocuments;
};

export type CarrierManifestDocument = {
  id?: number;
  details?: string | null;
  pickup?: Date | null;
  returnDistance?: number | null;
  returnDuration?: number | null;
  shipments?: Array<CarrierShipment> | null;
};

export type CarrierServicesResponse = {
  services?: Array<CarrierServicesResponseService> | null;
  packageTypes?: Array<string> | null;
  serviceIdParameter?: string | null;
  packageTypeParameter?: string | null;
};

export type CarrierServicesResponseResponseData = {
  data?: CarrierServicesResponse;
};

export type CarrierServicesResponseService = {
  id?: string | null;
  name?: string | null;
  parameters?: Array<ConfigurationParameter> | null;
  packageTypes?: Array<string> | null;
};

export type CarrierShipment = {
  id: number;
  readonly shipmentStatus:
    | "PENDING_PICKUP"
    | "IN_TRANSIT"
    | "DELIVERED"
    | "EXCEPTION"
    | "UNKNOWN"
    | "DRAFT";
  destinationAddress?: DocumentAddress;
  date: Date;
  codValue?: number | null;
  deliveryInstructions?: string | null;
  driverNotes?: string | null;
  pickupPosition?: number | null;
  pickupDuration?: number | null;
  pickupDistance?: number | null;
  items: Array<CarrierShipmentItem>;
};

export type shipmentStatus =
  | "PENDING_PICKUP"
  | "IN_TRANSIT"
  | "DELIVERED"
  | "EXCEPTION"
  | "UNKNOWN"
  | "DRAFT";

export const shipmentStatus = {
  PENDING_PICKUP: "PENDING_PICKUP",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  UNKNOWN: "UNKNOWN",
  DRAFT: "DRAFT",
} as const;

export type CarrierShipmentItem = {
  id?: number;
  item?: DocumentItemInfo;
  uom?: IdName;
  identifiers?: Array<string> | null;
  itemDescription?: string | null;
  qtyPacked?: number;
  qtyValidated?: number;
  packNumber?: number;
  packSerial: string;
  packSscc: string;
  palletSerial?: string | null;
  palletSscc?: string | null;
  packedWeight?: number | null;
};

export type CarrierShipmentValidationItemRequest = {
  id?: number;
  validatedQty?: number | null;
};

export type CarrierShipmentValidationRequest = {
  items?: Array<CarrierShipmentValidationItemRequest> | null;
  notes?: string | null;
  signatureBase64?: string | null;
  codReceived?: number | null;
  markException?: boolean;
  receivedBy?: string | null;
  attentionNotes?: boolean;
};

export type ClientConfiguration = {
  baseUri?: string | null;
  syncInventoryInput?: InventoryInputConfigConfigurablePipeline;
  syncPackingInput?: SyncPackingInputConfigConfigurablePipeline;
  syncPackingOutput?: SyncPackingOutputConfigConfigurablePipeline;
  syncReceiveInput?: SyncReceiveInputConfigConfigurablePipeline;
  syncReceiveOutput?: SyncReceiveOutputConfigConfigurablePipeline;
};

export type ClientConfigurationAppIntegrationUpsert = {
  name: string;
  configuration: ClientConfiguration;
  warehouseId?: string | null;
  triggerMinute?: Array<string> | null;
};

export type ColumnDisplay = {
  field?: string | null;
  headerName?: string | null;
  readonly hide?: boolean;
};

export type ColumnDisplayUnpagedListResults = {
  results?: Array<ColumnDisplay> | null;
};

export type Common_ProductBatchDetails = {
  batchID?: number;
  batchNumber?: string | null;
  expiryDate?: Date | null;
  manufacturingDate?: Date | null;
  lotNumber?: string | null;
  qty?: number;
};

export type CompanyHeader = {
  id: number;
  name: string;
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  line4?: string | null;
  isDefault?: boolean;
  sequenceName?: string | null;
  imageUrl?: string | null;
  taxNumber?: string | null;
  fiscalYearStartMonth?: number | null;
};

export type CompanyHeaderUnpagedListResults = {
  results?: Array<CompanyHeader> | null;
};

export type ConfigurablePipelinesConfigurationResponse = {
  syncInventoryInput?: PipelineConfiguration;
  syncPackingInput?: PipelineConfiguration;
  syncPackingOutput?: PipelineConfiguration;
  syncReceiveInput?: PipelineConfiguration;
  syncReceiveOutput?: PipelineConfiguration;
};

export type ConfigurablePipelinesConfigurationResponseResponseData = {
  data?: ConfigurablePipelinesConfigurationResponse;
};

export type ConfigurationObject = {
  type?: string | null;
  name?: string | null;
  description?: string | null;
  readonly parameters?: Array<ConfigurationProperty> | null;
  attributes?: Array<string> | null;
  readonly sections?: Array<ConfigurationSection> | null;
};

export type ConfigurationObjectUnpagedListResults = {
  results?: Array<ConfigurationObject> | null;
};

export type ConfigurationParameter = {
  name: string;
  value?: string | null;
};

export type ConfigurationProperty = {
  name: string;
  description?: string | null;
  sectionId?: string | null;
  help?: string | null;
  placeholder?: string | null;
  required?: boolean;
  defaultValue?: string | null;
  multiple?: boolean;
  small?: boolean;
  type?:
    | (
        | "TEXT"
        | "LIST"
        | "CHECKBOX"
        | "NUMBER"
        | "WAREHOUSE"
        | "WAREHOUSE_WITH_GROUPS"
        | "WAREHOUSE_GROUP"
        | "DOC_QUEUE"
        | "DOC_TAG"
        | "COLOR"
        | "CONTACT"
        | "UOM"
        | "DATE"
        | "DATE_RANGE"
        | "DIVIDER"
        | "SALES_REP"
        | "CARRIER"
        | "COMPANY_HEADER"
        | "CURRENCY"
        | "COUNTRY"
        | "ITEM_TAG"
        | "ITEM_CATEGORY"
        | "ITEM_BRAND"
        | "ITEM_PRICELIST"
        | "ITEM_ID"
        | "CUSTOM_FEED"
        | "PIPELINE"
        | "MARKETPLACE_AMAZON"
        | "PRINT_QUEUE"
        | "PASSWORD"
        | "NESTED_OBJECT"
        | "LIST_NAME"
        | "URI"
        | "READ_ONLY"
      )
    | null;
  lineBreak?: "None" | "Before" | "After" | "BeforeAndAfter";
  options?: {
    [key: string]: string;
  } | null;
  useDictionary?: boolean;
  dictionaryFetchName?: string | null;
  enableWith?: string | null;
  nestedObject?: ConfigurationObject;
  listName?: string | null;
  isReadOnly?: boolean;
};

export type type2 =
  | "TEXT"
  | "LIST"
  | "CHECKBOX"
  | "NUMBER"
  | "WAREHOUSE"
  | "WAREHOUSE_WITH_GROUPS"
  | "WAREHOUSE_GROUP"
  | "DOC_QUEUE"
  | "DOC_TAG"
  | "COLOR"
  | "CONTACT"
  | "UOM"
  | "DATE"
  | "DATE_RANGE"
  | "DIVIDER"
  | "SALES_REP"
  | "CARRIER"
  | "COMPANY_HEADER"
  | "CURRENCY"
  | "COUNTRY"
  | "ITEM_TAG"
  | "ITEM_CATEGORY"
  | "ITEM_BRAND"
  | "ITEM_PRICELIST"
  | "ITEM_ID"
  | "CUSTOM_FEED"
  | "PIPELINE"
  | "MARKETPLACE_AMAZON"
  | "PRINT_QUEUE"
  | "PASSWORD"
  | "NESTED_OBJECT"
  | "LIST_NAME"
  | "URI"
  | "READ_ONLY";

export const type2 = {
  TEXT: "TEXT",
  LIST: "LIST",
  CHECKBOX: "CHECKBOX",
  NUMBER: "NUMBER",
  WAREHOUSE: "WAREHOUSE",
  WAREHOUSE_WITH_GROUPS: "WAREHOUSE_WITH_GROUPS",
  WAREHOUSE_GROUP: "WAREHOUSE_GROUP",
  DOC_QUEUE: "DOC_QUEUE",
  DOC_TAG: "DOC_TAG",
  COLOR: "COLOR",
  CONTACT: "CONTACT",
  UOM: "UOM",
  DATE: "DATE",
  DATE_RANGE: "DATE_RANGE",
  DIVIDER: "DIVIDER",
  SALES_REP: "SALES_REP",
  CARRIER: "CARRIER",
  COMPANY_HEADER: "COMPANY_HEADER",
  CURRENCY: "CURRENCY",
  COUNTRY: "COUNTRY",
  ITEM_TAG: "ITEM_TAG",
  ITEM_CATEGORY: "ITEM_CATEGORY",
  ITEM_BRAND: "ITEM_BRAND",
  ITEM_PRICELIST: "ITEM_PRICELIST",
  ITEM_ID: "ITEM_ID",
  CUSTOM_FEED: "CUSTOM_FEED",
  PIPELINE: "PIPELINE",
  MARKETPLACE_AMAZON: "MARKETPLACE_AMAZON",
  PRINT_QUEUE: "PRINT_QUEUE",
  PASSWORD: "PASSWORD",
  NESTED_OBJECT: "NESTED_OBJECT",
  LIST_NAME: "LIST_NAME",
  URI: "URI",
  READ_ONLY: "READ_ONLY",
} as const;

export type lineBreak = "None" | "Before" | "After" | "BeforeAndAfter";

export const lineBreak = {
  NONE: "None",
  BEFORE: "Before",
  AFTER: "After",
  BEFORE_AND_AFTER: "BeforeAndAfter",
} as const;

export type ConfigurationRequest = {
  type: string;
  parameters?: Array<ConfigurationParameter> | null;
};

export type ConfigurationResponse = {
  type: string;
  jsonConfiguration?: string | null;
};

export type ConfigurationSection = {
  id: string;
  name: string;
  order: number;
  collapsed: boolean;
};

export type ContactAddress = {
  id?: string | null;
  address: DocumentAddress;
  isDefaultBilling?: boolean;
  isDefaultShipping?: boolean;
  isShipping?: boolean | null;
  deliveryInstructions?: string | null;
};

export type ContactAddressUnpagedListResults = {
  results?: Array<ContactAddress> | null;
};

export type ContactBalance = {
  creditLimitExceeded: boolean;
  accountBalance?: number | null;
  creditLimit?: number | null;
  overdueBalance?: number | null;
  balanceModifiedAt?: Date | null;
};

export type ContactCreateRequest = {
  code: string;
  name: string;
  email?: string | null;
  tags?: Array<number> | null;
  billingAddress?: DocumentAddress;
  shippingAddress?: DocumentAddress;
  headerId?: number | null;
  soTermsId?: number | null;
  pricelistId?: string | null;
  pricelistCreate?: boolean | null;
  currencyCode?: string | null;
  taxIdentifiers?: Array<ContactTaxIdentifierUpsert> | null;
};

export type ContactEntity = {
  id?: string;
  name: string;
  code: string;
  readonly codeName: string;
  externalReference?: string | null;
  isActive: boolean;
  tags?: Array<IdNameEntity> | null;
  salesRep?: GuidIdNameEntity;
  taxGroup?: GuidIdNameEntity;
  pricelist?: GuidIdNameEntity;
  createdAt?: Date;
  modifiedAt?: Date | null;
  balance?: ContactBalance;
};

export type ContactEntityResponseDataResponse = {
  data: ContactEntity;
};

export type ContactLedger = {
  accountNumber?: string | null;
  accountName?: string | null;
  creditLimit?: number | null;
  currencyISOCode?: string | null;
  countryCode?: string | null;
  taxRegistrationNumber?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  city?: string | null;
  county?: string | null;
  country?: string | null;
  postCode?: string | null;
};

export type ContactListInfo = {
  id?: string;
  name: string;
  code: string;
  readonly codeName: string;
  externalReference?: string | null;
  isActive: boolean;
  tags?: Array<IdNameEntity> | null;
  salesRep?: GuidIdNameEntity;
  taxGroup?: GuidIdNameEntity;
  pricelist?: GuidIdNameEntity;
};

export type ContactListInfoCursorListResults = {
  results?: Array<ContactListInfo> | null;
  nextCursor?: string | null;
};

export type ContactLookup = {
  id?: string;
  name: string;
  code: string;
  readonly codeName: string;
};

export type ContactLookupResponseDataResponse = {
  data: ContactLookup;
};

export type ContactLookupUnpagedListResults = {
  results?: Array<ContactLookup> | null;
};

export type ContactTag = {
  id: number;
  name: string;
  readonly tagColor?: string | null;
  customerTag?: boolean;
  supplierTag?: boolean;
};

export type ContactTagBulkOperation = {
  update?: {
    [key: string]: ContactTagUpsert;
  } | null;
  create?: Array<ContactTagUpsert> | null;
  delete?: Array<number> | null;
};

export type ContactTagUnpagedListResults = {
  results?: Array<ContactTag> | null;
};

export type ContactTagUpsert = {
  name: string;
  tagColor?: string | null;
  customerTag?: boolean | null;
  supplierTag?: boolean | null;
};

export type ContactTaxIdentifierUpsert = {
  type: "companyNumber" | "taxNumber" | "eoriNumber" | "iossNumber";
  identifier: string;
};

export type type3 = "companyNumber" | "taxNumber" | "eoriNumber" | "iossNumber";

export const type3 = {
  COMPANY_NUMBER: "companyNumber",
  TAX_NUMBER: "taxNumber",
  EORI_NUMBER: "eoriNumber",
  IOSS_NUMBER: "iossNumber",
} as const;

export type ContactUpsertRequest = {
  code?: string | null;
  name?: string | null;
  isActive?: boolean | null;
  email?: string | null;
  tags?: Array<number> | null;
  headerId?: number | null;
  soTermsId?: number | null;
  pricelistId?: string | null;
  currencyCode?: string | null;
};

export type ConversationCreateResponse = {
  sessionId: string;
  disclaimer: ConversationCreateResponseDisclaimer;
  remainingQuota: number;
};

export type ConversationCreateResponseDisclaimer = {
  disclaimer: string;
  version: number;
};

export type ConversationCreateResponseResponseData = {
  data?: ConversationCreateResponse;
};

export type ConversationExportRequest = {
  sessionId: string;
  messageId: string;
};

export type ConversationFeedbackRequest = {
  sessionId: string;
  messageId: string;
  isHelpful?: boolean;
  comments?: string | null;
};

export type ConversationQueryResult = {
  type?: "value" | "table";
  messages?: Array<string> | null;
  title?: string | null;
  data?: string | null;
  exportable?: boolean;
};

export type type4 = "value" | "table";

export const type4 = {
  VALUE: "value",
  TABLE: "table",
} as const;

export type ConversationRequest = {
  sessionId: string;
  question: string;
};

export type ConversationResponse = {
  sessionId: string;
  messageId: string;
  errorMessage?: string | null;
  retryIdentifier?: string | null;
  queryResult?: ConversationQueryResult;
  remainingQuota?: number | null;
};

export type ConversationResponseResponseData = {
  data?: ConversationResponse;
};

export type ConversationRetryRequest = {
  sessionId: string;
  retryIdentifier: string;
};

export type CountryTaxSettings = {
  countryCode: string;
  readonly countryName: string;
  taxGroupId: string;
};

export type CountryTaxSettingsUnpagedListResults = {
  results?: Array<CountryTaxSettings> | null;
};

export type CountryTaxSettingsUpsert = {
  countryCode: Array<string>;
  taxGroupId?: string | null;
};

export type CreatePurchaseOrderRequest = {
  contact: string;
  warehouse?: string | null;
  date?: Date | null;
  currency?: CurrencyRate;
  documentReference?: string | null;
  confirm?: boolean;
  credit?: boolean;
  billing?: DocumentAddress;
  shipping?: DocumentAddress;
  lines?: Array<CreatePurchaseOrderRequestLine> | null;
  append?: boolean;
  backToBackMode?: ("NONE" | "BACK_TO_BACK" | "DIRECT_DELIVERY") | null;
  deliveryDate?: Date | null;
};

export type backToBackMode = "NONE" | "BACK_TO_BACK" | "DIRECT_DELIVERY";

export const backToBackMode = {
  NONE: "NONE",
  BACK_TO_BACK: "BACK_TO_BACK",
  DIRECT_DELIVERY: "DIRECT_DELIVERY",
} as const;

export type CreatePurchaseOrderRequestLine = {
  qty: number;
  uom?: number | null;
  description?: string | null;
  lineReference?: string | null;
  sku: string;
  price?: Price;
  weight?: number | null;
  size?: number | null;
  linkedLineId?: number | null;
  lineNotes?: string | null;
  itemExpectedDate?: Date | null;
};

export type CreateSalesOrderRequestLine = {
  qty: number;
  uom?: number | null;
  description?: string | null;
  lineReference?: string | null;
  sku: string;
  price?: Price;
  weight?: number | null;
  size?: number | null;
  priceIncludesTaxes?: boolean;
};

export type CreditTerm = {
  id: number;
  name: string;
  type: "NET" | "EOM" | "MFI";
  days: number;
  isCod: boolean;
  upfrontPayment: number;
  settlements?: Array<CreditTermSettlement> | null;
};

export type type5 = "NET" | "EOM" | "MFI";

export const type5 = {
  NET: "NET",
  EOM: "EOM",
  MFI: "MFI",
} as const;

export type CreditTermSettlement = {
  id?: number;
  days?: number;
  discountValue?: number;
  discountType?: "Percentage" | "Value";
};

export type discountType = "Percentage" | "Value";

export const discountType = {
  PERCENTAGE: "Percentage",
  VALUE: "Value",
} as const;

export type CreditTermSettlementUpsert = {
  termId: number;
  days?: number;
  discountValue?: number;
  discountType?: "Percentage" | "Value";
};

export type CreditTermUnpagedListResults = {
  results?: Array<CreditTerm> | null;
};

export type CreditTermUpsert = {
  name: string;
  type: "NET" | "EOM" | "MFI";
  days: number;
  isCod?: boolean;
  upfrontPayment?: number;
};

export type CurrencyDetails = {
  id: string;
  name: string;
  symbol?: string | null;
  value?: number;
  isPrimary?: boolean;
  fix?: CurrencyFix;
  valueUpdated?: Date | null;
};

export type CurrencyDetailsUnpagedListResults = {
  results?: Array<CurrencyDetails> | null;
};

export type CurrencyFix = {
  date: Date;
  rate: number;
};

export type CurrencyRate = {
  code?: string | null;
  rate?: number | null;
};

export type CurrencyUpsert = {
  id: string;
  name: string;
  value?: number | null;
  symbol?: string | null;
  isPrimary?: boolean | null;
};

export type CustomerPeriodicSalesPeriod = {
  periodId?: number;
  startDate?: Date;
  endDate?: Date;
};

export type CustomerPeriodicSalesQty = {
  periodId?: number;
  quantity?: number;
};

export type CustomerPeriodicSalesResults = {
  periods?: Array<CustomerPeriodicSalesPeriod> | null;
  items?: Array<CustomerPeriodicSalesSku> | null;
};

export type CustomerPeriodicSalesResultsResponseData = {
  data?: CustomerPeriodicSalesResults;
};

export type CustomerPeriodicSalesSku = {
  itemSku?: string | null;
  parentItemSku?: string | null;
  siblings?: boolean | null;
  results?: Array<CustomerPeriodicSalesQty> | null;
  readonly quantity?: number;
};

export type CustomerPortal = {
  id: number;
  name: string;
  title?: string | null;
  logoUrl?: string | null;
  backgroundImageUrl?: string | null;
  welcomeMessage?: string | null;
  itemSettings: CustomerPortalItemSettings;
  orderSettings: CustomerPortalOrderSettings;
  warehouseId?: string | null;
};

export type CustomerPortalBase = {
  id?: number;
  name?: string | null;
  title?: string | null;
  url?: string | null;
};

export type CustomerPortalBaseUnpagedListResults = {
  results?: Array<CustomerPortalBase> | null;
};

export type CustomerPortalItemSettings = {
  hidePrices?: boolean;
  hideOutOfStock?: boolean;
  hideImages?: boolean;
  categoriesExclude?: Array<number> | null;
  tagsExclude?: Array<number> | null;
  brandsExclude?: Array<number> | null;
  categories?: Array<number> | null;
  tags?: Array<number> | null;
  brands?: Array<number> | null;
};

export type CustomerPortalOrderSettings = {
  minimumOrderValue?: number | null;
};

export type CustomerPortalResponseData = {
  data?: CustomerPortal;
};

export type DataExportDestination = {
  emails?: Array<string> | null;
  notifications?: Array<string> | null;
};

export type DataExportDisplayDetails = {
  id?: number;
  user?: string | null;
  status?: "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED" | "NO_DATA";
  startedDate?: Date;
  progress?: number;
  description?: string | null;
  downloadUrl?: string | null;
  details?: string | null;
  rowsCount?: number | null;
  isSchedule?: boolean;
  destination?: DataExportDestination;
};

export type status3 =
  | "PENDING"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "FAILED"
  | "NO_DATA";

export const status3 = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  NO_DATA: "NO_DATA",
} as const;

export type DataExportDisplayDetailsListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<DataExportDisplayDetails> | null;
  readonly mightHaveMore: boolean;
};

export type DateOnlyRange = {
  start?: Date;
  end?: Date;
};

export type DateRangeOffset = {
  start?: Date;
  end?: Date;
};

export type DateRanges = {
  range1?: DateOnlyRange;
  range2?: DateOnlyRange;
};

export type DateSegment = {
  salesValueNet?: number;
  salesValueGross?: number;
  orders?: number;
  itemsSold?: number;
  grossProfit?: number;
  grossProfitMarkup?: number;
  grossProfitMargin?: number;
  dateName?: string | null;
};

export type DateSegmentUnpagedListResults = {
  results?: Array<DateSegment> | null;
};

export type Dimensions = {
  width?: number | null;
  height?: number | null;
  length?: number | null;
  uom?: ("cm" | "ft" | "in" | "m" | "mm") | null;
};

export type uom = "cm" | "ft" | "in" | "m" | "mm";

export const uom = {
  CM: "cm",
  FT: "ft",
  IN: "in",
  M: "m",
  MM: "mm",
} as const;

export type DocumentAddress = {
  name?: string | null;
  att?: string | null;
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  postal?: string | null;
  countryCode?: string | null;
  email?: string | null;
  gln?: string | null;
  phone?: string | null;
  readonly countryName?: string | null;
};

export type DocumentAddressUnpagedListResults = {
  results?: Array<DocumentAddress> | null;
};

export type DocumentAttachment = {
  id?: string | null;
  author?: string | null;
  createdDate?: Date;
  description?: string | null;
  url?: string | null;
  signature?: string | null;
};

export type DocumentAttachmentUnpagedListResults = {
  results?: Array<DocumentAttachment> | null;
};

export type DocumentContactDetails = {
  id?: string;
  code?: string | null;
  name?: string | null;
  readonly codeName?: string | null;
  attentionMessage?: string | null;
  referenceId?: string | null;
  gln?: string | null;
  eori?: string | null;
  tags?: string | null;
  readonly tagsList?: Array<string> | null;
};

export type DocumentContactInfo = {
  id?: string;
  code?: string | null;
  name?: string | null;
  readonly codeName?: string | null;
};

export type DocumentCustomField = {
  id: number;
  name: string;
  documentType:
    | "SO"
    | "PO"
    | "BLL"
    | "SHP"
    | "INV"
    | "INASN"
    | "INSHP"
    | "TRN"
    | "TRC"
    | "CONTACT";
  valueType: "TEXT" | "NUMBER" | "DATE" | "LIST" | "DATE_TIME";
  mandatory?: boolean;
  options?: Array<string> | null;
};

export type documentType =
  | "SO"
  | "PO"
  | "BLL"
  | "SHP"
  | "INV"
  | "INASN"
  | "INSHP"
  | "TRN"
  | "TRC"
  | "CONTACT";

export const documentType = {
  SO: "SO",
  PO: "PO",
  BLL: "BLL",
  SHP: "SHP",
  INV: "INV",
  INASN: "INASN",
  INSHP: "INSHP",
  TRN: "TRN",
  TRC: "TRC",
  CONTACT: "CONTACT",
} as const;

export type valueType = "TEXT" | "NUMBER" | "DATE" | "LIST" | "DATE_TIME";

export const valueType = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  DATE: "DATE",
  LIST: "LIST",
  DATE_TIME: "DATE_TIME",
} as const;

export type DocumentCustomFieldCreate = {
  name: string;
  documentType:
    | "SO"
    | "PO"
    | "BLL"
    | "SHP"
    | "INV"
    | "INASN"
    | "INSHP"
    | "TRN"
    | "TRC"
    | "CONTACT";
  valueType: "TEXT" | "NUMBER" | "DATE" | "LIST" | "DATE_TIME";
  mandatory?: boolean | null;
  options?: Array<string> | null;
};

export type DocumentCustomFieldUnpagedListResults = {
  results?: Array<DocumentCustomField> | null;
};

export type DocumentCustomFieldUpdate = {
  name: string;
  mandatory?: boolean | null;
  options?: Array<string> | null;
};

export type DocumentCustomFieldValue = {
  name?: string | null;
  value?: string | null;
  id?: number;
  readonly type?: "TEXT" | "NUMBER" | "DATE" | "LIST" | "DATE_TIME";
};

export type type6 = "TEXT" | "NUMBER" | "DATE" | "LIST" | "DATE_TIME";

export const type6 = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  DATE: "DATE",
  LIST: "LIST",
  DATE_TIME: "DATE_TIME",
} as const;

export type DocumentEntityProperty = {
  value: string | null;
  updated?: Date | null;
};

export type DocumentExportUpdate = {
  exported: boolean;
  exportToken?: string | null;
  errorMessage?: string | null;
  successMessage?: string | null;
  exception?: string | null;
};

export type DocumentItemBulkInsert = {
  /**
   * Item Identifier, SKU, EAN, UPC etc
   */
  item?: string | null;
  /**
   * Item description
   */
  description?: string | null;
  /**
   * Item quantity, default is 1
   */
  qty?: string | null;
  /**
   * Item UOM, default is item default UOM
   */
  uom?: string | null;
  /**
   * Price
   */
  price?: string | null;
  /**
   * Discount
   */
  discount?: string | null;
  /**
   * Total weight, used for weight priced item
   */
  weight?: string | null;
  size?: string | null;
  /**
   * SQ: RRP
   */
  rrp?: string | null;
  /**
   * SQ: Minimum Qty
   */
  minimumQty?: string | null;
  /**
   * Item contact reference
   */
  contactReference?: string | null;
  lineNotes?: string | null;
  batch?: string | null;
  bin?: string | null;
  custom1?: string | null;
};

export type DocumentItemBulkInsertItemBasedBulkUpsertRequest = {
  items: Array<DocumentItemBulkInsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
};

export type DocumentItemInfo = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  type?: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  defaultUomId?: number;
  inventoryModelId?: number;
  isPurchasable?: boolean;
  isSellable?: boolean;
  pricing?: "QUANTITY" | "WEIGHT";
  isEol?: boolean;
  brand?: string | null;
  category?: string | null;
  department?: string | null;
  imageUrl?: string | null;
};

export type type7 =
  | "STOCK_ITEM"
  | "SERVICE_ITEM"
  | "KIT_ITEM"
  | "BOM_ITEM"
  | "GROUP_ITEM";

export const type7 = {
  STOCK_ITEM: "STOCK_ITEM",
  SERVICE_ITEM: "SERVICE_ITEM",
  KIT_ITEM: "KIT_ITEM",
  BOM_ITEM: "BOM_ITEM",
  GROUP_ITEM: "GROUP_ITEM",
} as const;

export type pricing = "QUANTITY" | "WEIGHT";

export const pricing = {
  QUANTITY: "QUANTITY",
  WEIGHT: "WEIGHT",
} as const;

export type DocumentItemInfoInventory = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  type?: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  defaultUomId?: number;
  inventoryModelId?: number;
  isPurchasable?: boolean;
  isSellable?: boolean;
  pricing?: "QUANTITY" | "WEIGHT";
  isEol?: boolean;
  brand?: string | null;
  category?: string | null;
  department?: string | null;
  imageUrl?: string | null;
  inventory?: ItemInventoryBase;
};

export type DocumentLinePrice = {
  priceBeforeDiscount?: number | null;
  discountValue?: number | null;
  discountFixed?: boolean | null;
  priceAfterDiscount?: number | null;
  taxCode?: string | null;
  taxRate?: number | null;
  taxValue?: number | null;
  readonly priceAfterTax?: number | null;
};

export type DocumentLinePriceExpected = {
  price?: number | null;
  discount?: number | null;
  priceDefault?: number | null;
};

export type DocumentLineSubtotal = {
  price?: number | null;
  taxValue?: number | null;
  readonly total?: number | null;
};

export type DocumentNote = {
  id?: string | null;
  note?: string | null;
  classes?: string | null;
  author?: string | null;
  createdDate?: Date;
};

export type DocumentNoteResponseData = {
  data?: DocumentNote;
};

export type DocumentNoteUnpagedListResults = {
  results?: Array<DocumentNote> | null;
};

export type DocumentProperties = {
  stage?: DocumentEntityProperty;
  notesCount?: number;
  notesError?: boolean;
  author?: string | null;
  created?: Date | null;
  modified?: Date | null;
  tags?: Array<number> | null;
  attachments?: number;
  emailed?: boolean;
};

export type DocumentQueue = {
  id?: number;
  name?: string | null;
  isPublic?: boolean;
  isAttention?: boolean;
  queueCount?: DocumentQueueCount;
};

export type DocumentQueueCount = {
  count?: number;
  updated?: Date | null;
};

export type DocumentQueueUnpagedListResults = {
  results?: Array<DocumentQueue> | null;
};

export type DocumentSearchResult = {
  documentType?: string | null;
  documentId?: string | null;
  documentDate?: Date | null;
  documentPartner?: string | null;
  details?: string | null;
};

export type DocumentSearchResultUnpagedListResults = {
  results?: Array<DocumentSearchResult> | null;
};

export type DocumentStage = {
  id: number;
  name: string;
  documentTypes?: Array<string> | null;
  authorizedUsers?: Array<IdName> | null;
  defaultDocuments?: Array<string> | null;
};

export type DocumentStageUnpagedListResults = {
  results?: Array<DocumentStage> | null;
};

export type DocumentStageUpsert = {
  name: string;
  documentTypes?: Array<string> | null;
  authorizedUsers?: Array<number> | null;
  defaultDocuments?: Array<string> | null;
};

export type DocumentTag = {
  id: number;
  name: string;
  code?: string | null;
  color?: string | null;
  readonly textColor?: string | null;
  appVisible?: boolean;
  readonly rules?: Array<
    | "pickingPriority"
    | "preventAutoInvoice"
    | "forceAutoInvoice"
    | "forceAutoBackorder"
    | "forceAutoFinalise"
    | "preventAutoFinalise"
    | "autoInvoiceOnValidation"
  > | null;
};

export type DocumentTagsUpdate = {
  operation: "ADD" | "SET" | "REMOVE";
  tags: Array<number>;
};

export type operation = "ADD" | "SET" | "REMOVE";

export const operation = {
  ADD: "ADD",
  SET: "SET",
  REMOVE: "REMOVE",
} as const;

export type DocumentTagUnpagedListResults = {
  results?: Array<DocumentTag> | null;
};

export type DocumentTagUpsert = {
  name: string;
  code?: string | null;
  color?: string | null;
  appVisible?: boolean | null;
  rules?: Array<
    | "pickingPriority"
    | "preventAutoInvoice"
    | "forceAutoInvoice"
    | "forceAutoBackorder"
    | "forceAutoFinalise"
    | "preventAutoFinalise"
    | "autoInvoiceOnValidation"
  > | null;
};

export type DocumentType_1UnpagedListResults = {
  results?: Array<Int32DocumentType> | null;
};

export type DocumentTypeResponseDataResponse = {
  data: EntityDocumentType;
};

export type DocumentTypeUnpagedListResults = {
  results?: Array<EntityDocumentType> | null;
};

export type DocumentValueSummary = {
  net?: PriceTaxedLcy;
  gross?: number;
  discount?: number;
  readonly discountPercent?: number;
};

export type EmailTemplate = {
  id: number;
  name: string;
  default?: Array<string> | null;
};

export type EmailTemplateDetails = {
  id: number;
  name: string;
  default?: Array<string> | null;
  subject?: string | null;
  body?: string | null;
};

export type EmailTemplateDetailsResponseData = {
  data?: EmailTemplateDetails;
};

export type EmailTemplateUnpagedListResults = {
  results?: Array<EmailTemplate> | null;
};

export type EmailTemplateUpsert = {
  name: string;
  default?: Array<string> | null;
  subject: string;
  body: string;
};

export type EntityDocumentType = {
  type?: string | null;
  id?: string | null;
  readonly name?: string | null;
};

export type ErrorDetail = {
  field?: string | null;
  code?: string | null;
  description?: string | null;
};

export type ErrorResponse = {
  errors?: Array<string> | null;
  errorDetails?: Array<ErrorDetail> | null;
  error?: string | null;
  metadata?: {
    [key: string]: string;
  } | null;
};

export type EventMonitor = {
  id: number;
  name: string;
  active: boolean;
  conditions: Array<EventMonitorCondition>;
  alerts: Array<EventMonitorAlert>;
};

export type EventMonitorAlert = {
  id?: number;
  user?: Int32IdName;
  alertType?: "NOTIFICATION" | "EMAIL" | "SMS" | "WEBHOOK";
  readonly interval?: number;
};

export type alertType = "NOTIFICATION" | "EMAIL" | "SMS" | "WEBHOOK";

export const alertType = {
  NOTIFICATION: "NOTIFICATION",
  EMAIL: "EMAIL",
  SMS: "SMS",
  WEBHOOK: "WEBHOOK",
} as const;

export type EventMonitorBase = {
  id: number;
  name: string;
  active: boolean;
};

export type EventMonitorBaseUnpagedListResults = {
  results?: Array<EventMonitorBase> | null;
};

export type EventMonitorCondition = {
  id?: number;
  level?: "ERROR" | "WARNING";
  eventType?: "PIPELINE" | "EDI" | "OUTGOING_EMAIL" | "MARKETPLACE";
};

export type level = "ERROR" | "WARNING";

export const level = {
  ERROR: "ERROR",
  WARNING: "WARNING",
} as const;

export type eventType = "PIPELINE" | "EDI" | "OUTGOING_EMAIL" | "MARKETPLACE";

export const eventType = {
  PIPELINE: "PIPELINE",
  EDI: "EDI",
  OUTGOING_EMAIL: "OUTGOING_EMAIL",
  MARKETPLACE: "MARKETPLACE",
} as const;

export type EventMonitorResponseData = {
  data?: EventMonitor;
};

export type EventMonitorUpsert = {
  name: string;
  active: boolean;
  conditions: Array<EventMonitorUpsertCondition>;
  alerts: Array<EventMonitorUpsertAlert>;
};

export type EventMonitorUpsertAlert = {
  userId: number;
  alertType: "NOTIFICATION" | "EMAIL" | "SMS" | "WEBHOOK";
};

export type EventMonitorUpsertCondition = {
  eventType: "PIPELINE" | "EDI" | "OUTGOING_EMAIL" | "MARKETPLACE";
};

export type ExportPending = {
  customers?: Array<ContactLedger> | null;
  suppliers?: Array<ContactLedger> | null;
  invoices?: Array<InvoiceItem> | null;
  bills?: Array<BillItem> | null;
  transactions?: Array<StockTransaction> | null;
};

export type ExportPendingResponseData = {
  data?: ExportPending;
};

export type ExportRequest = {
  [key: string]: unknown;
};

export type ExportResponse = {
  id?: string | null;
};

export type ExportResponseResponseData = {
  data?: ExportResponse;
};

export type FbaInboundItemPrepInstructionsRequest = {
  sellerSku: string;
  quantity: number;
  uomId?: number | null;
};

export type FbaShipmentTemp = {
  trnDocument?: InboundPlanTrn;
  shipment?: SpApiFulfillmentInboundShipment;
  items?: Array<SpApiFulfillmentInboundItem> | null;
};

export type FbaShipmentTempUnpagedListResults = {
  results?: Array<FbaShipmentTemp> | null;
};

export type FeeDescription = {
  description?: string | null;
  fee?: Money;
};

export type FieldMappingConfig = {
  propertyName?: string | null;
  customFieldName?: string | null;
  isCustom?: boolean;
};

export type FileBase64Input = {
  fileName: string;
  base64: string;
  contentType?: string | null;
  readonly hasContent?: boolean;
};

export type ForgotPasswordRequest = {
  email: string;
  captcha: string;
};

export type GenericDocumentDetails = {
  contactId?: string | null;
  contactName?: string | null;
  warehouseId?: string | null;
  pricelistId?: string | null;
  contactAlerts?: string | null;
  currency?: string | null;
  docReference?: string | null;
  currencyRate?: number | null;
  isCredit?: boolean;
  isExported?: boolean;
  exportConfirmed?: boolean;
  documentTags?: Array<number> | null;
  contactTags?: Array<number> | null;
  metadata?: {
    [key: string]: string;
  } | null;
};

export type GenericDocumentDetailsResponseData = {
  data?: GenericDocumentDetails;
};

export type GlobalSettingsResponse = {
  profitMethod?: "PROFIT_MARGIN" | "MARKUP";
  flags?: Array<NameValue_1> | null;
};

export type profitMethod = "PROFIT_MARGIN" | "MARKUP";

export const profitMethod = {
  PROFIT_MARGIN: "PROFIT_MARGIN",
  MARKUP: "MARKUP",
} as const;

export type GlobalSettingsResponseResponseData = {
  data?: GlobalSettingsResponse;
};

export type Grouped = {
  groupName?: string | null;
  alerts?: number;
  lastAlertDate?: Date;
  readonly lastAlert?: string | null;
};

export type GroupedUnpagedListResults = {
  results?: Array<Grouped> | null;
};

export type GuidIdName = {
  id?: string;
  name?: string | null;
};

export type GuidIdNameEntity = {
  id: string;
  name: string;
};

export type HeaderSequence = {
  name?: string | null;
  prefix?: string | null;
  creditNextValue?: number;
  invoiceNextValue?: number;
};

export type HeaderSequenceCreate = {
  name: string;
  prefix: string;
};

export type HeaderSequenceUnpagedListResults = {
  results?: Array<HeaderSequence> | null;
};

export type HeaderSequenceUpdate = {
  creditNextValue?: number | null;
  invoiceNextValue?: number | null;
};

export type IdListRequest = {
  ids: Array<number>;
};

export type IdName = {
  id?: number;
  name?: string | null;
};

export type IdNameEntity = {
  id: number;
  name: string;
};

export type IdNameEntity_1UnpagedListResults = {
  results?: Array<StringIdNameEntity> | null;
};

export type IdNameEntityUnpagedListResults = {
  results?: Array<IdNameEntity> | null;
};

export type IdNameUnpagedListResults = {
  results?: Array<IdName> | null;
};

export type IdValue_2 = {
  id?: number;
  value?: ItemBatchBase;
};

export type IEnumerable_1ResponseData = {
  data?: Array<ItemBase> | null;
};

export type ImageTag = {
  id?: number;
  name?: string | null;
  readonly tagColor?: string | null;
};

export type ImageTagUnpagedListResults = {
  results?: Array<ImageTag> | null;
};

export type ImageTagUpsert = {
  name: string;
  tagColor?: string | null;
};

export type InboundDocument = {
  document?: GenericDocumentDetails;
  lines?: Array<InboundDocumentLine> | null;
  costs?: Array<InboundDocumentCost> | null;
  merge?: boolean;
};

export type InboundDocumentCarrierInfo = {
  carrierId: number;
  trackingNumber: string;
};

export type InboundDocumentCost = {
  id?: number;
  name?: string | null;
  reference?: string | null;
  cost?: MoneyCurrencyRate;
  contact?: StringIdName;
};

export type InboundDocumentLine = {
  id?: number;
  item: DocumentItemInfo;
  uomId?: number;
  quantity?: number;
  contactReference?: string | null;
  price?: Price;
  additionalCost?: Price;
  restrictBatchId?: number | null;
  batches?: Array<ItemBatchInfo> | null;
  substituteUom?: Array<AlternativeUom> | null;
};

export type InboundDocumentReceive = {
  date?: Date | null;
  warehouseCode?: string | null;
  importReference?: string | null;
  documentReferenceType?: ("DELIVERY_NOTE" | "INVOICE") | null;
  documentReference?: string | null;
  currency?: string | null;
  currencyRate?: number | null;
  receivingNotes?: string | null;
  merge?: boolean | null;
  costs?: Array<InboundDocumentReceiveCost> | null;
  items?: Array<InboundDocumentReceiveItem> | null;
  carrier?: InboundDocumentCarrierInfo;
};

export type documentReferenceType = "DELIVERY_NOTE" | "INVOICE";

export const documentReferenceType = {
  DELIVERY_NOTE: "DELIVERY_NOTE",
  INVOICE: "INVOICE",
} as const;

export type InboundDocumentReceiveCost = {
  costId: number;
  cost: MoneyCurrencyRate;
  reference: string;
  contactCode: string;
};

export type InboundDocumentReceiveItem = {
  lineId: number;
  qty?: number;
  uomId?: number | null;
  contactReference?: string | null;
  price?: Price;
  additionalCost?: Price;
  alternativeSku?: string | null;
  batch?: IdValue_2;
  bin?: string | null;
  weight?: number | null;
  weightTotal?: boolean;
};

export type InboundDocumentResponseData = {
  data?: InboundDocument;
};

export type InboundPlanConfirmIdRequest = {
  id: string;
};

export type InboundPlanItem = {
  sellerSku?: string | null;
  fnsku?: string | null;
  item?: ItemBase;
  quantity?: number;
  unitsQuantity?: number;
  uom?: IdName;
  labelOwner?: ("AMAZON" | "SELLER" | "NONE") | null;
  prepInstructions?: Array<SpApiFulfillmentInboundPrepInstruction> | null;
};

export type InboundPlanShipment = {
  id: string;
  warehouseId: string;
  destination: DocumentAddress;
  items: Array<InboundPlanItem>;
};

export type InboundPlanShipmentPlacementDetailsRequest = {
  forceGenerate?: boolean;
};

export type InboundPlanShipmentPlacementDetailsResponse = {
  id?: string | null;
  shipmentsCount?: number;
  totalCost?: Money;
  expiration?: Date | null;
  fees?: Array<FeeDescription> | null;
  discounts?: Array<FeeDescription> | null;
  shipments?: Array<InboundPlanShipment> | null;
};

export type InboundPlanShipmentPlacementDetailsResponseResponseDataResponse = {
  data: InboundPlanShipmentPlacementDetailsResponse;
};

export type InboundPlanShipmentPlacementDetailsResponseUnpagedListResults = {
  results?: Array<InboundPlanShipmentPlacementDetailsResponse> | null;
};

export type InboundPlanTransportationConfirmationRequest = {
  transportation: InboundTransportationOption;
  deliveryWindow: InboundTransportationDeliveryWindow;
};

export type InboundPlanTransportationOptionsRequest = {
  shipmentTime?: Date | null;
  packages?: Array<number> | null;
};

export type InboundPlanTransportationOptionsResponse = {
  transportationOptions?: Array<InboundTransportationOption> | null;
  deliveryWindowOptions?: Array<InboundTransportationDeliveryWindow> | null;
};

export type InboundPlanTransportationOptionsResponseResponseDataResponse = {
  data: InboundPlanTransportationOptionsResponse;
};

export type InboundPlanTrn = {
  id: number;
  shipmentId?: string | null;
  fbaShipmentId?: string | null;
  type?: "holding" | "shipment";
};

export type InboundPlanTrnUnpagedListResults = {
  results?: Array<InboundPlanTrn> | null;
};

export type InboundReceiveMultipleDocumentsRequest = {
  receiveDate?: Date | null;
  contactId?: Array<string> | null;
  items?: Array<InboundReceiveMultipleDocumentsRequestItem> | null;
};

export type InboundReceiveMultipleDocumentsRequestItem = {
  documentLineId?: number | null;
  item?: string | null;
  qty?: string | null;
  uom?: string | null;
  price?: string | null;
  discount?: string | null;
  batch?: string | null;
  bin?: string | null;
  weight?: string | null;
  document?: string | null;
  carrier?: string | null;
  carrierTracking?: string | null;
  [key: string]: (unknown | number | string) | undefined;
};

export type InboundReceiveRequest = {
  receiveDate?: Date | null;
  warehouseCode?: string | null;
  receiveReference?: string | null;
  receiveReferenceType?: string | null;
  currency?: string | null;
  currencyRate?: number | null;
  items?: Array<InboundReceiveRequestItem> | null;
};

export type InboundReceiveRequestItem = {
  documentLineId?: number | null;
  item?: string | null;
  qty?: string | null;
  uom?: string | null;
  price?: string | null;
  discount?: string | null;
  batch?: string | null;
  bin?: string | null;
  weight?: string | null;
  [key: string]: (unknown | number | string) | undefined;
};

export type InboundStatus = {
  name?: string | null;
  state?: string | null;
};

export type InboundStatusBadge = {
  id: number;
  name: string;
  state?: ("danger" | "warning" | "success" | "info") | null;
  pinned: boolean;
};

export type state = "danger" | "warning" | "success" | "info";

export const state = {
  DANGER: "danger",
  WARNING: "warning",
  SUCCESS: "success",
  INFO: "info",
} as const;

export type InboundStatusBadgeUnpagedListResults = {
  results?: Array<InboundStatusBadge> | null;
};

export type InboundStatusBadgeUpsert = {
  name: string;
  state?: ("danger" | "warning" | "success" | "info") | null;
  pinned?: boolean;
};

export type InboundTransportationDeliveryWindow = {
  /**
   * Identifies type of Delivery Window Availability. Values: `AVAILABLE`, `CONGESTED`
   */
  availabilityType: string;
  /**
   * Identifier of a delivery window option. A delivery window option represent one option for when a shipment is expected to be delivered.
   */
  id: string;
  /**
   * The timestamp at which this delivery window option ends. This is based in ISO 8601 datetime with pattern `yyyy-MM-ddTHH:mm:ss.sssZ`.
   */
  endDate: Date;
  /**
   * The timestamp at which this delivery window option starts. This is based in ISO 8601 datetime with pattern `yyyy-MM-ddTHH:mm:ss.sssZ`.
   */
  startDate: Date;
  /**
   * The timestamp at which this window delivery option becomes no longer valid. This is based in ISO 8601 datetime with pattern `yyyy-MM-ddTHH:mm:ss.sssZ`.
   */
  validUntil: Date;
};

export type InboundTransportationOption = {
  id: string | null;
  carrierName: string | null;
  carrierCode: string | null;
  carrierAppointment?: DateRangeOffset;
  shipmentId: string;
  quote?: InboundTransportationQuote;
  /**
   * Identifies a list of preconditions for confirming the transportation option.
   */
  preconditions?: Array<string> | null;
  /**
   * Mode of shipment transportation that this option will provide. Can be: `GROUND_SMALL_PARCEL`, `FREIGHT_LTL`, `FREIGHT_FTL_PALLET`, `FREIGHT_FTL_NONPALLET`, `OCEAN_LCL`, `OCEAN_FCL`, `AIR_SMALL_PARCEL`, `AIR_SMALL_PARCEL_EXPRESS`.
   */
  shippingMode: string;
  /**
   * Shipping program for the option. Can be: `AMAZON_PARTNERED_CARRIER`, `USE_YOUR_OWN_CARRIER`.
   */
  shippingSolution: string;
};

export type InboundTransportationQuote = {
  cost: Money;
  /**
   * The timestamp at which this transportation option quote becomes no longer valid. This is based in ISO 8601 datetime with pattern `yyyy-MM-ddTHH:mm:ss.sssZ`.
   */
  expiration?: Date | null;
  /**
   * Voidable until timestamp.
   */
  voidableUntil?: Date | null;
};

export type Int32DocumentType = {
  type?: string | null;
  id?: number;
  readonly name?: string | null;
};

export type Int32IdName = {
  id?: number;
  name?: string | null;
};

export type Int32ResponseDataResponse = {
  data: number;
};

export type InventoryCacheType = {
  itemTags: Array<TagBasedEntity> | null;
  itemUoms: Array<IdName> | null;
  imageTags: Array<TagBasedEntity> | null;
};

export type InventoryInputConfigConfigurablePipeline = {
  formatConfig: PipelineFormatConfig;
  fileConfig: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: Array<ConfigurationParameter> | null;
};

export type InventoryModel = {
  id?: number;
  name?: string | null;
  readonly updateId?: string | null;
  batchEntryMode?: "NONE" | "ACTIVE" | "STRICT";
  batchDataMode?:
    | (
        | "BEST_BEFORE_DATE"
        | "FULL_BATCH_INFO"
        | "PRODUCTION_DATE"
        | "LOT_NUMBER"
        | "SERIAL_NUMBER"
      )
    | null;
  binMode?: "NONE" | "ACTIVE" | "STRICT";
  cogs?: "FIFO" | "WAC";
  readonly batchFields?: Array<string> | null;
  requiresQc?: boolean;
  mandatorySo?: boolean;
  batchNameFormat?: string | null;
  shelfLifeDays?: number | null;
};

export type batchEntryMode = "NONE" | "ACTIVE" | "STRICT";

export const batchEntryMode = {
  NONE: "NONE",
  ACTIVE: "ACTIVE",
  STRICT: "STRICT",
} as const;

export type batchDataMode =
  | "BEST_BEFORE_DATE"
  | "FULL_BATCH_INFO"
  | "PRODUCTION_DATE"
  | "LOT_NUMBER"
  | "SERIAL_NUMBER";

export const batchDataMode = {
  BEST_BEFORE_DATE: "BEST_BEFORE_DATE",
  FULL_BATCH_INFO: "FULL_BATCH_INFO",
  PRODUCTION_DATE: "PRODUCTION_DATE",
  LOT_NUMBER: "LOT_NUMBER",
  SERIAL_NUMBER: "SERIAL_NUMBER",
} as const;

export type binMode = "NONE" | "ACTIVE" | "STRICT";

export const binMode = {
  NONE: "NONE",
  ACTIVE: "ACTIVE",
  STRICT: "STRICT",
} as const;

export type cogs = "FIFO" | "WAC";

export const cogs = {
  FIFO: "FIFO",
  WAC: "WAC",
} as const;

export type InventoryModelUnpagedListResults = {
  results?: Array<InventoryModel> | null;
};

export type InventoryModelUpsert = {
  name: string;
  updateId?: string | null;
  batchEntryMode: "NONE" | "ACTIVE" | "STRICT";
  batchDataMode?:
    | (
        | "BEST_BEFORE_DATE"
        | "FULL_BATCH_INFO"
        | "PRODUCTION_DATE"
        | "LOT_NUMBER"
        | "SERIAL_NUMBER"
      )
    | null;
  binMode: "NONE" | "ACTIVE" | "STRICT";
  cogs: "FIFO" | "WAC";
  batchFields?: Array<string> | null;
  requiresQc?: boolean;
  mandatorySo?: boolean;
  batchNameFormat?: string | null;
  shelfLifeDays?: number | null;
};

export type InventoryProfileDetail = {
  readonly mpId?: Array<number> | null;
  percentage?: number;
  updateMin?: number | null;
  updateMax?: number | null;
  readonly sourceField?: "available" | "inc-purchase" | "static";
  staticAmount?: number | null;
};

export type sourceField = "available" | "inc-purchase" | "static";

export const sourceField = {
  AVAILABLE: "available",
  INC_PURCHASE: "inc-purchase",
  STATIC: "static",
} as const;

export type InventoryProfileDetailUpsert = {
  mpId?: Array<number> | null;
  percentage?: number | null;
  updateMin?: number | null;
  updateMax?: number | null;
  sourceField: "available" | "inc-purchase" | "static";
  staticAmount?: number | null;
};

export type InventoryProfileUpsert = {
  name: string;
  details: Array<InventoryProfileDetailUpsert>;
};

export type InventoryProfileWithDetails = {
  id?: number;
  name?: string | null;
  details?: Array<InventoryProfileDetail> | null;
};

export type InventoryProfileWithDetailsUnpagedListResults = {
  results?: Array<InventoryProfileWithDetails> | null;
};

export type InviteProcessRequest = {
  token: string;
  accept: boolean;
  profile?: InviteProfile;
};

export type InviteProfile = {
  nameFirst: string;
  nameLast: string;
  password1: string;
  password2: string;
};

export type InviteStatusRequest = {
  token: string;
};

export type InviteStatusResponse = {
  profileRequired?: boolean;
  inviteDescription?: string | null;
  profile?: UserProfileBase;
};

export type InviteStatusResponseResponseData = {
  data?: InviteStatusResponse;
};

export type InvoiceItem = {
  docId?: string | null;
  isCredit?: boolean;
};

export type InvoicesCreateRequest = {
  invoiceDate?: Date | null;
  soId: Array<string>;
  headerId?: number | null;
  quantityType: "Confirmed" | "Shipped" | "Packed" | "Validated";
  remainingMode?: ("Keep" | "Backorder" | "Finalize") | null;
  splitMode:
    | "None"
    | "Contact"
    | "SalesOrder"
    | "WarehouseContact"
    | "SalesOrderDate"
    | "WarehouseContactAddress";
  notes?: string | null;
  preventPrint?: boolean | null;
};

export type quantityType = "Confirmed" | "Shipped" | "Packed" | "Validated";

export const quantityType = {
  CONFIRMED: "Confirmed",
  SHIPPED: "Shipped",
  PACKED: "Packed",
  VALIDATED: "Validated",
} as const;

export type remainingMode = "Keep" | "Backorder" | "Finalize";

export const remainingMode = {
  KEEP: "Keep",
  BACKORDER: "Backorder",
  FINALIZE: "Finalize",
} as const;

export type splitMode =
  | "None"
  | "Contact"
  | "SalesOrder"
  | "WarehouseContact"
  | "SalesOrderDate"
  | "WarehouseContactAddress";

export const splitMode = {
  NONE: "None",
  CONTACT: "Contact",
  SALES_ORDER: "SalesOrder",
  WAREHOUSE_CONTACT: "WarehouseContact",
  SALES_ORDER_DATE: "SalesOrderDate",
  WAREHOUSE_CONTACT_ADDRESS: "WarehouseContactAddress",
} as const;

export type InvoicesCreateResponse = {
  documentId: Array<string>;
};

export type InvoicesCreateResponseResponseDataResponse = {
  data: InvoicesCreateResponse;
};

export type InvoicesEmailRequest = {
  invoiceId?: Array<string> | null;
  emailSubject?: string | null;
  emailBody?: string | null;
  printTemplateId?: number | null;
  combineInvoices?: boolean;
};

export type ItemAppCategoryDetails = {
  id: number;
  name: string;
  imageUrl?: string | null;
  parentId?: number | null;
  hidden?: boolean;
  description?: string | null;
};

export type ItemAppCategoryDetailsResponseDataResponse = {
  data: ItemAppCategoryDetails;
};

export type ItemAppCategoryHierarchy = {
  id: number;
  name: string;
  imageUrl?: string | null;
  parentId?: number | null;
  hidden?: boolean;
  categories?: Array<ItemAppCategoryHierarchy> | null;
};

export type ItemAppCategoryHierarchyUnpagedListResults = {
  results?: Array<ItemAppCategoryHierarchy> | null;
};

export type ItemAssemblyCreateConsumeEntry = {
  itemSku: string;
  uomId: number;
  quantity: number;
  batchId?: number | null;
  binLocation?: string | null;
};

export type ItemAssemblyCreateQuantity = {
  uomId: number;
  quantity: number;
};

export type ItemAssemblyCreateRequest = {
  parentItemSku: string;
  workOrderLineId?: number | null;
  quantities: Array<ItemAssemblyCreateQuantity>;
  assemblyDate?: Date | null;
  assemblyReference?: string | null;
  warehouseId: string;
  itemsConsumed: Array<ItemAssemblyCreateConsumeEntry>;
  notes?: string | null;
  timeTaken?: string | null;
  startTime?: Date | null;
  endTime?: Date | null;
  userPin: string;
  assemblyProductionPending: boolean;
  assemblyBinLocation?: string | null;
  assemblyBatchId?: number | null;
};

export type ItemAssemblyPrepBom = {
  item: ItemLookup;
  id: number;
  notes?: string | null;
  quantity: number;
  quantityType: "Multiple" | "Fixed";
  uomOptions?: Array<ItemAssemblyPrepUom> | null;
  inventorySummary?: Array<ItemInventory3dSummary> | null;
};

export type quantityType2 = "Multiple" | "Fixed";

export const quantityType2 = {
  MULTIPLE: "Multiple",
  FIXED: "Fixed",
} as const;

export type ItemAssemblyPrepRequest = {
  sku: string;
  workOrderLineId?: number | null;
  warehouseId: string;
};

export type ItemAssemblyPrepResponse = {
  parentItem: ItemLookup;
  parentUom: IdName;
  items: Array<ItemAssemblyPrepBom>;
  parentUoms: Array<ItemListUom>;
};

export type ItemAssemblyPrepResponseResponseDataResponse = {
  data: ItemAssemblyPrepResponse;
};

export type ItemAssemblyPrepUom = {
  id?: number;
  name?: string | null;
  shelfQty?: number | null;
  weightNet?: Weight;
  weightGross?: Weight;
  dimensions?: Dimensions;
  volume?: string | null;
  eanIdentifier?: string | null;
  skuIdentifier?: string | null;
  valueBuying?: number | null;
  valueLanded?: number | null;
  quantityExpected: number;
  isDefault: boolean;
  onHand?: number;
  available?: number;
};

export type ItemBase = {
  id?: string;
  sku?: string | null;
  title?: string | null;
};

export type ItemBaseResponseDataResponse = {
  data: ItemBase;
};

export type ItemBatchBase = {
  name?: string | null;
  productionDate?: Date | null;
  bestBeforeDate?: Date | null;
  fields?: {
    [key: string]: string | null;
  } | null;
};

export type ItemBatchInfo = {
  readonly id?: number;
  name?: string | null;
  productionDate?: Date | null;
  bestBeforeDate?: Date | null;
  readonly fields?: {
    [key: string]: string | null;
  } | null;
};

export type ItemBatchInfoUnpagedListResults = {
  results?: Array<ItemBatchInfo> | null;
};

export type ItemBrand = {
  id: number;
  name: string;
  leadTime?: number | null;
  imageUrl?: string | null;
  discountValue?: number | null;
};

export type ItemBrandUnpagedListResults = {
  results?: Array<ItemBrand> | null;
};

export type ItemCatalog = {
  id: number;
  name: string;
  isHidden?: boolean;
};

export type ItemCatalogUnpagedListResults = {
  results?: Array<ItemCatalog> | null;
};

export type ItemCatalogUpsert = {
  name: string;
  isHidden?: boolean;
};

export type ItemCategory = {
  id?: number;
  name?: string | null;
  nominal?: string | null;
  taxType: GuidIdName;
  hsCode?: string | null;
  defaultInventoryModel?: number | null;
  itemSkuPrefix?: string | null;
  discountValue?: number | null;
  taxItems?: Array<GuidIdNameEntity> | null;
};

export type ItemCategoryUnpagedListResults = {
  results?: Array<ItemCategory> | null;
};

export type ItemCategoryUpsert = {
  name: string;
  nominal?: string | null;
  taxType?: string | null;
  hsCode?: string | null;
  defaultInventoryModel?: number | null;
  itemSkuPrefix?: string | null;
  discountValue?: number | null;
  taxItems?: Array<string> | null;
};

export type ItemContactInfoUpsert = {
  sku?: string | null;
  title?: string | null;
  defaultUomId?: number | null;
};

export type ItemCreateAppInfoRequest = {
  hidden?: boolean;
  new?: boolean;
  newEndDate?: Date | null;
  categoryId?: number | null;
};

export type ItemCreateRequest = {
  type: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  sku: string;
  title: string;
  pricing?: ("QUANTITY" | "WEIGHT") | null;
  categoryId: number;
  inventoryModelId?: number | null;
  brandId?: number | null;
  departmentId?: number | null;
  identifier?: ItemIdentifier;
  commodity?: ItemHarmonization;
  parentSku?: string | null;
  taxType?: string | null;
  app?: ItemCreateAppInfoRequest;
  specs?: Array<ItemUpsertSpec> | null;
};

export type ItemDepartmentUpsert = {
  name: string;
};

export type ItemHarmonization = {
  hsCode?: string | null;
  countryOfOrigin?: string | null;
  readonly countryOfOriginName?: string | null;
};

export type ItemIdentifier = {
  ean?: string | null;
  upc?: string | null;
  asin?: string | null;
  isbn?: string | null;
};

export type ItemImagesBulkUpdateRequest = {
  id: Array<number>;
  setPrivate?: boolean | null;
  setPrimary?: boolean | null;
  tagsAdd?: Array<number> | null;
  tagsRemove?: Array<number> | null;
  tagsClear?: boolean | null;
  updatePosition?: boolean | null;
};

export type ItemImagesDropResponse = {
  item: ItemBase;
  imageId: number;
};

export type ItemImagesDropResponseResponseData = {
  data?: ItemImagesDropResponse;
};

export type ItemInventory3dSummary = {
  warehouse?: GuidIdName;
  onHand?: number | null;
  binLocation?: string | null;
  quarantined?: boolean;
  batchDetails?: ItemBatchInfo;
};

export type ItemInventory3dSummaryUnpagedListResults = {
  results?: Array<ItemInventory3dSummary> | null;
};

export type ItemInventoryBase = {
  onHand?: number | null;
  available?: number | null;
  onOrder?: number | null;
};

export type ItemInventoryByItemWarehouse = {
  onHand?: number | null;
  available?: number | null;
  onOrder?: number | null;
  warehouseCode?: string | null;
  itemSku?: string | null;
  itemTitle?: string | null;
  itemUom?: string | null;
  lastModified?: Date | null;
};

export type ItemInventoryByItemWarehouseDetailed = {
  onHand?: number | null;
  available?: number | null;
  onOrder?: number | null;
  warehouseCode?: string | null;
  itemSku?: string | null;
  itemTitle?: string | null;
  itemUom?: string | null;
  lastModified?: Date | null;
  binLocation?: string | null;
  batchDetails?: ItemBatchInfo;
};

export type ItemInventoryByItemWarehouseDetailedUnpagedListResults = {
  results?: Array<ItemInventoryByItemWarehouseDetailed> | null;
};

export type ItemInventoryByItemWarehouseUnpagedListResults = {
  results?: Array<ItemInventoryByItemWarehouse> | null;
};

export type ItemInventoryDrilldown = {
  readonly document?: string | null;
  documentType?: string | null;
  documentId?: string | null;
  details?: string | null;
  date?: Date | null;
  qty?: number;
  qtyUom?: number;
  uomId?: number;
  uomName?: string | null;
  notes?: string | null;
};

export type ItemInventoryDrilldownListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ItemInventoryDrilldown> | null;
  readonly mightHaveMore: boolean;
};

export type ItemInventoryLog = {
  warehouse?: GuidIdName;
  date?: Date;
  code?: string | null;
  price?: Money;
  weight?: number | null;
  qty?: number;
  uomName?: string | null;
  balance?: number;
  balanceUom?: string | null;
  document?: string | null;
  rootDocument?: string | null;
  documentDetails?: string | null;
  bin?: string | null;
  batchInfo?: ItemBatchInfo;
};

export type ItemInventoryLogListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ItemInventoryLog> | null;
  readonly mightHaveMore: boolean;
};

export type ItemInventorySummary = {
  inventories?: Array<ItemInventoryWithWarehouse> | null;
  summary?: Array<ItemInventoryWithWarehouseGroup> | null;
};

export type ItemInventorySummaryResponseData = {
  data?: ItemInventorySummary;
};

export type ItemInventoryWithWarehouse = {
  warehouse?: GuidIdName;
  onHand?: number | null;
  available?: number | null;
  blocked?: number | null;
  onOrder?: number | null;
  reserved?: number | null;
  uninvoiced?: number | null;
  directDispatch?: number | null;
  backToBack?: number | null;
  inTransit?: number | null;
  achievable?: number | null;
  weight?: number | null;
  cost?: MoneyWithLcy;
  landedCost?: MoneyWithLcy;
  wacValue?: number | null;
};

export type ItemInventoryWithWarehouseGroup = {
  warehouse?: GuidIdName;
  onHand?: number | null;
  available?: number | null;
  blocked?: number | null;
  onOrder?: number | null;
  reserved?: number | null;
  uninvoiced?: number | null;
  directDispatch?: number | null;
  backToBack?: number | null;
  inTransit?: number | null;
  achievable?: number | null;
  weight?: number | null;
  cost?: MoneyWithLcy;
  landedCost?: MoneyWithLcy;
  wacValue?: number | null;
  warehouseGroup?: GuidIdName;
};

export type ItemLabelPrintBatchRequest = {
  bestBeforeDate?: Date | null;
  productionDate?: Date | null;
  lotNumber?: string | null;
  itemQuantity?: number | null;
};

export type ItemLabelPrintItemRequest = {
  sku: string;
  uomId?: number | null;
  copies?: number | null;
  itemWeight?: number | null;
  batch?: ItemLabelPrintBatchRequest;
  freeText?: string | null;
};

export type ItemLabelPrintResult = {
  id?: number;
  item: ItemLookup;
  quantity?: number;
  itemWeight?: number | null;
  batchMode?:
    | (
        | "BEST_BEFORE_DATE"
        | "FULL_BATCH_INFO"
        | "PRODUCTION_DATE"
        | "LOT_NUMBER"
        | "SERIAL_NUMBER"
      )
    | null;
  batch?: ItemBatchInfo;
};

export type batchMode =
  | "BEST_BEFORE_DATE"
  | "FULL_BATCH_INFO"
  | "PRODUCTION_DATE"
  | "LOT_NUMBER"
  | "SERIAL_NUMBER";

export const batchMode = {
  BEST_BEFORE_DATE: "BEST_BEFORE_DATE",
  FULL_BATCH_INFO: "FULL_BATCH_INFO",
  PRODUCTION_DATE: "PRODUCTION_DATE",
  LOT_NUMBER: "LOT_NUMBER",
  SERIAL_NUMBER: "SERIAL_NUMBER",
} as const;

export type ItemLabelPrintResultUnpagedListResults = {
  results?: Array<ItemLabelPrintResult> | null;
};

export type ItemLabelsDocumentPrintItemRequest = {
  id?: number;
  uomId?: number | null;
  copies?: number | null;
  itemWeight?: number | null;
  batch?: ItemLabelPrintBatchRequest;
  freeText?: string | null;
};

export type ItemLabelsDocumentPrintRequest = {
  items: Array<ItemLabelsDocumentPrintItemRequest>;
  queueId?: number | null;
  queueTags?: string | null;
  templateId?: number | null;
  uomId?: number | null;
  pricelistId?: string | null;
};

export type ItemLabelsPrintRequest = {
  items: Array<ItemLabelPrintItemRequest>;
  queueId?: number | null;
  queueTags?: string | null;
  templateId?: number | null;
  pricelistId?: string | null;
};

export type ItemLabelTemplate = {
  id: number;
  name: string;
  fileName?: string | null;
  url?: string | null;
};

export type ItemLabelTemplateUnpagedListResults = {
  results?: Array<ItemLabelTemplate> | null;
};

export type ItemListCompleteness = {
  id: number;
  score?: number;
  imageCount?: number;
};

export type ItemListImage = {
  id: number;
  imageUrl: string;
  imageUrlLarge: string;
  isPrimary?: boolean;
  isPrivate?: boolean;
  tags?: Array<number> | null;
  position?: number | null;
};

export type ItemListInfo = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  type?: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  defaultUomId?: number;
  inventoryModelId?: number;
  isPurchasable?: boolean;
  isSellable?: boolean;
  pricing?: "QUANTITY" | "WEIGHT";
  isEol?: boolean;
  category?: IdName;
  brand?: IdName;
  department?: IdName;
  appCategory?: IdName;
  tags?: Array<number> | null;
  hsCode?: string | null;
  countryOfOrigin?: string | null;
  itemSpecs?: Array<ItemSpec> | null;
  itemImages?: Array<ItemListImage> | null;
  itemCompleteness?: Array<ItemListCompleteness> | null;
  itemEan?: string | null;
  itemUpc?: string | null;
  itemAsin?: string | null;
  itemIsbn?: string | null;
  inventory?: ItemListInventory;
  price?: ItemListPrice;
  uom?: ItemListUom;
};

export type ItemListInfoCursorListResults = {
  results?: Array<ItemListInfo> | null;
  nextCursor?: string | null;
};

export type ItemListInfoResponseDataResponse = {
  data: ItemListInfo;
};

export type ItemListInventory = {
  onHand?: number | null;
  available?: number | null;
  onOrder?: number | null;
  buying?: Money;
};

export type ItemListPrice = {
  price?: Money;
  retailPrice?: Money;
  discount?: number | null;
  hasConditionalPricing?: boolean;
};

export type ItemListUom = {
  id?: number;
  name?: string | null;
  shelfQty?: number | null;
  weightNet?: Weight;
  weightGross?: Weight;
  dimensions?: Dimensions;
  volume?: string | null;
  eanIdentifier?: string | null;
  skuIdentifier?: string | null;
};

export type ItemLookup = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  type?: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  defaultUomId?: number;
  inventoryModelId?: number;
  isPurchasable?: boolean;
  isSellable?: boolean;
  pricing?: "QUANTITY" | "WEIGHT";
  isEol?: boolean;
};

export type ItemLookupDocument = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  type?: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  defaultUomId?: number;
  inventoryModelId?: number;
  isPurchasable?: boolean;
  isSellable?: boolean;
  pricing?: "QUANTITY" | "WEIGHT";
  isEol?: boolean;
  imageUrl?: string | null;
  showWeight?: boolean;
  showSize?: boolean;
  contactReference?: string | null;
  extraFields?: string | null;
  weightValue?: number | null;
  shelfQty?: number;
  inventoryAvailable?: number;
  inventoryModel?: InventoryModel;
};

export type ItemLookupDocumentUnpagedListResults = {
  results?: Array<ItemLookupDocument> | null;
};

export type ItemLookupImage = {
  id?: string;
  sku?: string | null;
  title?: string | null;
  type?: "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM";
  defaultUomId?: number;
  inventoryModelId?: number;
  isPurchasable?: boolean;
  isSellable?: boolean;
  pricing?: "QUANTITY" | "WEIGHT";
  isEol?: boolean;
  imageUrl?: string | null;
};

export type ItemLookupImageResponseDataResponse = {
  data: ItemLookupImage;
};

export type ItemOnOrderDetail = {
  baseType?: string | null;
  baseId?: string | null;
  partnerName?: string | null;
  expectedDate?: Date | null;
  qty?: number;
  uom?: number;
};

export type ItemPriceLookup = {
  uomIds?: Array<number> | null;
  value?: number | null;
  discount?: number | null;
  manualPrice?: number | null;
  rrp?: number | null;
  qtyBasedDiscounts?: boolean | null;
  source?: string | null;
};

export type ItemPriceLookupResponseData = {
  data?: ItemPriceLookup;
};

export type ItemQuickViewResults = {
  readonly document?: string | null;
  documentType?: string | null;
  documentId?: string | null;
  details?: string | null;
  date?: Date | null;
  qty?: number;
  uomName?: string | null;
  price?: Money;
};

export type ItemQuickViewResultsListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ItemQuickViewResults> | null;
  readonly mightHaveMore: boolean;
};

export type ItemsCatalogUpsert = {
  /**
   * Item Identifier, SKU, EAN, UPC etc
   */
  item?: string | null;
  sort_value?: string | null;
};

export type ItemsCatalogUpsertItemBasedBulkUpsertRequest = {
  items: Array<ItemsCatalogUpsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
};

export type ItemSegment = {
  salesValueNet?: number;
  salesValueGross?: number;
  orders?: number;
  itemsSold?: number;
  grossProfit?: number;
  grossProfitMarkup?: number;
  grossProfitMargin?: number;
  itemSku?: string | null;
  readonly itemSKU?: string | null;
  itemTitle?: string | null;
};

export type ItemSegmentUnpagedListResults = {
  results?: Array<ItemSegment> | null;
};

export type ItemsImageFilterQueryBased = {
  tag?: Array<number> | null;
  tagExclude?: Array<number> | null;
  untagged?: boolean;
};

export type ItemsListBySkuRequest = {
  sku: Array<string>;
  pimView?: number | null;
  imageView?: boolean | null;
  imagesFilterQueryBased?: ItemsImageFilterQueryBased;
  pricelistId?: string | null;
  warehouseId?: string | null;
  uomId?: number | null;
  inStockOnly?: boolean | null;
};

export type ItemsListResult = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  items?: Array<ItemListInfo> | null;
  itemPimView?: ItemView;
  specsError?: Array<number> | null;
};

export type ItemsListResultResponseData = {
  data?: ItemsListResult;
};

export type ItemsMappingItemRequest = {
  documentLineId?: string | null;
  sku?: string | null;
  uomId?: number | null;
  quantity: number;
};

export type ItemsMappingItemResponse = {
  item?: ItemBase;
  quantity?: number;
  uom?: IdName;
  vendors?: Array<ItemsMappingItemVendorResponse> | null;
};

export type ItemsMappingItemVendorResponse = {
  contact?: ContactLookup;
  price?: PriceCurrency;
  lastReceived?: Date | null;
  minimumOrder?: number | null;
  isDefault?: boolean;
  uom?: ItemsMappingItemVendorUomResponse;
  documentName?: string | null;
  ratingPrice?: number;
};

export type ItemsMappingItemVendorUomResponse = {
  id?: number;
  name?: string | null;
  convertedQty?: number;
};

export type ItemsMappingRequest = {
  documentType?: string | null;
  documentId?: string | null;
  warehouse?: StringNameOrId;
  items: Array<ItemsMappingItemRequest>;
};

export type ItemsMappingResponse = {
  directDeliveryEnabled?: boolean;
  backToBackEnabled?: boolean;
  items?: Array<ItemsMappingItemResponse> | null;
};

export type ItemsMappingResponseResponseData = {
  data?: ItemsMappingResponse;
};

export type ItemSpec = {
  id?: number;
  name?: string | null;
  value?: string | null;
};

export type ItemSpecification = {
  id: number;
  name: string;
  type?:
    | "NUMBER"
    | "DECIMAL"
    | "LONG_TEXT"
    | "LIST"
    | "BOOLEAN"
    | "DATE"
    | "URL";
  isMandatory?: boolean;
  isPublic?: boolean;
  isVariation?: boolean;
  options?: Array<IdName> | null;
  categoryIds?: Array<number> | null;
};

export type type8 =
  | "NUMBER"
  | "DECIMAL"
  | "LONG_TEXT"
  | "LIST"
  | "BOOLEAN"
  | "DATE"
  | "URL";

export const type8 = {
  NUMBER: "NUMBER",
  DECIMAL: "DECIMAL",
  LONG_TEXT: "LONG_TEXT",
  LIST: "LIST",
  BOOLEAN: "BOOLEAN",
  DATE: "DATE",
  URL: "URL",
} as const;

export type ItemSpecificationOption = {
  id?: number;
  name: string;
};

export type ItemSpecificationUnpagedListResults = {
  results?: Array<ItemSpecification> | null;
};

export type ItemSpecificationUpsert = {
  name: string;
  type:
    | "NUMBER"
    | "DECIMAL"
    | "LONG_TEXT"
    | "LIST"
    | "BOOLEAN"
    | "DATE"
    | "URL";
  isMandatory?: boolean;
  isPublic?: boolean;
  isVariation?: boolean;
  deletedOptions?: Array<number> | null;
  options?: Array<ItemSpecificationOption> | null;
  categoryIds?: Array<number> | null;
};

export type ItemSpecUnpagedListResults = {
  results?: Array<ItemSpec> | null;
};

export type ItemTag = {
  id: number;
  name: string;
  code?: string | null;
  readonly tagColor?: string | null;
  isPromo?: boolean;
  isClearance?: boolean;
  tagFilter?: boolean;
  autoAppend?: boolean;
};

export type ItemTagsUpdate = {
  mode: "add" | "set" | "remove";
  sku: Array<string>;
  tagId: Array<number>;
};

export type mode = "add" | "set" | "remove";

export const mode = {
  ADD: "add",
  SET: "set",
  REMOVE: "remove",
} as const;

export type ItemTagUnpagedListResults = {
  results?: Array<ItemTag> | null;
};

export type ItemTagUpsert = {
  name: string;
  code?: string | null;
  tagColor?: string | null;
  isPromo?: boolean;
  isClearance?: boolean;
  tagFilter?: boolean;
  autoAppend?: boolean;
};

export type ItemUom = {
  id?: number;
  name?: string | null;
  shelfQty?: number | null;
  weightNet?: number | null;
  weightGross?: number | null;
  weightUom?: ("kg" | "g" | "oz" | "lb") | null;
  height?: number;
  width?: number;
  length?: number;
  dimensionUom?: ("cm" | "ft" | "in" | "m" | "mm") | null;
  volume?: string | null;
  ean?: string | null;
  skuIdentifier?: string | null;
  readonly cbm?: number;
};

export type weightUom = "kg" | "g" | "oz" | "lb";

export const weightUom = {
  KG: "kg",
  G: "g",
  OZ: "oz",
  LB: "lb",
} as const;

export type dimensionUom = "cm" | "ft" | "in" | "m" | "mm";

export const dimensionUom = {
  CM: "cm",
  FT: "ft",
  IN: "in",
  M: "m",
  MM: "mm",
} as const;

export type ItemUomEntity = {
  id: number;
  name: string;
  code?: string | null;
  readonly updateId?: string | null;
  isDefault?: boolean;
  readonly isBase?: boolean;
  defaultValue?: number | null;
  isHidden?: boolean;
  isolatePacking?: boolean;
};

export type ItemUomEntityUnpagedListResults = {
  results?: Array<ItemUomEntity> | null;
};

export type ItemUomUnpagedListResults = {
  results?: Array<ItemUom> | null;
};

export type ItemUomUpsert = {
  name: string;
  updateId?: string | null;
  code?: string | null;
  isHidden?: boolean;
  defaultValue?: number | null;
  isolatePacking?: boolean;
};

export type ItemUpsert = {
  sku: string;
  title?: string | null;
  brand?: string | null;
  department?: string | null;
  category?: string | null;
  canSell?: string | null;
  canPurchase?: string | null;
  inventoryModel?: string | null;
  newSku?: string | null;
  description?: string | null;
  itemEan?: string | null;
  itemUpc?: string | null;
  itemAsin?: string | null;
  itemIsbn?: string | null;
  taxCode?: string | null;
  vendors?: Array<ItemUpsertVendor> | null;
  prices?: Array<PricelistEntryUpsert> | null;
  uoms?: Array<ItemUpsertUom> | null;
  buyingPrice?: string | null;
  autoConfirm?: string | null;
  pricing?: string | null;
  itemType?: string | null;
  appSorting?: string | null;
  appCategory?: string | null;
  appHidden?: string | null;
  appMarkedNew?: string | null;
  appNewExpiry?: string | null;
  parentSku?: string | null;
  itemEol?: string | null;
  images?: Array<ItemUpsertImage> | null;
  warehouse?: Array<ItemUpsertWarehouse> | null;
  defaultUom?: string | null;
  pickingDescription?: string | null;
  pickingNotes?: string | null;
  packingNotes?: string | null;
  appMessage?: string | null;
  relatedItemSku?: string | null;
  shelfLifeDays?: string | null;
  hsCode?: string | null;
  countryOfOrigin?: string | null;
  customsDeclarationCountry?: string | null;
  customsDeclarationText?: string | null;
  inventoryProfile?: string | null;
  specs?: Array<ItemUpsertSpec> | null;
};

export type ItemUpsertImage = {
  tags?: Array<number> | null;
  isPrimary?: boolean;
  isPrivate?: boolean;
  data?: UrlOrFileBase64Input;
  url?: string | null;
};

export type ItemUpsertImageGlobalSettings = {
  tags?: Array<number> | null;
  isPrimary?: boolean;
  isPrivate?: boolean;
  continueOnError?: boolean;
};

export type ItemUpsertSpec = {
  id: number;
  value: string;
};

export type ItemUpsertUom = {
  uom: Nullable_1NameOrId;
  shelfQty?: string | null;
  volume?: string | null;
  weightNet?: string | null;
  weightGross?: string | null;
  dimensions?: string | null;
  uomEan?: string | null;
  uomSku?: string | null;
};

export type ItemUpsertVendor = {
  vendor: string;
  reference?: string | null;
  title?: string | null;
  price?: string | null;
  uom?: string | null;
  discount?: string | null;
  minimum?: string | null;
  multiplier?: string | null;
  buyingUom?: string | null;
  addFixed?: string | null;
  addPercent?: string | null;
};

export type ItemUpsertWarehouse = {
  warehouse: string;
  bin1?: string | null;
  bin2?: string | null;
  leadTime?: string | null;
  dispatchFee?: string | null;
  orderLevel?: string | null;
  maxLevel?: string | null;
};

export type ItemVendorCatalogUpsert = {
  price?: number | null;
  currency?: string | null;
  discount?: number | null;
  minimumOrder?: number | null;
  defaultVendor?: boolean | null;
  fixedCost?: number | null;
  fixedPercentage?: number | null;
  uomId?: number | null;
  orderQtys?: number | null;
};

export type ItemView = {
  id?: number;
  name?: string | null;
  fields?: Array<ItemViewField> | null;
};

export type ItemViewField = {
  fieldType?: "ITEM_FIELD" | "ITEM_SPEC" | "COMPLETENESS";
  id?: string | null;
  header?: string | null;
  fieldValueType?:
    | ("Image" | "Money" | "Weight" | "Dimensions" | "ItemTags")
    | null;
};

export type fieldType = "ITEM_FIELD" | "ITEM_SPEC" | "COMPLETENESS";

export const fieldType = {
  ITEM_FIELD: "ITEM_FIELD",
  ITEM_SPEC: "ITEM_SPEC",
  COMPLETENESS: "COMPLETENESS",
} as const;

export type fieldValueType =
  | "Image"
  | "Money"
  | "Weight"
  | "Dimensions"
  | "ItemTags";

export const fieldValueType = {
  IMAGE: "Image",
  MONEY: "Money",
  WEIGHT: "Weight",
  DIMENSIONS: "Dimensions",
  ITEM_TAGS: "ItemTags",
} as const;

export type ItemViewFieldDefinition = {
  field?: string | null;
  header?: string | null;
  importField?: string | null;
  valueType?: ("Image" | "Money" | "Weight" | "Dimensions" | "ItemTags") | null;
};

export type valueType2 =
  | "Image"
  | "Money"
  | "Weight"
  | "Dimensions"
  | "ItemTags";

export const valueType2 = {
  IMAGE: "Image",
  MONEY: "Money",
  WEIGHT: "Weight",
  DIMENSIONS: "Dimensions",
  ITEM_TAGS: "ItemTags",
} as const;

export type ItemViewFieldDefinitionUnpagedListResults = {
  results?: Array<ItemViewFieldDefinition> | null;
};

export type ItemViewUnpagedListResults = {
  results?: Array<ItemView> | null;
};

export type ItemViewUpsert = {
  name: string;
  fields: Array<ItemViewUpsertField>;
};

export type ItemViewUpsertField = {
  fieldType: "ITEM_FIELD" | "ITEM_SPEC" | "COMPLETENESS";
  id: string;
  header?: string | null;
};

export type KpiDashboard = {
  id?: string;
  title?: string | null;
  columns?: number;
  locked?: boolean;
  accessToken?: string | null;
};

export type KpiDashboardUnpagedListResults = {
  results?: Array<KpiDashboard> | null;
};

export type KpiDashboardUpsert = {
  title: string;
  columns: number;
  locked?: boolean;
};

export type KpiDashboardWithWidgets = {
  id?: string;
  title?: string | null;
  columns?: number;
  locked?: boolean;
  accessToken?: string | null;
  widgets?: Array<KpiWidgetDetails> | null;
};

export type KpiDashboardWithWidgetsResponseData = {
  data?: KpiDashboardWithWidgets;
};

export type KpiWidgetConfigDetail = {
  type: string;
  parameters?: Array<ConfigurationParameter> | null;
  id?: number;
  title?: string | null;
};

export type KpiWidgetConfigDetailUnpagedListResults = {
  results?: Array<KpiWidgetConfigDetail> | null;
};

export type KpiWidgetDetails = {
  id?: number;
  row?: number;
  col?: number;
  width?: number;
  height?: number;
  type?: string | null;
};

export type KpiWidgetPositionRequest = {
  row: number;
  col: number;
  width: number;
  height: number;
  id: number;
};

export type LanguageEntity = {
  id: string;
  name: string;
};

export type LanguageEntityUnpagedListResults = {
  results?: Array<LanguageEntity> | null;
};

export type LinkedServices = {
  shippingService?: ItemBase;
  giftwrapService?: ItemBase;
  giftwrapServiceTag?: IdName;
  orderDiscountServiceId?: ItemBase;
  virtualKitHolder?: ItemBase;
};

export type LinkedServicesResponseData = {
  data?: LinkedServices;
};

export type ListedItem = {
  id: number;
  sellerSku: string;
  itemTitle?: string | null;
  url?: string | null;
  price?: number | null;
  priceCurrency?: string | null;
  pricePending?: number | null;
  quantity?: number | null;
  retailPrice?: number | null;
  marketplaceFulfilled?: boolean;
  linkedItem?: ListedItemLink;
  suggestedLinkItem?: ListedItemLink;
  lastSeen?: Date | null;
  isInactive?: boolean;
  marketplaceItemId?: string | null;
  marketplaceInventoryId?: string | null;
};

export type ListedItemLink = {
  item?: ItemBase;
  uom?: IdName;
};

export type ListedItemListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ListedItem> | null;
  readonly mightHaveMore: boolean;
};

export type ListedItemsBulkUpdateRequest = {
  ids: Array<number>;
  action: "unlink" | "delete" | "ignore" | "suggest" | "accept";
};

export type action = "unlink" | "delete" | "ignore" | "suggest" | "accept";

export const action = {
  UNLINK: "unlink",
  DELETE: "delete",
  IGNORE: "ignore",
  SUGGEST: "suggest",
  ACCEPT: "accept",
} as const;

export type ListedItemsUpdateRequest = {
  id: number;
  itemSku: string;
  uomId: number;
  marketplaceFulfilled?: boolean | null;
  price?: number | null;
  retailPrice?: number | null;
};

export type ListedShipmentInfo = {
  shipmentId?: string | null;
  shipmentCreated?: Date;
  shipmentStatus?: string | null;
  shipmentExpected?: Date;
  soId?: string | null;
  soWarning?: boolean;
  packStatus?: ("waiting" | "partial" | "complete" | "na") | null;
  invoiceStatus?: ("waiting" | "partial" | "complete" | "na") | null;
  readonly canImportShipment?: boolean;
  readonly canRejectShipment?: boolean;
  readonly canProcessPackages?: boolean;
};

export type packStatus = "waiting" | "partial" | "complete" | "na";

export const packStatus = {
  WAITING: "waiting",
  PARTIAL: "partial",
  COMPLETE: "complete",
  NA: "na",
} as const;

export type invoiceStatus = "waiting" | "partial" | "complete" | "na";

export const invoiceStatus = {
  WAITING: "waiting",
  PARTIAL: "partial",
  COMPLETE: "complete",
  NA: "na",
} as const;

export type ListedShipmentInfoUnpagedListResults = {
  results?: Array<ListedShipmentInfo> | null;
};

export type Listing = {
  imageUrl?: string | null;
  listed?: boolean;
  description?: string | null;
  keywords?: string | null;
  listingSection?: string | null;
};

export type ListingBulkSearch = {
  linked?: "ANY" | "LINKED" | "UNLINKED";
  fulfillment?: "ANY" | "MERCHANT" | "MARKETPLACE";
  includeInventory?: string | null;
  search?: string | null;
  sellerSku?: Array<string> | null;
  includeValues?: boolean | null;
};

export type linked = "ANY" | "LINKED" | "UNLINKED";

export const linked = {
  ANY: "ANY",
  LINKED: "LINKED",
  UNLINKED: "UNLINKED",
} as const;

export type fulfillment = "ANY" | "MERCHANT" | "MARKETPLACE";

export const fulfillment = {
  ANY: "ANY",
  MERCHANT: "MERCHANT",
  MARKETPLACE: "MARKETPLACE",
} as const;

export type ListingDetail = {
  mpSku?: string | null;
  marketplaceItemId?: string | null;
  listingTitle?: string | null;
  listingUrl?: string | null;
  fulfillment?: "MERCHANT" | "MARKETPLACE";
  qtyListed?: number | null;
  linkedItem?: ListingLinkedItem;
};

export type fulfillment2 = "MERCHANT" | "MARKETPLACE";

export const fulfillment2 = {
  MERCHANT: "MERCHANT",
  MARKETPLACE: "MARKETPLACE",
} as const;

export type ListingDetailInventory = {
  onHand?: number | null;
  available?: number | null;
  wacValue?: Money;
};

export type ListingDetailListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ListingDetail> | null;
  readonly mightHaveMore: boolean;
};

export type ListingDetailUnpagedListResults = {
  results?: Array<ListingDetail> | null;
};

export type ListingItem = {
  readonly id: string;
  listing: Listing;
  configuration: ConfigurationObject;
};

export type ListingItemUnpagedListResults = {
  results?: Array<ListingItem> | null;
};

export type ListingLinkedItem = {
  item?: ItemBase;
  uom?: IdName;
  inventory?: ListingDetailInventory;
};

export type ListResultsPo = {
  contact?: DocumentContactInfo;
  document?: DocumentProperties;
  customFields?: Array<DocumentCustomFieldValue> | null;
  id?: string | null;
  warehouseName?: string | null;
  isCredit?: boolean;
  date?: Date;
  currency?: string | null;
  etaDate?: Date | null;
  status?: "Pending" | "Partially" | "Complete";
  contactReference?: string | null;
  receiveStatus?: "Pending" | "Partially" | "Complete";
  billingStatus?: "Pending" | "Partially" | "Complete";
  totalNet?: number;
  totalGross?: number;
  totalTax?: number;
  directDelivery?: boolean;
  backorder?: boolean;
  finalized?: boolean;
  due?: boolean;
};

export type status4 = "Pending" | "Partially" | "Complete";

export const status4 = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
} as const;

export type receiveStatus2 = "Pending" | "Partially" | "Complete";

export const receiveStatus2 = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
} as const;

export type billingStatus = "Pending" | "Partially" | "Complete";

export const billingStatus = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
} as const;

export type ListResultsPoListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ListResultsPo> | null;
  readonly mightHaveMore: boolean;
};

export type LoginCreateSessionRequest = {
  email: string;
  captcha: string;
  browser?: string | null;
  scope?: string | null;
  returnUrl?: string | null;
  tenantId?: string | null;
};

export type LoginCreateSessionResponse = {
  sessionId: string;
  email: string;
  captchaValidated: boolean;
  sso: Array<string>;
};

export type LoginCreateSessionResponseResponseData = {
  data?: LoginCreateSessionResponse;
};

export type LoginEmailRequest = {
  deviceId?: string | null;
  deviceSignature?: string | null;
  email: string;
  scope?: string | null;
  captcha: string;
  returnUrl?: string | null;
  tid?: string | null;
};

export type LoginEmailResponse = {
  requestId?: string | null;
  email?: string | null;
  sso?: Array<string> | null;
  captchaValidated?: boolean;
};

export type LoginEmailResponseResponseData = {
  data?: LoginEmailResponse;
};

export type LoginMfaNotifyRequest = {
  deviceId?: string | null;
  deviceSignature?: string | null;
  requestId: string;
  type: string;
};

export type LoginMfaRequest = {
  deviceId?: string | null;
  deviceSignature?: string | null;
  requestId: string;
  type: string;
  response: string;
  trustDevice?: boolean;
};

export type LoginPasswordMfaMethod = {
  id?: string | null;
  title?: string | null;
  type?: string | null;
  description?: string | null;
  isPrimary?: boolean;
  canDelete?: boolean;
  instructions?: string | null;
  notify?: boolean;
  responseType?: string | null;
  responseLength?: number;
  publicKey?: string | null;
};

export type LoginPasswordRequest = {
  deviceId?: string | null;
  deviceSignature?: string | null;
  requestId: string;
  password: string;
  captcha?: string | null;
};

export type LoginPasswordResponse = {
  displayMessage?: string | null;
  token?: string | null;
  redirectUrl?: string | null;
  profile?: UserProfileBase;
  billing?: boolean;
  requiredAction?: AuthResponseAction;
  mfa?: Array<LoginPasswordMfaMethod> | null;
  organizations?: Array<AuthResponseOrganisation> | null;
};

export type LoginPasswordResponseResponseData = {
  data?: LoginPasswordResponse;
};

export type MarketplaceCacheType = {
  marketplaces: Array<IdName> | null;
};

export type MarketplaceConfiguration = {
  marketplace?: MarketplaceDetails;
  settings?: MarketplaceSettings;
  configuration?: ConfigurationResponse;
};

export type MarketplaceConfigurationResponseDataResponse = {
  data: MarketplaceConfiguration;
};

export type MarketplaceDetails = {
  marketplaceId: number;
  readonly id?: string | null;
  group?: GuidIdNameEntity;
  enabled: boolean;
  name: string;
  marketplaceFulfilmentWarehouse?: GuidIdName;
  ordersSync?: MarketplaceSyncStatus;
  pricesSync?: MarketplaceSyncStatus;
  inventorySync?: MarketplaceSyncStatus;
  exception?: MarketplaceErrorDetails;
  configurationType?: string | null;
  readonly type?: string | null;
  readonly integrationId: string;
  metadata?: {
    [key: string]: string;
  } | null;
};

export type MarketplaceDetailsResponseData = {
  data?: MarketplaceDetails;
};

export type MarketplaceDetailsUnpagedListResults = {
  results?: Array<MarketplaceDetails> | null;
};

export type MarketplaceErrorDetails = {
  date?: Date;
  message?: string | null;
};

export type MarketplaceGroupBase = {
  id: string;
  name: string;
  isAuthenticated: boolean;
};

export type MarketplaceGroupBaseUnpagedListResults = {
  results?: Array<MarketplaceGroupBase> | null;
};

export type MarketplaceGroupConfiguration = {
  group?: MarketplaceGroupBase;
  configuration?: ConfigurationResponse;
};

export type MarketplaceGroupConfigurationResponseDataResponse = {
  data: MarketplaceGroupConfiguration;
};

export type MarketplaceItemsUpsertRequest = {
  items: Array<MarketplaceItemUpsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
  createIfNotExists?: boolean;
};

export type MarketplaceItemUpsert = {
  sellerSku?: string | null;
  linkedSku?: string | null;
  linkedUom?: string | null;
  price?: string | null;
  marketplaceFulfilled?: string | null;
  retailPrice?: string | null;
};

export type MarketplaceListedItemsSummary = {
  listedCount: number;
  suggestedLinkCount: number;
  unlinkedCount: number;
  lastFetch?: Date | null;
};

export type MarketplaceListedItemsSummaryResponseDataResponse = {
  data: MarketplaceListedItemsSummary;
};

export type MarketplaceSettings = {
  ordersSync?: MarketplaceSettingsOrdersSync;
  inventorySync?: MarketplaceSettingsInventorySync;
};

export type MarketplaceSettingsInventorySync = {
  priceSyncEnabled?: boolean;
  inventorySyncEnabled?: boolean;
  fulfilmentWarehouses?: Array<string> | null;
  inventoryMin?: number | null;
  inventoryMax?: number | null;
  targetMargin?: number | null;
};

export type MarketplaceSettingsOrdersSync = {
  enabled?: boolean;
  contactId?: string | null;
  minimumDate?: Date | null;
  warehouseId?: string | null;
  marketplaceFulfilmentWarehouseId?: string | null;
};

export type MarketplaceSettingsUpsert = {
  ordersSync: MarketplaceSettingsOrdersSync;
  inventorySync: MarketplaceSettingsInventorySync;
};

export type MarketplaceSyncStatus = {
  enabled?: boolean;
  lastSync?: Date | null;
};

export type MarketplaceUpsert = {
  name: string;
  enabled: boolean;
  cloneId?: number | null;
  marketplaceIdentifier?: string | null;
  settings: MarketplaceSettingsUpsert;
  configuration: ConfigurationRequest;
};

export type MatchedDocumentAiSetContactRequest = {
  contactId: string;
};

export type MatchedDocumentContact = {
  name?: string | null;
  email?: string | null;
  taxId?: string | null;
  phone?: string | null;
};

export type MatchedDocumentContactSelect = {
  invoiceLines: Array<MatchedInvoiceLine>;
  matches?: Array<ContactLookup> | null;
};

export type MatchedDocumentResponse = {
  id: string;
  stage: "Processing" | "Failed" | "ContactSelect" | "Result";
  invoiceSummary: MatchedInvoiceSummary;
  contactSelect: MatchedDocumentContactSelect;
  result?: MatchedDocumentResult;
};

export type stage2 = "Processing" | "Failed" | "ContactSelect" | "Result";

export const stage2 = {
  PROCESSING: "Processing",
  FAILED: "Failed",
  CONTACT_SELECT: "ContactSelect",
  RESULT: "Result",
} as const;

export type MatchedDocumentResponseResponseDataResponse = {
  data: MatchedDocumentResponse;
};

export type MatchedDocumentResult = {
  contact: ContactLookup;
  invoiceLines: Array<MatchedInvoiceLineResult>;
};

export type MatchedInvoiceLine = {
  lineNumber: number;
  description?: string | null;
  amount?: Money;
  productCode?: string | null;
  quantity?: number | null;
  unitPrice?: Money;
};

export type MatchedInvoiceLineLink = {
  documentType: string;
  documentId: string;
  item: ItemBase;
  description: string;
  quantityDue: number;
  quantityApplied: number;
};

export type MatchedInvoiceLineResult = {
  lineNumber: number;
  description?: string | null;
  amount?: Money;
  productCode?: string | null;
  quantity?: number | null;
  unitPrice?: Money;
  links?: Array<MatchedInvoiceLineLink> | null;
};

export type MatchedInvoiceSummary = {
  vendor?: MatchedDocumentContact;
  subTotal?: Money;
  totalTax?: Money;
  totalDiscount?: Money;
  total?: Money;
  invoiceId?: string | null;
  orderNumber?: string | null;
  dueDate?: Date | null;
  invoiceDate?: Date | null;
};

export type Message = {
  id?: number;
  alertDate?: Date;
  groupName?: string | null;
  message?: string | null;
  dismissedDate?: Date | null;
  dismissedBy?: string | null;
};

export type MessageUnpagedListResults = {
  results?: Array<Message> | null;
};

export type MfaDeviceSetupConfirmRequest = {
  mfaType: string;
  token: string;
  response: string;
};

export type MfaDeviceSetupRequest = {
  mfaType: string;
  info?: string | null;
};

export type MfaDeviceSetupResponse = {
  token: string;
  imageData?: string | null;
};

export type MfaDeviceSetupResponseResponseData = {
  data?: MfaDeviceSetupResponse;
};

export type MfaMethod = {
  id?: string | null;
  title?: string | null;
  type?: string | null;
  description?: string | null;
  isPrimary?: boolean;
  canDelete?: boolean;
};

export type MfaMethodsResponse = {
  used?: Array<MfaMethod> | null;
  available?: Array<MfaMethod> | null;
};

export type MfaMethodsResponseResponseData = {
  data?: MfaMethodsResponse;
};

export type MfaSetupConfirmResponse = {
  recoveryCodes?: Array<string> | null;
};

export type MfaSetupConfirmResponseResponseData = {
  data?: MfaSetupConfirmResponse;
};

export type Money = {
  currencyCode?: string | null;
  amount?: number;
};

export type MoneyCurrencyRate = {
  currencyCode?: string | null;
  amount?: number;
  currencyRate?: number | null;
};

export type MoneyWithLcy = {
  currencyCode?: string | null;
  amount?: number;
  amountLcy?: number;
};

export type NameValue_1 = {
  name?: string | null;
  value?: string | null;
};

export type NewDocumentNote = {
  note?: string | null;
  classes?: string | null;
};

export type Notification = {
  id: number;
  createdDate: Date;
  title?: string | null;
  message?: string | null;
  isRead?: boolean;
  url?: string | null;
  progress?: number | null;
  type?: string | null;
};

export type NotificationCount = {
  notifications: number;
  emailQueue: number;
};

export type NotificationCountResponseData = {
  data?: NotificationCount;
};

export type NotificationListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<Notification> | null;
  readonly mightHaveMore: boolean;
};

export type Nullable_1NameOrId = {
  name?: string | null;
  id?: number | null;
};

export type OauthAuthenticationRequest = {
  deviceId?: string | null;
  deviceSignature?: string | null;
  scope?: string | null;
  returnUrl?: string | null;
  tid?: string | null;
  requestId: string;
  provider: string;
  autoCode: string;
};

export type Organisation = {
  id?: string | null;
  name?: string | null;
  logo?: string | null;
  taxNumber?: string | null;
  appUrl?: string | null;
  currency?: string | null;
  region?: string | null;
  readonly currencySymbol?: string | null;
};

export type PackageTypeEntity = {
  id: number;
  name: string;
  dimensions: Dimensions;
  identifier?: string | null;
  cost?: Money;
  color?: string | null;
};

export type PackageTypeEntityUnpagedListResults = {
  results?: Array<PackageTypeEntity> | null;
};

export type PackageTypeUpsert = {
  name: string;
  dimensions: Dimensions;
  identifier?: string | null;
  cost?: Money;
  color?: string | null;
};

export type Packing_AlternativeUom = {
  uomid?: number;
  shelfQty?: number;
  uomName?: string | null;
  /**
   * @deprecated
   */
  ratio?: number;
  /**
   * @deprecated
   */
  ratioToUom?: number;
  multiplier?: number;
  divisor?: number;
  isolate?: boolean;
  identifiers?: Array<ProductIdentifier> | null;
};

export type Packing_DocumentDetails = {
  baseType?: string | null;
  baseID?: string | null;
  readonly documentId?: string | null;
  destinationID?: string;
  contactCode?: string | null;
  destinationName?: string | null;
  documentDate?: Date | null;
  printCount?: number;
  packingStatus?: number;
  shippingAddressName?: string | null;
  shippingAttentionName?: string | null;
  shippingAddress1?: string | null;
  shippingAddress2?: string | null;
  shippingTown?: string | null;
  shippingState?: string | null;
  shippingZip?: string | null;
  shippingCountry?: string | null;
  shippingGLN?: string | null;
  shippingPhone?: string | null;
  shippingEmail?: string | null;
  deliveryDateFrom?: Date | null;
  deliveryDateTo?: Date | null;
  pickingNotes?: string | null;
  deliveryNotes?: string | null;
  warehouseID?: string;
  warehouseType?: number;
  tags?: string | null;
  documentReference?: string | null;
  salesRepName?: string | null;
  packageTypeId?: number;
  assignedCarrierId?: number | null;
  assignedCarrier?: string | null;
  zoneIdPreference?: number | null;
  userCreated?: string | null;
  userConfirmed?: string | null;
  originAddress?: Address;
  shippingAddress?: Address;
};

export type Packing_Package = {
  packageInfo?: Packing_PackageInfo;
  innerPacks?: Array<Packing_PackageInfo> | null;
  lines?: Array<Packing_PackageContentLine> | null;
};

export type Packing_PackageContentLine = {
  aid?: number;
  baseDetailID?: number;
  packID?: number;
  packedQty?: number;
  validatedQty?: number | null;
  scannedQty?: number | null;
  batchID?: number | null;
  unitWeightIsTotal?: boolean | null;
  unitWeight?: number | null;
  unitSize?: number | null;
  totalWeight?: number | null;
  totalSize?: number | null;
  batchExpiryDate?: Date | null;
  batchManufacturingDate?: Date | null;
  batchLotNumber?: string | null;
  batchNumber?: string | null;
  batchName?: string | null;
  batchFields?: string | null;
  readonly batchFieldsText?: string | null;
  readonly batchFieldsList?: Array<NameValue_1> | null;
  batchRemaining?: number | null;
  uom?: number | null;
  uomName?: string | null;
  printNet?: number | null;
  packedProductID?: string | null;
  /**
   * @deprecated
   */
  packedProductCode?: string | null;
  /**
   * @deprecated
   */
  packedProductTitle?: string | null;
  packedBINLocation?: string | null;
  valueEach?: number | null;
  valueEachGross?: number | null;
  readonly valueTotal?: number | null;
  readonly valueTotalGross?: number | null;
  valueCurrency?: string | null;
  itemWeightInGr?: number | null;
  readonly itemWeightInKg?: number;
  partDetails?: PartDetails;
  shelfQty?: number | null;
  kitQtyTotal?: number | null;
};

export type Packing_PackageInfo = {
  weightValue?: number | null;
  weightUOM?: string | null;
  dimensionsW?: number | null;
  dimensionsH?: number | null;
  dimensionsD?: number | null;
  dimensionsUOM?: string | null;
  packReference?: string | null;
  readonly dimensions?: string | null;
  readonly weight?: string | null;
  packID?: number;
  packType?: ("pack" | "pallet") | null;
  packSerial?: string | null;
  packSSCC?: string | null;
  readonly packSSCCFormated?: string | null;
  baseType?: string | null;
  baseID?: string | null;
  baseDocumentReference?: string | null;
  packDate?: Date | null;
  packNumber?: number | null;
  totalPackagesCount?: number | null;
  packUser?: string | null;
  shippingID?: number | null;
  parentID?: number | null;
  shpid?: string | null;
  shipmentLabelUrl?: string | null;
  shipmentTracking?: string | null;
  parentSerialNumber?: string | null;
  packTotalQty?: number;
  amazon2dBarcode?: string | null;
  packageReference?: string | null;
  isVirtualPackage?: boolean;
};

export type packType = "pack" | "pallet";

export const packType = {
  PACK: "pack",
  PALLET: "pallet",
} as const;

export type Packing_PackingDocument = {
  document?: Packing_DocumentDetails;
  packs?: Array<Packing_PackageInfo> | null;
  lines?: Array<Packing_PackingDocumentDetail> | null;
  newPackageInfo?: Packing_PackageInfo;
  newTagIds?: Array<number> | null;
  unlisted?: Array<Packing_PackingDocumentDetail> | null;
  startTime?: Date | null;
  docNote?: string | null;
  docNoteClass?: string | null;
};

export type Packing_PackingDocumentDetail = {
  inventoryCount?: number;
  inventoryAvailable?: number;
  inventoryBlocked?: number;
  inventoryExpected?: number;
  inventoryReserved?: number;
  inventoryAvailableOtherWarehouses?: number;
  inventoryExpectedDetails?: string | null;
  binLocationA?: string | null;
  binLocationB?: string | null;
  binLocation?: string | null;
  binPriority?: number | null;
  itemExpectedDate?: Date | null;
  partId?: string;
  partTitle?: string | null;
  partCode?: string | null;
  partEAN?: string | null;
  partUPC?: string | null;
  partASIN?: string | null;
  partISBN?: string | null;
  partBrandName?: string | null;
  partCategoryName?: string | null;
  partDepartmentName?: string | null;
  partImageS?: string | null;
  partImageL?: string | null;
  partImageM?: string | null;
  partImageO?: string | null;
  partMPN?: string | null;
  partType?:
    | ("STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM")
    | null;
  readonly itemTypeDescription?: string | null;
  pricingMethod?: ("QUANTITY" | "WEIGHT") | null;
  partNominalCode?: string | null;
  stockingWarehouseId?: string | null;
  partBuyingPrice?: number | null;
  partBuyingCurrency?: string | null;
  partBuyingPriceLCY?: number | null;
  parentPartId?: string | null;
  inventoryModelId?: number | null;
  inventoryModelName?: string | null;
  readonly isStockItem?: boolean;
  readonly isInventoryItem?: boolean;
  internalComments?: string | null;
  itemTags?: string | null;
  sellableItem?: boolean | null;
  purchasableItem?: boolean | null;
  isEOL?: boolean;
  docReference?: string | null;
  specifications?: {
    [key: string]: unknown;
  } | null;
  itemHsCode?: string | null;
  itemCOO?: string | null;
  itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
  partID?: string;
  partDocumentDescription?: string | null;
  uom?: number;
  uomText?: string | null;
  subInventoryCount?: number | null;
  subInventoryAvailable?: number | null;
  partImageURL?: string | null;
  partPricingMethod?: number;
  shelfLifeDays?: number | null;
  batchable?: boolean;
  inventoryModel?: number;
  batchDataMode?:
    | "BEST_BEFORE_DATE"
    | "FULL_BATCH_INFO"
    | "PRODUCTION_DATE"
    | "LOT_NUMBER"
    | "SERIAL_NUMBER";
  batchStrict?: boolean;
  binMode?: number;
  uomShelfQty?: number | null;
  uomDimVolume?: string | null;
  uomWeight?: number | null;
  uomWeightGross?: number | null;
  uomWeightUOM?: string | null;
  uomWeightKG?: number | null;
  uomWeightGR?: number | null;
  uomDimHeight?: number | null;
  uomDimWidth?: number | null;
  uomDimLength?: number | null;
  uomDimUOM?: string | null;
  uomInfoEan?: string | null;
  uomInfoSku?: string | null;
  detailID?: number;
  qty?: number;
  baseID?: string | null;
  baseType?: string | null;
  uomWarn?: boolean;
  qtyOnPurchase?: number;
  requestedBatchID?: number | null;
  requestedBatchDetails?: string | null;
  noBatchQty?: number;
  separatePacking?: boolean;
  hasBackToBack?: boolean;
  packingContent?: Array<Packing_PackageContentLine> | null;
  inventoryDetails?: Array<Packing_PackingInventoryDetail> | null;
  identifiers?: Array<ProductIdentifier> | null;
  alternativeUOMs?: Array<Packing_AlternativeUom> | null;
  batches?: Array<Common_ProductBatchDetails> | null;
  alternatives?: Array<Packing_PackingDocumentDetail> | null;
  taughtBarcodes?: Array<string> | null;
  updatedBinLocationA?: string | null;
  updatedBinLocationB?: string | null;
  pickingNotes?: string | null;
  packingNotes?: string | null;
  parentPartCode?: string | null;
  parentPartTitle?: string | null;
  stockingCompanyName?: string | null;
};

export type partType =
  | "STOCK_ITEM"
  | "SERVICE_ITEM"
  | "KIT_ITEM"
  | "BOM_ITEM"
  | "GROUP_ITEM";

export const partType = {
  STOCK_ITEM: "STOCK_ITEM",
  SERVICE_ITEM: "SERVICE_ITEM",
  KIT_ITEM: "KIT_ITEM",
  BOM_ITEM: "BOM_ITEM",
  GROUP_ITEM: "GROUP_ITEM",
} as const;

export type pricingMethod = "QUANTITY" | "WEIGHT";

export const pricingMethod = {
  QUANTITY: "QUANTITY",
  WEIGHT: "WEIGHT",
} as const;

export type Packing_PackingInventoryDetail = {
  qty?: number;
  batchID?: number;
  batchDate?: Date | null;
  binLocation?: string | null;
  binType?: number;
  binPriority?: number;
};

export type PackingDocumentResponseData = {
  data?: Packing_PackingDocument;
};

export type PalletizeRequest = {
  packId: Array<number>;
  dimensions?: Dimensions;
  weight?: Weight;
  packDate?: Date | null;
};

export type PartDetails = {
  inventoryCount?: number;
  inventoryAvailable?: number;
  inventoryBlocked?: number;
  inventoryExpected?: number;
  inventoryReserved?: number;
  inventoryAvailableOtherWarehouses?: number;
  inventoryExpectedDetails?: string | null;
  binLocationA?: string | null;
  binLocationB?: string | null;
  binLocation?: string | null;
  binPriority?: number | null;
  itemExpectedDate?: Date | null;
  partId?: string;
  partTitle?: string | null;
  partCode?: string | null;
  partEAN?: string | null;
  partUPC?: string | null;
  partASIN?: string | null;
  partISBN?: string | null;
  partBrandName?: string | null;
  partCategoryName?: string | null;
  partDepartmentName?: string | null;
  partImageS?: string | null;
  partImageL?: string | null;
  partImageM?: string | null;
  partImageO?: string | null;
  partMPN?: string | null;
  partType?:
    | ("STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM")
    | null;
  readonly itemTypeDescription?: string | null;
  pricingMethod?: ("QUANTITY" | "WEIGHT") | null;
  partNominalCode?: string | null;
  stockingWarehouseId?: string | null;
  partBuyingPrice?: number | null;
  partBuyingCurrency?: string | null;
  partBuyingPriceLCY?: number | null;
  parentPartId?: string | null;
  inventoryModelId?: number | null;
  inventoryModelName?: string | null;
  readonly isStockItem?: boolean;
  readonly isInventoryItem?: boolean;
  internalComments?: string | null;
  itemTags?: string | null;
  sellableItem?: boolean | null;
  purchasableItem?: boolean | null;
  isEOL?: boolean;
  docReference?: string | null;
  specifications?: {
    [key: string]: unknown;
  } | null;
  itemHsCode?: string | null;
  itemCOO?: string | null;
  itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
};

export type PasswordResetRequest = {
  host: string;
  captcha: string;
  password1: string;
  password2: string;
  resetToken: string;
};

export type PckActive = {
  id?: number;
  createdDate?: Date;
  workflow?: IdName;
  warehouse?: GuidIdName;
  assignedUser?: Array<IdName> | null;
  claimedUser?: IdName;
  claimedDate?: Date | null;
  totalOrdersCount?: number;
  pendingOrdersCount?: number;
};

export type PckActiveUnpagedListResults = {
  results?: Array<PckActive> | null;
};

export type PckCreateRequest = {
  documentId: Array<string>;
  binPriorityMin?: number | null;
  binPriorityMax?: number | null;
  multilineMode?: ("any" | "SINGLE_LINE" | "MULTI_LINE") | null;
  assignedUser?: Array<number> | null;
  overwriteInPck?: boolean | null;
  maxOrdersPerPck?: number | null;
  description?: string | null;
  zoneIdPreference?: number | null;
};

export type multilineMode = "any" | "SINGLE_LINE" | "MULTI_LINE";

export const multilineMode = {
  ANY: "any",
  SINGLE_LINE: "SINGLE_LINE",
  MULTI_LINE: "MULTI_LINE",
} as const;

export type PckMergeRequest = {
  documentId: Array<number>;
};

export type PckScheduledAssignRequest = {
  pckId?: number | null;
  lineId: Array<number>;
};

export type PckScheduledUpsertRequest = {
  description?: string | null;
  warehouseId: string;
  schedule: Date;
  assignedUser?: Array<number> | null;
  assignments?: Array<number> | null;
};

export type PendingInboundDocument = {
  documentType?: string | null;
  documentId?: string | null;
  supplierName?: string | null;
  documentDate?: Date | null;
  documentReference?: string | null;
  deliveryDue?: Date | null;
};

export type PickWorkflow = {
  id?: number;
  name?: string | null;
  queue?: IdName;
  binPriorityMin?: number | null;
  binPriorityMax?: number | null;
  multilineMode?: "any" | "SINGLE_LINE" | "MULTI_LINE";
  runAtHour?: Array<string> | null;
  runAtDays?: Array<
    | "Sunday"
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
  > | null;
  assignedUser?: Array<IdName> | null;
  overwriteInPck?: boolean;
  maxOrdersPerPck?: number | null;
  mergeDispatchWarehouse?: GuidIdName;
  pckMode?: number | null;
  continuousPck?: boolean;
  groupOrdersToTote?: boolean;
};

export type PickWorkflowUnpagedListResults = {
  results?: Array<PickWorkflow> | null;
};

export type PickWorkflowUpsert = {
  name: string;
  queueId: number;
  binPriorityMin?: number | null;
  binPriorityMax?: number | null;
  multilineMode?: ("any" | "SINGLE_LINE" | "MULTI_LINE") | null;
  runAtHour?: Array<string> | null;
  runAtDays?: Array<
    | "Sunday"
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
  > | null;
  assignedUser?: Array<number> | null;
  overwriteInPck?: boolean | null;
  maxOrdersPerPck?: number | null;
  mergeDispatchWarehouse?: string | null;
  pckMode?: number | null;
  continuousPck?: boolean | null;
  groupOrdersToTote?: boolean | null;
};

export type PimCompleteness = {
  id: number;
  name: string;
  imageTags?: Array<IdName> | null;
  specs?: Array<IdName> | null;
};

export type PimCompletenessUnpagedListResults = {
  results?: Array<PimCompleteness> | null;
};

export type PimCompletenessUpsert = {
  name: string;
  imageTags?: Array<number> | null;
  specs: Array<number>;
};

export type Pipeline = {
  id: number;
  name: string;
  type?: string | null;
  direction?: "OUTBOUND" | "INBOUND";
  triggerMinute?: Array<string> | null;
  triggerHour?: Array<string> | null;
  triggerDelay?: number | null;
  lastOperation?: PipelineLastOperation;
};

export type direction = "OUTBOUND" | "INBOUND";

export const direction = {
  OUTBOUND: "OUTBOUND",
  INBOUND: "INBOUND",
} as const;

export type PipelineActivity = {
  id: number;
  startTime: Date;
  completeTime?: Date | null;
  status?: string | null;
  details?: string | null;
  hasLogItems: boolean;
};

export type PipelineActivityLog = {
  timestamp?: Date;
  level?: string | null;
  message?: string | null;
};

export type PipelineActivityLogUnpagedListResults = {
  results?: Array<PipelineActivityLog> | null;
};

export type PipelineActivityUnpagedListResults = {
  results?: Array<PipelineActivity> | null;
};

export type PipelineConfiguration = {
  fields?: Array<PipelineFieldItem> | null;
  configuration?: ConfigurationObject;
  direction?: "OUTBOUND" | "INBOUND";
};

export type PipelineDetails = {
  id: number;
  name: string;
  type?: string | null;
  direction?: "OUTBOUND" | "INBOUND";
  triggerMinute?: Array<string> | null;
  triggerHour?: Array<string> | null;
  triggerDelay?: number | null;
  lastOperation?: PipelineLastOperation;
  formatConfig?: PipelineFormatConfig;
  fileConfig?: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: unknown;
};

export type PipelineDetailsResponseData = {
  data?: PipelineDetails;
};

export type PipelineEndpoint = {
  uri?: string | null;
};

export type PipelineEndpointResponseData = {
  data?: PipelineEndpoint;
};

export type PipelineFieldItem = {
  fieldName?: string | null;
  displayName?: string | null;
  help?: string | null;
  dateType?: string | null;
  isCustom?: boolean;
};

export type PipelineFileConfig = {
  outputFileName?: string | null;
  inputFilePattern?: string | null;
  inputFilePatternMode?: ("ALL" | "NEWEST" | "OLDEST") | null;
  ignoreReadErrors?: boolean | null;
  processCompleteAction?: "KEEP" | "DELETE" | "MOVE";
};

export type inputFilePatternMode = "ALL" | "NEWEST" | "OLDEST";

export const inputFilePatternMode = {
  ALL: "ALL",
  NEWEST: "NEWEST",
  OLDEST: "OLDEST",
} as const;

export type processCompleteAction = "KEEP" | "DELETE" | "MOVE";

export const processCompleteAction = {
  KEEP: "KEEP",
  DELETE: "DELETE",
  MOVE: "MOVE",
} as const;

export type PipelineFormatConfig = {
  mapping?: Array<FieldMappingConfig> | null;
  headless?: boolean;
  format?: "CSV" | "TSV" | "JSON" | "XML" | "XLSX";
  culture?: string | null;
  csvDelimiter?: string | null;
};

export type format = "CSV" | "TSV" | "JSON" | "XML" | "XLSX";

export const format = {
  CSV: "CSV",
  TSV: "TSV",
  JSON: "JSON",
  XML: "XML",
  XLSX: "XLSX",
} as const;

export type PipelineLastOperation = {
  status?: "SUCCESSFUL" | "FAILED" | "WARNING";
  message?: string | null;
  date?: Date;
};

export type status5 = "SUCCESSFUL" | "FAILED" | "WARNING";

export const status5 = {
  SUCCESSFUL: "SUCCESSFUL",
  FAILED: "FAILED",
  WARNING: "WARNING",
} as const;

export type PipelinesConfigurationResponse = {
  inbound?: {
    [key: string]: PipelineConfiguration;
  } | null;
  outbound?: {
    [key: string]: PipelineConfiguration;
  } | null;
  hostedStorage?: boolean;
};

export type PipelinesConfigurationResponseResponseData = {
  data?: PipelinesConfigurationResponse;
};

export type PipelineUnpagedListResults = {
  results?: Array<Pipeline> | null;
};

export type PipelineUpsert = {
  formatConfig: PipelineFormatConfig;
  fileConfig: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: Array<ConfigurationParameter> | null;
  name: string;
  type: string;
  direction: "OUTBOUND" | "INBOUND";
  triggerMinute?: Array<string> | null;
  triggerHour?: Array<string> | null;
  triggerDelay?: number | null;
};

export type PortalAccountDetails = {
  balance?: number;
};

export type PortalAccountDetailsResponseDataResponse = {
  data: PortalAccountDetails;
};

export type PortalAccountInvoice = {
  invoiceId?: string | null;
  invoiceDate?: Date;
  invoiceTotal?: number;
};

export type PortalAccountInvoiceUnpagedListResults = {
  results?: Array<PortalAccountInvoice> | null;
};

export type PortalAccountOrder = {
  soId?: string | null;
  readonly id?: string | null;
  readonly so?: string | null;
  orderDate?: Date;
  orderStatus?: string | null;
};

export type PortalAccountOrderUnpagedListResults = {
  results?: Array<PortalAccountOrder> | null;
};

export type PortalAccountSettings = {
  stockStatus?: boolean;
  placeOrders?: boolean;
  displayPrices?: boolean;
  disableAddAddress?: boolean;
  disableDueDate?: boolean;
  displayItemSpecs?: boolean;
  categoryFilterType?: string | null;
  disableOosItems?: boolean;
  splitUomPrice?: boolean;
  dateFormat?: string | null;
};

export type PortalAddress = {
  name?: string | null;
  attention?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  phone?: string | null;
  email?: string | null;
};

export type PortalBasketAddress = {
  addressId?: string;
  address?: string | null;
  isDefault?: boolean;
};

export type PortalBasketItem = {
  entryId?: number;
  itemId?: string;
  uomId?: number | null;
  qty?: number;
  itemSKU?: string | null;
  itemTitle?: string | null;
  imageUrl?: string | null;
  sellPrice?: number | null;
  isEstimated?: boolean;
  discount?: number;
  lineTotal?: number;
  lineDiscount?: number;
  uomName?: string | null;
  uomWeight?: number;
  pricingMethod?: number;
  availableStock?: number;
};

export type PortalBasketItemRequest = {
  itemId: string;
  qty?: number;
  uomId?: number | null;
};

export type PortalBasketItemResponse = {
  updatedQty?: number;
  basket?: BasketSummary;
};

export type PortalBasketItemResponseResponseDataResponse = {
  data: PortalBasketItemResponse;
};

export type PortalBasketResponse = {
  items?: Array<PortalBasketItem> | null;
  basketTotals?: PortalBasketTotals;
  address?: Array<PortalBasketAddress> | null;
};

export type PortalBasketResponseResponseDataResponse = {
  data: PortalBasketResponse;
};

export type PortalBasketTotals = {
  subtotal?: number;
  discounts?: number;
  taxes?: number;
  total?: number;
};

export type PortalCatalogAppCategory = {
  id?: number;
  parentId?: number | null;
  name?: string | null;
  imageUrl?: string | null;
  hasSubItems?: boolean;
};

export type PortalCatalogCurrency = {
  code?: string | null;
  symbol?: string | null;
};

export type PortalCatalogFilter = {
  name?: string | null;
  imageUrl?: string | null;
};

export type PortalCatalogItem = {
  positionId?: number;
  itemId?: string;
  parentItemId?: string | null;
  itemSKU?: string | null;
  itemTitle?: string | null;
  itemBrandName?: string | null;
  itemDepartmentName?: string | null;
  itemCategoryName?: string | null;
  itemEan?: string | null;
  itemUpc?: string | null;
  sellPrice?: number;
  isPromotion?: boolean;
  isClearance?: boolean;
  wasPrice?: number | null;
  vatRat?: number;
  rrp?: number;
  pricingMethod?: number;
  availableStock?: number | null;
  discount?: number | null;
  uomName?: string | null;
  uomId?: number;
  isMarkedNew?: boolean;
  inStock?: boolean;
  shelfQty?: number;
  uomVolume?: string | null;
  uomWeight?: string | null;
  isFrequent?: boolean;
  frequentQty?: number;
  qtyInBasket?: number;
  leadTime?: Date | null;
  isParent?: boolean;
  appCatId?: number;
  parentAppCatId?: number;
  tags?: Array<string> | null;
  itemImages?: Array<string> | null;
  subItems?: Array<PortalCatalogItem> | null;
  promos?: Array<PortalCatalogPromo> | null;
  uoms?: Array<PortalCatalogUom> | null;
};

export type PortalCatalogItemUnpagedListResults = {
  results?: Array<PortalCatalogItem> | null;
};

export type PortalCatalogPromo = {
  qty?: number;
  endDate?: Date | null;
  price?: number;
  discount?: number | null;
  description?: string | null;
};

export type PortalCatalogResponse = {
  currency?: PortalCatalogCurrency;
  items?: Array<PortalCatalogItem> | null;
  brands?: Array<PortalCatalogFilter> | null;
  departments?: Array<PortalCatalogFilter> | null;
  categories?: Array<PortalCatalogFilter> | null;
  appCategories?: Array<PortalCatalogAppCategory> | null;
  tags?: Array<string> | null;
  catalogComplete?: boolean;
};

export type PortalCatalogResponseResponseDataResponse = {
  data: PortalCatalogResponse;
};

export type PortalCatalogUom = {
  id?: number;
  name?: string | null;
  shelfQty?: number;
  price?: number;
  discount?: number | null;
  ratio?: string | null;
  wasPrice?: number | null;
};

export type PortalChckoutRequest = {
  /**
   * Due Date, Optional, when null default due date is used
   */
  dueDate?: Date | null;
  /**
   * Customer order instructions
   */
  instructions?: string | null;
  /**
   * When using address from list, supplier existing addressId
   */
  addressId?: string | null;
  /**
   * Customer order reference
   */
  reference?: string | null;
  address?: PortalAddress;
};

export type PortalCheckoutResponse = {
  soId?: string | null;
  success?: boolean;
};

export type PortalCheckoutResponseResponseDataResponse = {
  data: PortalCheckoutResponse;
};

export type PortalForgotPasswordRequest = {
  email: string;
  captcha: string;
  host: string;
};

export type PostcodeLookupRequest = {
  postcode: string;
};

export type Price = {
  each?: (number | string) | null;
  discount?: (number | string) | null;
  discountFixed?: boolean;
};

export type PriceCurrency = {
  each?: number | null;
  discount?: number | null;
  discountFixed?: boolean;
  currency?: string | null;
};

export type Pricelist = {
  id: string;
  name: string;
  currency: string;
  isDefault: boolean;
  targetMargin?: number | null;
  discount?: number | null;
  priceFlattened: boolean;
  parent?: GuidIdName;
  isParent: boolean;
};

export type PricelistConditionalUpsert = {
  /**
   * Item Identifier, SKU, EAN, UPC etc
   */
  item?: string | null;
  minimum?: string | null;
  autoApply?: string | null;
  preventDiscount?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  price?: string | null;
  discount?: string | null;
  description?: string | null;
};

export type PricelistConditionalUpsertPricelistUpsert = {
  items: Array<PricelistConditionalUpsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
  pricelists?: Array<string> | null;
};

export type PricelistEntryConditional = {
  minimumQty?: number | null;
  autoApply?: boolean;
  startDate?: Date | null;
  endDate?: Date | null;
  price?: number | null;
  discount?: number | null;
  discountFixed?: boolean | null;
  description?: string | null;
  updatedAt?: Date | null;
};

export type PricelistEntryPerItem = {
  price?: number | null;
  rrp?: number | null;
  pricelistReference?: string | null;
  pricelistEan?: string | null;
  targetMargin?: number | null;
  discount?: number | null;
  updatedAt?: Date | null;
  prevPrice?: number | null;
  prevDiscount?: number | null;
  conditionalPricing?: Array<PricelistEntryConditional> | null;
  uomPricing?: Array<PricelistUomEntry> | null;
  pricelist?: GuidIdName;
};

export type PricelistEntryPerItemUnpagedListResults = {
  results?: Array<PricelistEntryPerItem> | null;
};

export type PricelistEntryUpsert = {
  /**
   * Item Identifier, SKU, EAN, UPC etc
   */
  item?: string | null;
  /**
   * Pricelist name, required if payload pricelistId is undefined
   */
  pricelist?: string | null;
  price?: string | null;
  description?: string | null;
  reference?: string | null;
  rrp?: string | null;
  discount?: string | null;
  pricelist_ean?: string | null;
  target_pm?: string | null;
  target_price?: string | null;
};

export type PricelistEntryUpsertPricelistBulkUpsert = {
  items: Array<PricelistEntryUpsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
  pricelists?: Array<string> | null;
};

export type PricelistExportRequest = {
  type: "entries" | "conditionals" | "uoms";
};

export type type9 = "entries" | "conditionals" | "uoms";

export const type9 = {
  ENTRIES: "entries",
  CONDITIONALS: "conditionals",
  UOMS: "uoms",
} as const;

export type PricelistUnpagedListResults = {
  results?: Array<Pricelist> | null;
};

export type PricelistUomEntry = {
  uomId?: number;
  uomName?: string | null;
  price?: number | null;
  updatedAt?: Date | null;
};

export type PricelistUomUpsert = {
  /**
   * Item Identifier, SKU, EAN, UPC etc
   */
  item?: string | null;
  price?: string | null;
  reference?: string | null;
  uom?: string | null;
};

export type PricelistUomUpsertPricelistUpsert = {
  items: Array<PricelistUomUpsert>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
  pricelists?: Array<string> | null;
};

export type PricelistUpsert = {
  name: string;
  id?: string | null;
  currency: string;
  targetMargin?: number | null;
  discount?: number | null;
  priceFlattened?: boolean;
  parentId?: string | null;
};

export type PriceTaxedLcy = {
  price?: number | null;
  tax?: number | null;
  readonly total?: number | null;
  lcy?: number;
};

export type PrintQueueInfoEntity = {
  id?: number;
  name?: string | null;
  pendingJobs?: number;
  renderConfig?: PrintQueueRenderConfig;
  accessToken?: string | null;
};

export type PrintQueueInfoEntityUnpagedListResults = {
  results?: Array<PrintQueueInfoEntity> | null;
};

export type PrintQueueRenderConfig = {
  labelRender?: ("NONE" | "IMAGE" | "PDF") | null;
};

export type labelRender = "NONE" | "IMAGE" | "PDF";

export const labelRender = {
  NONE: "NONE",
  IMAGE: "IMAGE",
  PDF: "PDF",
} as const;

export type PrintQueueUpsert = {
  name: string;
  renderConfig?: PrintQueueRenderConfig;
};

export type PrintStationAccess = {
  configuration?: PrintStationConfiguration;
};

export type PrintStationAccessResponseData = {
  data?: PrintStationAccess;
};

export type PrintStationConfiguration = {
  name?: string | null;
  accessKey?: string | null;
  entityName?: string | null;
};

export type ProductIdentifier = {
  identifier?: string | null;
  uom?: number;
  inputType?: number;
  multiplied?: number;
};

export type ProfitRatingEntity = {
  id?: number;
  name?: string | null;
  starting?: number;
  color?: string | null;
  requiresElevation?: boolean;
};

export type ProfitRatingEntityUnpagedListResults = {
  results?: Array<ProfitRatingEntity> | null;
};

export type ProfitRatingUpsert = {
  name: string;
  starting: number;
  color?: string | null;
  requiresElevation?: boolean;
};

export type PurchaseOrderDocument = {
  header?: PurchaseOrderDocumentHeader;
  lines?: Array<PurchaseOrderDocumentLine> | null;
  summary?: DocumentValueSummary;
};

export type PurchaseOrderDocumentHeader = {
  id?: string | null;
  isCredit?: boolean;
  contact?: DocumentContactDetails;
  date?: Date;
  warehouse?: GuidIdName;
  currency?: CurrencyRate;
  documentReference?: string | null;
  deliveryDate?: Date | null;
  document?: DocumentProperties;
  customFields?: Array<DocumentCustomFieldValue> | null;
};

export type PurchaseOrderDocumentLine = {
  id?: number;
  item?: DocumentItemInfoInventory;
  uom?: IdName;
  description?: string | null;
  lineReference?: string | null;
  qtyRequested?: number;
  qtyConfirmed?: number;
  qtyReceived?: number;
  qtyBilled?: number;
  price?: DocumentLinePrice;
  subtotal?: DocumentLineSubtotal;
};

export type PurchaseOrderDocumentResponseData = {
  data?: PurchaseOrderDocument;
};

export type PusherConfig = {
  appId?: string | null;
  key?: string | null;
  cluster?: string | null;
};

export type QueuedMessage = {
  id?: number;
  userId?: number | null;
  user?: IdNameEntity;
  type: "Email";
  status: "Pending" | "Sent" | "Read" | "Failed";
  sendMethod: "Manual" | "Automatic";
  createdDate: Date;
  updatedDate: Date;
  attachments?: number;
  details?: string | null;
  document?: string | null;
  subject?: string | null;
  dismissed?: boolean | null;
  recipients?: Array<QueuedMessageRecipient> | null;
};

export type type10 = "Email";

export const type10 = {
  EMAIL: "Email",
} as const;

export type status6 = "Pending" | "Sent" | "Read" | "Failed";

export const status6 = {
  PENDING: "Pending",
  SENT: "Sent",
  READ: "Read",
  FAILED: "Failed",
} as const;

export type sendMethod = "Manual" | "Automatic";

export const sendMethod = {
  MANUAL: "Manual",
  AUTOMATIC: "Automatic",
} as const;

export type QueuedMessageAttachment = {
  fileName?: string | null;
  url?: string | null;
};

export type QueuedMessageBody = {
  subject?: string | null;
  body?: string | null;
  emailSender?: string | null;
  attachments?: Array<QueuedMessageAttachment> | null;
};

export type QueuedMessageBodyResponseData = {
  data?: QueuedMessageBody;
};

export type QueuedMessageListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<QueuedMessage> | null;
  readonly mightHaveMore: boolean;
};

export type QueuedMessageRecipient = {
  name?: string | null;
  address?: string | null;
  recipientType: "To" | "Bcc";
};

export type recipientType = "To" | "Bcc";

export const recipientType = {
  TO: "To",
  BCC: "Bcc",
} as const;

export type RctCost = {
  cost?: MoneyCurrencyRate;
  currencyCost?: number | null;
  billId?: number | null;
  name?: string | null;
};

export type RctDetail = {
  id?: number;
  item?: DocumentItemInfo;
  uomId?: number;
  quantity?: number;
  price?: Price;
  landedPrice?: number | null;
  totalWeight?: number | null;
  additionalCost?: Price;
};

export type RctDocument = {
  header?: RctDocumentHeader;
  lines?: Array<RctDetail> | null;
  costs?: Array<RctCost> | null;
};

export type RctDocumentHeader = {
  id?: number;
  date?: Date | null;
  documentType?: string | null;
  documentId?: string | null;
  warehouse?: GuidIdName;
  currency?: string | null;
  currencyRate?: number | null;
  documentReferenceType?: ("DELIVERY_NOTE" | "INVOICE") | null;
  documentReference?: string | null;
  exportPending?: boolean;
  exported?: boolean;
};

export type RctDocumentUnpagedListResults = {
  results?: Array<RctDocument> | null;
};

export type RctEmbeddedExpenseType = {
  id: number;
  name: string;
  enabled?: boolean;
  expenseMethod?: "Quantity" | "Value" | "Weight" | "Volume" | "Custom";
  linkedItem?: ItemBase;
};

export type expenseMethod =
  | "Quantity"
  | "Value"
  | "Weight"
  | "Volume"
  | "Custom";

export const expenseMethod = {
  QUANTITY: "Quantity",
  VALUE: "Value",
  WEIGHT: "Weight",
  VOLUME: "Volume",
  CUSTOM: "Custom",
} as const;

export type RctEmbeddedExpenseTypeUnpagedListResults = {
  results?: Array<RctEmbeddedExpenseType> | null;
};

export type RctEmbeddedExpenseTypeUpsert = {
  name: string;
  enabled: boolean;
  expenseMethod: "Quantity" | "Value" | "Weight" | "Volume" | "Custom";
  linkedItemId?: string | null;
};

export type ReceiveResponse = {
  rctId?: Array<number> | null;
};

export type ReportPeriodEntity = {
  id?: number;
  name?: string | null;
  start?: Date;
  end?: Date;
};

export type ReportPeriodUpsert = {
  name: string;
  start: Date;
  end: Date;
};

export type ReportRequest = {
  type: string;
  parameters?: Array<ConfigurationParameter> | null;
};

export type ReportResult = {
  report: ConfigurationRequest;
  schema: Array<ReportResultSchema>;
  renderType: "TABLE" | "FORECAST";
  records: Array<{
    [key: string]: unknown;
  }>;
  helpers?: {
    [key: string]: unknown;
  } | null;
  generatePo?: ReportResultGeneratePoFields;
};

export type renderType = "TABLE" | "FORECAST";

export const renderType = {
  TABLE: "TABLE",
  FORECAST: "FORECAST",
} as const;

export type ReportResultGeneratePoFields = {
  quantity: string;
  uomId?: string | null;
};

export type ReportResultResponseData = {
  data?: ReportResult;
};

export type ReportResultSchema = {
  field: string;
  type:
    | "TEXT"
    | "SKU"
    | "MONEY"
    | "INVENTORY"
    | "DATE"
    | "DATE_TIME"
    | "DATE_AGO"
    | "INVENTORY_DRILLDOWN"
    | "ATTENTION";
  summary: "COUNT" | "SUM" | "AVG";
  headers?: Array<string> | null;
  readonly headerName: string;
  exportOnly?: boolean;
};

export type type11 =
  | "TEXT"
  | "SKU"
  | "MONEY"
  | "INVENTORY"
  | "DATE"
  | "DATE_TIME"
  | "DATE_AGO"
  | "INVENTORY_DRILLDOWN"
  | "ATTENTION";

export const type11 = {
  TEXT: "TEXT",
  SKU: "SKU",
  MONEY: "MONEY",
  INVENTORY: "INVENTORY",
  DATE: "DATE",
  DATE_TIME: "DATE_TIME",
  DATE_AGO: "DATE_AGO",
  INVENTORY_DRILLDOWN: "INVENTORY_DRILLDOWN",
  ATTENTION: "ATTENTION",
} as const;

export type summary = "COUNT" | "SUM" | "AVG";

export const summary = {
  COUNT: "COUNT",
  SUM: "SUM",
  AVG: "AVG",
} as const;

export type ReportScheduleCreate = {
  ownerId?: number | null;
  isActive: boolean;
  name: string;
  cron: string;
  report: ConfigurationRequest;
  emailAddress: string;
  removeColumns?: Array<string> | null;
};

export type ReportScheduleEntity = {
  id: string;
  owner?: IdName;
  isActive?: boolean;
  name?: string | null;
  cron?: string | null;
  cronExpression?: string | null;
  nextOccurring?: Date | null;
  reportType?: string | null;
  emailAddress: string;
  removeColumns?: Array<string> | null;
};

export type ReportScheduleEntityResponseData = {
  data?: ReportScheduleEntity;
};

export type ReportScheduleEntityUnpagedListResults = {
  results?: Array<ReportScheduleEntity> | null;
};

export type ReportScheduleUpdate = {
  ownerId?: number | null;
  isActive: boolean;
  name: string;
  cron: string;
  emailAddress: string;
  removeColumns?: Array<string> | null;
};

export type ReportTemplateBase = {
  id: number;
  name: string;
  reportType: string;
  useHeaders?: boolean;
  versionId?: number;
  isDefault?: boolean;
  reportTokenId?: string | null;
  versionCount?: number;
  url?: string | null;
};

export type ReportTemplateBaseUnpagedListResults = {
  results?: Array<ReportTemplateBase> | null;
};

export type ReportTemplateUpload = {
  user?: string | null;
  created?: Date;
  url: string;
};

export type ReportTemplateUploadUnpagedListResults = {
  results?: Array<ReportTemplateUpload> | null;
};

export type ReportTypeConfiguration = {
  type?: string | null;
  name?: string | null;
  description?: string | null;
  readonly parameters?: Array<ConfigurationProperty> | null;
  attributes?: Array<string> | null;
  readonly sections?: Array<ConfigurationSection> | null;
  reportClass?: "inventory" | "sales" | "other";
  filter?: ReportTypeFilter;
};

export type reportClass = "inventory" | "sales" | "other";

export const reportClass = {
  INVENTORY: "inventory",
  SALES: "sales",
  OTHER: "other",
} as const;

export type ReportTypeConfigurationUnpagedListResults = {
  results?: Array<ReportTypeConfiguration> | null;
};

export type ReportTypeFilter = {
  filterItems?: boolean;
  filterSales?: boolean;
  filterItemSpecs?: boolean;
};

export type SalesOrderAttachDraftShipmentRequest = {
  carrierId: number;
  /**
   * Used when label failed to create, when this is in use, anything related to label (Like carrierReference, labelContent etc) is ignored
   */
  errorMessage?: string | null;
  /**
   * Overwrite existing label for order, if this is set to false (default) and SO already has a draft shipment, HTTP response will be 400
   */
  overwrite?: boolean;
  /**
   * Contains a unique carrier tracking number for this shipment
   */
  carrierReference: string;
  /**
   * Optional, Contains a unique carrier Consignment Id for this shipment
   */
  shipmentConsignmentId?: string | null;
  /**
   * base64 containing the label
   */
  labelContent: string;
  labelType: "pdf" | "png" | "jpg" | "zpl";
  shipmentCost?: Money;
  eta?: Date | null;
  requireManifesting?: boolean;
};

export type labelType = "pdf" | "png" | "jpg" | "zpl";

export const labelType = {
  PDF: "pdf",
  PNG: "png",
  JPG: "jpg",
  ZPL: "zpl",
} as const;

export type SalesOrderCreateDraftShipmentRequest = {
  /**
   * If true, the API will wait for the shipment to be created before returning a response
   */
  wait?: boolean;
  carrierId?: number | null;
  omitNotes?: boolean;
};

export type SalesOrderCreateRequest = {
  contact: string;
  warehouse?: string | null;
  date?: Date | null;
  currency?: CurrencyRate;
  documentReference?: string | null;
  confirm?: boolean;
  credit?: boolean;
  billing?: DocumentAddress;
  shipping?: DocumentAddress;
  lines?: Array<CreateSalesOrderRequestLine> | null;
  deliveryStart?: Date | null;
  dueDate?: Date | null;
  uniqueImportReference?: string | null;
  salesRep?: string | null;
  userPin?: string | null;
  posMode?: boolean;
};

export type SalesOrderDocument = {
  header?: SalesOrderDocumentHeader;
  lines?: Array<SalesOrderDocumentLine> | null;
  summary?: DocumentValueSummary;
  packages?: Array<Packing_Package> | null;
};

export type SalesOrderDocumentCarrier = {
  assigned?: IdName;
  shipment?: SalesOrderDocumentDraftShipment;
  packageTemplate?: IdName;
};

export type SalesOrderDocumentDispatch = {
  dispatchDate?: Date | null;
  dueDate?: Date | null;
  mode?: ("Split" | "Complete") | null;
  pickingMode?: ("Strict" | "Sibling" | "SiblingBrand") | null;
  mergedInto?: string | null;
  mergingFrom?: Array<string> | null;
  progress?: number | null;
  enabled?: boolean;
};

export type mode2 = "Split" | "Complete";

export const mode2 = {
  SPLIT: "Split",
  COMPLETE: "Complete",
} as const;

export type pickingMode = "Strict" | "Sibling" | "SiblingBrand";

export const pickingMode = {
  STRICT: "Strict",
  SIBLING: "Sibling",
  SIBLING_BRAND: "SiblingBrand",
} as const;

export type SalesOrderDocumentDraftShipment = {
  id?: number | null;
  labelUrl?: string | null;
  errorMessage?: string | null;
};

export type SalesOrderDocumentFlags = {
  isPosMode?: boolean;
  isParked?: boolean;
  isConsignment?: boolean;
  isBackOrder?: boolean;
  isFinalized?: boolean;
  isResend?: boolean;
  isResent?: boolean;
  isMasked?: boolean;
  isPrinted?: boolean;
};

export type SalesOrderDocumentHeader = {
  id?: string | null;
  isCredit?: boolean;
  status: "Draft" | "Confirmed" | "Canceled";
  contact?: DocumentContactDetails;
  date?: Date;
  warehouse?: GuidIdName;
  currency?: CurrencyRate;
  documentReference?: string | null;
  taxNumber?: string | null;
  taxGroup?: GuidIdName;
  dispatch: SalesOrderDocumentDispatch;
  salesRep?: GuidIdName;
  document?: DocumentProperties;
  flags: SalesOrderDocumentFlags;
  carrier?: SalesOrderDocumentCarrier;
  billingAddress?: DocumentAddress;
  shippingAddress?: DocumentAddress;
  customFields?: Array<DocumentCustomFieldValue> | null;
};

export type status7 = "Draft" | "Confirmed" | "Canceled";

export const status7 = {
  DRAFT: "Draft",
  CONFIRMED: "Confirmed",
  CANCELED: "Canceled",
} as const;

export type SalesOrderDocumentLine = {
  id?: number;
  item?: DocumentItemInfoInventory;
  uom?: IdName;
  description?: string | null;
  lineReference?: string | null;
  batch?: ItemBatchInfo;
  parentId?: number | null;
  salesRep?: GuidIdName;
  qtyRequested?: number;
  qtyConfirmed?: number;
  qtyPacked?: number;
  qtyInvoiced?: number;
  qtyReturned?: number | null;
  qtyCredited?: number | null;
  priceExpected?: DocumentLinePriceExpected;
  price?: DocumentLinePrice;
  subtotal?: DocumentLineSubtotal;
};

export type SalesOrderDocumentResponseData = {
  data?: SalesOrderDocument;
};

export type SalesOrderListResult = {
  contact?: DocumentContactInfo;
  document?: DocumentProperties;
  customFields?: Array<DocumentCustomFieldValue> | null;
  id: string;
  isCredit?: boolean;
  warehouseName?: string | null;
  date: Date;
  generatedDate: Date;
  flags?: SalesOrderDocumentFlags;
  carrier?: SalesOrderDocumentCarrier;
  currency: string;
  totals: DocumentValueSummary;
  status?: "Draft" | "Confirmed" | "Canceled";
  packingStage?: "Pending" | "Partially" | "Complete";
  packingPendingStage?: "Pending" | "Partially" | "Complete";
  invoiceStage?: "Pending" | "Partially" | "Complete";
  reference?: string | null;
  dispatchStart?: Date;
  dispatchDue?: Date;
  dispatchDueTime?: Date | null;
  deliveryStatus?:
    | (
        | "PENDING_PICKUP"
        | "IN_TRANSIT"
        | "DELIVERED"
        | "EXCEPTION"
        | "UNKNOWN"
        | "DRAFT"
      )
    | null;
  hasPickingNotes?: boolean;
  pckId?: number | null;
  externalFulfilmentStatus?:
    | ("Pending" | "Partially" | "Complete" | "Exception")
    | null;
  paymentStatus?: ("Draft" | "Confirmed" | "Canceled") | null;
  mergedInto?: string | null;
  itemsDue?: number;
};

export type packingStage = "Pending" | "Partially" | "Complete";

export const packingStage = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
} as const;

export type packingPendingStage = "Pending" | "Partially" | "Complete";

export const packingPendingStage = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
} as const;

export type invoiceStage = "Pending" | "Partially" | "Complete";

export const invoiceStage = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
} as const;

export type deliveryStatus =
  | "PENDING_PICKUP"
  | "IN_TRANSIT"
  | "DELIVERED"
  | "EXCEPTION"
  | "UNKNOWN"
  | "DRAFT";

export const deliveryStatus = {
  PENDING_PICKUP: "PENDING_PICKUP",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  UNKNOWN: "UNKNOWN",
  DRAFT: "DRAFT",
} as const;

export type externalFulfilmentStatus =
  | "Pending"
  | "Partially"
  | "Complete"
  | "Exception";

export const externalFulfilmentStatus = {
  PENDING: "Pending",
  PARTIALLY: "Partially",
  COMPLETE: "Complete",
  EXCEPTION: "Exception",
} as const;

export type paymentStatus = "Draft" | "Confirmed" | "Canceled";

export const paymentStatus = {
  DRAFT: "Draft",
  CONFIRMED: "Confirmed",
  CANCELED: "Canceled",
} as const;

export type SalesOrderListResultCursorListResults = {
  results?: Array<SalesOrderListResult> | null;
  nextCursor?: string | null;
};

export type SalesOrderMergeRequest = {
  intoDocumentId: string;
  fromDocumentIds: Array<string>;
};

export type SalesOrderMergeSuggestion = {
  contact?: ContactLookup;
  document?: EntityDocumentType;
  documents: Array<EntityDocumentType>;
  address: DocumentAddress;
};

export type SalesOrderMergeSuggestionUnpagedListResults = {
  results?: Array<SalesOrderMergeSuggestion> | null;
};

export type SalesOrderReturnReason = {
  id: number;
  name: string;
  hidden?: boolean;
};

export type SalesOrderReturnReasonUnpagedListResults = {
  results?: Array<SalesOrderReturnReason> | null;
};

export type SalesOrderReturnReasonUpsert = {
  name: string;
  hidden?: boolean;
};

export type SalesOverview = {
  results?: SalesOverviewSegment;
  previous?: SalesOverviewSegment;
};

export type SalesOverviewRanged = {
  results?: SalesOverviewSegment;
  previous?: SalesOverviewSegment;
  dateRanges?: DateRanges;
};

export type SalesOverviewRangedResponseData = {
  data?: SalesOverviewRanged;
};

export type SalesOverviewResponseData = {
  data?: SalesOverview;
};

export type SalesOverviewSegment = {
  salesValueNet?: number;
  salesValueGross?: number;
  orders?: number;
  itemsSold?: number;
  grossProfit?: number;
  grossProfitMarkup?: number;
  grossProfitMargin?: number;
};

export type SalesReportDrillDownQty = {
  readonly document?: string | null;
  documentType?: string | null;
  documentId?: string | null;
  date?: Date;
  isCredit?: boolean;
  contactName?: string | null;
  warehouseName?: string | null;
  grossPrice?: number;
  netPrice?: number;
  uomName?: string | null;
  isPromotion?: boolean;
  qty?: number;
};

export type SalesReportDrillDownQtyListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<SalesReportDrillDownQty> | null;
  readonly mightHaveMore: boolean;
};

export type SalesReportDrillDownQtySummary = {
  name?: string | null;
  qtySold?: number;
  qtyReturned?: number;
};

export type SalesReportDrillDownQtySummaryUnpagedListResults = {
  results?: Array<SalesReportDrillDownQtySummary> | null;
};

export type SalesReportDrillDownRequest = {
  limit?: number | null;
  offset?: number | null;
  startDate: Date;
  endDate: Date;
  parameters?: Array<ConfigurationParameter> | null;
};

export type SegmentDetails = {
  id?: number;
  segmentName: string;
  segmentCode: string;
  taxNumber?: string | null;
  eori?: string | null;
  currency?: string | null;
  isActive?: boolean;
  defaultItemCOO?: string | null;
  defaultItemHSCode?: string | null;
};

export type SegmentDetailsListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<SegmentDetails> | null;
  readonly mightHaveMore: boolean;
};

export type SegmentDetailsResponseData = {
  data?: SegmentDetails;
};

export type ShipmentDetail = {
  contact?: DocumentContactInfo;
  document?: DocumentProperties;
  customFields?: Array<DocumentCustomFieldValue> | null;
  id?: string | null;
  shipperName?: string | null;
  shipperScac?: string | null;
  containerNumber?: string | null;
  bolNumber?: string | null;
  shipmentReference?: string | null;
  loadingDate?: Date | null;
  orderedDate?: Date | null;
  departureDate?: Date | null;
  arrivalDate?: Date | null;
  containerType?: string | null;
  shpStatusName?: string | null;
  asns?: Array<AsnDetail> | null;
};

export type ShipmentDetailListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<ShipmentDetail> | null;
  readonly mightHaveMore: boolean;
};

export type ShipmentsImportItem = {
  document?: string | null;
  packages?: string | null;
  tracking?: string | null;
};

export type ShipmentsImportRequest = {
  items: Array<ShipmentsImportItem>;
  packagesMode?:
    | (
        | "existingPackagesOnly"
        | "createPackagesAndShipNewPackagesOnly"
        | "createPackagesIfRequiredAndShipNewPackagesAndExisting"
      )
    | null;
  preventLabelPrinting?: boolean;
};

export type packagesMode =
  | "existingPackagesOnly"
  | "createPackagesAndShipNewPackagesOnly"
  | "createPackagesIfRequiredAndShipNewPackagesAndExisting";

export const packagesMode = {
  EXISTING_PACKAGES_ONLY: "existingPackagesOnly",
  CREATE_PACKAGES_AND_SHIP_NEW_PACKAGES_ONLY:
    "createPackagesAndShipNewPackagesOnly",
  CREATE_PACKAGES_IF_REQUIRED_AND_SHIP_NEW_PACKAGES_AND_EXISTING:
    "createPackagesIfRequiredAndShipNewPackagesAndExisting",
} as const;

export type ShippingCarrier = {
  id: number;
  name: string;
  enabled?: boolean;
  service?: string | null;
  scac?: string | null;
  code?: string | null;
  autoGenerateLabel?: boolean;
  billingItem?: ItemBase;
  trackingUrlPattern?: string | null;
  standardEta?: number | null;
  dnt?: boolean;
  serviceCost?: Money;
  renderScript?: string | null;
  queueId?: number | null;
  configurationType?: string | null;
  readonly integrationId: string;
};

export type ShippingCarrierDetails = {
  carrier?: ShippingCarrier;
  configuration?: ConfigurationResponse;
};

export type ShippingCarrierDetailsResponseDataResponse = {
  data: ShippingCarrierDetails;
};

export type ShippingCarrierUnpagedListResults = {
  results?: Array<ShippingCarrier> | null;
};

export type ShippingCarrierUpsert = {
  name: string;
  enabled: boolean;
  service?: string | null;
  scac?: string | null;
  code?: string | null;
  autoGenerateLabel?: boolean | null;
  trackingUrlPattern?: string | null;
  standardEta?: number | null;
  cloneId?: number | null;
  dnt?: boolean | null;
  serviceCost?: Money;
  renderScript?: string | null;
  queueId?: number | null;
  insuranceAppId?: number | null;
  insuranceMandatory?: boolean | null;
  configuration?: ConfigurationRequest;
};

export type SmtpCustomDetails = {
  host: string;
  port: number;
  secure?: boolean;
  username: string;
  senderName: string;
  bcc?: string | null;
};

export type SmtpCustomUpsert = {
  name: string;
  senderAddress: string;
  host: string;
  port: number;
  secure?: boolean;
  username: string;
  password?: string | null;
  senderName: string;
  bcc?: string | null;
  rolesAccess?: Array<number> | null;
};

export type SmtpDetails = {
  id?: number;
  name?: string | null;
  type: "CUSTOM" | "OAUTH";
  rolesAccess?: Array<number> | null;
  customDetails?: SmtpCustomDetails;
  oauthDetails?: SmtpOauthDetails;
};

export type type12 = "CUSTOM" | "OAUTH";

export const type12 = {
  CUSTOM: "CUSTOM",
  OAUTH: "OAUTH",
} as const;

export type SmtpDetailsResponseDataResponse = {
  data: SmtpDetails;
};

export type SmtpListDetail = {
  id: number;
  name: string;
  type?: "CUSTOM" | "OAUTH";
  senderAddress?: string | null;
  ready?: boolean;
  readonly authorizeUrl?: string | null;
};

export type SmtpListDetailUnpagedListResults = {
  results?: Array<SmtpListDetail> | null;
};

export type SmtpOauthDetails = {
  oauthType?: "GOOGLE" | "OFFICE365";
  senderAddress: string;
};

export type oauthType = "GOOGLE" | "OFFICE365";

export const oauthType = {
  GOOGLE: "GOOGLE",
  OFFICE365: "OFFICE365",
} as const;

export type SmtpOauthUpsert = {
  name: string;
  oauthType?: "GOOGLE" | "OFFICE365";
  senderAddress: string;
  rolesAccess?: Array<number> | null;
};

export type SmtpTestRequest = {
  email: string;
};

export type SpApiFulfillmentInboundAddress = {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  companyName?: string | null;
  countryCode: string;
  email?: string | null;
  name: string;
  phoneNumber?: string | null;
  postalCode: string;
  stateOrProvinceCode?: string | null;
};

export type SpApiFulfillmentInboundAppointmentSlotTime = {
  endTime: Date;
  startTime: Date;
};

export type SpApiFulfillmentInboundBox = {
  boxId?: string | null;
  contentInformationSource?:
    | ("BOX_CONTENT_PROVIDED" | "MANUAL_PROCESS" | "BARCODE_2D")
    | null;
  destinationRegion?: SpApiFulfillmentInboundRegion;
  dimensions?: SpApiFulfillmentInboundDimensions;
  items?: Array<SpApiFulfillmentInboundItem> | null;
  packageId: string;
  quantity?: number | null;
  templateName?: string | null;
  weight?: SpApiFulfillmentInboundWeight;
};

export type contentInformationSource =
  | "BOX_CONTENT_PROVIDED"
  | "MANUAL_PROCESS"
  | "BARCODE_2D";

export const contentInformationSource = {
  BOX_CONTENT_PROVIDED: "BOX_CONTENT_PROVIDED",
  MANUAL_PROCESS: "MANUAL_PROCESS",
  BARCODE_2D: "BARCODE_2D",
} as const;

export type SpApiFulfillmentInboundCarrier = {
  alphaCode?: string | null;
  name?: string | null;
};

export type SpApiFulfillmentInboundCarrierAppointment = {
  endTime: Date;
  startTime: Date;
};

export type SpApiFulfillmentInboundConfirmTransportationOptionsRequest = {
  transportationSelections: Array<SpApiFulfillmentInboundTransportationSelection>;
};

export type SpApiFulfillmentInboundContactInformation = {
  email?: string | null;
  name: string;
  phoneNumber: string;
};

export type SpApiFulfillmentInboundCurrency = {
  amount?: number;
  code: string;
};

export type SpApiFulfillmentInboundDates = {
  readyToShipWindow?: SpApiFulfillmentInboundWindow;
};

export type SpApiFulfillmentInboundDimensions = {
  height?: number;
  length?: number;
  unitOfMeasurement: "IN" | "CM";
  width?: number;
};

export type unitOfMeasurement = "IN" | "CM";

export const unitOfMeasurement = {
  IN: "IN",
  CM: "CM",
} as const;

export type SpApiFulfillmentInboundFreightInformation = {
  declaredValue?: SpApiFulfillmentInboundCurrency;
  freightClass?: string | null;
};

export type SpApiFulfillmentInboundGenerateTransportationOptionsRequest = {
  placementOptionId: string;
  shipmentTransportationConfigurations: Array<SpApiFulfillmentInboundShipmentTransportationConfiguration>;
};

export type SpApiFulfillmentInboundItem = {
  asin: string;
  expiration?: string | null;
  fnsku: string;
  labelOwner: "AMAZON" | "SELLER" | "NONE";
  manufacturingLotCode?: string | null;
  msku: string;
  prepInstructions: Array<SpApiFulfillmentInboundPrepInstruction>;
  quantity?: number;
};

export type SpApiFulfillmentInboundLtlTrackingDetail = {
  billOfLadingNumber?: string | null;
  freightBillNumber?: Array<string> | null;
};

export type SpApiFulfillmentInboundPalletInput = {
  dimensions?: SpApiFulfillmentInboundDimensions;
  quantity?: number;
  stackability?: ("STACKABLE" | "NON_STACKABLE") | null;
  weight?: SpApiFulfillmentInboundWeight;
};

export type stackability = "STACKABLE" | "NON_STACKABLE";

export const stackability = {
  STACKABLE: "STACKABLE",
  NON_STACKABLE: "NON_STACKABLE",
} as const;

export type SpApiFulfillmentInboundPrepInstruction = {
  fee?: SpApiFulfillmentInboundCurrency;
  prepOwner?: string | null;
  prepType?: string | null;
};

export type SpApiFulfillmentInboundQuote = {
  cost: SpApiFulfillmentInboundCurrency;
  expiration?: Date | null;
  voidableUntil?: Date | null;
};

export type SpApiFulfillmentInboundRegion = {
  countryCode?: string | null;
  state?: string | null;
  warehouseId?: string | null;
};

export type SpApiFulfillmentInboundSelectedDeliveryWindow = {
  availabilityType: string;
  deliveryWindowOptionId: string;
  editableUntil?: Date | null;
  endDate: Date;
  startDate: Date;
};

export type SpApiFulfillmentInboundSelfShipAppointmentDetails = {
  appointmentId?: number | null;
  appointmentSlotTime?: SpApiFulfillmentInboundAppointmentSlotTime;
  appointmentStatus?: string | null;
};

export type SpApiFulfillmentInboundShipment = {
  amazonReferenceId?: string | null;
  contactInformation?: SpApiFulfillmentInboundContactInformation;
  dates?: SpApiFulfillmentInboundDates;
  destination: SpApiFulfillmentInboundShipmentDestination;
  freightInformation?: SpApiFulfillmentInboundFreightInformation;
  name?: string | null;
  placementOptionId: string;
  selectedDeliveryWindow?: SpApiFulfillmentInboundSelectedDeliveryWindow;
  selectedTransportationOptionId?: string | null;
  selfShipAppointmentDetails?: Array<SpApiFulfillmentInboundSelfShipAppointmentDetails> | null;
  shipmentConfirmationId?: string | null;
  shipmentId: string;
  source: SpApiFulfillmentInboundShipmentSource;
  status?: string | null;
  trackingDetails?: SpApiFulfillmentInboundTrackingDetails;
};

export type SpApiFulfillmentInboundShipmentDestination = {
  address?: SpApiFulfillmentInboundAddress;
  destinationType: string;
  warehouseId?: string | null;
};

export type SpApiFulfillmentInboundShipmentSource = {
  address?: SpApiFulfillmentInboundAddress;
  sourceType: string;
};

export type SpApiFulfillmentInboundShipmentTransportationConfiguration = {
  contactInformation?: SpApiFulfillmentInboundContactInformation;
  freightInformation?: SpApiFulfillmentInboundFreightInformation;
  pallets?: Array<SpApiFulfillmentInboundPalletInput> | null;
  readyToShipWindow: SpApiFulfillmentInboundWindowInput;
  shipmentId: string;
};

export type SpApiFulfillmentInboundSpdTrackingDetail = {
  spdTrackingItems?: Array<SpApiFulfillmentInboundSpdTrackingItem> | null;
};

export type SpApiFulfillmentInboundSpdTrackingItem = {
  boxId?: string | null;
  trackingId?: string | null;
  trackingNumberValidationStatus?: string | null;
};

export type SpApiFulfillmentInboundTrackingDetails = {
  ltlTrackingDetail?: SpApiFulfillmentInboundLtlTrackingDetail;
  spdTrackingDetail?: SpApiFulfillmentInboundSpdTrackingDetail;
};

export type SpApiFulfillmentInboundTransportationOption = {
  carrier: SpApiFulfillmentInboundCarrier;
  carrierAppointment?: SpApiFulfillmentInboundCarrierAppointment;
  preconditions: Array<string>;
  quote?: SpApiFulfillmentInboundQuote;
  shipmentId: string;
  shippingMode: string;
  shippingSolution: string;
  transportationOptionId: string;
};

export type SpApiFulfillmentInboundTransportationSelection = {
  contactInformation?: SpApiFulfillmentInboundContactInformation;
  shipmentId: string;
  transportationOptionId: string;
};

export type SpApiFulfillmentInboundWeight = {
  unit: "LB" | "KG";
  value?: number;
};

export type unit = "LB" | "KG";

export const unit = {
  LB: "LB",
  KG: "KG",
} as const;

export type SpApiFulfillmentInboundWindow = {
  editableUntil?: Date | null;
  end: Date;
  start: Date;
};

export type SpApiFulfillmentInboundWindowInput = {
  start: Date;
};

export type SqBlockType = {
  id: number;
  name: string;
  isDefault?: boolean;
  blockAvailability?: boolean;
};

export type SqBlockTypeUnpagedListResults = {
  results?: Array<SqBlockType> | null;
};

export type SqBlockTypeUpsert = {
  name: string;
  blockAvailability: boolean;
};

export type StockTransaction = {
  docId?: number;
};

export type StorageDataRequest = {
  value: string;
  /**
   * Value content type, text/plain is default
   */
  mimeType?: string | null;
};

export type StoreInfo = {
  name: string;
  welcomeMessage?: string | null;
  iconUrl?: string | null;
  backgroundUrl?: string | null;
  isAuthenticated: boolean;
};

export type StoreInfoRequest = {
  host: string;
  token?: string | null;
};

export type StoreInfoResponseDataResponse = {
  data: StoreInfo;
};

export type StringIdName = {
  id?: string | null;
  name?: string | null;
};

export type StringIdNameEntity = {
  id: string;
  name: string;
};

export type StringNameOrId = {
  name?: string | null;
  id?: string | null;
};

export type StringResponseData = {
  data?: string | null;
};

export type StringResponseDataResponse = {
  data: string;
};

export type StringUnpagedListResults = {
  results?: Array<string> | null;
};

export type SyncPackingInputConfigConfigurablePipeline = {
  formatConfig: PipelineFormatConfig;
  fileConfig: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: Array<ConfigurationParameter> | null;
};

export type SyncPackingOutputConfigConfigurablePipeline = {
  formatConfig: PipelineFormatConfig;
  fileConfig: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: Array<ConfigurationParameter> | null;
};

export type SyncReceiveInputConfigConfigurablePipeline = {
  formatConfig: PipelineFormatConfig;
  fileConfig: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: Array<ConfigurationParameter> | null;
};

export type SyncReceiveOutputConfigConfigurablePipeline = {
  formatConfig: PipelineFormatConfig;
  fileConfig: PipelineFileConfig;
  uri?: string | null;
  pipelineConfiguration?: Array<ConfigurationParameter> | null;
};

export type TagBasedEntity = {
  id: number;
  name: string;
  code?: string | null;
  color?: string | null;
};

export type TaxGroup = {
  id: string;
  name: string;
  nominalCode?: string | null;
  taxDiscountApplied?: boolean;
  isDefault?: boolean;
};

export type TaxGroupDetails = {
  id: string;
  name: string;
  nominalCode?: string | null;
  taxDiscountApplied?: boolean;
  isDefault?: boolean;
  rates?: Array<TaxGroupRateValueDetails> | null;
  taxes?: Array<TaxGroupItemDetails> | null;
};

export type TaxGroupDetailsResponseDataResponse = {
  data: TaxGroupDetails;
};

export type TaxGroupItemDetails = {
  name?: string | null;
  taxAmount?: number | null;
  vatRate?: number | null;
  enabled?: boolean;
  taxItem: TaxItem;
};

export type TaxGroupItemUpdate = {
  name?: string | null;
  taxAmount?: number | null;
  vatRate?: number | null;
  enabled?: boolean;
  taxItemId: string;
};

export type TaxGroupRateValueDetails = {
  rate: number;
  taxCode?: string | null;
  incomeTaxReference?: string | null;
  expenseTaxReference?: string | null;
  taxType: GuidIdName;
};

export type TaxGroupRateValueUpdate = {
  rate: number;
  taxCode?: string | null;
  incomeTaxReference?: string | null;
  expenseTaxReference?: string | null;
  taxTypeId: string;
};

export type TaxGroupUnpagedListResults = {
  results?: Array<TaxGroup> | null;
};

export type TaxGroupUpsert = {
  name: string;
  id?: string | null;
  nominalCode?: string | null;
  taxDiscountApplied?: boolean;
  rates?: Array<TaxGroupRateValueUpdate> | null;
  taxes?: Array<TaxGroupItemUpdate> | null;
};

export type TaxItem = {
  id: string;
  name: string;
  individuallyPriced?: boolean;
  embedded?: boolean;
};

export type TaxItemUnpagedListResults = {
  results?: Array<TaxItem> | null;
};

export type TaxItemUpsert = {
  name: string;
  id?: string | null;
  individuallyPriced?: boolean;
  embedded?: boolean;
};

export type TaxType = {
  id: string;
  name: string;
  code?: string | null;
  isDefault?: boolean;
};

export type TaxTypeUnpagedListResults = {
  results?: Array<TaxType> | null;
};

export type TaxTypeUpsert = {
  name: string;
  id?: string | null;
  code: string;
};

export type Ticket = {
  id?: string | null;
  token?: string | null;
  created?: Date;
  updated?: Date | null;
  open?: boolean;
  status?: string | null;
  subject?: string | null;
  description?: string | null;
  sender?: string | null;
  type?: string | null;
};

export type TicketConversation = {
  id?: string | null;
  created_at?: Date;
  updated_at?: Date | null;
  body?: string | null;
  incoming?: boolean;
  from?: string | null;
};

export type TicketList = {
  emailValidated?: boolean;
  tickets?: Array<Ticket> | null;
};

export type TicketListResponseData = {
  data?: TicketList;
};

export type TicketWithConversations = {
  id?: string | null;
  token?: string | null;
  created?: Date;
  updated?: Date | null;
  open?: boolean;
  status?: string | null;
  subject?: string | null;
  description?: string | null;
  sender?: string | null;
  type?: string | null;
  descriptionHtml?: string | null;
  agentName?: string | null;
  conversations?: Array<TicketConversation> | null;
};

export type TicketWithConversationsResponseData = {
  data?: TicketWithConversations;
};

export type TokenAuthenticationResponse = {
  tokens?: Array<BaseAuthenticationResponse> | null;
};

export type TokenAuthenticationResponseResponseDataResponse = {
  data: TokenAuthenticationResponse;
};

export type TransportationOptionUnpagedListResults = {
  results?: Array<SpApiFulfillmentInboundTransportationOption> | null;
};

export type TrcClass = {
  id?: number;
  name?: string | null;
  isNegative?: boolean;
};

export type TrcClassUnpagedListResults = {
  results?: Array<TrcClass> | null;
};

export type TrcClassUpsert = {
  name: string;
  isNegative?: boolean;
};

export type TrustedDevice = {
  id?: string | null;
  name?: string | null;
  location?: string | null;
  createdTime?: Date;
  lastUsedTime?: Date | null;
  thisDevice?: boolean;
};

export type TrustedDeviceUnpagedListResults = {
  results?: Array<TrustedDevice> | null;
};

export type UnassignPackage = {
  packageCount: number;
  weight?: Weight;
  value?: Money;
  packingDate?: Date | null;
  documentType: string;
  documentId: string;
  readonly document: string;
  destinationAddress?: DocumentAddress;
  assignedCarrierId?: number | null;
  routePosition?: number | null;
  isPreDue: boolean;
  isPostDue: boolean;
  dueDate?: Date | null;
};

export type UnassignPackagesPlanRequest = {
  documents: Array<string>;
  optimize?: boolean;
  startDate?: Date | null;
  warehouseId: string;
};

export type UnassignPackagesPlanResponse = {
  planId: string;
  distanceMeters?: number | null;
  distanceText?: string | null;
  duration?: string | null;
  durationText?: string | null;
  routes?: Array<UnassignPackagesPlanRouteResponse> | null;
  copyrights?: string | null;
  waypointsOrder?: Array<string> | null;
};

export type UnassignPackagesPlanRouteResponse = {
  distanceMeters?: number;
  distanceText?: string | null;
  duration?: string;
  durationText?: string | null;
  destination?: DocumentAddress;
};

export type UnassignPackagesSavePackageResponse = {
  document: string;
  success?: boolean;
  shipmentId?: number | null;
  errorMessage?: string | null;
};

export type UnassignPackagesSaveRequest = {
  documents: Array<string>;
  driverName?: string | null;
  carrierId: number;
  startDate?: Date | null;
  warehouseId: string;
  planResponse?: UnassignPackagesPlanResponse;
};

export type UnassignPackagesSaveResponse = {
  spkId?: number | null;
  packages?: Array<UnassignPackagesSavePackageResponse> | null;
};

export type UnassignPackagesSaveResponseResponseDataResponse = {
  data: UnassignPackagesSaveResponse;
};

export type UnassignPackageUnpagedListResults = {
  results?: Array<UnassignPackage> | null;
};

export type UnpagedListResults_1UnpagedListResults = {
  results?: Array<FbaShipmentTempUnpagedListResults> | null;
};

export type UrlOrFileBase64Input = {
  url?: string | null;
  file?: FileBase64Input;
};

export type UserBase = {
  id?: number;
  name?: string | null;
  active?: boolean;
  role?: IdName;
};

export type UserBaseUnpagedListResults = {
  results?: Array<UserBase> | null;
};

export type UserInfoCurrent = {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  role?: string | null;
  locale?: string | null;
  emailValidated?: boolean;
  organization?: Organisation;
  settings?: UserSettings;
  scopes?: Array<string> | null;
};

export type UserInfoCurrentResponseData = {
  data?: UserInfoCurrent;
};

export type UserInviteRequest = {
  firstName: string;
  lastName: string;
  emailAddress: string;
  roleId: number;
  warehouseId: string;
};

export type UserPasswordResetRequest = {
  password1: string;
  password2: string;
  token: string;
};

export type UserPasswordUpdateRequest = {
  password1: string;
  password2: string;
  currentPassword: string;
};

export type UserProfileBase = {
  nameFirst: string;
  nameLast: string;
};

export type UserProfileBaseResponseData = {
  data?: UserProfileBase;
};

export type UserPusherConfig = {
  config?: PusherConfig;
  channels?: Array<string> | null;
};

export type UserSettings = {
  printQueueId?: number | null;
  warehouseId?: string | null;
  pusher?: UserPusherConfig;
};

export type WarehouseBin = {
  id?: number;
  name: string;
  type: "Storage" | "Tote" | "Ship" | "Receiving" | "Pick";
  lastBinCount?: Date | null;
  priority?: number;
  dimensions?: Dimensions;
  utilization?: number | null;
  utilizationPercent?: number | null;
  color?: string | null;
  maxPickQty?: number | null;
};

export type type13 = "Storage" | "Tote" | "Ship" | "Receiving" | "Pick";

export const type13 = {
  STORAGE: "Storage",
  TOTE: "Tote",
  SHIP: "Ship",
  RECEIVING: "Receiving",
  PICK: "Pick",
} as const;

export type WarehouseBinImport = {
  name: string;
  type?: string | null;
  priority?: string | null;
  dimensions?: string | null;
  color?: string | null;
};

export type WarehouseBinImportBulkUpsertRequest = {
  items: Array<WarehouseBinImport>;
  source?: string | null;
  params?: Array<ConfigurationParameter> | null;
};

export type WarehouseBinListResults = {
  totalCount?: number | null;
  offset?: number | null;
  limit?: number | null;
  results?: Array<WarehouseBin> | null;
  readonly mightHaveMore: boolean;
};

export type WarehouseBinUpsert = {
  name: string;
  nameUpdate?: string | null;
  type: "Storage" | "Tote" | "Ship" | "Receiving" | "Pick";
  priority?: number | null;
  dimensions?: Dimensions;
  color?: string | null;
};

export type WarehouseEntity = {
  id?: string;
  name?: string | null;
  code?: string | null;
  isDefault?: boolean;
  type?: "storage" | "depot";
  isActive?: boolean;
  parent?: GuidIdName;
};

export type type14 = "storage" | "depot";

export const type14 = {
  STORAGE: "storage",
  DEPOT: "depot",
} as const;

export type WarehouseEntityDetails = {
  id?: string;
  name?: string | null;
  code?: string | null;
  isDefault?: boolean;
  type?: "storage" | "depot";
  isActive?: boolean;
  parent?: GuidIdName;
  address?: DocumentAddress;
  timeZone?: string | null;
  currencyId?: string | null;
  headerId?: number | null;
  quickViewHidden?: boolean;
  dispatchItemFee?: number | null;
  taxIdentifiers?: Array<WarehouseTaxIdentifier> | null;
  itemTagsFilter?: Array<number> | null;
  contactTagsFilter?: Array<number> | null;
  pricelistId?: string | null;
};

export type WarehouseEntityDetailsResponseDataResponse = {
  data: WarehouseEntityDetails;
};

export type WarehouseEntityUnpagedListResults = {
  results?: Array<WarehouseEntity> | null;
};

export type WarehouseGroupDetails = {
  id?: string;
  name?: string | null;
  code?: string | null;
  warehouses: Array<GuidIdName>;
};

export type WarehouseGroupDetailsUnpagedListResults = {
  results?: Array<WarehouseGroupDetails> | null;
};

export type WarehouseGroupUpsert = {
  name: string;
  id?: string | null;
  warehouseId: Array<string>;
};

export type WarehouseListItem = {
  id?: string;
  name?: string | null;
  isDefault?: boolean;
  type?: "warehouse" | "group";
};

export type type15 = "warehouse" | "group";

export const type15 = {
  WAREHOUSE: "warehouse",
  GROUP: "group",
} as const;

export type WarehouseTaxIdentifier = {
  type?: "eori";
  value?: string | null;
};

export type type16 = "eori";

export const type16 = {
  EORI: "eori",
} as const;

export type WarehouseUpsert = {
  name: string;
  id?: string | null;
  code: string;
  type?: ("storage" | "depot") | null;
  isActive?: boolean | null;
  parentId?: string | null;
  address: DocumentAddress;
  timeZone?: string | null;
  currencyId?: string | null;
  headerId?: number | null;
  quickViewHidden?: boolean | null;
  dispatchItemFee?: number | null;
  taxIdentifiers?: Array<WarehouseTaxIdentifier> | null;
  itemTagsFilter?: Array<number> | null;
  contactTagsFilter?: Array<number> | null;
  pricelistId?: string | null;
};

export type WarehouseZone = {
  id?: number;
  name?: string | null;
  minPriority?: number;
  maxPriority?: number;
};

export type WarehouseZoneUnpagedListResults = {
  results?: Array<WarehouseZone> | null;
};

export type WarehouseZoneUpsert = {
  name: string;
  minPriority: number;
  maxPriority: number;
};

export type WebhookEndpointEntity = {
  id: number;
  name: string;
  endpointType: "Url";
  endpointUri: string;
  enabled: boolean;
  secret: string;
  headers?: Array<WebhookEndpointHeaderEntity> | null;
  subscriptions: Array<
    | "item.created"
    | "item.updated"
    | "item.images.modified"
    | "item.specifications.modified"
    | "item.price.modified"
    | "contact.created"
    | "contact.updated"
    | "order.created"
    | "order.updated"
    | "order.deleted"
  >;
};

export type endpointType = "Url";

export const endpointType = {
  URL: "Url",
} as const;

export type WebhookEndpointEntityUnpagedListResults = {
  results?: Array<WebhookEndpointEntity> | null;
};

export type WebhookEndpointEntityUpsert = {
  name: string;
  endpointType: "Url";
  endpointUri: string;
  enabled: boolean;
  headers?: Array<WebhookEndpointHeaderEntity> | null;
  subscriptions: Array<
    | "item.created"
    | "item.updated"
    | "item.images.modified"
    | "item.specifications.modified"
    | "item.price.modified"
    | "contact.created"
    | "contact.updated"
    | "order.created"
    | "order.updated"
    | "order.deleted"
  >;
};

export type WebhookEndpointHeaderEntity = {
  name: string;
  value: string;
};

export type Weight = {
  value?: number | null;
  uom?: ("kg" | "g" | "oz" | "lb") | null;
};

export type uom2 = "kg" | "g" | "oz" | "lb";

export const uom2 = {
  KG: "kg",
  G: "g",
  OZ: "oz",
  LB: "lb",
} as const;

export type WmsCacheType = {
  warehouses: Array<WarehouseListItem> | null;
};

export type WorkOrder = {
  id: number;
  createdDate: Date;
  scheduledDate: Date;
  reference?: string | null;
  status: "Planned" | "InProgress" | "Completed" | "Cancelled";
  percentComplete: number;
  numberOfItems: number;
  items: Array<WorkOrderSummaryItem>;
};

export type status8 = "Planned" | "InProgress" | "Completed" | "Cancelled";

export const status8 = {
  PLANNED: "Planned",
  IN_PROGRESS: "InProgress",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
} as const;

export type WorkOrderResponseDataResponse = {
  data: WorkOrder;
};

export type WorkOrderSummary = {
  id: number;
  createdDate: Date;
  scheduledDate: Date;
  reference?: string | null;
  status: "Planned" | "InProgress" | "Completed" | "Cancelled";
  percentComplete: number;
  numberOfItems: number;
};

export type WorkOrderSummaryCursorListResults = {
  results?: Array<WorkOrderSummary> | null;
  nextCursor?: string | null;
};

export type WorkOrderSummaryItem = {
  id: number;
  item: ItemLookup;
  quantity: number;
  pendingQuantity: number;
  childItems?: Array<WorkOrderSummaryItem> | null;
};

export type UsersListApiResponse = ApiUserUnpagedListResults;

export type UsersListApiError = ErrorResponse;

export type CacheListResponse2 = CacheListResponseResponseDataResponse;

export type CacheListError = ErrorResponse;

export type CompanyHeadersListResponse = CompanyHeaderUnpagedListResults;

export type CompanyHeadersListError = ErrorResponse;

export type CompanyHeaderUpsertData = {
  body?: {
    /**
     * Maximum file size is 500 KB. Allowed files: .jpg, .jpeg, .png, .gif
     */
    image?: Blob | File;
    Line1?: string;
    Line2?: string;
    Line3?: string;
    Line4?: string;
    SequenceName?: string;
    TaxNumber?: string;
    FiscalYearStartMonth?: number;
    Name?: string;
  };
  path: {
    id: number;
  };
};

export type CompanyHeaderUpsertResponse = void;

export type CompanyHeaderUpsertError = ErrorResponse;

export type CompanyHeaderDeleteData = {
  path: {
    id: number;
  };
};

export type CompanyHeaderDeleteResponse = void;

export type CompanyHeaderDeleteError = ErrorResponse;

export type CreditTermsListResponse = CreditTermUnpagedListResults;

export type CreditTermsListError = ErrorResponse;

export type CreditTermsUpsertData = {
  body?: CreditTermUpsert;
  path: {
    id: number;
  };
};

export type CreditTermsUpsertResponse = void;

export type CreditTermsUpsertError = ErrorResponse;

export type CreditTermsDeleteData = {
  path: {
    id: number;
  };
};

export type CreditTermsDeleteResponse = void;

export type CreditTermsDeleteError = ErrorResponse;

export type CreditTermSettlementsDeleteData = {
  path: {
    id: number;
  };
};

export type CreditTermSettlementsDeleteResponse = void;

export type CreditTermSettlementsDeleteError = ErrorResponse;

export type CreditTermSettlementsUpsertData = {
  body?: CreditTermSettlementUpsert;
  path: {
    id: number;
  };
};

export type CreditTermSettlementsUpsertResponse = void;

export type CreditTermSettlementsUpsertError = ErrorResponse;

export type CurrenciesListResponse = CurrencyDetailsUnpagedListResults;

export type CurrenciesListError = ErrorResponse;

export type CurrenciesUpsertData = {
  body?: CurrencyUpsert;
};

export type CurrenciesUpsertResponse = void;

export type CurrenciesUpsertError = ErrorResponse;

export type CurrenciesDeleteData = {
  path: {
    id: string;
  };
};

export type CurrenciesDeleteResponse = void;

export type CurrenciesDeleteError = ErrorResponse;

export type CurrenciesSetPrimaryData = {
  path: {
    id: string;
  };
};

export type CurrenciesSetPrimaryResponse = void;

export type CurrenciesSetPrimaryError = ErrorResponse;

export type CurrenciesUpdateRatesResponse = CurrencyDetailsUnpagedListResults;

export type CurrenciesUpdateRatesError = ErrorResponse;

export type CustomerPortalsListResponse = CustomerPortalBaseUnpagedListResults;

export type CustomerPortalsListError = ErrorResponse;

export type CustomerPortalsGetData = {
  path: {
    id: number;
  };
};

export type CustomerPortalsGetResponse = CustomerPortalResponseData;

export type CustomerPortalsGetError = ErrorResponse;

export type CustomerPortalsUpsertData = {
  body?: {
    name?: string;
    title?: string;
    welcomeMessage?: string;
    /**
     * Maximum file size is 500 KB. Allowed files: .jpg, .jpeg, .png, .gif
     */
    logo?: Blob | File;
    backgroundImage?: Blob | File;
    "itemSettings.HidePrices"?: boolean;
    "itemSettings.HideOutOfStock"?: boolean;
    "itemSettings.HideImages"?: boolean;
    "itemSettings.CategoriesExclude"?: Array<number>;
    "itemSettings.TagsExclude"?: Array<number>;
    "itemSettings.BrandsExclude"?: Array<number>;
    "itemSettings.Categories"?: Array<number>;
    "itemSettings.Tags"?: Array<number>;
    "itemSettings.Brands"?: Array<number>;
    "orderSettings.MinimumOrderValue"?: number;
    warehouseId?: string;
  };
  path: {
    id: number;
  };
};

export type CustomerPortalsUpsertResponse = void;

export type CustomerPortalsUpsertError = ErrorResponse;

export type DocumentCustomFieldsListResponse =
  DocumentCustomFieldUnpagedListResults;

export type DocumentCustomFieldsListError = ErrorResponse;

export type DocumentCustomFieldCreateData = {
  body?: DocumentCustomFieldCreate;
};

export type DocumentCustomFieldCreateResponse = void;

export type DocumentCustomFieldCreateError = ErrorResponse;

export type DocumentCustomFieldDeleteData = {
  path: {
    id: number;
  };
};

export type DocumentCustomFieldDeleteResponse = void;

export type DocumentCustomFieldDeleteError = ErrorResponse;

export type DocumentCustomFieldUpdateData = {
  body?: DocumentCustomFieldUpdate;
  path: {
    id: number;
  };
};

export type DocumentCustomFieldUpdateResponse = void;

export type DocumentCustomFieldUpdateError = ErrorResponse;

export type DocumentStageListResponse = DocumentStageUnpagedListResults;

export type DocumentStageListError = ErrorResponse;

export type DocumentStageDeleteData = {
  path: {
    id: number;
  };
};

export type DocumentStageDeleteResponse = void;

export type DocumentStageDeleteError = ErrorResponse;

export type DocumentStageUpsertData = {
  body?: DocumentStageUpsert;
  path: {
    id: number;
  };
};

export type DocumentStageUpsertResponse = void;

export type DocumentStageUpsertError = ErrorResponse;

export type DocumentTagsListResponse = DocumentTagUnpagedListResults;

export type DocumentTagsListError = ErrorResponse;

export type DocumentTagsDeleteData = {
  path: {
    id: number;
  };
};

export type DocumentTagsDeleteResponse = void;

export type DocumentTagsDeleteError = ErrorResponse;

export type DocumentTagsUpsertData = {
  body?: DocumentTagUpsert;
  path: {
    id: number;
  };
};

export type DocumentTagsUpsertResponse = void;

export type DocumentTagsUpsertError = ErrorResponse;

export type EmailTemplatesListResponse = EmailTemplateUnpagedListResults;

export type EmailTemplatesListError = ErrorResponse;

export type EmailTemplatesDeleteData = {
  path: {
    id: number;
  };
};

export type EmailTemplatesDeleteResponse = void;

export type EmailTemplatesDeleteError = ErrorResponse;

export type EmailTemplatesGetData = {
  path: {
    id: number;
  };
};

export type EmailTemplatesGetResponse = EmailTemplateDetailsResponseData;

export type EmailTemplatesGetError = ErrorResponse;

export type EmailTemplatesUpsertData = {
  body?: EmailTemplateUpsert;
  path: {
    id: number;
  };
};

export type EmailTemplatesUpsertResponse = void;

export type EmailTemplatesUpsertError = ErrorResponse;

export type GlobalSettingsResponse2 = GlobalSettingsResponseResponseData;

export type GlobalSettingsError = ErrorResponse;

export type HeaderSequencesCreateData = {
  body?: HeaderSequenceCreate;
};

export type HeaderSequencesCreateResponse = void;

export type HeaderSequencesCreateError = ErrorResponse;

export type HeaderSequencesDeleteData = {
  path: {
    name: string;
  };
};

export type HeaderSequencesDeleteResponse = void;

export type HeaderSequencesDeleteError = ErrorResponse;

export type HeaderSequencesUpdateData = {
  body?: HeaderSequenceUpdate;
  path: {
    name: string;
  };
};

export type HeaderSequencesUpdateResponse = void;

export type HeaderSequencesUpdateError = ErrorResponse;

export type HeaderSequencesDetailsResponse = HeaderSequenceUnpagedListResults;

export type HeaderSequencesDetailsError = ErrorResponse;

export type HeaderSequencesNamesResponse = StringUnpagedListResults;

export type HeaderSequencesNamesError = ErrorResponse;

export type InboundAsnStatusBadgeDeleteData = {
  path: {
    id: number;
  };
};

export type InboundAsnStatusBadgeDeleteResponse = void;

export type InboundAsnStatusBadgeDeleteError = ErrorResponse;

export type InboundAsnStatusBadgesListResponse =
  InboundStatusBadgeUnpagedListResults;

export type InboundAsnStatusBadgesListError = ErrorResponse;

export type InboundAsnStatusBadgeUpsertData = {
  body?: InboundStatusBadgeUpsert;
  path: {
    id: number;
  };
};

export type InboundAsnStatusBadgeUpsertResponse = void;

export type InboundAsnStatusBadgeUpsertError = ErrorResponse;

export type InboundStatusBadgeSetOrderData = {
  body?: IdListRequest;
};

export type InboundStatusBadgeSetOrderResponse = void;

export type InboundStatusBadgeSetOrderError = ErrorResponse;

export type InboundShpStatusBadgesListResponse =
  InboundStatusBadgeUnpagedListResults;

export type InboundShpStatusBadgesListError = ErrorResponse;

export type InboundShpStatusBadgeUpsertData = {
  body?: InboundStatusBadgeUpsert;
  path: {
    id: number;
  };
};

export type InboundShpStatusBadgeUpsertResponse = void;

export type InboundShpStatusBadgeUpsertError = ErrorResponse;

export type ItemLabelTemplatesListResponse =
  ItemLabelTemplateUnpagedListResults;

export type ItemLabelTemplatesListError = ErrorResponse;

export type ItemLabelTemplatesDeleteData = {
  path: {
    id: number;
  };
};

export type ItemLabelTemplatesDeleteResponse = void;

export type ItemLabelTemplatesDeleteError = ErrorResponse;

export type ItemLabelTemplatesUpsertData = {
  body?: {
    /**
     * Maximum file size is 500 KB. Allowed files: .btw, .trdx, .trdp, .prn, .zpl
     */
    templateFile?: Blob | File;
    Name?: string;
  };
  path: {
    id: number;
  };
};

export type ItemLabelTemplatesUpsertResponse = void;

export type ItemLabelTemplatesUpsertError = ErrorResponse;

export type LanguagesListResponse = LanguageEntityUnpagedListResults;

export type LanguagesListError = ErrorResponse;

export type ListResponseData = {
  path: {
    listType: string;
  };
};

export type ListResponseResponse = IdNameEntity_1UnpagedListResults;

export type ListResponseError = ErrorResponse;

export type MonitorsListResponse = EventMonitorBaseUnpagedListResults;

export type MonitorsListError = ErrorResponse;

export type MonitorsDeleteData = {
  path: {
    id: number;
  };
};

export type MonitorsDeleteResponse = void;

export type MonitorsDeleteError = ErrorResponse;

export type MonitorsGetData = {
  path: {
    id: number;
  };
};

export type MonitorsGetResponse = EventMonitorResponseData;

export type MonitorsGetError = ErrorResponse;

export type MonitorsUpsertData = {
  body?: EventMonitorUpsert;
  path: {
    id: number;
  };
};

export type MonitorsUpsertResponse = void;

export type MonitorsUpsertError = ErrorResponse;

export type OutgoingEmailsListResponse = SmtpListDetailUnpagedListResults;

export type OutgoingEmailsListError = ErrorResponse;

export type OutgoingEmailsDeleteData = {
  path: {
    id: number;
  };
};

export type OutgoingEmailsDeleteResponse = void;

export type OutgoingEmailsDeleteError = ErrorResponse;

export type OutgoingEmailsGetData = {
  path: {
    id: number;
  };
};

export type OutgoingEmailsGetResponse = SmtpDetailsResponseDataResponse;

export type OutgoingEmailsGetError = ErrorResponse;

export type OutgoingEmailsUpsertCustomData = {
  body?: SmtpCustomUpsert;
  path: {
    id: number;
  };
};

export type OutgoingEmailsUpsertCustomResponse =
  SmtpDetailsResponseDataResponse;

export type OutgoingEmailsUpsertCustomError = ErrorResponse;

export type OutgoingEmailsUpsertOAuthData = {
  body?: SmtpOauthUpsert;
  path: {
    id: number;
  };
};

export type OutgoingEmailsUpsertOAuthResponse = SmtpDetailsResponseDataResponse;

export type OutgoingEmailsUpsertOAuthError = ErrorResponse;

export type OutgoingEmailsTestData = {
  body?: SmtpTestRequest;
  path: {
    id: number;
  };
};

export type OutgoingEmailsTestResponse = void;

export type OutgoingEmailsTestError = ErrorResponse;

export type PackageTypesListResponse = PackageTypeEntityUnpagedListResults;

export type PackageTypesListError = ErrorResponse;

export type PackageTypeUpsertData = {
  body?: PackageTypeUpsert;
  path: {
    id: number;
  };
};

export type PackageTypeUpsertResponse = void;

export type PackageTypeUpsertError = ErrorResponse;

export type PackageTypeDeleteData = {
  path: {
    id: number;
  };
};

export type PackageTypeDeleteResponse = void;

export type PackageTypeDeleteError = ErrorResponse;

export type PackageTypesSetOrderData = {
  body?: IdListRequest;
};

export type PackageTypesSetOrderResponse = void;

export type PackageTypesSetOrderError = ErrorResponse;

export type PipelinesListResponse = PipelineUnpagedListResults;

export type PipelinesListError = ErrorResponse;

export type PipelinesDeleteData = {
  path: {
    id: number;
  };
};

export type PipelinesDeleteResponse = void;

export type PipelinesDeleteError = ErrorResponse;

export type PipelinesGetData = {
  path: {
    id: number;
  };
};

export type PipelinesGetResponse = PipelineDetailsResponseData;

export type PipelinesGetError = ErrorResponse;

export type PipelinesUpsertData = {
  body?: PipelineUpsert;
  path: {
    id: number;
  };
};

export type PipelinesUpsertResponse = void;

export type PipelinesUpsertError = ErrorResponse;

export type PipelinesActivityData = {
  path: {
    id: number;
  };
};

export type PipelinesActivityResponse = PipelineActivityUnpagedListResults;

export type PipelinesActivityError = ErrorResponse;

export type PipelinesActivityLogData = {
  path: {
    activityId: number;
    id: number;
  };
};

export type PipelinesActivityLogResponse =
  PipelineActivityLogUnpagedListResults;

export type PipelinesActivityLogError = ErrorResponse;

export type PipelinesTriggerData = {
  path: {
    id: number;
  };
};

export type PipelinesTriggerResponse = void;

export type PipelinesTriggerError = ErrorResponse;

export type PipelinesConfigurationResponse2 =
  PipelinesConfigurationResponseResponseData;

export type PipelinesConfigurationError = ErrorResponse;

export type PipelinesEndpointResponse = PipelineEndpointResponseData;

export type PipelinesEndpointError = ErrorResponse;

export type PrintQueuesListResponse = PrintQueueInfoEntityUnpagedListResults;

export type PrintQueuesListError = ErrorResponse;

export type PrintQueuesDeleteData = {
  path: {
    id: number;
  };
};

export type PrintQueuesDeleteResponse = void;

export type PrintQueuesDeleteError = ErrorResponse;

export type PrintQueuesUpsertData = {
  body?: PrintQueueUpsert;
  path: {
    id: number;
  };
};

export type PrintQueuesUpsertResponse = void;

export type PrintQueuesUpsertError = ErrorResponse;

export type PrintQueuesPurgeData = {
  path: {
    id: number;
  };
};

export type PrintQueuesPurgeResponse = void;

export type PrintQueuesPurgeError = ErrorResponse;

export type ProfitRatingsListResponse = ProfitRatingEntityUnpagedListResults;

export type ProfitRatingsListError = ErrorResponse;

export type ProfitRatingsUpsertData = {
  body?: ProfitRatingUpsert;
  path: {
    id: number;
  };
};

export type ProfitRatingsUpsertResponse = void;

export type ProfitRatingsUpsertError = ErrorResponse;

export type ProfitRatingsDeleteData = {
  path: {
    id: number;
  };
};

export type ProfitRatingsDeleteResponse = void;

export type ProfitRatingsDeleteError = ErrorResponse;

export type RctEmbeddedExpenseTypesListResponse =
  RctEmbeddedExpenseTypeUnpagedListResults;

export type RctEmbeddedExpenseTypesListError = ErrorResponse;

export type RctEmbeddedExpenseTypesUpsertData = {
  body?: RctEmbeddedExpenseTypeUpsert;
  path: {
    id: number;
  };
};

export type RctEmbeddedExpenseTypesUpsertResponse = void;

export type RctEmbeddedExpenseTypesUpsertError = ErrorResponse;

export type ReportPeriodDeleteData = {
  path: {
    id: number;
  };
};

export type ReportPeriodDeleteResponse = void;

export type ReportPeriodDeleteError = ErrorResponse;

export type ReportPeriodUpsertData = {
  body?: ReportPeriodUpsert;
  path: {
    id: number;
  };
};

export type ReportPeriodUpsertResponse = void;

export type ReportPeriodUpsertError = ErrorResponse;

export type ReportTemplatesListResponse = ReportTemplateBaseUnpagedListResults;

export type ReportTemplatesListError = ErrorResponse;

export type ReportTemplatesDeleteData = {
  path: {
    id: number;
  };
};

export type ReportTemplatesDeleteResponse = void;

export type ReportTemplatesDeleteError = ErrorResponse;

export type ReportTemplateUpsertData = {
  body?: {
    /**
     * Maximum file size is 200 KB. Allowed files: .trdx, .trdp, .pdf
     */
    file?: Blob | File;
    reportType?: string;
    name?: string;
    useHeaders?: boolean;
    versionId?: string;
  };
  path: {
    id: number;
  };
};

export type ReportTemplateUpsertResponse = void;

export type ReportTemplateUpsertError = ErrorResponse;

export type ReportTemplatesHistoryData = {
  path: {
    id: number;
  };
};

export type ReportTemplatesHistoryResponse =
  ReportTemplateUploadUnpagedListResults;

export type ReportTemplatesHistoryError = ErrorResponse;

export type ReportTemplatesSetDefaultData = {
  path: {
    id: number;
  };
};

export type ReportTemplatesSetDefaultResponse = void;

export type ReportTemplatesSetDefaultError = ErrorResponse;

export type SalesOrderReturnReasonsListResponse =
  SalesOrderReturnReasonUnpagedListResults;

export type SalesOrderReturnReasonsListError = ErrorResponse;

export type SalesOrderReturnReasonUpsertData = {
  body?: SalesOrderReturnReasonUpsert;
  path: {
    id: number;
  };
};

export type SalesOrderReturnReasonUpsertResponse = void;

export type SalesOrderReturnReasonUpsertError = ErrorResponse;

export type SalesOrderReturnReasonDeleteData = {
  path: {
    id: number;
  };
};

export type SalesOrderReturnReasonDeleteResponse = void;

export type SalesOrderReturnReasonDeleteError = ErrorResponse;

export type SqBlockTypesListResponse = SqBlockTypeUnpagedListResults;

export type SqBlockTypesListError = ErrorResponse;

export type SqBlockTypesUpsertData = {
  body?: SqBlockTypeUpsert;
  path: {
    id: number;
  };
};

export type SqBlockTypesUpsertResponse = void;

export type SqBlockTypesUpsertError = ErrorResponse;

export type SqBlockTypesDeleteData = {
  path: {
    id: number;
  };
};

export type SqBlockTypesDeleteResponse = void;

export type SqBlockTypesDeleteError = ErrorResponse;

export type SqBlockTypesSetDefaultData = {
  path: {
    id: number;
  };
};

export type SqBlockTypesSetDefaultResponse = void;

export type SqBlockTypesSetDefaultError = ErrorResponse;

export type CountryTaxesResponse = CountryTaxSettingsUnpagedListResults;

export type CountryTaxesError = ErrorResponse;

export type CountryTaxesUpsertData = {
  body?: CountryTaxSettingsUpsert;
};

export type CountryTaxesUpsertResponse = void;

export type CountryTaxesUpsertError = ErrorResponse;

export type TaxGroupsListResponse = TaxGroupUnpagedListResults;

export type TaxGroupsListError = ErrorResponse;

export type TaxGroupsUpsertData = {
  body?: TaxGroupUpsert;
};

export type TaxGroupsUpsertResponse = void;

export type TaxGroupsUpsertError = ErrorResponse;

export type TaxGroupsDetailsData = {
  path: {
    id: string;
  };
};

export type TaxGroupsDetailsResponse = TaxGroupDetailsResponseDataResponse;

export type TaxGroupsDetailsError = ErrorResponse;

export type TaxGroupsSetDefaultData = {
  path: {
    id: string;
  };
};

export type TaxGroupsSetDefaultResponse = void;

export type TaxGroupsSetDefaultError = ErrorResponse;

export type TaxItemsListResponse = TaxItemUnpagedListResults;

export type TaxItemsListError = ErrorResponse;

export type TaxItemsUpsertData = {
  body?: TaxItemUpsert;
};

export type TaxItemsUpsertResponse = void;

export type TaxItemsUpsertError = ErrorResponse;

export type TaxItemsDeleteData = {
  path: {
    id: string;
  };
};

export type TaxItemsDeleteResponse = void;

export type TaxItemsDeleteError = ErrorResponse;

export type TaxTypesListResponse = TaxTypeUnpagedListResults;

export type TaxTypesListError = ErrorResponse;

export type TaxTypeUpsertData = {
  body?: TaxTypeUpsert;
};

export type TaxTypeUpsertResponse = void;

export type TaxTypeUpsertError = ErrorResponse;

export type TaxTypeDeleteData = {
  path: {
    id: string;
  };
};

export type TaxTypeDeleteResponse = void;

export type TaxTypeDeleteError = ErrorResponse;

export type TaxTypeSetDefaultData = {
  path: {
    id: string;
  };
};

export type TaxTypeSetDefaultResponse = void;

export type TaxTypeSetDefaultError = ErrorResponse;

export type UsersListActiveResponse = UserBaseUnpagedListResults;

export type UsersListActiveError = ErrorResponse;

export type UsersInviteData = {
  body?: UserInviteRequest;
};

export type UsersInviteResponse = void;

export type UsersInviteError = ErrorResponse;

export type WebhookEndpointsListResponse =
  WebhookEndpointEntityUnpagedListResults;

export type WebhookEndpointsListError = ErrorResponse;

export type WebhookEndpointsUpsertData = {
  body?: WebhookEndpointEntityUpsert;
  path: {
    id: number;
  };
};

export type WebhookEndpointsUpsertResponse = void;

export type WebhookEndpointsUpsertError = ErrorResponse;

export type WebhookEndpointsDeleteData = {
  path: {
    id: number;
  };
};

export type WebhookEndpointsDeleteResponse = void;

export type WebhookEndpointsDeleteError = ErrorResponse;

export type WebhookEndpointsTestData = {
  path: {
    id: number;
  };
};

export type WebhookEndpointsTestResponse = void;

export type WebhookEndpointsTestError = ErrorResponse;

export type WebhookSubscriptionTypesResponse = IdNameEntity_1UnpagedListResults;

export type WebhookSubscriptionTypesError = ErrorResponse;

export type AmazonInboundPlansCreateData = {
  body?: AmazonInboundPlansCreateRequest;
  path: {
    mpId: string;
  };
};

export type AmazonInboundPlansCreateResponse2 =
  AmazonInboundPlansCreateResponseResponseDataResponse;

export type AmazonInboundPlansCreateError = ErrorResponse;

export type AmazonInboundPlansListData = {
  path: {
    mpId: string;
  };
  query?: {
    cursor?: string;
  };
};

export type AmazonInboundPlansListResponse =
  AmazonInboundPlansSummaryDetailCursorListResults;

export type AmazonInboundPlansListError = ErrorResponse;

export type AmazonInboundPlansDetailsData = {
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansDetailsResponse =
  AmazonInboundPlansDetailResponseDataResponse;

export type AmazonInboundPlansDetailsError = ErrorResponse;

export type AmazonInboundPlansCancelData = {
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansCancelResponse = void;

export type AmazonInboundPlansCancelError = ErrorResponse;

export type AmazonInboundPlansHoldingTrnsCreateData = {
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansHoldingTrnsCreateResponse =
  AmazonInboundPlansTrnDocumentUnpagedListResults;

export type AmazonInboundPlansHoldingTrnsCreateError = ErrorResponse;

export type AmazonInboundPlansPackingOptionsConfirmData = {
  body?: AmazonInboundPlansIdRequest;
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansPackingOptionsConfirmResponse = void;

export type AmazonInboundPlansPackingOptionsConfirmError = ErrorResponse;

export type AmazonInboundPlansPackingOptionsListData = {
  path: {
    forceGenerate: boolean;
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansPackingOptionsListResponse =
  AmazonInboundPlansPackingOptionUnpagedListResults;

export type AmazonInboundPlansPackingOptionsListError = ErrorResponse;

export type AmazonInboundPlansPlacementOptionsConfirmData = {
  body?: InboundPlanConfirmIdRequest;
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansPlacementOptionsConfirmResponse = void;

export type AmazonInboundPlansPlacementOptionsConfirmError = ErrorResponse;

export type AmazonInboundPlansRenameData = {
  body?: AmazonInboundPlansRenameRequest;
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansRenameResponse = void;

export type AmazonInboundPlansRenameError = ErrorResponse;

export type AmazonInboundPlansSubmitPackingInformationData = {
  body?: AmazonInboundPlansSubmitPackingRequest;
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlansSubmitPackingInformationResponse = void;

export type AmazonInboundPlansSubmitPackingInformationError = ErrorResponse;

export type AmazonSellerFlexImportShipmentData = {
  path: {
    appId: number;
    shipmentId: string;
  };
};

export type AmazonSellerFlexImportShipmentResponse = void;

export type AmazonSellerFlexImportShipmentError = ErrorResponse;

export type AmazonSellerFlexOrdersMapData = {
  path: {
    appId: number;
  };
};

export type AmazonSellerFlexOrdersMapResponse =
  ListedShipmentInfoUnpagedListResults;

export type AmazonSellerFlexOrdersMapError = ErrorResponse;

export type AmazonSellerFlexProcessPackagesData = {
  path: {
    appId: number;
    soId: string;
  };
};

export type AmazonSellerFlexProcessPackagesResponse = void;

export type AmazonSellerFlexProcessPackagesError = ErrorResponse;

export type AmazonSellerFlexRejectShipmentData = {
  path: {
    appId: number;
    shipmentId: string;
  };
};

export type AmazonSellerFlexRejectShipmentResponse = void;

export type AmazonSellerFlexRejectShipmentError = ErrorResponse;

export type AppsListResponse = AppDetailsUnpagedListResults;

export type AppsListError = ErrorResponse;

export type AppsGetData = {
  path: {
    id: number;
  };
};

export type AppsGetResponse = AppConfigurationResponseDataResponse;

export type AppsGetError = ErrorResponse;

export type AppsUpsertData = {
  body?: AppDetailsUpsert;
  path: {
    id: number;
  };
};

export type AppsUpsertResponse = void;

export type AppsUpsertError = ErrorResponse;

export type AppsDeleteData = {
  path: {
    id: number;
  };
};

export type AppsDeleteResponse = void;

export type AppsDeleteError = ErrorResponse;

export type AppsConfigurationResponse = ListingItemUnpagedListResults;

export type AppsConfigurationError = ErrorResponse;

export type CarriersListResponse = ShippingCarrierUnpagedListResults;

export type CarriersListError = ErrorResponse;

export type CarriersUpsertData = {
  body?: ShippingCarrierUpsert;
  path: {
    carrierId: number;
  };
};

export type CarriersUpsertResponse = void;

export type CarriersUpsertError = ErrorResponse;

export type CarriersDeleteData = {
  path: {
    carrierId: number;
  };
};

export type CarriersDeleteResponse = void;

export type CarriersDeleteError = ErrorResponse;

export type CarriersGetData = {
  path: {
    id: number;
  };
};

export type CarriersGetResponse = ShippingCarrierDetailsResponseDataResponse;

export type CarriersGetError = ErrorResponse;

export type CarriersConfigurationResponse = ListingItemUnpagedListResults;

export type CarriersConfigurationError = ErrorResponse;

export type CarriersServicesData = {
  body?: ConfigurationRequest;
};

export type CarriersServicesResponse = CarrierServicesResponseResponseData;

export type CarriersServicesError = ErrorResponse;

export type Configurable3PlUpsertData = {
  body?: ClientConfigurationAppIntegrationUpsert;
  path: {
    appId: number;
  };
};

export type Configurable3PlUpsertResponse = void;

export type Configurable3PlUpsertError = ErrorResponse;

export type Configurable3PlConfigurationResponse =
  ConfigurablePipelinesConfigurationResponseResponseData;

export type Configurable3PlConfigurationError = ErrorResponse;

export type IntegrationDictionaryData = {
  body?: ConfigurationRequest;
  path: {
    name: string;
    type: "App" | "Marketplace" | "Carrier";
  };
  query?: {
    integrationId?: string;
  };
};

export type IntegrationDictionaryResponse = IdNameEntity_1UnpagedListResults;

export type IntegrationDictionaryError = ErrorResponse;

export type MarketplacesListAllResponse = MarketplaceDetailsUnpagedListResults;

export type MarketplacesListAllError = ErrorResponse;

export type MarketplacesGetData = {
  path: {
    id: number;
  };
};

export type MarketplacesGetResponse =
  MarketplaceConfigurationResponseDataResponse;

export type MarketplacesGetError = ErrorResponse;

export type MarketplacesUpsertData = {
  body?: MarketplaceUpsert;
  path: {
    id: number;
  };
};

export type MarketplacesUpsertResponse = void;

export type MarketplacesUpsertError = ErrorResponse;

export type MarketplaceDeleteData = {
  path: {
    id: number;
  };
};

export type MarketplaceDeleteResponse = void;

export type MarketplaceDeleteError = ErrorResponse;

export type MarketplaceListedItemsData = {
  path: {
    id: number;
  };
  query?: {
    fulfillment?: "merchant" | "marketplace";
    hideInactive?: boolean;
    includeIgnored?: boolean;
    inStockOnly?: boolean;
    limit?: number;
    offset?: number;
    query?: string;
    status?: "linked" | "suggested" | "unlinked";
  };
};

export type MarketplaceListedItemsResponse = ListedItemListResults;

export type MarketplaceListedItemsError = ErrorResponse;

export type MarketplaceListedItemsBulkUpdateData = {
  body?: ListedItemsBulkUpdateRequest;
  path: {
    id: number;
  };
};

export type MarketplaceListedItemsBulkUpdateResponse = void;

export type MarketplaceListedItemsBulkUpdateError = ErrorResponse;

export type MarketplaceListedItemsExportData = {
  path: {
    id: number;
  };
};

export type MarketplaceListedItemsExportResponse = ExportResponseResponseData;

export type MarketplaceListedItemsExportError = ErrorResponse;

export type MarketplaceListedItemsImportData = {
  body?: MarketplaceItemsUpsertRequest;
  path: {
    id: number;
  };
};

export type MarketplaceListedItemsImportResponse = void;

export type MarketplaceListedItemsImportError = ErrorResponse;

export type MarketplaceListedItemsSummaryData = {
  path: {
    id: number;
  };
};

export type MarketplaceListedItemsSummaryResponse =
  MarketplaceListedItemsSummaryResponseDataResponse;

export type MarketplaceListedItemsSummaryError = ErrorResponse;

export type MarketplaceListedItemsUpdateData = {
  body?: ListedItemsUpdateRequest;
  path: {
    id: number;
  };
};

export type MarketplaceListedItemsUpdateResponse = void;

export type MarketplaceListedItemsUpdateError = ErrorResponse;

export type MarketplacesConfigurationResponse = ListingItemUnpagedListResults;

export type MarketplacesConfigurationError = ErrorResponse;

export type MarketplacesGroupsResponse = MarketplaceGroupBaseUnpagedListResults;

export type MarketplacesGroupsError = ErrorResponse;

export type MarketplacesGroupData = {
  path: {
    id: string;
  };
};

export type MarketplacesGroupResponse =
  MarketplaceGroupConfigurationResponseDataResponse;

export type MarketplacesGroupError = ErrorResponse;

export type PostAuthenticationInviteProcessData = {
  body?: InviteProcessRequest;
};

export type PostAuthenticationInviteProcessResponse = void;

export type PostAuthenticationInviteProcessError = ErrorResponse;

export type PostAuthenticationInviteStatusData = {
  body?: InviteStatusRequest;
};

export type PostAuthenticationInviteStatusResponse =
  InviteStatusResponseResponseData;

export type PostAuthenticationInviteStatusError = ErrorResponse;

export type PostAuthenticationLoginEmailData = {
  body?: LoginEmailRequest;
};

export type PostAuthenticationLoginEmailResponse =
  LoginEmailResponseResponseData;

export type PostAuthenticationLoginEmailError = ErrorResponse;

export type PostAuthenticationLoginMfaData = {
  body?: LoginMfaRequest;
};

export type PostAuthenticationLoginMfaResponse =
  LoginPasswordResponseResponseData;

export type PostAuthenticationLoginMfaError = ErrorResponse;

export type PostAuthenticationLoginMfaNotifyData = {
  body?: LoginMfaNotifyRequest;
};

export type PostAuthenticationLoginMfaNotifyResponse = void;

export type PostAuthenticationLoginMfaNotifyError = ErrorResponse;

export type PostAuthenticationLoginPasswordData = {
  body?: LoginPasswordRequest;
};

export type PostAuthenticationLoginPasswordResponse =
  LoginPasswordResponseResponseData;

export type PostAuthenticationLoginPasswordError = ErrorResponse;

export type PostAuthenticationLogoutResponse = void;

export type PostAuthenticationLogoutError = ErrorResponse;

export type PostAuthenticationOauthData = {
  body?: OauthAuthenticationRequest;
};

export type PostAuthenticationOauthResponse = LoginPasswordResponseResponseData;

export type PostAuthenticationOauthError = ErrorResponse;

export type PostAuthenticationPasswordResetRequestData = {
  body?: ForgotPasswordRequest;
};

export type PostAuthenticationPasswordResetRequestResponse = void;

export type PostAuthenticationPasswordResetRequestError = ErrorResponse;

export type PostAuthenticationPasswordResetResponseData = {
  body?: UserPasswordResetRequest;
};

export type PostAuthenticationPasswordResetResponseResponse = void;

export type PostAuthenticationPasswordResetResponseError = ErrorResponse;

export type GetAuthenticationProfileResponse = UserProfileBaseResponseData;

export type GetAuthenticationProfileError = ErrorResponse;

export type PostAuthenticationProfileData = {
  body?: UserProfileBase;
};

export type PostAuthenticationProfileResponse = void;

export type PostAuthenticationProfileError = ErrorResponse;

export type GetAuthenticationProfileMfaMethodsResponse =
  MfaMethodsResponseResponseData;

export type GetAuthenticationProfileMfaMethodsError = ErrorResponse;

export type DeleteAuthenticationProfileMfaMethodsIdData = {
  path: {
    id: string;
  };
};

export type DeleteAuthenticationProfileMfaMethodsIdResponse = void;

export type DeleteAuthenticationProfileMfaMethodsIdError = ErrorResponse;

export type PutAuthenticationProfileMfaMethodsIdDefaultData = {
  path: {
    id: string;
  };
};

export type PutAuthenticationProfileMfaMethodsIdDefaultResponse = void;

export type PutAuthenticationProfileMfaMethodsIdDefaultError = ErrorResponse;

export type PostAuthenticationProfileMfaSetupData = {
  body?: MfaDeviceSetupRequest;
};

export type PostAuthenticationProfileMfaSetupResponse =
  MfaDeviceSetupResponseResponseData;

export type PostAuthenticationProfileMfaSetupError = ErrorResponse;

export type PostAuthenticationProfileMfaSetupConfirmData = {
  body?: MfaDeviceSetupConfirmRequest;
};

export type PostAuthenticationProfileMfaSetupConfirmResponse =
  MfaSetupConfirmResponseResponseData;

export type PostAuthenticationProfileMfaSetupConfirmError = ErrorResponse;

export type GetAuthenticationProfileMfaTrustedDevicesData = {
  query?: {
    deviceId?: string;
    deviceSignature?: string;
  };
};

export type GetAuthenticationProfileMfaTrustedDevicesResponse =
  TrustedDeviceUnpagedListResults;

export type GetAuthenticationProfileMfaTrustedDevicesError = ErrorResponse;

export type DeleteAuthenticationProfileMfaTrustedDevicesDeviceidData = {
  path: {
    deviceId: string;
  };
};

export type DeleteAuthenticationProfileMfaTrustedDevicesDeviceidResponse = void;

export type DeleteAuthenticationProfileMfaTrustedDevicesDeviceidError =
  ErrorResponse;

export type PostAuthenticationProfilePasswordUpdateData = {
  body?: UserPasswordUpdateRequest;
};

export type PostAuthenticationProfilePasswordUpdateResponse = void;

export type PostAuthenticationProfilePasswordUpdateError = ErrorResponse;

export type PostAuthenticationTokenData = {
  body?: BaseAuthFirstRequest;
};

export type PostAuthenticationTokenResponse = LoginPasswordResponseResponseData;

export type PostAuthenticationTokenError = ErrorResponse;

export type LoginCreateData = {
  body?: LoginCreateSessionRequest;
};

export type LoginCreateResponse = LoginCreateSessionResponseResponseData;

export type LoginCreateError = ErrorResponse;

export type ContactAddressListData = {
  path: {
    contactCode: string;
  };
};

export type ContactAddressListResponse = ContactAddressUnpagedListResults;

export type ContactAddressListError = ErrorResponse;

export type ContactsLookupData = {
  query: {
    query: string;
    tag?: Array<number>;
    /**
     * Contact Type, C: Customers only, S: Suppliers only
     */
    type?: string;
  };
};

export type ContactsLookupResponse = ContactLookupUnpagedListResults;

export type ContactsLookupError = ErrorResponse;

export type ContactTagsListResponse = ContactTagUnpagedListResults;

export type ContactTagsListError = ErrorResponse;

export type ContactTagsListUpsertData = {
  body?: ContactTagUpsert;
  path: {
    id: number;
  };
};

export type ContactTagsListUpsertResponse = void;

export type ContactTagsListUpsertError = ErrorResponse;

export type ContactTagsListDeleteData = {
  path: {
    id: number;
  };
};

export type ContactTagsListDeleteResponse = void;

export type ContactTagsListDeleteError = ErrorResponse;

export type ContactTagsListBulkOperationData = {
  body?: ContactTagBulkOperation;
};

export type ContactTagsListBulkOperationResponse = void;

export type ContactTagsListBulkOperationError = ErrorResponse;

export type ContactCreateData = {
  body?: ContactCreateRequest;
};

export type ContactCreateResponse = ContactLookupResponseDataResponse;

export type ContactCreateError = ErrorResponse | unknown;

export type ContactEntityData = {
  path: {
    id: string;
  };
};

export type ContactEntityResponse = ContactEntityResponseDataResponse;

export type ContactEntityError = ErrorResponse;

export type ContactEntityByCodeData = {
  path: {
    code: string;
  };
};

export type ContactEntityByCodeResponse = ContactEntityResponseDataResponse;

export type ContactEntityByCodeError = ErrorResponse;

export type ContactsListData = {
  query?: {
    active?: "ONLY" | "EXCLUDE";
    creditAlert?: "ONLY" | "EXCLUDE";
    cursor?: string;
    includeArchived?: boolean;
    limit?: number;
    modifiedSince?: Date;
    query?: string;
    salesRep?: Array<string>;
    tagged?: Array<number>;
  };
};

export type ContactsListResponse = ContactListInfoCursorListResults;

export type ContactsListError = ErrorResponse;

export type ContactUpdateData = {
  body?: ContactUpsertRequest;
  path: {
    id: string;
  };
};

export type ContactUpdateResponse = void;

export type ContactUpdateError = ErrorResponse;

export type AppUpdateCheckData = {
  path: {
    appId: string;
  };
};

export type AppUpdateCheckResponse = AppUpdateResponseResponseData;

export type AppUpdateCheckError = ErrorResponse;

export type GetDevicesPrintStationData = {
  query: {
    accessToken: string;
  };
};

export type GetDevicesPrintStationResponse = PrintStationAccessResponseData;

export type GetDevicesPrintStationError = ErrorResponse;

export type PostDevicesPrintStationMappingData = {
  query: {
    accessToken: string;
    machineName: string;
  };
};

export type PostDevicesPrintStationMappingResponse = void;

export type PostDevicesPrintStationMappingError = ErrorResponse | unknown;

export type DocumentAttachmentsListData = {
  path: {
    documentId: string;
    documentType: string;
  };
};

export type DocumentAttachmentsListResponse =
  DocumentAttachmentUnpagedListResults;

export type DocumentAttachmentsListError = ErrorResponse;

export type DocumentAttachmentsCreateData = {
  body?: {
    file: Array<Blob | File>;
    description?: string;
  };
  path: {
    documentId: string;
    documentType: string;
  };
};

export type DocumentAttachmentsCreateResponse = void;

export type DocumentAttachmentsCreateError = ErrorResponse;

export type ScanToCloudUploadData = {
  body?: {
    documentId: string;
    decoders?: string;
    file: Array<Blob | File>;
    description?: string;
  };
};

export type ScanToCloudUploadResponse = void;

export type ScanToCloudUploadError = ErrorResponse;

export type BulkInsertData = {
  body?: DocumentItemBulkInsertItemBasedBulkUpsertRequest;
  path: {
    documentId: string;
    documentType: string;
  };
};

export type BulkInsertResponse = void;

export type BulkInsertError = ErrorResponse;

export type DataExportMonitorListData = {
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    showGlobalExports?: boolean;
  };
};

export type DataExportMonitorListResponse = DataExportDisplayDetailsListResults;

export type DataExportMonitorListError = ErrorResponse;

export type DocumentDetailsData = {
  path: {
    documentId: string;
    documentType: string;
  };
};

export type DocumentDetailsResponse = GenericDocumentDetailsResponseData;

export type DocumentDetailsError = ErrorResponse;

export type ExportPendingUpdateData = {
  body?: DocumentExportUpdate;
  path: {
    documentId: string;
    documentType: string;
  };
};

export type ExportPendingUpdateResponse = void;

export type ExportPendingUpdateError = ErrorResponse;

export type ExportPendingListData = {
  path: {
    headerId: number;
  };
};

export type ExportPendingListResponse = ExportPendingResponseData;

export type ExportPendingListError = ErrorResponse;

export type ItemSearchData = {
  path: {
    documentType: string;
  };
  query?: {
    appCatId?: string;
    brandId?: string;
    contactId?: string;
    pricelistId?: string;
    query?: string;
    skuSearch?: string;
    warehouseId?: string;
  };
};

export type ItemSearchResponse = ItemLookupDocumentUnpagedListResults;

export type ItemSearchError = ErrorResponse;

export type ItemPriceLookupData = {
  path: {
    documentType: string;
    itemId: string;
  };
  query?: {
    contactId?: string;
    currency?: string;
    pricelistId?: string;
    qty?: string;
    uomId?: number;
    warehouseId?: string;
  };
};

export type ItemPriceLookupResponse = ItemPriceLookupResponseData;

export type ItemPriceLookupError = ErrorResponse;

export type MatchedDocumentAiDetailsData = {
  path: {
    documentId: string;
  };
};

export type MatchedDocumentAiDetailsResponse =
  MatchedDocumentResponseResponseDataResponse;

export type MatchedDocumentAiDetailsError = ErrorResponse;

export type MatchedDocumentAiAcceptData = {
  path: {
    documentId: string;
  };
};

export type MatchedDocumentAiAcceptResponse = void;

export type MatchedDocumentAiAcceptError = ErrorResponse;

export type MatchedDocumentAiConfirmContactData = {
  body?: MatchedDocumentAiSetContactRequest;
  path: {
    documentId: string;
  };
};

export type MatchedDocumentAiConfirmContactResponse =
  MatchedDocumentResponseResponseDataResponse;

export type MatchedDocumentAiConfirmContactError = ErrorResponse;

export type MatchedDocumentAiCreateData = {
  body?: {
    file: Blob | File;
    use?: boolean;
  };
};

export type MatchedDocumentAiCreateResponse =
  MatchedDocumentResponseResponseDataResponse;

export type MatchedDocumentAiCreateError = ErrorResponse;

export type DocumentNotesListData = {
  path: {
    documentId: string;
    documentType: string;
  };
};

export type DocumentNotesListResponse = DocumentNoteUnpagedListResults;

export type DocumentNotesListError = ErrorResponse;

export type DocumentNotesAppendData = {
  body?: NewDocumentNote;
  path: {
    documentId: string;
    documentType: string;
  };
};

export type DocumentNotesAppendResponse = DocumentNoteResponseData;

export type DocumentNotesAppendError = ErrorResponse;

export type DocumentNotesDeleteData = {
  path: {
    noteId: number;
  };
};

export type DocumentNotesDeleteResponse = void;

export type DocumentNotesDeleteError = ErrorResponse;

export type PostcodeLookupData = {
  body?: PostcodeLookupRequest;
};

export type PostcodeLookupResponse = DocumentAddressUnpagedListResults;

export type PostcodeLookupError = ErrorResponse;

export type DocumentQueuesData = {
  path: {
    documentType: string;
  };
};

export type DocumentQueuesResponse = DocumentQueueUnpagedListResults;

export type DocumentQueuesError = ErrorResponse;

export type DocumentsSearchData = {
  query: {
    documentTypes?: string;
    query: string;
  };
};

export type DocumentsSearchResponse = DocumentSearchResultUnpagedListResults;

export type DocumentsSearchError = ErrorResponse;

export type GetDocumentsStorageKeyData = {
  path: {
    key: string;
  };
};

export type PostDocumentsStorageKeyData = {
  body?: StorageDataRequest;
  path: {
    key: string;
  };
};

export type DocumentTagsUpdateData = {
  body?: DocumentTagsUpdate;
  path: {
    documentId: string;
    documentType: string;
  };
};

export type DocumentTagsUpdateResponse = void;

export type DocumentTagsUpdateError = ErrorResponse;

export type GetInboundDocumentAsnData = {
  query?: {
    contact?: Array<string>;
    customField?: Array<string>;
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    reference?: string;
    status?: Array<string>;
  };
};

export type GetInboundDocumentAsnResponse = AsnResultListResults;

export type GetInboundDocumentAsnError = ErrorResponse;

export type PurchaseOrderGetData = {
  path: {
    documentId: string;
  };
};

export type PurchaseOrderGetResponse = PurchaseOrderDocumentResponseData;

export type PurchaseOrderGetError = ErrorResponse;

export type PoListData = {
  query?: {
    asnId?: number;
    billingStage?: Array<"Pending" | "Partially" | "Complete">;
    contact?: Array<string>;
    currency?: string;
    directDispatch?: "ONLY" | "EXCLUDE";
    dueOnly?: boolean;
    dueWithin?: number;
    endDate?: Date;
    etaMax?: Date;
    etaMin?: Date;
    excludeTagged?: Array<number>;
    finalized?: "ONLY" | "EXCLUDE";
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    orderType?: "Pending" | "Partially" | "Complete";
    receivingStage?: Array<"Pending" | "Partially" | "Complete">;
    stage?: Array<number>;
    startDate?: Date;
    status?: Array<"DRAFT" | "CONFIRMED" | "ACKNOWLEDGED" | "CANCELLED">;
    supplierReference?: string;
    tagged?: Array<number>;
    warehouseCode?: string;
  };
};

export type PoListResponse = ListResultsPoListResults;

export type PoListError = ErrorResponse;

export type GetInboundDocumentShpSearchData = {
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
  };
};

export type GetInboundDocumentShpSearchResponse = ShipmentDetailListResults;

export type GetInboundDocumentShpSearchError = ErrorResponse;

export type ItemsMappingData = {
  body?: ItemsMappingRequest;
};

export type ItemsMappingResponse2 = ItemsMappingResponseResponseData;

export type ItemsMappingError = ErrorResponse;

export type GetInboundPendingResponse = Array<PendingInboundDocument>;

export type GetInboundPendingError = ErrorResponse;

export type CreatePurchaseOrderData = {
  body?: CreatePurchaseOrderRequest;
};

export type CreatePurchaseOrderResponse = DocumentTypeResponseDataResponse;

export type CreatePurchaseOrderError = ErrorResponse;

export type CreatePurchaseOrdersData = {
  body?: Array<CreatePurchaseOrderRequest>;
};

export type CreatePurchaseOrdersResponse = DocumentTypeUnpagedListResults;

export type CreatePurchaseOrdersError = ErrorResponse;

export type RctDocumentLinkedData = {
  path: {
    documentId: string;
    documentType: string;
  };
};

export type RctDocumentLinkedResponse = RctDocumentUnpagedListResults;

export type RctDocumentLinkedError = ErrorResponse;

export type ReceiveData = {
  body?: InboundReceiveMultipleDocumentsRequest;
};

export type ReceiveResponse2 = ReceiveResponse;

export type ReceiveError = ErrorResponse;

export type ReceiveByDocumentData = {
  body?: InboundReceiveRequest;
  path: {
    documentId: string;
    documentType: string;
  };
};

export type ReceiveByDocumentResponse = ReceiveResponse;

export type ReceiveByDocumentError = ErrorResponse;

export type InboundDocumentGetData = {
  path: {
    documentId: string;
    documentType: string;
  };
};

export type InboundDocumentGetResponse = InboundDocumentResponseData;

export type InboundDocumentGetError = ErrorResponse;

export type InboundDocumentCreateData = {
  body?: InboundDocumentReceive;
  headers: {
    "x-idempotency-key": string;
  };
  path: {
    documentId: string;
    documentType: string;
  };
};

export type InboundDocumentCreateResponse = void;

export type InboundDocumentCreateError = ErrorResponse;

export type PostInventoryAssemblyCreateData = {
  body?: ItemAssemblyCreateRequest;
};

export type PostInventoryAssemblyCreateResponse = ItemAssemblyCreateRequest;

export type PostInventoryAssemblyCreateError = ErrorResponse;

export type PostInventoryAssemblyPrepData = {
  body?: ItemAssemblyPrepRequest;
};

export type PostInventoryAssemblyPrepResponse =
  ItemAssemblyPrepResponseResponseDataResponse;

export type PostInventoryAssemblyPrepError = ErrorResponse;

export type GetInventoryAssemblyWorkOrdersData = {
  query?: {
    cursor?: string;
    dueOnly?: boolean;
    limit?: number;
    status?: "Planned" | "InProgress" | "Completed" | "Cancelled";
  };
};

export type GetInventoryAssemblyWorkOrdersResponse =
  WorkOrderSummaryCursorListResults;

export type GetInventoryAssemblyWorkOrdersError = ErrorResponse;

export type GetInventoryAssemblyWorkOrdersIdData = {
  path: {
    id: number;
  };
};

export type GetInventoryAssemblyWorkOrdersIdResponse =
  WorkOrderResponseDataResponse;

export type GetInventoryAssemblyWorkOrdersIdError = ErrorResponse;

export type BinContentData = {
  path: {
    binName: string;
  };
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    uomCode?: string;
  };
};

export type BinContentResponse = BinContentItemListResults;

export type BinContentError = ErrorResponse;

export type CatalogItemsExportData = {
  body?: ExportRequest;
  path: {
    id: number;
  };
};

export type CatalogItemsExportResponse = ExportResponseResponseData;

export type CatalogItemsExportError = ErrorResponse;

export type ItemCatalogBulkImportData = {
  body?: ItemsCatalogUpsertItemBasedBulkUpsertRequest;
  path: {
    id: number;
  };
};

export type ItemCatalogBulkImportResponse = void;

export type ItemCatalogBulkImportError = ErrorResponse;

export type ItemIdentifierNextEanResponse = StringResponseData;

export type ItemIdentifierNextEanError = ErrorResponse;

export type ItemLabelsDocumentListData = {
  path: {
    documentId: string;
    documentType: string;
  };
};

export type ItemLabelsDocumentListResponse =
  ItemLabelPrintResultUnpagedListResults;

export type ItemLabelsDocumentListError = ErrorResponse;

export type ItemLabelsPrintBulkData = {
  body?: ItemLabelsPrintRequest;
};

export type ItemLabelsPrintBulkResponse = void;

export type ItemLabelsPrintBulkError = ErrorResponse;

export type ItemLabelsDocumentPrintData = {
  body?: ItemLabelsDocumentPrintRequest;
  path: {
    documentId: string;
    documentType: string;
  };
};

export type ItemLabelsDocumentPrintResponse = void;

export type ItemLabelsDocumentPrintError = ErrorResponse;

export type ItemBasicDetailsData = {
  path: {
    itemSku: string;
  };
};

export type ItemBasicDetailsResponse = ItemLookupImageResponseDataResponse;

export type ItemBasicDetailsError = ErrorResponse | unknown;

export type ItemBatchesData = {
  path: {
    itemSku: string;
  };
};

export type ItemBatchesResponse = ItemBatchInfoUnpagedListResults;

export type ItemBatchesError = ErrorResponse | unknown;

export type ItemContactInfoUpsertData = {
  body?: ItemContactInfoUpsert;
  path: {
    contactCode: string;
    itemSku: string;
  };
};

export type ItemContactInfoUpsertResponse = void;

export type ItemContactInfoUpsertError = ErrorResponse;

export type ItemIdentifierAppendData = {
  path: {
    /**
     * Item SKU
     */
    itemSku: string;
  };
  query: {
    /**
     * Item identifier text
     */
    identifier: string;
    /**
     * UOM Code or name, optional, uses item default UOM if left blank
     */
    uom?: string;
  };
};

export type ItemIdentifierAppendResponse = void;

export type ItemIdentifierAppendError = ErrorResponse | unknown;

export type ItemImagesAddData = {
  body?: AppendItemImageRequest;
  path: {
    itemSku: string;
  };
};

export type ItemImagesAddResponse = AppendItemImageResponseUnpagedListResults;

export type ItemImagesAddError = ErrorResponse;

export type ItemImagesDeleteData = {
  path: {
    imageId: number;
    itemSku: string;
  };
};

export type ItemImagesDeleteResponse = void;

export type ItemImagesDeleteError = ErrorResponse;

export type ItemImageUpdateData = {
  path: {
    imageId: number;
    itemSku: string;
  };
  query?: {
    setDefault?: boolean;
    setPrivate?: boolean;
  };
};

export type ItemImageUpdateResponse = void;

export type ItemImageUpdateError = ErrorResponse;

export type ItemInventoryData = {
  path: {
    itemSku: string;
  };
  query?: {
    uomId?: number;
  };
};

export type ItemInventoryResponse = ItemInventorySummaryResponseData;

export type ItemInventoryError = ErrorResponse | unknown;

export type ItemInventory3DData = {
  path: {
    itemSku: string;
  };
  query?: {
    summaryGrouping?: "Bin" | "Batch";
    warehouseId?: string;
  };
};

export type ItemInventory3DResponse = ItemInventory3dSummaryUnpagedListResults;

export type ItemInventory3DError = ErrorResponse | unknown;

export type ItemInventoryLogData = {
  path: {
    itemSku: string;
  };
  query?: {
    batchId?: number;
    bin?: string;
    endDate?: Date;
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    startDate?: Date;
    transactionType?: string;
    warehouseId?: string;
  };
};

export type ItemInventoryLogResponse = ItemInventoryLogListResults;

export type ItemInventoryLogError = ErrorResponse | unknown;

export type ItemInventoryDrilldownData = {
  path: {
    itemSku: string;
    warehouseId: string;
  };
  query: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    type:
      | "INBOUND"
      | "OUTBOUND"
      | "AGING"
      | "UNINVOICED"
      | "TRN"
      | "POB2B"
      | "PODD"
      | "BLOCKED";
  };
};

export type ItemInventoryDrilldownResponse = ItemInventoryDrilldownListResults;

export type ItemInventoryDrilldownError = ErrorResponse | unknown;

export type ItemPricingData = {
  path: {
    itemSku: string;
  };
};

export type ItemPricingResponse = PricelistEntryPerItemUnpagedListResults;

export type ItemPricingError = ErrorResponse | unknown;

export type ItemQuickViewData = {
  path: {
    itemSku: string;
    qvType: "SALES" | "PURCHASES";
  };
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
  };
};

export type ItemQuickViewResponse = ItemQuickViewResultsListResults;

export type ItemQuickViewError = ErrorResponse | unknown;

export type ItemUomData = {
  path: {
    itemSku: string;
  };
};

export type ItemUomResponse = ItemUomUnpagedListResults;

export type ItemUomError = ErrorResponse | unknown;

export type ItemVendorCatalogUpsertData = {
  body?: ItemVendorCatalogUpsert;
  path: {
    contactCode: string;
    itemSku: string;
  };
};

export type ItemVendorCatalogUpsertResponse = void;

export type ItemVendorCatalogUpsertError = ErrorResponse;

export type ItemImagesBulkUpdateData = {
  body?: ItemImagesBulkUpdateRequest;
};

export type ItemImagesBulkUpdateResponse = void;

export type ItemImagesBulkUpdateError = ErrorResponse;

export type ItemImagesDropData = {
  body?: {
    /**
     * Maximum file size is 10 MB. Allowed files: .jpg, .jpeg, .png, .gif
     */
    file: Blob | File;
    skus?: Array<string>;
    setPrivate?: boolean;
    setPrimary?: boolean;
    tagsAdd?: Array<number>;
  };
};

export type ItemImagesDropResponse2 = ItemImagesDropResponseResponseData;

export type ItemImagesDropError = ErrorResponse;

export type PatchInventoryItemTagsData = {
  body?: ItemTagsUpdate;
};

export type PatchInventoryItemTagsResponse = void;

export type PatchInventoryItemTagsError = ErrorResponse;

export type ItemsListExportData = {
  query?: {
    "images.tag"?: Array<number>;
    "images.tagExclude"?: Array<number>;
    "images.untagged"?: boolean;
    imageView?: boolean;
    inStockOnly?: boolean;
    "items.appCategory"?: Array<number>;
    "items.appCategoryExclude"?: boolean;
    "items.appHidden"?: "ONLY" | "EXCLUDE";
    "items.appMarkedNew"?: "ONLY" | "EXCLUDE";
    "items.brand"?: Array<number>;
    "items.brandExclude"?: boolean;
    "items.category"?: Array<number>;
    "items.categoryExclude"?: boolean;
    "items.department"?: Array<number>;
    "items.departmentExclude"?: boolean;
    "items.eol"?: "ONLY" | "EXCLUDE";
    "items.sku"?: Array<string>;
    "items.skuExclude"?: boolean;
    "items.tag"?: Array<number>;
    "items.tagExclude"?: Array<number>;
    "items.tagsAll"?: boolean;
    "items.type"?: Array<
      "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM"
    >;
    "items.vendor"?: Array<string>;
    "items.vendorExclude"?: boolean;
    limit?: number;
    offset?: number;
    pimView?: number;
    pricelistId?: string;
    query?: string;
    uomId?: number;
    warehouseId?: string;
  };
};

export type ItemsListExportResponse = ExportResponseResponseData;

export type ItemsListExportError = ErrorResponse;

export type ItemsListData = {
  query?: {
    "images.tag"?: Array<number>;
    "images.tagExclude"?: Array<number>;
    "images.untagged"?: boolean;
    imageView?: boolean;
    inStockOnly?: boolean;
    "items.appCategory"?: Array<number>;
    "items.appCategoryExclude"?: boolean;
    "items.appHidden"?: "ONLY" | "EXCLUDE";
    "items.appMarkedNew"?: "ONLY" | "EXCLUDE";
    "items.brand"?: Array<number>;
    "items.brandExclude"?: boolean;
    "items.category"?: Array<number>;
    "items.categoryExclude"?: boolean;
    "items.department"?: Array<number>;
    "items.departmentExclude"?: boolean;
    "items.eol"?: "ONLY" | "EXCLUDE";
    "items.sku"?: Array<string>;
    "items.skuExclude"?: boolean;
    "items.tag"?: Array<number>;
    "items.tagExclude"?: Array<number>;
    "items.tagsAll"?: boolean;
    "items.type"?: Array<
      "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM"
    >;
    "items.vendor"?: Array<string>;
    "items.vendorExclude"?: boolean;
    limit?: number;
    offset?: number;
    pimView?: number;
    pricelistId?: string;
    query?: string;
    uomId?: number;
    warehouseId?: string;
  };
};

export type ItemsListResponse = ItemsListResultResponseData;

export type ItemsListError = ErrorResponse;

export type ItemsListBySkusData = {
  body?: ItemsListBySkuRequest;
};

export type ItemsListBySkusResponse = ItemsListResultResponseData;

export type ItemsListBySkusError = ErrorResponse;

export type ItemsBulkUpsertData = {
  body?: BulkItemUpsertRequest;
};

export type ItemsBulkUpsertResponse = void;

export type ItemsBulkUpsertError = ErrorResponse;

export type ItemLookupData = {
  query: {
    query: string;
  };
};

export type ItemLookupResponse = IEnumerable_1ResponseData;

export type ItemLookupError = ErrorResponse;

export type PricelistConditionalUpsertData = {
  body?: PricelistConditionalUpsertPricelistUpsert;
};

export type PricelistConditionalUpsertResponse = void;

export type PricelistConditionalUpsertError = ErrorResponse;

export type PricelistUomUpsertData = {
  body?: PricelistUomUpsertPricelistUpsert;
};

export type PricelistUomUpsertResponse = void;

export type PricelistUomUpsertError = ErrorResponse;

export type PricelistPurgeConditionalsData = {
  path: {
    id: string;
  };
};

export type PricelistPurgeConditionalsResponse = void;

export type PricelistPurgeConditionalsError = ErrorResponse;

export type PricelistExportData = {
  body?: PricelistExportRequest;
  path: {
    id: string;
  };
};

export type PricelistExportResponse = ExportResponseResponseData;

export type PricelistExportError = ErrorResponse;

export type PricelistPurgeConditionalsAllResponse = void;

export type PricelistPurgeConditionalsAllError = ErrorResponse;

export type PricelistExportAllData = {
  body?: PricelistExportRequest;
};

export type PricelistExportAllResponse = ExportResponseResponseData;

export type PricelistExportAllError = ErrorResponse;

export type PricelistEntriesUpsertData = {
  body?: PricelistEntryUpsertPricelistBulkUpsert;
};

export type PricelistEntriesUpsertResponse = void;

export type PricelistEntriesUpsertError = ErrorResponse;

export type StockSummaryData = {
  query?: {
    /**
     * A date (UTC) since last stock change
     */
    modifiedSinceUtc?: Date;
    /**
     * List of SKUs to retrieve
     */
    skus?: Array<string>;
    /**
     * When blank will use default warehouse, use * for all warehouses or specify warehouse code
     */
    warehouseCode?: string;
  };
};

export type StockSummaryResponse =
  ItemInventoryByItemWarehouseUnpagedListResults;

export type StockSummaryError = ErrorResponse;

export type StockSummaryDetailedData = {
  query?: {
    /**
     * A date (UTC) since last stock change
     */
    modifiedSinceUtc?: Date;
    /**
     * Filter for items in a pricelist
     */
    pricelistId?: string;
    /**
     * List of SKUs to retrieve
     */
    skus?: Array<string>;
    /**
     * When blank will use default warehouse, use * for all warehouses or specify warehouse code
     */
    warehouseCode?: string;
  };
};

export type StockSummaryDetailedResponse =
  ItemInventoryByItemWarehouseDetailedUnpagedListResults;

export type StockSummaryDetailedError = ErrorResponse;

export type ItemAppCategoriesDeleteData = {
  path: {
    id: number;
  };
};

export type ItemAppCategoriesDeleteResponse = void;

export type ItemAppCategoriesDeleteError = ErrorResponse;

export type ItemAppCategoriesGetData = {
  path: {
    id: number;
  };
};

export type ItemAppCategoriesGetResponse =
  ItemAppCategoryDetailsResponseDataResponse;

export type ItemAppCategoriesGetError = ErrorResponse;

export type ItemAppCategoriesUpsertData = {
  body?: {
    name?: string;
    description?: string;
    parentId?: number;
    isHidden?: boolean;
    image?: Blob | File;
  };
  path: {
    id: number;
  };
};

export type ItemAppCategoriesUpsertResponse = void;

export type ItemAppCategoriesUpsertError = ErrorResponse;

export type ItemAppCategoriesSortingData = {
  body?: IdListRequest;
};

export type ItemAppCategoriesSortingResponse = void;

export type ItemAppCategoriesSortingError = ErrorResponse;

export type ItemBrandsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemBrandsDeleteResponse = void;

export type ItemBrandsDeleteError = ErrorResponse;

export type ItemBrandsUpsertData = {
  body?: {
    /**
     * Maximum file size is 500 KB. Allowed files: .jpg, .jpeg, .png, .gif
     */
    image?: Blob | File;
    discountValue?: number;
    LeadTime?: number;
    ImageUrl?: string;
    Name?: string;
  };
  path: {
    id: number;
  };
};

export type ItemBrandsUpsertResponse = void;

export type ItemBrandsUpsertError = ErrorResponse;

export type ItemCatalogsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemCatalogsDeleteResponse = void;

export type ItemCatalogsDeleteError = ErrorResponse;

export type ItemCatalogsUpsertData = {
  body?: ItemCatalogUpsert;
  path: {
    id: number;
  };
};

export type ItemCatalogsUpsertResponse = void;

export type ItemCatalogsUpsertError = ErrorResponse;

export type ItemCatalogsPurgeData = {
  path: {
    id: number;
  };
};

export type ItemCatalogsPurgeResponse = void;

export type ItemCatalogsPurgeError = ErrorResponse;

export type ItemCategoriesDeleteData = {
  path: {
    id: number;
  };
};

export type ItemCategoriesDeleteResponse = void;

export type ItemCategoriesDeleteError = ErrorResponse;

export type ItemCategoriesUpsertData = {
  body?: ItemCategoryUpsert;
  path: {
    id: number;
  };
};

export type ItemCategoriesUpsertResponse = void;

export type ItemCategoriesUpsertError = ErrorResponse;

export type ItemImageTagsListResponse = ImageTagUnpagedListResults;

export type ItemImageTagsListError = ErrorResponse;

export type ItemImageTagsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemImageTagsDeleteResponse = void;

export type ItemImageTagsDeleteError = ErrorResponse;

export type ItemImageTagsUpsertData = {
  body?: ImageTagUpsert;
  path: {
    id: number;
  };
};

export type ItemImageTagsUpsertResponse = void;

export type ItemImageTagsUpsertError = ErrorResponse;

export type ItemDepartmentsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemDepartmentsDeleteResponse = void;

export type ItemDepartmentsDeleteError = ErrorResponse;

export type ItemDepartmentsUpsertData = {
  body?: ItemDepartmentUpsert;
  path: {
    id: number;
  };
};

export type ItemDepartmentsUpsertResponse = void;

export type ItemDepartmentsUpsertError = ErrorResponse;

export type ItemTagsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemTagsDeleteResponse = void;

export type ItemTagsDeleteError = ErrorResponse;

export type ItemTagsUpsertData = {
  body?: ItemTagUpsert;
  path: {
    id: number;
  };
};

export type ItemTagsUpsertResponse = void;

export type ItemTagsUpsertError = ErrorResponse;

export type ItemViewsListResponse = ItemViewUnpagedListResults;

export type ItemViewsListError = ErrorResponse;

export type ItemViewsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemViewsDeleteResponse = void;

export type ItemViewsDeleteError = ErrorResponse;

export type ItemViewsUpsertData = {
  body?: ItemViewUpsert;
  path: {
    id: number;
  };
};

export type ItemViewsUpsertResponse = void;

export type ItemViewsUpsertError = ErrorResponse;

export type ItemViewsFieldDefinitionsResponse =
  ItemViewFieldDefinitionUnpagedListResults;

export type ItemViewsFieldDefinitionsError = ErrorResponse;

export type InventoryModelsListResponse = InventoryModelUnpagedListResults;

export type InventoryModelsListError = ErrorResponse;

export type InventoryModelsUpsertData = {
  body?: InventoryModelUpsert;
};

export type InventoryModelsUpsertResponse = void;

export type InventoryModelsUpsertError = ErrorResponse;

export type InventoryModelsDeleteData = {
  path: {
    id: number;
  };
};

export type InventoryModelsDeleteResponse = void;

export type InventoryModelsDeleteError = ErrorResponse;

export type PimCompletenessListResponse = PimCompletenessUnpagedListResults;

export type PimCompletenessListError = ErrorResponse;

export type PimCompletenessDeleteData = {
  path: {
    id: number;
  };
};

export type PimCompletenessDeleteResponse = void;

export type PimCompletenessDeleteError = ErrorResponse;

export type PimCompletenessUpsertData = {
  body?: PimCompletenessUpsert;
  path: {
    id: number;
  };
};

export type PimCompletenessUpsertResponse = void;

export type PimCompletenessUpsertError = ErrorResponse;

export type PricelistListResponse = PricelistUnpagedListResults;

export type PricelistListError = ErrorResponse;

export type PricelistUpsertData = {
  body?: PricelistUpsert;
};

export type PricelistUpsertResponse = void;

export type PricelistUpsertError = ErrorResponse;

export type PricelistDeleteData = {
  path: {
    id: string;
  };
};

export type PricelistDeleteResponse = void;

export type PricelistDeleteError = ErrorResponse;

export type PricelistSetDefaultData = {
  path: {
    id: string;
  };
};

export type PricelistSetDefaultResponse = void;

export type PricelistSetDefaultError = ErrorResponse;

export type InventoryProfilesListResponse =
  InventoryProfileWithDetailsUnpagedListResults;

export type InventoryProfilesListError = ErrorResponse;

export type InventoryProfilesUpsertData = {
  body?: InventoryProfileUpsert;
  path: {
    id: number;
  };
};

export type InventoryProfilesUpsertResponse = void;

export type InventoryProfilesUpsertError = ErrorResponse;

export type InventoryProfilesDeleteData = {
  path: {
    id: number;
  };
};

export type InventoryProfilesDeleteResponse = void;

export type InventoryProfilesDeleteError = ErrorResponse;

export type ItemSpecificationsListResponse =
  ItemSpecificationUnpagedListResults;

export type ItemSpecificationsListError = ErrorResponse;

export type ItemSpecificationsDeleteData = {
  path: {
    id: number;
  };
};

export type ItemSpecificationsDeleteResponse = void;

export type ItemSpecificationsDeleteError = ErrorResponse;

export type ItemSpecificationsUpsertData = {
  body?: ItemSpecificationUpsert;
  path: {
    id: number;
  };
};

export type ItemSpecificationsUpsertResponse = void;

export type ItemSpecificationsUpsertError = ErrorResponse;

export type ItemSpecificationsExportResponse = void;

export type ItemSpecificationsExportError = ErrorResponse;

export type ItemSpecificationsSetOrderData = {
  body?: IdListRequest;
};

export type ItemSpecificationsSetOrderResponse = void;

export type ItemSpecificationsSetOrderError = ErrorResponse;

export type TrcClassListResponse = TrcClassUnpagedListResults;

export type TrcClassListError = ErrorResponse;

export type TrcClassUpsertData = {
  body?: TrcClassUpsert;
  path: {
    id: number;
  };
};

export type TrcClassUpsertResponse = void;

export type TrcClassUpsertError = ErrorResponse;

export type TrcClassDeleteData = {
  path: {
    id: number;
  };
};

export type TrcClassDeleteResponse = void;

export type TrcClassDeleteError = ErrorResponse;

export type UomListResponse = ItemUomEntityUnpagedListResults;

export type UomListError = ErrorResponse;

export type UomUpsertData = {
  body?: ItemUomUpsert;
};

export type UomUpsertResponse = void;

export type UomUpsertError = ErrorResponse;

export type UomDeleteData = {
  path: {
    id: number;
  };
};

export type UomDeleteResponse = void;

export type UomDeleteError = ErrorResponse;

export type UomSetDefaultData = {
  path: {
    id: number;
  };
};

export type UomSetDefaultResponse = void;

export type UomSetDefaultError = ErrorResponse;

export type ItemAppCategoriesListResponse =
  ItemAppCategoryHierarchyUnpagedListResults;

export type ItemAppCategoriesListError = ErrorResponse;

export type ItemBrandsListResponse = ItemBrandUnpagedListResults;

export type ItemBrandsListError = ErrorResponse;

export type ItemCatalogsListResponse = ItemCatalogUnpagedListResults;

export type ItemCatalogsListError = ErrorResponse;

export type ItemCategoriesListResponse = ItemCategoryUnpagedListResults;

export type ItemCategoriesListError = ErrorResponse;

export type ItemDepartmentsListResponse = IdNameEntityUnpagedListResults;

export type ItemDepartmentsListError = ErrorResponse;

export type ItemTagsListResponse = ItemTagUnpagedListResults;

export type ItemTagsListError = ErrorResponse;

export type ItemCreateData = {
  body?: ItemCreateRequest;
};

export type ItemCreateResponse = ItemBaseResponseDataResponse;

export type ItemCreateError = ErrorResponse;

export type InventoryItemsDetailsData = {
  path: {
    sku: string;
  };
};

export type InventoryItemsDetailsResponse = ItemListInfoResponseDataResponse;

export type InventoryItemsDetailsError = ErrorResponse;

export type InventoryItemsListData = {
  query?: {
    cursor?: string;
    inStockOnly?: boolean;
    "items.appCategory"?: Array<number>;
    "items.appCategoryExclude"?: boolean;
    "items.appHidden"?: "ONLY" | "EXCLUDE";
    "items.appMarkedNew"?: "ONLY" | "EXCLUDE";
    "items.brand"?: Array<number>;
    "items.brandExclude"?: boolean;
    "items.category"?: Array<number>;
    "items.categoryExclude"?: boolean;
    "items.department"?: Array<number>;
    "items.departmentExclude"?: boolean;
    "items.eol"?: "ONLY" | "EXCLUDE";
    "items.sku"?: Array<string>;
    "items.skuExclude"?: boolean;
    "items.tag"?: Array<number>;
    "items.tagExclude"?: Array<number>;
    "items.tagsAll"?: boolean;
    "items.type"?: Array<
      "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM"
    >;
    "items.vendor"?: Array<string>;
    "items.vendorExclude"?: boolean;
    limit?: number;
    modifiedSince?: Date;
    pricelistId?: string;
    query?: string;
    uomId?: number;
    warehouseId?: string;
  };
};

export type InventoryItemsListResponse = ItemListInfoCursorListResults;

export type InventoryItemsListError = ErrorResponse;

export type MarketplaceDetailsData = {
  path: {
    mpId: string;
  };
};

export type MarketplaceDetailsResponse = MarketplaceDetailsResponseData;

export type MarketplaceDetailsError = ErrorResponse;

export type AmazonInboundPrepInstructionsData = {
  body?: AmazonInboundPrepInstructionsRequest;
  path: {
    mpId: string;
  };
};

export type AmazonInboundPrepInstructionsResponse2 =
  AmazonInboundPrepInstructionsResponseUnpagedListResults;

export type AmazonInboundPrepInstructionsError = ErrorResponse;

export type AmazonInboundUpdatePrepDetailsData = {
  body?: AmazonInboundUpdatePrepDetailsRequest;
  path: {
    mpId: string;
  };
};

export type AmazonInboundUpdatePrepDetailsResponse = void;

export type AmazonInboundUpdatePrepDetailsError = ErrorResponse;

export type AmazonInboundPlacementTransportAcceptData = {
  body?: InboundPlanTransportationConfirmationRequest;
  path: {
    mpId: string;
    trnId: number;
  };
};

export type AmazonInboundPlacementTransportAcceptResponse = void;

export type AmazonInboundPlacementTransportAcceptError = ErrorResponse;

export type AmazonInboundPlacementTransportListData = {
  body?: InboundPlanTransportationOptionsRequest;
  path: {
    mpId: string;
    trnId: number;
  };
};

export type AmazonInboundPlacementTransportListResponse =
  InboundPlanTransportationOptionsResponseResponseDataResponse;

export type AmazonInboundPlacementTransportListError = ErrorResponse;

export type AmazonInboundPlanCreateTrnData = {
  path: {
    mpId: string;
    planId: string;
    warehouseId: string;
  };
};

export type AmazonInboundPlanCreateTrnResponse =
  InboundPlanTrnUnpagedListResults;

export type AmazonInboundPlanCreateTrnError = ErrorResponse;

export type AmazonInboundPlanPlacementOptionsDetailedListData = {
  body?: InboundPlanShipmentPlacementDetailsRequest;
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlanPlacementOptionsDetailedListResponse =
  InboundPlanShipmentPlacementDetailsResponseUnpagedListResults;

export type AmazonInboundPlanPlacementOptionsDetailedListError = ErrorResponse;

export type AmazonInboundPlanPlacementOptionsDetailsData = {
  path: {
    mpId: string;
    placementOptionId: string;
    planId: string;
  };
};

export type AmazonInboundPlanPlacementOptionsDetailsResponse =
  InboundPlanShipmentPlacementDetailsResponseResponseDataResponse;

export type AmazonInboundPlanPlacementOptionsDetailsError = ErrorResponse;

export type AmazonInboundPlanShipmentsListData = {
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlanShipmentsListResponse =
  UnpagedListResults_1UnpagedListResults;

export type AmazonInboundPlanShipmentsListError = ErrorResponse;

export type AmazonInboundPlanTransportationConfirmationData = {
  body?: SpApiFulfillmentInboundConfirmTransportationOptionsRequest;
  path: {
    mpId: string;
    planId: string;
  };
};

export type AmazonInboundPlanTransportationConfirmationResponse = void;

export type AmazonInboundPlanTransportationConfirmationError = ErrorResponse;

export type AmazonInboundPlanTransportListData = {
  body?: SpApiFulfillmentInboundGenerateTransportationOptionsRequest;
  path: {
    mpId: string;
    planId: string;
  };
  query?: {
    forceGenerate?: boolean;
    partneredOnly?: boolean;
  };
};

export type AmazonInboundPlanTransportListResponse =
  TransportationOptionUnpagedListResults;

export type AmazonInboundPlanTransportListError = ErrorResponse;

export type MarketplaceListingsListData = {
  path: {
    mpId: string;
  };
  query?: {
    fulfillment?: "ANY" | "MERCHANT" | "MARKETPLACE";
    includeInventory?: string;
    includeValues?: boolean;
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    linked?: "ANY" | "LINKED" | "UNLINKED";
    /**
     * Offset items amount
     */
    offset?: number;
    search?: string;
    sellerSku?: Array<string>;
  };
};

export type MarketplaceListingsListResponse = ListingDetailListResults;

export type MarketplaceListingsListError = ErrorResponse;

export type MarketplaceListingsLoadData = {
  body?: ListingBulkSearch;
  path: {
    mpId: string;
  };
};

export type MarketplaceListingsLoadResponse = ListingDetailUnpagedListResults;

export type MarketplaceListingsLoadError = ErrorResponse;

export type AmazonInboundDocumentListData = {
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    mpId?: string;
    /**
     * Offset items amount
     */
    offset?: number;
    packingStatus?: Array<"PENDING" | "PARTIALLY" | "COMPLETE" | "NA">;
    receiveStatus?: Array<"PENDING" | "PARTIALLY" | "COMPLETE" | "NA">;
  };
};

export type AmazonInboundDocumentListResponse =
  AmazonInboundDocumentListResults;

export type AmazonInboundDocumentListError = ErrorResponse;

export type GetMarketplacesLinkedServicesResponse = LinkedServicesResponseData;

export type GetMarketplacesLinkedServicesError = ErrorResponse;

export type CarrierAttachmentsData = {
  body?: {
    file: Array<Blob | File>;
    description?: string;
  };
  path: {
    shpId: number;
  };
};

export type CarrierAttachmentsResponse = void;

export type CarrierAttachmentsError = ErrorResponse;

export type CarrierDocumentsResponse = CarrierDocumentsResponseDataResponse;

export type CarrierDocumentsError = ErrorResponse;

export type CarrierValidateData = {
  body?: CarrierShipmentValidationRequest;
  path: {
    shpId: number;
  };
};

export type CarrierValidateResponse = void;

export type CarrierValidateError = ErrorResponse;

export type GetOutboundDocumentSoDocumentidTrendsData = {
  path: {
    documentId: string;
  };
  query?: {
    length?: number;
    period?: "M" | "W";
  };
};

export type GetOutboundDocumentSoDocumentidTrendsResponse =
  CustomerPeriodicSalesResultsResponseData;

export type GetOutboundDocumentSoDocumentidTrendsError = ErrorResponse;

export type InvoicesCreateData = {
  body?: InvoicesCreateRequest;
};

export type InvoicesCreateResponse2 =
  InvoicesCreateResponseResponseDataResponse;

export type InvoicesCreateError = ErrorResponse;

export type InvoicesEmailData = {
  body?: InvoicesEmailRequest;
};

export type InvoicesEmailResponse = void;

export type InvoicesEmailError = ErrorResponse;

export type GetPackingDocumentData = {
  path: {
    baseId: string;
    baseType: string;
  };
  query?: {
    packageId?: number;
  };
};

export type GetPackingDocumentResponse = PackingDocumentResponseData;

export type GetPackingDocumentError = ErrorResponse;

export type PackagesUnassignPlanData = {
  body?: UnassignPackagesPlanRequest;
};

export type PackagesUnassignPlanResponse = UnassignPackagesPlanResponse;

export type PackagesUnassignPlanError = ErrorResponse;

export type PackagesUnassignSaveData = {
  body?: UnassignPackagesSaveRequest;
};

export type PackagesUnassignSaveResponse =
  UnassignPackagesSaveResponseResponseDataResponse;

export type PackagesUnassignSaveError = ErrorResponse;

export type PackagesUnassignListData = {
  query?: {
    startDate?: string;
    warehouseId?: string;
  };
};

export type PackagesUnassignListResponse = UnassignPackageUnpagedListResults;

export type PackagesUnassignListError = ErrorResponse;

export type PackagesPalletizeData = {
  body: PalletizeRequest;
};

export type PackagesPalletizeResponse = void;

export type PackagesPalletizeError = ErrorResponse;

export type PickWorkflowsListResponse = PickWorkflowUnpagedListResults;

export type PickWorkflowsListError = ErrorResponse;

export type PickWorkflowsDeleteData = {
  path: {
    id: number;
  };
};

export type PickWorkflowsDeleteResponse = void;

export type PickWorkflowsDeleteError = ErrorResponse;

export type PickWorkflowsUpsertData = {
  body?: PickWorkflowUpsert;
  path: {
    id: number;
  };
};

export type PickWorkflowsUpsertResponse = void;

export type PickWorkflowsUpsertError = ErrorResponse;

export type PickWorkflowsTriggerData = {
  path: {
    id: number;
  };
};

export type PickWorkflowsTriggerResponse = void;

export type PickWorkflowsTriggerError = ErrorResponse;

export type ShipmentsImportData = {
  body?: ShipmentsImportRequest;
};

export type ShipmentsImportResponse = void;

export type ShipmentsImportError = ErrorResponse;

export type SalesOrderGetData = {
  path: {
    documentId: string;
  };
};

export type SalesOrderGetResponse = SalesOrderDocumentResponseData;

export type SalesOrderGetError = ErrorResponse;

export type SalesOrderAttachDraftShipmentData = {
  body?: SalesOrderAttachDraftShipmentRequest;
  path: {
    documentId: string;
  };
};

export type SalesOrderAttachDraftShipmentResponse = Int32ResponseDataResponse;

export type SalesOrderAttachDraftShipmentError = ErrorResponse;

export type SalesOrderCreateDraftShipmentData = {
  body?: SalesOrderCreateDraftShipmentRequest;
  path: {
    documentId: string;
  };
};

export type SalesOrderCreateDraftShipmentResponse = StringResponseDataResponse;

export type SalesOrderCreateDraftShipmentError = ErrorResponse;

export type SalesOrderCreateData = {
  body?: SalesOrderCreateRequest;
};

export type SalesOrderCreateResponse = DocumentTypeResponseDataResponse;

export type SalesOrderCreateError = ErrorResponse;

export type PackagesDeleteData = {
  body: IdListRequest;
};

export type PackagesDeleteResponse = void;

export type PackagesDeleteError = ErrorResponse;

export type PckDeleteData = {
  path: {
    pckId: number;
  };
};

export type PckDeleteResponse = void;

export type PckDeleteError = ErrorResponse;

export type PckUnclaimData = {
  path: {
    pckId: number;
  };
};

export type PckUnclaimResponse = void;

export type PckUnclaimError = ErrorResponse;

export type PckActiveListResponse = PckActiveUnpagedListResults;

export type PckActiveListError = ErrorResponse;

export type PckCreateData = {
  body: PckCreateRequest;
};

export type PckCreateResponse = DocumentType_1UnpagedListResults;

export type PckCreateError = ErrorResponse;

export type PckMergeData = {
  body: PckMergeRequest;
};

export type PckMergeResponse = void;

export type PckMergeError = ErrorResponse;

export type PckScheduledUpsertData = {
  body: PckScheduledUpsertRequest;
  path: {
    id: number;
  };
};

export type PckScheduledUpsertResponse = Int32ResponseDataResponse;

export type PckScheduledUpsertError = ErrorResponse;

export type PckScheduledAssignmentData = {
  body: PckScheduledAssignRequest;
};

export type PckScheduledAssignmentResponse = void;

export type PckScheduledAssignmentError = ErrorResponse;

export type AccountDetailsResponse = PortalAccountDetailsResponseDataResponse;

export type AccountDetailsError = ErrorResponse;

export type ListInvoicesResponse = PortalAccountInvoiceUnpagedListResults;

export type ListInvoicesError = ErrorResponse;

export type ListOrdersResponse = PortalAccountOrderUnpagedListResults;

export type ListOrdersError = ErrorResponse;

export type DownloadOrderData = {
  path: {
    soId: string;
  };
};

export type DownloadOrderResponse = unknown;

export type DownloadOrderError = ErrorResponse;

export type AuthenticateData = {
  body?: AuthenticationRequest;
};

export type AuthenticateResponse = AuthenticationResponseResponseDataResponse;

export type AuthenticateError = ErrorResponse;

export type ClearBasketResponse = void;

export type ClearBasketError = ErrorResponse;

export type BasketResponse = PortalBasketResponseResponseDataResponse;

export type BasketError = ErrorResponse;

export type BasketSetData = {
  body?: PortalBasketItemRequest;
};

export type BasketSetResponse = PortalBasketItemResponseResponseDataResponse;

export type BasketSetError = ErrorResponse;

export type BasketSummaryResponse = BasketSummaryResponseDataResponse;

export type BasketSummaryError = ErrorResponse;

export type CatalogData = {
  query?: {
    ssp?: boolean;
  };
};

export type CatalogResponse = PortalCatalogResponseResponseDataResponse;

export type CatalogError = ErrorResponse;

export type CatalogItemsData = {
  query?: {
    appCatId?: number;
    brand?: string;
    category?: string;
    department?: string;
    freqOnly?: boolean;
    inStockOnly?: boolean;
    limit?: number;
    newOnly?: boolean;
    offset?: number;
    promoOnly?: boolean;
    query?: string;
  };
};

export type CatalogItemsResponse = PortalCatalogItemUnpagedListResults;

export type CatalogItemsError = ErrorResponse;

export type CheckoutData = {
  body?: PortalChckoutRequest;
};

export type CheckoutResponse = PortalCheckoutResponseResponseDataResponse;

export type CheckoutError = ErrorResponse;

export type ForgotPasswordData = {
  body?: PortalForgotPasswordRequest;
};

export type ForgotPasswordResponse = void;

export type ForgotPasswordError = ErrorResponse;

export type PortalInfoData = {
  body?: StoreInfoRequest;
};

export type PortalInfoResponse = StoreInfoResponseDataResponse;

export type PortalInfoError = ErrorResponse;

export type ItemSpecsData = {
  path: {
    sku: string;
  };
};

export type ItemSpecsResponse = ItemSpecUnpagedListResults;

export type ItemSpecsError = ErrorResponse;

export type ResetPasswordData = {
  body?: PasswordResetRequest;
};

export type ResetPasswordResponse = void;

export type ResetPasswordError = ErrorResponse;

export type TokenAuthenticationData = {
  body?: AuthenticationTokenRequest;
};

export type TokenAuthenticationResponse2 =
  TokenAuthenticationResponseResponseDataResponse;

export type TokenAuthenticationError = ErrorResponse;

export type UserInfoResponse = AuthenticationResponseResponseDataResponse;

export type UserInfoError = ErrorResponse;

export type AiConversationCreateResponse =
  ConversationCreateResponseResponseData;

export type AiConversationCreateError = ErrorResponse;

export type AiConversationMessageData = {
  body?: ConversationRequest;
};

export type AiConversationMessageResponse = ConversationResponseResponseData;

export type AiConversationMessageError = ErrorResponse;

export type AiConversationMessageExportData = {
  body?: ConversationExportRequest;
};

export type AiConversationMessageExportResponse = void;

export type AiConversationMessageExportError = ErrorResponse;

export type AiConversationMessageFeedbackData = {
  body?: ConversationFeedbackRequest;
};

export type AiConversationMessageFeedbackResponse = void;

export type AiConversationMessageFeedbackError = ErrorResponse;

export type AiConversationMessageRetryData = {
  body?: ConversationRetryRequest;
};

export type AiConversationMessageRetryResponse =
  ConversationResponseResponseData;

export type AiConversationMessageRetryError = ErrorResponse;

export type GetReportsCustomFeedIdKeyData = {
  path: {
    id: number;
    key: string;
  };
};

export type GetReportsCustomFeedIdKeyResponse = unknown;

export type GetReportsCustomFeedIdKeyError = ErrorResponse;

export type KpiDashboardCreateData = {
  body?: KpiDashboardUpsert;
};

export type KpiDashboardCreateResponse = void;

export type KpiDashboardCreateError = ErrorResponse;

export type KpiDashboardListResponse = KpiDashboardUnpagedListResults;

export type KpiDashboardListError = ErrorResponse;

export type KpiDashboardWidgetsDeleteData = {
  path: {
    dashboardId: string;
    widgetId: number;
  };
};

export type KpiDashboardWidgetsDeleteResponse = void;

export type KpiDashboardWidgetsDeleteError = ErrorResponse;

export type KpiDashboardWidgetsUpsertData = {
  body?: ConfigurationRequest;
  path: {
    dashboardId: string;
    widgetId: number;
  };
};

export type KpiDashboardWidgetsUpsertResponse = void;

export type KpiDashboardWidgetsUpsertError = ErrorResponse;

export type KpiDashboardWidgetsListData = {
  path: {
    dashboardId: string;
  };
};

export type KpiDashboardWidgetsListResponse =
  KpiWidgetConfigDetailUnpagedListResults;

export type KpiDashboardWidgetsListError = ErrorResponse;

export type KpiDashboardDeleteData = {
  path: {
    id: string;
  };
};

export type KpiDashboardDeleteResponse = void;

export type KpiDashboardDeleteError = ErrorResponse;

export type KpiDashboardUpdateData = {
  body?: KpiDashboardUpsert;
  path: {
    id: string;
  };
};

export type KpiDashboardUpdateResponse = void;

export type KpiDashboardUpdateError = ErrorResponse;

export type KpiDashboardData = {
  path: {
    /**
     * Dashboard token as retrieved from RP13
     */
    token: string;
  };
};

export type KpiDashboardResponse = KpiDashboardWithWidgetsResponseData;

export type KpiDashboardError = ErrorResponse;

export type KpiDashboardWidgetsValueData = {
  path: {
    /**
     * Dashboard token as retrieved from RP13
     */
    token: string;
    widgetId: number;
  };
};

export type KpiDashboardWidgetsValueResponse = {
  [key: string]: unknown;
};

export type KpiDashboardWidgetsValueError = ErrorResponse;

export type KpiDashboardWidgetsUpdatePositionData = {
  body?: Array<KpiWidgetPositionRequest>;
  path: {
    /**
     * Dashboard token as retrieved from RP13
     */
    token: string;
  };
};

export type KpiDashboardWidgetsUpdatePositionResponse = void;

export type KpiDashboardWidgetsUpdatePositionError = ErrorResponse;

export type WidgetTypesResponse = ConfigurationObjectUnpagedListResults;

export type WidgetTypesError = ErrorResponse;

export type GetReportsListTypesResponse =
  ReportTypeConfigurationUnpagedListResults;

export type GetReportsListTypesError = ErrorResponse;

export type GetReportsReportServerItemsData = {
  query: {
    /**
     * This operation allows to supply the Api key as part of the Url Query, you can use Api User key with 'Reports' scope
     */
    apiKey?: string;
    "items.appCategory"?: Array<number>;
    "items.appCategoryExclude"?: boolean;
    "items.appHidden"?: "ONLY" | "EXCLUDE";
    "items.appMarkedNew"?: "ONLY" | "EXCLUDE";
    "items.brand"?: Array<number>;
    "items.brandExclude"?: boolean;
    "items.category"?: Array<number>;
    "items.categoryExclude"?: boolean;
    "items.department"?: Array<number>;
    "items.departmentExclude"?: boolean;
    "items.eol"?: "ONLY" | "EXCLUDE";
    "items.sku"?: Array<string>;
    "items.skuExclude"?: boolean;
    "items.tag"?: Array<number>;
    "items.tagExclude"?: Array<number>;
    "items.tagsAll"?: boolean;
    "items.type"?: Array<
      "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM"
    >;
    "items.vendor"?: Array<string>;
    "items.vendorExclude"?: boolean;
    value: "AVAILABLE" | "ON_HAND" | "ON_ORDER" | "RESERVED" | "BLOCKED";
    warehouse?: Array<string>;
  };
};

export type GetReportsReportServerItemsResponse = number;

export type GetReportsReportServerItemsError = ErrorResponse;

export type GetReportsReportServerSalesData = {
  query: {
    /**
     * This operation allows to supply the Api key as part of the Url Query, you can use Api User key with 'Reports' scope
     */
    apiKey?: string;
    "date.end"?: Date;
    "date.start"?: Date;
    "items.appCategory"?: Array<number>;
    "items.appCategoryExclude"?: boolean;
    "items.appHidden"?: "ONLY" | "EXCLUDE";
    "items.appMarkedNew"?: "ONLY" | "EXCLUDE";
    "items.brand"?: Array<number>;
    "items.brandExclude"?: boolean;
    "items.category"?: Array<number>;
    "items.categoryExclude"?: boolean;
    "items.department"?: Array<number>;
    "items.departmentExclude"?: boolean;
    "items.eol"?: "ONLY" | "EXCLUDE";
    "items.sku"?: Array<string>;
    "items.skuExclude"?: boolean;
    "items.tag"?: Array<number>;
    "items.tagExclude"?: Array<number>;
    "items.tagsAll"?: boolean;
    "items.type"?: Array<
      "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM"
    >;
    "items.vendor"?: Array<string>;
    "items.vendorExclude"?: boolean;
    "sales.contact"?: Array<string>;
    "sales.contactExclude"?: boolean;
    "sales.salesRep"?: Array<string>;
    "sales.salesRepExclude"?: boolean;
    "sales.tag"?: Array<number>;
    "sales.tagExclude"?: Array<number>;
    source: "SALES" | "INVOICES";
    useGrossValues?: boolean;
    useLcy?: boolean;
    value:
      | "VALUE_BILLED"
      | "VALUE_INVOICED"
      | "VALUE_CREDITED"
      | "QTY_BILLED"
      | "QTY_INVOICED"
      | "QTY_CREDITED";
    warehouse?: Array<string>;
  };
};

export type GetReportsReportServerSalesResponse = number;

export type GetReportsReportServerSalesError = ErrorResponse;

export type ReportTemplatesNamesListData = {
  query?: {
    reportType?: Array<string>;
  };
};

export type ReportTemplatesNamesListResponse = IdNameUnpagedListResults;

export type ReportTemplatesNamesListError = ErrorResponse;

export type RunReportData = {
  body?: ReportRequest;
};

export type RunReportResponse = ReportResultResponseData;

export type RunReportError = ErrorResponse;

export type ItemSalesDrillDownData = {
  body?: SalesReportDrillDownRequest;
  path: {
    itemSku: string;
  };
};

export type ItemSalesDrillDownResponse = SalesReportDrillDownQtyListResults;

export type ItemSalesDrillDownError = ErrorResponse;

export type ItemSalesDrillDownSummaryData = {
  body?: SalesReportDrillDownRequest;
  path: {
    itemSku: string;
    summaryType: "channel" | "customer" | "marketplace";
  };
};

export type ItemSalesDrillDownSummaryResponse =
  SalesReportDrillDownQtySummaryUnpagedListResults;

export type ItemSalesDrillDownSummaryError = ErrorResponse;

export type SalesOverviewPerformanceBySectionData = {
  path: {
    section:
      | "customers"
      | "customer"
      | "brand"
      | "category"
      | "department"
      | "marketplace"
      | "channel";
  };
  query: {
    /**
     * End of date range, When this is blank the 'start' value will be used
     */
    end?: Date;
    excludeServices?: boolean;
    /**
     * Beginning of date range
     */
    start: Date;
  };
};

export type SalesOverviewPerformanceBySectionResponse =
  BySectionUnpagedListResults;

export type SalesOverviewPerformanceBySectionError = ErrorResponse;

export type GetReportsSalesOverviewPerformanceDailyData = {
  query: {
    /**
     * End of date range, When this is blank the 'start' value will be used
     */
    end?: Date;
    /**
     * Beginning of date range
     */
    start: Date;
  };
};

export type GetReportsSalesOverviewPerformanceDailyResponse =
  DateSegmentUnpagedListResults;

export type GetReportsSalesOverviewPerformanceDailyError = ErrorResponse;

export type SalesOverviewPerformanceByItemData = {
  query: {
    /**
     * End of date range, When this is blank the 'start' value will be used
     */
    end?: Date;
    excludeServices?: boolean;
    /**
     * Beginning of date range
     */
    start: Date;
  };
};

export type SalesOverviewPerformanceByItemResponse =
  ItemSegmentUnpagedListResults;

export type SalesOverviewPerformanceByItemError = ErrorResponse;

export type SalesOverviewSummaryByDateData = {
  query: {
    /**
     * End of date range, 'start' is used when this is blank
     */
    end?: Date;
    prevEnd?: Date;
    prevStart?: Date;
    /**
     * Beginning of date range
     */
    start: Date;
  };
};

export type SalesOverviewSummaryByDateResponse = SalesOverviewResponseData;

export type SalesOverviewSummaryByDateError = ErrorResponse;

export type SalesOverviewSummaryData = {
  path: {
    range: "dtd" | "wtd" | "ytd" | "mtd" | "qtd";
  };
  query?: {
    /**
     * Set to true when the comparison period is for same time range on previous year, as opposed to same time range on previous occurrence, for example: when using mtd, by default the previous compared period is previous mtd, when this is true, the previous mtd will be the same date range on previous year
     */
    yearCompare?: boolean;
  };
};

export type SalesOverviewSummaryResponse = SalesOverviewRangedResponseData;

export type SalesOverviewSummaryError = ErrorResponse;

export type ScheduledReportsCreateData = {
  body?: ReportScheduleCreate;
};

export type ScheduledReportsCreateResponse = void;

export type ScheduledReportsCreateError = ErrorResponse;

export type ScheduledReportsListResponse =
  ReportScheduleEntityUnpagedListResults;

export type ScheduledReportsListError = ErrorResponse;

export type ScheduledReportsDeleteData = {
  path: {
    id: string;
  };
};

export type ScheduledReportsDeleteResponse = void;

export type ScheduledReportsDeleteError = ErrorResponse;

export type ScheduledReportsGetData = {
  path: {
    id: string;
  };
};

export type ScheduledReportsGetResponse = ReportScheduleEntityResponseData;

export type ScheduledReportsGetError = ErrorResponse;

export type ScheduledReportsUpdateData = {
  body?: ReportScheduleUpdate;
  path: {
    id: string;
  };
};

export type ScheduledReportsUpdateResponse = void;

export type ScheduledReportsUpdateError = ErrorResponse;

export type PostReportsSchedulesIdExecuteData = {
  path: {
    id: string;
  };
};

export type PostReportsSchedulesIdExecuteResponse = ReportResultResponseData;

export type PostReportsSchedulesIdExecuteError = ErrorResponse;

export type GetReportsSoCustomerPeriodicSoidData = {
  path: {
    soId: string;
  };
  query?: {
    length?: number;
    period?: "M" | "W";
  };
};

export type GetReportsSoCustomerPeriodicSoidResponse =
  CustomerPeriodicSalesResultsResponseData;

export type GetReportsSoCustomerPeriodicSoidError = ErrorResponse;

export type PutReportsSystemAlertsDismissGroupData = {
  query: {
    groupName: string;
  };
};

export type PutReportsSystemAlertsDismissGroupResponse = void;

export type PutReportsSystemAlertsDismissGroupError = ErrorResponse;

export type PutReportsSystemAlertsDismissMessageData = {
  query: {
    alertId: number;
  };
};

export type PutReportsSystemAlertsDismissMessageResponse = void;

export type PutReportsSystemAlertsDismissMessageError = ErrorResponse;

export type GetReportsSystemAlertsGroupsResponse = GroupedUnpagedListResults;

export type GetReportsSystemAlertsGroupsError = ErrorResponse;

export type GetReportsSystemAlertsMessagesData = {
  query: {
    groupName: string;
  };
};

export type GetReportsSystemAlertsMessagesResponse = MessageUnpagedListResults;

export type GetReportsSystemAlertsMessagesError = ErrorResponse;

export type SalesOrdersListData = {
  query?: {
    assignedCarrier?: Array<number>;
    backOrder?: "ONLY" | "EXCLUDE";
    carrierLabelMode?: "Complete" | "NoLabelOrError" | "NoLabel" | "Error";
    channelOrderNumber?: string;
    channels?: Array<number>;
    consignment?: "ONLY" | "EXCLUDE";
    contact?: Array<string>;
    "contact.exclude"?: boolean;
    creditFilter?: boolean;
    creditTerms?: Array<number>;
    currency?: string;
    "date.end"?: string;
    "date.start"?: string;
    "dispatchDate.end"?: string;
    "dispatchDate.start"?: string;
    dispatchMissing?: boolean;
    "dueDateRange.end"?: string;
    "dueDateRange.start"?: string;
    dueDateReady?: boolean;
    dueOnly?: boolean;
    excludeLinesMode?: Array<"SingleQty" | "SingleLine" | "MultiLine">;
    finalized?: "ONLY" | "EXCLUDE";
    hideMerged?: boolean;
    hourEnd?: number;
    hourStart?: number;
    id?: Array<string>;
    invoiceStage?: Array<"Pending" | "Partially" | "Complete">;
    "items.appCategory"?: Array<number>;
    "items.appCategoryExclude"?: boolean;
    "items.appHidden"?: "ONLY" | "EXCLUDE";
    "items.appMarkedNew"?: "ONLY" | "EXCLUDE";
    "items.brand"?: Array<number>;
    "items.brandExclude"?: boolean;
    "items.category"?: Array<number>;
    "items.categoryExclude"?: boolean;
    "items.department"?: Array<number>;
    "items.departmentExclude"?: boolean;
    "items.eol"?: "ONLY" | "EXCLUDE";
    "items.sku"?: Array<string>;
    "items.skuExclude"?: boolean;
    "items.tag"?: Array<number>;
    "items.tagExclude"?: Array<number>;
    "items.tagsAll"?: boolean;
    "items.type"?: Array<
      "STOCK_ITEM" | "SERVICE_ITEM" | "KIT_ITEM" | "BOM_ITEM" | "GROUP_ITEM"
    >;
    "items.vendor"?: Array<string>;
    "items.vendorExclude"?: boolean;
    itemState?:
      | "Unpacked"
      | "Uninvoiced"
      | "UnfulfillableAll"
      | "UnfulfillableAny"
      | "Fulfillable";
    limit?: number;
    linesMode?: Array<"SingleQty" | "SingleLine" | "MultiLine">;
    modifiedSince?: Date;
    mpId?: Array<number>;
    offset?: number;
    packingReady?: Array<"Pending" | "Partially" | "Complete">;
    packingStage?: Array<"Pending" | "Partially" | "Complete">;
    parked?: "ONLY" | "EXCLUDE";
    paymentStatus?: Array<"Pending" | "Partially" | "Complete">;
    pckId?: number;
    pckMode?: "ONLY" | "EXCLUDE";
    printed?: "ONLY" | "EXCLUDE";
    reference?: string;
    resendMode?: "ONLY" | "EXCLUDE";
    resultsSorting?:
      | "OrderDate"
      | "OrderDateDescending"
      | "DueDate"
      | "DueDateDescending"
      | "DispatchDate"
      | "DispatchDateDescending"
      | "CreateDate"
      | "CreateDateDescending"
      | "FirstSku";
    salesRepId?: string;
    shipmentStatus?: Array<
      | "PendingPickup"
      | "InTransit"
      | "Delivered"
      | "Exception"
      | "Unknown"
      | "Draft"
    >;
    stage?: Array<number>;
    "stage.exclude"?: boolean;
    status?: Array<"Draft" | "Confirmed" | "Canceled">;
    tag?: Array<number>;
    tagExclude?: Array<number>;
    warehouse?: string;
  };
};

export type SalesOrdersListResponse = SalesOrderListResultCursorListResults;

export type SalesOrdersListError = ErrorResponse;

export type SalesOrderMergeData = {
  body?: SalesOrderMergeRequest;
};

export type SalesOrderMergeResponse = void;

export type SalesOrderMergeError = ErrorResponse;

export type SalesOrderMergeSuggestionsResponse =
  SalesOrderMergeSuggestionUnpagedListResults;

export type SalesOrderMergeSuggestionsError = ErrorResponse;

export type SegmentsUpsertData = {
  body?: SegmentDetails;
  path: {
    id: number;
  };
};

export type SegmentsUpsertResponse = void;

export type SegmentsUpsertError = ErrorResponse;

export type SegmentsGetData = {
  path: {
    id: number;
  };
};

export type SegmentsGetResponse = SegmentDetailsResponseData;

export type SegmentsGetError = ErrorResponse | unknown;

export type SegmentsListData = {
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
  };
};

export type SegmentsListResponse = SegmentDetailsListResults;

export type SegmentsListError = ErrorResponse;

export type ApiTokenCreateData = {
  body?: ApiTokenCreateRequest;
};

export type ApiTokenCreateResponse2 = ApiTokenCreateResponseResponseData;

export type ApiTokenCreateError = ErrorResponse;

export type ApiTokenDetailsResponse2 = ApiTokenDetailsResponseResponseData;

export type ApiTokenDetailsError = ErrorResponse;

export type ApiTokenUpdateData = {
  body?: ApiTokenUpdateRequest;
};

export type ApiTokenUpdateResponse = void;

export type ApiTokenUpdateError = ErrorResponse;

export type ColumnDisplayData = {
  path: {
    viewName: string;
  };
};

export type ColumnDisplayResponse = ColumnDisplayUnpagedListResults;

export type ColumnDisplayError = ErrorResponse;

export type EmailValidationRequestResponse = void;

export type EmailValidationRequestError = ErrorResponse;

export type SelfInfoResponse = UserInfoCurrentResponseData;

export type SelfInfoError = ErrorResponse;

export type QueuedMessagesData = {
  query?: {
    errorsOnly?: boolean;
    includeAutoSent?: boolean;
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    query?: string;
  };
};

export type QueuedMessagesResponse = QueuedMessageListResults;

export type QueuedMessagesError = ErrorResponse;

export type QueuedMessagesBodyData = {
  path: {
    id: number;
  };
};

export type QueuedMessagesBodyResponse = QueuedMessageBodyResponseData;

export type QueuedMessagesBodyError = ErrorResponse;

export type QueuedMessagesDeleteData = {
  path: {
    id: number;
  };
};

export type QueuedMessagesDeleteResponse = void;

export type QueuedMessagesDeleteError = ErrorResponse;

export type QueuedMessagesDismissData = {
  path: {
    id: number;
  };
};

export type QueuedMessagesDismissResponse = void;

export type QueuedMessagesDismissError = ErrorResponse;

export type QueuedMessagesRequeueData = {
  path: {
    id: number;
  };
};

export type QueuedMessagesRequeueResponse = void;

export type QueuedMessagesRequeueError = ErrorResponse;

export type NotificationsData = {
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
  };
};

export type NotificationsResponse = NotificationListResults;

export type NotificationsError = ErrorResponse;

export type NotificationsCountResponse = NotificationCountResponseData;

export type NotificationsCountError = ErrorResponse;

export type SupportTicketsReplyData = {
  body?: {
    files?: Array<Blob | File>;
    type: string;
    subject: string;
    body: string;
    ccEmail: Array<string>;
  };
};

export type SupportTicketsReplyResponse = void;

export type SupportTicketsReplyError = ErrorResponse;

export type SupportTicketGetData = {
  path: {
    ticketId: string;
  };
  query: {
    token: string;
  };
};

export type SupportTicketGetResponse = TicketWithConversationsResponseData;

export type SupportTicketGetError = ErrorResponse;

export type SupportTicketsListData = {
  query?: {
    status?: "OPEN" | "CLOSED";
  };
};

export type SupportTicketsListResponse = TicketListResponseData;

export type SupportTicketsListError = ErrorResponse;

export type WarehouseGroupsResponse = WarehouseGroupDetailsUnpagedListResults;

export type WarehouseGroupsError = ErrorResponse;

export type WarehouseGroupUpsertData = {
  body?: WarehouseGroupUpsert;
};

export type WarehouseGroupUpsertResponse = void;

export type WarehouseGroupUpsertError = ErrorResponse;

export type WarehouseGroupsDeleteData = {
  path: {
    groupId: string;
  };
};

export type WarehouseGroupsDeleteResponse = void;

export type WarehouseGroupsDeleteError = ErrorResponse;

export type WarehousesListResponse = WarehouseEntityUnpagedListResults;

export type WarehousesListError = ErrorResponse;

export type WarehouseUpsertData = {
  body?: WarehouseUpsert;
};

export type WarehouseUpsertResponse = void;

export type WarehouseUpsertError = ErrorResponse;

export type WarehousesDetailsData = {
  path: {
    id: string;
  };
};

export type WarehousesDetailsResponse =
  WarehouseEntityDetailsResponseDataResponse;

export type WarehousesDetailsError = ErrorResponse;

export type WarehousesDeleteData = {
  path: {
    warehouseId: string;
  };
  query?: {
    purge?: boolean;
  };
};

export type WarehousesDeleteResponse = void;

export type WarehousesDeleteError = ErrorResponse;

export type WarehouseBinsUpsertData = {
  body?: WarehouseBinUpsert;
  path: {
    warehouseId: string;
  };
};

export type WarehouseBinsUpsertResponse = void;

export type WarehouseBinsUpsertError = ErrorResponse;

export type WarehouseBinsListData = {
  path: {
    warehouseId: string;
  };
};

export type WarehouseBinsListResponse = StringUnpagedListResults;

export type WarehouseBinsListError = ErrorResponse;

export type WarehouseBinsSearchData = {
  path: {
    warehouseId: string;
  };
  query?: {
    /**
     * Items per page, default is 50, max 250
     */
    limit?: number;
    /**
     * Offset items amount
     */
    offset?: number;
    query?: string;
  };
};

export type WarehouseBinsSearchResponse = WarehouseBinListResults;

export type WarehouseBinsSearchError = ErrorResponse;

export type WarehouseBinsDeleteData = {
  path: {
    binId: number;
    warehouseId: string;
  };
};

export type WarehouseBinsDeleteResponse = void;

export type WarehouseBinsDeleteError = ErrorResponse;

export type WarehouseBinsImportData = {
  body?: WarehouseBinImportBulkUpsertRequest;
  path: {
    warehouseId: string;
  };
};

export type WarehouseBinsImportResponse = void;

export type WarehouseBinsImportError = ErrorResponse;

export type WarehouseZonesListData = {
  path: {
    warehouseId: string;
  };
};

export type WarehouseZonesListResponse = WarehouseZoneUnpagedListResults;

export type WarehouseZonesListError = ErrorResponse;

export type WarehouseZoneDeleteData = {
  path: {
    warehouseId: string;
    zoneId: number;
  };
};

export type WarehouseZoneDeleteResponse = void;

export type WarehouseZoneDeleteError = ErrorResponse;

export type WarehouseZonesUpsertData = {
  body?: WarehouseZoneUpsert;
  path: {
    warehouseId: string;
    zoneId: number;
  };
};

export type WarehouseZonesUpsertResponse = void;

export type WarehouseZonesUpsertError = ErrorResponse;

export type CacheListResponseTransformer = (
  data: any
) => Promise<CacheListResponse>;

export type CacheListResponseResponseDataResponseModelResponseTransformer = (
  data: any
) => CacheListResponseResponseDataResponse;

export type CacheListResponseModelResponseTransformer = (
  data: any
) => CacheListResponse;

export type AdministrationCacheTypeModelResponseTransformer = (
  data: any
) => AdministrationCacheType;

export type ReportPeriodEntityModelResponseTransformer = (
  data: any
) => ReportPeriodEntity;

export const ReportPeriodEntityModelResponseTransformer: ReportPeriodEntityModelResponseTransformer =
  (data) => {
    if (data?.start) {
      data.start = new Date(data.start);
    }
    if (data?.end) {
      data.end = new Date(data.end);
    }
    return data;
  };

export const AdministrationCacheTypeModelResponseTransformer: AdministrationCacheTypeModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.reportPeriods)) {
      data.reportPeriods.forEach(ReportPeriodEntityModelResponseTransformer);
    }
    return data;
  };

export const CacheListResponseModelResponseTransformer: CacheListResponseModelResponseTransformer =
  (data) => {
    if (data?.administration) {
      AdministrationCacheTypeModelResponseTransformer(data.administration);
    }
    return data;
  };

export const CacheListResponseResponseDataResponseModelResponseTransformer: CacheListResponseResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      CacheListResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const CacheListResponseTransformer: CacheListResponseTransformer =
  async (data) => {
    CacheListResponseResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type CurrenciesListResponseTransformer = (
  data: any
) => Promise<CurrenciesListResponse>;

export type CurrencyDetailsUnpagedListResultsModelResponseTransformer = (
  data: any
) => CurrencyDetailsUnpagedListResults;

export type CurrencyDetailsModelResponseTransformer = (
  data: any
) => CurrencyDetails;

export type CurrencyFixModelResponseTransformer = (data: any) => CurrencyFix;

export const CurrencyFixModelResponseTransformer: CurrencyFixModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const CurrencyDetailsModelResponseTransformer: CurrencyDetailsModelResponseTransformer =
  (data) => {
    if (data?.fix) {
      CurrencyFixModelResponseTransformer(data.fix);
    }
    if (data?.valueUpdated) {
      data.valueUpdated = new Date(data.valueUpdated);
    }
    return data;
  };

export const CurrencyDetailsUnpagedListResultsModelResponseTransformer: CurrencyDetailsUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(CurrencyDetailsModelResponseTransformer);
    }
    return data;
  };

export const CurrenciesListResponseTransformer: CurrenciesListResponseTransformer =
  async (data) => {
    CurrencyDetailsUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type CurrenciesUpdateRatesResponseTransformer = (
  data: any
) => Promise<CurrenciesUpdateRatesResponse>;

export const CurrenciesUpdateRatesResponseTransformer: CurrenciesUpdateRatesResponseTransformer =
  async (data) => {
    CurrencyDetailsUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type PipelinesListResponseTransformer = (
  data: any
) => Promise<PipelinesListResponse>;

export type PipelineUnpagedListResultsModelResponseTransformer = (
  data: any
) => PipelineUnpagedListResults;

export type PipelineModelResponseTransformer = (data: any) => Pipeline;

export type PipelineLastOperationModelResponseTransformer = (
  data: any
) => PipelineLastOperation;

export const PipelineLastOperationModelResponseTransformer: PipelineLastOperationModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const PipelineModelResponseTransformer: PipelineModelResponseTransformer =
  (data) => {
    if (data?.lastOperation) {
      PipelineLastOperationModelResponseTransformer(data.lastOperation);
    }
    return data;
  };

export const PipelineUnpagedListResultsModelResponseTransformer: PipelineUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PipelineModelResponseTransformer);
    }
    return data;
  };

export const PipelinesListResponseTransformer: PipelinesListResponseTransformer =
  async (data) => {
    PipelineUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type PipelinesGetResponseTransformer = (
  data: any
) => Promise<PipelinesGetResponse>;

export type PipelineDetailsResponseDataModelResponseTransformer = (
  data: any
) => PipelineDetailsResponseData;

export type PipelineDetailsModelResponseTransformer = (
  data: any
) => PipelineDetails;

export const PipelineDetailsModelResponseTransformer: PipelineDetailsModelResponseTransformer =
  (data) => {
    if (data?.lastOperation) {
      PipelineLastOperationModelResponseTransformer(data.lastOperation);
    }
    return data;
  };

export const PipelineDetailsResponseDataModelResponseTransformer: PipelineDetailsResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      PipelineDetailsModelResponseTransformer(data.data);
    }
    return data;
  };

export const PipelinesGetResponseTransformer: PipelinesGetResponseTransformer =
  async (data) => {
    PipelineDetailsResponseDataModelResponseTransformer(data);
    return data;
  };

export type PipelinesActivityResponseTransformer = (
  data: any
) => Promise<PipelinesActivityResponse>;

export type PipelineActivityUnpagedListResultsModelResponseTransformer = (
  data: any
) => PipelineActivityUnpagedListResults;

export type PipelineActivityModelResponseTransformer = (
  data: any
) => PipelineActivity;

export const PipelineActivityModelResponseTransformer: PipelineActivityModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.completeTime) {
      data.completeTime = new Date(data.completeTime);
    }
    return data;
  };

export const PipelineActivityUnpagedListResultsModelResponseTransformer: PipelineActivityUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PipelineActivityModelResponseTransformer);
    }
    return data;
  };

export const PipelinesActivityResponseTransformer: PipelinesActivityResponseTransformer =
  async (data) => {
    PipelineActivityUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type PipelinesActivityLogResponseTransformer = (
  data: any
) => Promise<PipelinesActivityLogResponse>;

export type PipelineActivityLogUnpagedListResultsModelResponseTransformer = (
  data: any
) => PipelineActivityLogUnpagedListResults;

export type PipelineActivityLogModelResponseTransformer = (
  data: any
) => PipelineActivityLog;

export const PipelineActivityLogModelResponseTransformer: PipelineActivityLogModelResponseTransformer =
  (data) => {
    if (data?.timestamp) {
      data.timestamp = new Date(data.timestamp);
    }
    return data;
  };

export const PipelineActivityLogUnpagedListResultsModelResponseTransformer: PipelineActivityLogUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PipelineActivityLogModelResponseTransformer);
    }
    return data;
  };

export const PipelinesActivityLogResponseTransformer: PipelinesActivityLogResponseTransformer =
  async (data) => {
    PipelineActivityLogUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ReportTemplatesHistoryResponseTransformer = (
  data: any
) => Promise<ReportTemplatesHistoryResponse>;

export type ReportTemplateUploadUnpagedListResultsModelResponseTransformer = (
  data: any
) => ReportTemplateUploadUnpagedListResults;

export type ReportTemplateUploadModelResponseTransformer = (
  data: any
) => ReportTemplateUpload;

export const ReportTemplateUploadModelResponseTransformer: ReportTemplateUploadModelResponseTransformer =
  (data) => {
    if (data?.created) {
      data.created = new Date(data.created);
    }
    return data;
  };

export const ReportTemplateUploadUnpagedListResultsModelResponseTransformer: ReportTemplateUploadUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ReportTemplateUploadModelResponseTransformer);
    }
    return data;
  };

export const ReportTemplatesHistoryResponseTransformer: ReportTemplatesHistoryResponseTransformer =
  async (data) => {
    ReportTemplateUploadUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type AmazonInboundPlansListResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlansListResponse>;

export type AmazonInboundPlansSummaryDetailCursorListResultsModelResponseTransformer =
  (data: any) => AmazonInboundPlansSummaryDetailCursorListResults;

export type AmazonInboundPlansSummaryDetailModelResponseTransformer = (
  data: any
) => AmazonInboundPlansSummaryDetail;

export type AmazonInboundPlansTrnDocumentModelResponseTransformer = (
  data: any
) => AmazonInboundPlansTrnDocument;

export type AmazonInboundPlansTrnDocumentBoxingModelResponseTransformer = (
  data: any
) => AmazonInboundPlansTrnDocumentBoxing;

export type AmazonInboundPlansTrnDocumentBoxingItemModelResponseTransformer = (
  data: any
) => AmazonInboundPlansTrnDocumentBoxingItem;

export const AmazonInboundPlansTrnDocumentBoxingItemModelResponseTransformer: AmazonInboundPlansTrnDocumentBoxingItemModelResponseTransformer =
  (data) => {
    if (data?.dateBatch) {
      data.dateBatch = new Date(data.dateBatch);
    }
    return data;
  };

export const AmazonInboundPlansTrnDocumentBoxingModelResponseTransformer: AmazonInboundPlansTrnDocumentBoxingModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.items)) {
      data.items.forEach(
        AmazonInboundPlansTrnDocumentBoxingItemModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlansTrnDocumentModelResponseTransformer: AmazonInboundPlansTrnDocumentModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.boxing)) {
      data.boxing.forEach(
        AmazonInboundPlansTrnDocumentBoxingModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlansSummaryDetailModelResponseTransformer: AmazonInboundPlansSummaryDetailModelResponseTransformer =
  (data) => {
    if (data?.created) {
      data.created = new Date(data.created);
    }
    if (data?.lastUpdated) {
      data.lastUpdated = new Date(data.lastUpdated);
    }
    if (Array.isArray(data?.trnDocuments)) {
      data.trnDocuments.forEach(
        AmazonInboundPlansTrnDocumentModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlansSummaryDetailCursorListResultsModelResponseTransformer: AmazonInboundPlansSummaryDetailCursorListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        AmazonInboundPlansSummaryDetailModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlansListResponseTransformer: AmazonInboundPlansListResponseTransformer =
  async (data) => {
    AmazonInboundPlansSummaryDetailCursorListResultsModelResponseTransformer(
      data
    );
    return data;
  };

export type AmazonInboundPlansDetailsResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlansDetailsResponse>;

export type AmazonInboundPlansDetailResponseDataResponseModelResponseTransformer =
  (data: any) => AmazonInboundPlansDetailResponseDataResponse;

export type AmazonInboundPlansDetailModelResponseTransformer = (
  data: any
) => AmazonInboundPlansDetail;

export const AmazonInboundPlansDetailModelResponseTransformer: AmazonInboundPlansDetailModelResponseTransformer =
  (data) => {
    if (data?.created) {
      data.created = new Date(data.created);
    }
    if (data?.lastUpdated) {
      data.lastUpdated = new Date(data.lastUpdated);
    }
    if (Array.isArray(data?.trnDocuments)) {
      data.trnDocuments.forEach(
        AmazonInboundPlansTrnDocumentModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlansDetailResponseDataResponseModelResponseTransformer: AmazonInboundPlansDetailResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      AmazonInboundPlansDetailModelResponseTransformer(data.data);
    }
    return data;
  };

export const AmazonInboundPlansDetailsResponseTransformer: AmazonInboundPlansDetailsResponseTransformer =
  async (data) => {
    AmazonInboundPlansDetailResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type AmazonInboundPlansHoldingTrnsCreateResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlansHoldingTrnsCreateResponse>;

export type AmazonInboundPlansTrnDocumentUnpagedListResultsModelResponseTransformer =
  (data: any) => AmazonInboundPlansTrnDocumentUnpagedListResults;

export const AmazonInboundPlansTrnDocumentUnpagedListResultsModelResponseTransformer: AmazonInboundPlansTrnDocumentUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        AmazonInboundPlansTrnDocumentModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlansHoldingTrnsCreateResponseTransformer: AmazonInboundPlansHoldingTrnsCreateResponseTransformer =
  async (data) => {
    AmazonInboundPlansTrnDocumentUnpagedListResultsModelResponseTransformer(
      data
    );
    return data;
  };

export type AmazonSellerFlexOrdersMapResponseTransformer = (
  data: any
) => Promise<AmazonSellerFlexOrdersMapResponse>;

export type ListedShipmentInfoUnpagedListResultsModelResponseTransformer = (
  data: any
) => ListedShipmentInfoUnpagedListResults;

export type ListedShipmentInfoModelResponseTransformer = (
  data: any
) => ListedShipmentInfo;

export const ListedShipmentInfoModelResponseTransformer: ListedShipmentInfoModelResponseTransformer =
  (data) => {
    if (data?.shipmentCreated) {
      data.shipmentCreated = new Date(data.shipmentCreated);
    }
    if (data?.shipmentExpected) {
      data.shipmentExpected = new Date(data.shipmentExpected);
    }
    return data;
  };

export const ListedShipmentInfoUnpagedListResultsModelResponseTransformer: ListedShipmentInfoUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ListedShipmentInfoModelResponseTransformer);
    }
    return data;
  };

export const AmazonSellerFlexOrdersMapResponseTransformer: AmazonSellerFlexOrdersMapResponseTransformer =
  async (data) => {
    ListedShipmentInfoUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type AppsConfigurationResponseTransformer = (
  data: any
) => Promise<AppsConfigurationResponse>;

export type ListingItemUnpagedListResultsModelResponseTransformer = (
  data: any
) => ListingItemUnpagedListResults;

export type ListingItemModelResponseTransformer = (data: any) => ListingItem;

export type ConfigurationObjectModelResponseTransformer = (
  data: any
) => ConfigurationObject;

export type ConfigurationPropertyModelResponseTransformer = (
  data: any
) => ConfigurationProperty;

export const ConfigurationPropertyModelResponseTransformer: ConfigurationPropertyModelResponseTransformer =
  (data) => {
    if (data?.nestedObject) {
      ConfigurationObjectModelResponseTransformer(data.nestedObject);
    }
    return data;
  };

export const ConfigurationObjectModelResponseTransformer: ConfigurationObjectModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.parameters)) {
      data.parameters.forEach(ConfigurationPropertyModelResponseTransformer);
    }
    return data;
  };

export const ListingItemModelResponseTransformer: ListingItemModelResponseTransformer =
  (data) => {
    if (data?.configuration) {
      ConfigurationObjectModelResponseTransformer(data.configuration);
    }
    return data;
  };

export const ListingItemUnpagedListResultsModelResponseTransformer: ListingItemUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ListingItemModelResponseTransformer);
    }
    return data;
  };

export const AppsConfigurationResponseTransformer: AppsConfigurationResponseTransformer =
  async (data) => {
    ListingItemUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type CarriersConfigurationResponseTransformer = (
  data: any
) => Promise<CarriersConfigurationResponse>;

export const CarriersConfigurationResponseTransformer: CarriersConfigurationResponseTransformer =
  async (data) => {
    ListingItemUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type Configurable3PlConfigurationResponseTransformer = (
  data: any
) => Promise<Configurable3PlConfigurationResponse>;

export type ConfigurablePipelinesConfigurationResponseResponseDataModelResponseTransformer =
  (data: any) => ConfigurablePipelinesConfigurationResponseResponseData;

export type ConfigurablePipelinesConfigurationResponseModelResponseTransformer =
  (data: any) => ConfigurablePipelinesConfigurationResponse;

export type PipelineConfigurationModelResponseTransformer = (
  data: any
) => PipelineConfiguration;

export const PipelineConfigurationModelResponseTransformer: PipelineConfigurationModelResponseTransformer =
  (data) => {
    if (data?.configuration) {
      ConfigurationObjectModelResponseTransformer(data.configuration);
    }
    return data;
  };

export const ConfigurablePipelinesConfigurationResponseModelResponseTransformer: ConfigurablePipelinesConfigurationResponseModelResponseTransformer =
  (data) => {
    if (data?.syncInventoryInput) {
      PipelineConfigurationModelResponseTransformer(data.syncInventoryInput);
    }
    if (data?.syncPackingInput) {
      PipelineConfigurationModelResponseTransformer(data.syncPackingInput);
    }
    if (data?.syncPackingOutput) {
      PipelineConfigurationModelResponseTransformer(data.syncPackingOutput);
    }
    if (data?.syncReceiveInput) {
      PipelineConfigurationModelResponseTransformer(data.syncReceiveInput);
    }
    if (data?.syncReceiveOutput) {
      PipelineConfigurationModelResponseTransformer(data.syncReceiveOutput);
    }
    return data;
  };

export const ConfigurablePipelinesConfigurationResponseResponseDataModelResponseTransformer: ConfigurablePipelinesConfigurationResponseResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ConfigurablePipelinesConfigurationResponseModelResponseTransformer(
        data.data
      );
    }
    return data;
  };

export const Configurable3PlConfigurationResponseTransformer: Configurable3PlConfigurationResponseTransformer =
  async (data) => {
    ConfigurablePipelinesConfigurationResponseResponseDataModelResponseTransformer(
      data
    );
    return data;
  };

export type MarketplacesListAllResponseTransformer = (
  data: any
) => Promise<MarketplacesListAllResponse>;

export type MarketplaceDetailsUnpagedListResultsModelResponseTransformer = (
  data: any
) => MarketplaceDetailsUnpagedListResults;

export type MarketplaceDetailsModelResponseTransformer = (
  data: any
) => MarketplaceDetails;

export type MarketplaceSyncStatusModelResponseTransformer = (
  data: any
) => MarketplaceSyncStatus;

export const MarketplaceSyncStatusModelResponseTransformer: MarketplaceSyncStatusModelResponseTransformer =
  (data) => {
    if (data?.lastSync) {
      data.lastSync = new Date(data.lastSync);
    }
    return data;
  };

export type MarketplaceErrorDetailsModelResponseTransformer = (
  data: any
) => MarketplaceErrorDetails;

export const MarketplaceErrorDetailsModelResponseTransformer: MarketplaceErrorDetailsModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const MarketplaceDetailsModelResponseTransformer: MarketplaceDetailsModelResponseTransformer =
  (data) => {
    if (data?.ordersSync) {
      MarketplaceSyncStatusModelResponseTransformer(data.ordersSync);
    }
    if (data?.pricesSync) {
      MarketplaceSyncStatusModelResponseTransformer(data.pricesSync);
    }
    if (data?.inventorySync) {
      MarketplaceSyncStatusModelResponseTransformer(data.inventorySync);
    }
    if (data?.exception) {
      MarketplaceErrorDetailsModelResponseTransformer(data.exception);
    }
    return data;
  };

export const MarketplaceDetailsUnpagedListResultsModelResponseTransformer: MarketplaceDetailsUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(MarketplaceDetailsModelResponseTransformer);
    }
    return data;
  };

export const MarketplacesListAllResponseTransformer: MarketplacesListAllResponseTransformer =
  async (data) => {
    MarketplaceDetailsUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type MarketplacesGetResponseTransformer = (
  data: any
) => Promise<MarketplacesGetResponse>;

export type MarketplaceConfigurationResponseDataResponseModelResponseTransformer =
  (data: any) => MarketplaceConfigurationResponseDataResponse;

export type MarketplaceConfigurationModelResponseTransformer = (
  data: any
) => MarketplaceConfiguration;

export type MarketplaceSettingsModelResponseTransformer = (
  data: any
) => MarketplaceSettings;

export type MarketplaceSettingsOrdersSyncModelResponseTransformer = (
  data: any
) => MarketplaceSettingsOrdersSync;

export const MarketplaceSettingsOrdersSyncModelResponseTransformer: MarketplaceSettingsOrdersSyncModelResponseTransformer =
  (data) => {
    if (data?.minimumDate) {
      data.minimumDate = new Date(data.minimumDate);
    }
    return data;
  };

export const MarketplaceSettingsModelResponseTransformer: MarketplaceSettingsModelResponseTransformer =
  (data) => {
    if (data?.ordersSync) {
      MarketplaceSettingsOrdersSyncModelResponseTransformer(data.ordersSync);
    }
    return data;
  };

export const MarketplaceConfigurationModelResponseTransformer: MarketplaceConfigurationModelResponseTransformer =
  (data) => {
    if (data?.marketplace) {
      MarketplaceDetailsModelResponseTransformer(data.marketplace);
    }
    if (data?.settings) {
      MarketplaceSettingsModelResponseTransformer(data.settings);
    }
    return data;
  };

export const MarketplaceConfigurationResponseDataResponseModelResponseTransformer: MarketplaceConfigurationResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      MarketplaceConfigurationModelResponseTransformer(data.data);
    }
    return data;
  };

export const MarketplacesGetResponseTransformer: MarketplacesGetResponseTransformer =
  async (data) => {
    MarketplaceConfigurationResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type MarketplaceListedItemsResponseTransformer = (
  data: any
) => Promise<MarketplaceListedItemsResponse>;

export type ListedItemListResultsModelResponseTransformer = (
  data: any
) => ListedItemListResults;

export type ListedItemModelResponseTransformer = (data: any) => ListedItem;

export const ListedItemModelResponseTransformer: ListedItemModelResponseTransformer =
  (data) => {
    if (data?.lastSeen) {
      data.lastSeen = new Date(data.lastSeen);
    }
    return data;
  };

export const ListedItemListResultsModelResponseTransformer: ListedItemListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ListedItemModelResponseTransformer);
    }
    return data;
  };

export const MarketplaceListedItemsResponseTransformer: MarketplaceListedItemsResponseTransformer =
  async (data) => {
    ListedItemListResultsModelResponseTransformer(data);
    return data;
  };

export type MarketplaceListedItemsSummaryResponseTransformer = (
  data: any
) => Promise<MarketplaceListedItemsSummaryResponse>;

export type MarketplaceListedItemsSummaryResponseDataResponseModelResponseTransformer =
  (data: any) => MarketplaceListedItemsSummaryResponseDataResponse;

export type MarketplaceListedItemsSummaryModelResponseTransformer = (
  data: any
) => MarketplaceListedItemsSummary;

export const MarketplaceListedItemsSummaryModelResponseTransformer: MarketplaceListedItemsSummaryModelResponseTransformer =
  (data) => {
    if (data?.lastFetch) {
      data.lastFetch = new Date(data.lastFetch);
    }
    return data;
  };

export const MarketplaceListedItemsSummaryResponseDataResponseModelResponseTransformer: MarketplaceListedItemsSummaryResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      MarketplaceListedItemsSummaryModelResponseTransformer(data.data);
    }
    return data;
  };

export const MarketplaceListedItemsSummaryResponseTransformer: MarketplaceListedItemsSummaryResponseTransformer =
  async (data) => {
    MarketplaceListedItemsSummaryResponseDataResponseModelResponseTransformer(
      data
    );
    return data;
  };

export type MarketplacesConfigurationResponseTransformer = (
  data: any
) => Promise<MarketplacesConfigurationResponse>;

export const MarketplacesConfigurationResponseTransformer: MarketplacesConfigurationResponseTransformer =
  async (data) => {
    ListingItemUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type GetAuthenticationProfileMfaTrustedDevicesResponseTransformer = (
  data: any
) => Promise<GetAuthenticationProfileMfaTrustedDevicesResponse>;

export type TrustedDeviceUnpagedListResultsModelResponseTransformer = (
  data: any
) => TrustedDeviceUnpagedListResults;

export type TrustedDeviceModelResponseTransformer = (
  data: any
) => TrustedDevice;

export const TrustedDeviceModelResponseTransformer: TrustedDeviceModelResponseTransformer =
  (data) => {
    if (data?.createdTime) {
      data.createdTime = new Date(data.createdTime);
    }
    if (data?.lastUsedTime) {
      data.lastUsedTime = new Date(data.lastUsedTime);
    }
    return data;
  };

export const TrustedDeviceUnpagedListResultsModelResponseTransformer: TrustedDeviceUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(TrustedDeviceModelResponseTransformer);
    }
    return data;
  };

export const GetAuthenticationProfileMfaTrustedDevicesResponseTransformer: GetAuthenticationProfileMfaTrustedDevicesResponseTransformer =
  async (data) => {
    TrustedDeviceUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ContactEntityResponseTransformer = (
  data: any
) => Promise<ContactEntityResponse>;

export type ContactEntityResponseDataResponseModelResponseTransformer = (
  data: any
) => ContactEntityResponseDataResponse;

export type ContactEntityModelResponseTransformer = (
  data: any
) => ContactEntity;

export type ContactBalanceModelResponseTransformer = (
  data: any
) => ContactBalance;

export const ContactBalanceModelResponseTransformer: ContactBalanceModelResponseTransformer =
  (data) => {
    if (data?.balanceModifiedAt) {
      data.balanceModifiedAt = new Date(data.balanceModifiedAt);
    }
    return data;
  };

export const ContactEntityModelResponseTransformer: ContactEntityModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.modifiedAt) {
      data.modifiedAt = new Date(data.modifiedAt);
    }
    if (data?.balance) {
      ContactBalanceModelResponseTransformer(data.balance);
    }
    return data;
  };

export const ContactEntityResponseDataResponseModelResponseTransformer: ContactEntityResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ContactEntityModelResponseTransformer(data.data);
    }
    return data;
  };

export const ContactEntityResponseTransformer: ContactEntityResponseTransformer =
  async (data) => {
    ContactEntityResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type ContactEntityByCodeResponseTransformer = (
  data: any
) => Promise<ContactEntityByCodeResponse>;

export const ContactEntityByCodeResponseTransformer: ContactEntityByCodeResponseTransformer =
  async (data) => {
    ContactEntityResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type DocumentAttachmentsListResponseTransformer = (
  data: any
) => Promise<DocumentAttachmentsListResponse>;

export type DocumentAttachmentUnpagedListResultsModelResponseTransformer = (
  data: any
) => DocumentAttachmentUnpagedListResults;

export type DocumentAttachmentModelResponseTransformer = (
  data: any
) => DocumentAttachment;

export const DocumentAttachmentModelResponseTransformer: DocumentAttachmentModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    return data;
  };

export const DocumentAttachmentUnpagedListResultsModelResponseTransformer: DocumentAttachmentUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DocumentAttachmentModelResponseTransformer);
    }
    return data;
  };

export const DocumentAttachmentsListResponseTransformer: DocumentAttachmentsListResponseTransformer =
  async (data) => {
    DocumentAttachmentUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type DataExportMonitorListResponseTransformer = (
  data: any
) => Promise<DataExportMonitorListResponse>;

export type DataExportDisplayDetailsListResultsModelResponseTransformer = (
  data: any
) => DataExportDisplayDetailsListResults;

export type DataExportDisplayDetailsModelResponseTransformer = (
  data: any
) => DataExportDisplayDetails;

export const DataExportDisplayDetailsModelResponseTransformer: DataExportDisplayDetailsModelResponseTransformer =
  (data) => {
    if (data?.startedDate) {
      data.startedDate = new Date(data.startedDate);
    }
    return data;
  };

export const DataExportDisplayDetailsListResultsModelResponseTransformer: DataExportDisplayDetailsListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DataExportDisplayDetailsModelResponseTransformer);
    }
    return data;
  };

export const DataExportMonitorListResponseTransformer: DataExportMonitorListResponseTransformer =
  async (data) => {
    DataExportDisplayDetailsListResultsModelResponseTransformer(data);
    return data;
  };

export type MatchedDocumentAiDetailsResponseTransformer = (
  data: any
) => Promise<MatchedDocumentAiDetailsResponse>;

export type MatchedDocumentResponseResponseDataResponseModelResponseTransformer =
  (data: any) => MatchedDocumentResponseResponseDataResponse;

export type MatchedDocumentResponseModelResponseTransformer = (
  data: any
) => MatchedDocumentResponse;

export type MatchedInvoiceSummaryModelResponseTransformer = (
  data: any
) => MatchedInvoiceSummary;

export const MatchedInvoiceSummaryModelResponseTransformer: MatchedInvoiceSummaryModelResponseTransformer =
  (data) => {
    if (data?.dueDate) {
      data.dueDate = new Date(data.dueDate);
    }
    if (data?.invoiceDate) {
      data.invoiceDate = new Date(data.invoiceDate);
    }
    return data;
  };

export const MatchedDocumentResponseModelResponseTransformer: MatchedDocumentResponseModelResponseTransformer =
  (data) => {
    if (data?.invoiceSummary) {
      MatchedInvoiceSummaryModelResponseTransformer(data.invoiceSummary);
    }
    return data;
  };

export const MatchedDocumentResponseResponseDataResponseModelResponseTransformer: MatchedDocumentResponseResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      MatchedDocumentResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const MatchedDocumentAiDetailsResponseTransformer: MatchedDocumentAiDetailsResponseTransformer =
  async (data) => {
    MatchedDocumentResponseResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type MatchedDocumentAiConfirmContactResponseTransformer = (
  data: any
) => Promise<MatchedDocumentAiConfirmContactResponse>;

export const MatchedDocumentAiConfirmContactResponseTransformer: MatchedDocumentAiConfirmContactResponseTransformer =
  async (data) => {
    MatchedDocumentResponseResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type MatchedDocumentAiCreateResponseTransformer = (
  data: any
) => Promise<MatchedDocumentAiCreateResponse>;

export const MatchedDocumentAiCreateResponseTransformer: MatchedDocumentAiCreateResponseTransformer =
  async (data) => {
    MatchedDocumentResponseResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type DocumentNotesListResponseTransformer = (
  data: any
) => Promise<DocumentNotesListResponse>;

export type DocumentNoteUnpagedListResultsModelResponseTransformer = (
  data: any
) => DocumentNoteUnpagedListResults;

export type DocumentNoteModelResponseTransformer = (data: any) => DocumentNote;

export const DocumentNoteModelResponseTransformer: DocumentNoteModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    return data;
  };

export const DocumentNoteUnpagedListResultsModelResponseTransformer: DocumentNoteUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DocumentNoteModelResponseTransformer);
    }
    return data;
  };

export const DocumentNotesListResponseTransformer: DocumentNotesListResponseTransformer =
  async (data) => {
    DocumentNoteUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type DocumentNotesAppendResponseTransformer = (
  data: any
) => Promise<DocumentNotesAppendResponse>;

export type DocumentNoteResponseDataModelResponseTransformer = (
  data: any
) => DocumentNoteResponseData;

export const DocumentNoteResponseDataModelResponseTransformer: DocumentNoteResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      DocumentNoteModelResponseTransformer(data.data);
    }
    return data;
  };

export const DocumentNotesAppendResponseTransformer: DocumentNotesAppendResponseTransformer =
  async (data) => {
    DocumentNoteResponseDataModelResponseTransformer(data);
    return data;
  };

export type DocumentQueuesResponseTransformer = (
  data: any
) => Promise<DocumentQueuesResponse>;

export type DocumentQueueUnpagedListResultsModelResponseTransformer = (
  data: any
) => DocumentQueueUnpagedListResults;

export type DocumentQueueModelResponseTransformer = (
  data: any
) => DocumentQueue;

export type DocumentQueueCountModelResponseTransformer = (
  data: any
) => DocumentQueueCount;

export const DocumentQueueCountModelResponseTransformer: DocumentQueueCountModelResponseTransformer =
  (data) => {
    if (data?.updated) {
      data.updated = new Date(data.updated);
    }
    return data;
  };

export const DocumentQueueModelResponseTransformer: DocumentQueueModelResponseTransformer =
  (data) => {
    if (data?.queueCount) {
      DocumentQueueCountModelResponseTransformer(data.queueCount);
    }
    return data;
  };

export const DocumentQueueUnpagedListResultsModelResponseTransformer: DocumentQueueUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DocumentQueueModelResponseTransformer);
    }
    return data;
  };

export const DocumentQueuesResponseTransformer: DocumentQueuesResponseTransformer =
  async (data) => {
    DocumentQueueUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type DocumentsSearchResponseTransformer = (
  data: any
) => Promise<DocumentsSearchResponse>;

export type DocumentSearchResultUnpagedListResultsModelResponseTransformer = (
  data: any
) => DocumentSearchResultUnpagedListResults;

export type DocumentSearchResultModelResponseTransformer = (
  data: any
) => DocumentSearchResult;

export const DocumentSearchResultModelResponseTransformer: DocumentSearchResultModelResponseTransformer =
  (data) => {
    if (data?.documentDate) {
      data.documentDate = new Date(data.documentDate);
    }
    return data;
  };

export const DocumentSearchResultUnpagedListResultsModelResponseTransformer: DocumentSearchResultUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DocumentSearchResultModelResponseTransformer);
    }
    return data;
  };

export const DocumentsSearchResponseTransformer: DocumentsSearchResponseTransformer =
  async (data) => {
    DocumentSearchResultUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type GetInboundDocumentAsnResponseTransformer = (
  data: any
) => Promise<GetInboundDocumentAsnResponse>;

export type AsnResultListResultsModelResponseTransformer = (
  data: any
) => AsnResultListResults;

export type AsnResultModelResponseTransformer = (data: any) => AsnResult;

export type DocumentPropertiesModelResponseTransformer = (
  data: any
) => DocumentProperties;

export type DocumentEntityPropertyModelResponseTransformer = (
  data: any
) => DocumentEntityProperty;

export const DocumentEntityPropertyModelResponseTransformer: DocumentEntityPropertyModelResponseTransformer =
  (data) => {
    if (data?.updated) {
      data.updated = new Date(data.updated);
    }
    return data;
  };

export const DocumentPropertiesModelResponseTransformer: DocumentPropertiesModelResponseTransformer =
  (data) => {
    if (data?.stage) {
      DocumentEntityPropertyModelResponseTransformer(data.stage);
    }
    if (data?.created) {
      data.created = new Date(data.created);
    }
    if (data?.modified) {
      data.modified = new Date(data.modified);
    }
    return data;
  };

export type AsnPoInfoModelResponseTransformer = (data: any) => AsnPoInfo;

export const AsnPoInfoModelResponseTransformer: AsnPoInfoModelResponseTransformer =
  (data) => {
    if (data?.expectedDate) {
      data.expectedDate = new Date(data.expectedDate);
    }
    return data;
  };

export const AsnResultModelResponseTransformer: AsnResultModelResponseTransformer =
  (data) => {
    if (data?.document) {
      DocumentPropertiesModelResponseTransformer(data.document);
    }
    if (data?.po) {
      AsnPoInfoModelResponseTransformer(data.po);
    }
    return data;
  };

export const AsnResultListResultsModelResponseTransformer: AsnResultListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(AsnResultModelResponseTransformer);
    }
    return data;
  };

export const GetInboundDocumentAsnResponseTransformer: GetInboundDocumentAsnResponseTransformer =
  async (data) => {
    AsnResultListResultsModelResponseTransformer(data);
    return data;
  };

export type PurchaseOrderGetResponseTransformer = (
  data: any
) => Promise<PurchaseOrderGetResponse>;

export type PurchaseOrderDocumentResponseDataModelResponseTransformer = (
  data: any
) => PurchaseOrderDocumentResponseData;

export type PurchaseOrderDocumentModelResponseTransformer = (
  data: any
) => PurchaseOrderDocument;

export type PurchaseOrderDocumentHeaderModelResponseTransformer = (
  data: any
) => PurchaseOrderDocumentHeader;

export const PurchaseOrderDocumentHeaderModelResponseTransformer: PurchaseOrderDocumentHeaderModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    if (data?.deliveryDate) {
      data.deliveryDate = new Date(data.deliveryDate);
    }
    if (data?.document) {
      DocumentPropertiesModelResponseTransformer(data.document);
    }
    return data;
  };

export const PurchaseOrderDocumentModelResponseTransformer: PurchaseOrderDocumentModelResponseTransformer =
  (data) => {
    if (data?.header) {
      PurchaseOrderDocumentHeaderModelResponseTransformer(data.header);
    }
    return data;
  };

export const PurchaseOrderDocumentResponseDataModelResponseTransformer: PurchaseOrderDocumentResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      PurchaseOrderDocumentModelResponseTransformer(data.data);
    }
    return data;
  };

export const PurchaseOrderGetResponseTransformer: PurchaseOrderGetResponseTransformer =
  async (data) => {
    PurchaseOrderDocumentResponseDataModelResponseTransformer(data);
    return data;
  };

export type PoListResponseTransformer = (data: any) => Promise<PoListResponse>;

export type ListResultsPoListResultsModelResponseTransformer = (
  data: any
) => ListResultsPoListResults;

export type ListResultsPoModelResponseTransformer = (
  data: any
) => ListResultsPo;

export const ListResultsPoModelResponseTransformer: ListResultsPoModelResponseTransformer =
  (data) => {
    if (data?.document) {
      DocumentPropertiesModelResponseTransformer(data.document);
    }
    if (data?.date) {
      data.date = new Date(data.date);
    }
    if (data?.etaDate) {
      data.etaDate = new Date(data.etaDate);
    }
    return data;
  };

export const ListResultsPoListResultsModelResponseTransformer: ListResultsPoListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ListResultsPoModelResponseTransformer);
    }
    return data;
  };

export const PoListResponseTransformer: PoListResponseTransformer = async (
  data
) => {
  ListResultsPoListResultsModelResponseTransformer(data);
  return data;
};

export type GetInboundDocumentShpSearchResponseTransformer = (
  data: any
) => Promise<GetInboundDocumentShpSearchResponse>;

export type ShipmentDetailListResultsModelResponseTransformer = (
  data: any
) => ShipmentDetailListResults;

export type ShipmentDetailModelResponseTransformer = (
  data: any
) => ShipmentDetail;

export const ShipmentDetailModelResponseTransformer: ShipmentDetailModelResponseTransformer =
  (data) => {
    if (data?.document) {
      DocumentPropertiesModelResponseTransformer(data.document);
    }
    if (data?.loadingDate) {
      data.loadingDate = new Date(data.loadingDate);
    }
    if (data?.orderedDate) {
      data.orderedDate = new Date(data.orderedDate);
    }
    if (data?.departureDate) {
      data.departureDate = new Date(data.departureDate);
    }
    if (data?.arrivalDate) {
      data.arrivalDate = new Date(data.arrivalDate);
    }
    return data;
  };

export const ShipmentDetailListResultsModelResponseTransformer: ShipmentDetailListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ShipmentDetailModelResponseTransformer);
    }
    return data;
  };

export const GetInboundDocumentShpSearchResponseTransformer: GetInboundDocumentShpSearchResponseTransformer =
  async (data) => {
    ShipmentDetailListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemsMappingResponseTransformer = (
  data: any
) => Promise<ItemsMappingResponse>;

export type ItemsMappingResponseResponseDataModelResponseTransformer = (
  data: any
) => ItemsMappingResponseResponseData;

export type ItemsMappingResponseModelResponseTransformer = (
  data: any
) => ItemsMappingResponse;

export type ItemsMappingItemResponseModelResponseTransformer = (
  data: any
) => ItemsMappingItemResponse;

export type ItemsMappingItemVendorResponseModelResponseTransformer = (
  data: any
) => ItemsMappingItemVendorResponse;

export const ItemsMappingItemVendorResponseModelResponseTransformer: ItemsMappingItemVendorResponseModelResponseTransformer =
  (data) => {
    if (data?.lastReceived) {
      data.lastReceived = new Date(data.lastReceived);
    }
    return data;
  };

export const ItemsMappingItemResponseModelResponseTransformer: ItemsMappingItemResponseModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.vendors)) {
      data.vendors.forEach(
        ItemsMappingItemVendorResponseModelResponseTransformer
      );
    }
    return data;
  };

export const ItemsMappingResponseModelResponseTransformer: ItemsMappingResponseModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.items)) {
      data.items.forEach(ItemsMappingItemResponseModelResponseTransformer);
    }
    return data;
  };

export const ItemsMappingResponseResponseDataModelResponseTransformer: ItemsMappingResponseResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ItemsMappingResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const ItemsMappingResponseTransformer: ItemsMappingResponseTransformer =
  async (data) => {
    ItemsMappingResponseResponseDataModelResponseTransformer(data);
    return data;
  };

export type GetInboundPendingResponseTransformer = (
  data: any
) => Promise<GetInboundPendingResponse>;

export type PendingInboundDocumentModelResponseTransformer = (
  data: any
) => PendingInboundDocument;

export const PendingInboundDocumentModelResponseTransformer: PendingInboundDocumentModelResponseTransformer =
  (data) => {
    if (data?.documentDate) {
      data.documentDate = new Date(data.documentDate);
    }
    if (data?.deliveryDue) {
      data.deliveryDue = new Date(data.deliveryDue);
    }
    return data;
  };

export const GetInboundPendingResponseTransformer: GetInboundPendingResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(PendingInboundDocumentModelResponseTransformer);
    }
    return data;
  };

export type RctDocumentLinkedResponseTransformer = (
  data: any
) => Promise<RctDocumentLinkedResponse>;

export type RctDocumentUnpagedListResultsModelResponseTransformer = (
  data: any
) => RctDocumentUnpagedListResults;

export type RctDocumentModelResponseTransformer = (data: any) => RctDocument;

export type RctDocumentHeaderModelResponseTransformer = (
  data: any
) => RctDocumentHeader;

export const RctDocumentHeaderModelResponseTransformer: RctDocumentHeaderModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const RctDocumentModelResponseTransformer: RctDocumentModelResponseTransformer =
  (data) => {
    if (data?.header) {
      RctDocumentHeaderModelResponseTransformer(data.header);
    }
    return data;
  };

export const RctDocumentUnpagedListResultsModelResponseTransformer: RctDocumentUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(RctDocumentModelResponseTransformer);
    }
    return data;
  };

export const RctDocumentLinkedResponseTransformer: RctDocumentLinkedResponseTransformer =
  async (data) => {
    RctDocumentUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type InboundDocumentGetResponseTransformer = (
  data: any
) => Promise<InboundDocumentGetResponse>;

export type InboundDocumentResponseDataModelResponseTransformer = (
  data: any
) => InboundDocumentResponseData;

export type InboundDocumentModelResponseTransformer = (
  data: any
) => InboundDocument;

export type InboundDocumentLineModelResponseTransformer = (
  data: any
) => InboundDocumentLine;

export type ItemBatchInfoModelResponseTransformer = (
  data: any
) => ItemBatchInfo;

export const ItemBatchInfoModelResponseTransformer: ItemBatchInfoModelResponseTransformer =
  (data) => {
    if (data?.productionDate) {
      data.productionDate = new Date(data.productionDate);
    }
    if (data?.bestBeforeDate) {
      data.bestBeforeDate = new Date(data.bestBeforeDate);
    }
    return data;
  };

export const InboundDocumentLineModelResponseTransformer: InboundDocumentLineModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.batches)) {
      data.batches.forEach(ItemBatchInfoModelResponseTransformer);
    }
    return data;
  };

export const InboundDocumentModelResponseTransformer: InboundDocumentModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.lines)) {
      data.lines.forEach(InboundDocumentLineModelResponseTransformer);
    }
    return data;
  };

export const InboundDocumentResponseDataModelResponseTransformer: InboundDocumentResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      InboundDocumentModelResponseTransformer(data.data);
    }
    return data;
  };

export const InboundDocumentGetResponseTransformer: InboundDocumentGetResponseTransformer =
  async (data) => {
    InboundDocumentResponseDataModelResponseTransformer(data);
    return data;
  };

export type PostInventoryAssemblyCreateResponseTransformer = (
  data: any
) => Promise<PostInventoryAssemblyCreateResponse>;

export type ItemAssemblyCreateRequestModelResponseTransformer = (
  data: any
) => ItemAssemblyCreateRequest;

export const ItemAssemblyCreateRequestModelResponseTransformer: ItemAssemblyCreateRequestModelResponseTransformer =
  (data) => {
    if (data?.assemblyDate) {
      data.assemblyDate = new Date(data.assemblyDate);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const PostInventoryAssemblyCreateResponseTransformer: PostInventoryAssemblyCreateResponseTransformer =
  async (data) => {
    ItemAssemblyCreateRequestModelResponseTransformer(data);
    return data;
  };

export type PostInventoryAssemblyPrepResponseTransformer = (
  data: any
) => Promise<PostInventoryAssemblyPrepResponse>;

export type ItemAssemblyPrepResponseResponseDataResponseModelResponseTransformer =
  (data: any) => ItemAssemblyPrepResponseResponseDataResponse;

export type ItemAssemblyPrepResponseModelResponseTransformer = (
  data: any
) => ItemAssemblyPrepResponse;

export type ItemAssemblyPrepBomModelResponseTransformer = (
  data: any
) => ItemAssemblyPrepBom;

export type ItemInventory3dSummaryModelResponseTransformer = (
  data: any
) => ItemInventory3dSummary;

export const ItemInventory3dSummaryModelResponseTransformer: ItemInventory3dSummaryModelResponseTransformer =
  (data) => {
    if (data?.batchDetails) {
      ItemBatchInfoModelResponseTransformer(data.batchDetails);
    }
    return data;
  };

export const ItemAssemblyPrepBomModelResponseTransformer: ItemAssemblyPrepBomModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.inventorySummary)) {
      data.inventorySummary.forEach(
        ItemInventory3dSummaryModelResponseTransformer
      );
    }
    return data;
  };

export const ItemAssemblyPrepResponseModelResponseTransformer: ItemAssemblyPrepResponseModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.items)) {
      data.items.forEach(ItemAssemblyPrepBomModelResponseTransformer);
    }
    return data;
  };

export const ItemAssemblyPrepResponseResponseDataResponseModelResponseTransformer: ItemAssemblyPrepResponseResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ItemAssemblyPrepResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const PostInventoryAssemblyPrepResponseTransformer: PostInventoryAssemblyPrepResponseTransformer =
  async (data) => {
    ItemAssemblyPrepResponseResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type GetInventoryAssemblyWorkOrdersResponseTransformer = (
  data: any
) => Promise<GetInventoryAssemblyWorkOrdersResponse>;

export type WorkOrderSummaryCursorListResultsModelResponseTransformer = (
  data: any
) => WorkOrderSummaryCursorListResults;

export type WorkOrderSummaryModelResponseTransformer = (
  data: any
) => WorkOrderSummary;

export const WorkOrderSummaryModelResponseTransformer: WorkOrderSummaryModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    if (data?.scheduledDate) {
      data.scheduledDate = new Date(data.scheduledDate);
    }
    return data;
  };

export const WorkOrderSummaryCursorListResultsModelResponseTransformer: WorkOrderSummaryCursorListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(WorkOrderSummaryModelResponseTransformer);
    }
    return data;
  };

export const GetInventoryAssemblyWorkOrdersResponseTransformer: GetInventoryAssemblyWorkOrdersResponseTransformer =
  async (data) => {
    WorkOrderSummaryCursorListResultsModelResponseTransformer(data);
    return data;
  };

export type GetInventoryAssemblyWorkOrdersIdResponseTransformer = (
  data: any
) => Promise<GetInventoryAssemblyWorkOrdersIdResponse>;

export type WorkOrderResponseDataResponseModelResponseTransformer = (
  data: any
) => WorkOrderResponseDataResponse;

export type WorkOrderModelResponseTransformer = (data: any) => WorkOrder;

export type WorkOrderSummaryItemModelResponseTransformer = (
  data: any
) => WorkOrderSummaryItem;

export const WorkOrderSummaryItemModelResponseTransformer: WorkOrderSummaryItemModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.childItems)) {
      data.childItems.forEach(WorkOrderSummaryItemModelResponseTransformer);
    }
    return data;
  };

export const WorkOrderModelResponseTransformer: WorkOrderModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    if (data?.scheduledDate) {
      data.scheduledDate = new Date(data.scheduledDate);
    }
    if (Array.isArray(data?.items)) {
      data.items.forEach(WorkOrderSummaryItemModelResponseTransformer);
    }
    return data;
  };

export const WorkOrderResponseDataResponseModelResponseTransformer: WorkOrderResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      WorkOrderModelResponseTransformer(data.data);
    }
    return data;
  };

export const GetInventoryAssemblyWorkOrdersIdResponseTransformer: GetInventoryAssemblyWorkOrdersIdResponseTransformer =
  async (data) => {
    WorkOrderResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type BinContentResponseTransformer = (
  data: any
) => Promise<BinContentResponse>;

export type BinContentItemListResultsModelResponseTransformer = (
  data: any
) => BinContentItemListResults;

export type BinContentItemModelResponseTransformer = (
  data: any
) => BinContentItem;

export const BinContentItemModelResponseTransformer: BinContentItemModelResponseTransformer =
  (data) => {
    if (data?.batch) {
      ItemBatchInfoModelResponseTransformer(data.batch);
    }
    return data;
  };

export const BinContentItemListResultsModelResponseTransformer: BinContentItemListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(BinContentItemModelResponseTransformer);
    }
    return data;
  };

export const BinContentResponseTransformer: BinContentResponseTransformer =
  async (data) => {
    BinContentItemListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemLabelsDocumentListResponseTransformer = (
  data: any
) => Promise<ItemLabelsDocumentListResponse>;

export type ItemLabelPrintResultUnpagedListResultsModelResponseTransformer = (
  data: any
) => ItemLabelPrintResultUnpagedListResults;

export type ItemLabelPrintResultModelResponseTransformer = (
  data: any
) => ItemLabelPrintResult;

export const ItemLabelPrintResultModelResponseTransformer: ItemLabelPrintResultModelResponseTransformer =
  (data) => {
    if (data?.batch) {
      ItemBatchInfoModelResponseTransformer(data.batch);
    }
    return data;
  };

export const ItemLabelPrintResultUnpagedListResultsModelResponseTransformer: ItemLabelPrintResultUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemLabelPrintResultModelResponseTransformer);
    }
    return data;
  };

export const ItemLabelsDocumentListResponseTransformer: ItemLabelsDocumentListResponseTransformer =
  async (data) => {
    ItemLabelPrintResultUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemBatchesResponseTransformer = (
  data: any
) => Promise<ItemBatchesResponse>;

export type ItemBatchInfoUnpagedListResultsModelResponseTransformer = (
  data: any
) => ItemBatchInfoUnpagedListResults;

export const ItemBatchInfoUnpagedListResultsModelResponseTransformer: ItemBatchInfoUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemBatchInfoModelResponseTransformer);
    }
    return data;
  };

export const ItemBatchesResponseTransformer: ItemBatchesResponseTransformer =
  async (data) => {
    ItemBatchInfoUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemInventory3DResponseTransformer = (
  data: any
) => Promise<ItemInventory3DResponse>;

export type ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer = (
  data: any
) => ItemInventory3dSummaryUnpagedListResults;

export const ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer: ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemInventory3dSummaryModelResponseTransformer);
    }
    return data;
  };

export const ItemInventory3DResponseTransformer: ItemInventory3DResponseTransformer =
  async (data) => {
    ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemInventoryLogResponseTransformer = (
  data: any
) => Promise<ItemInventoryLogResponse>;

export type ItemInventoryLogListResultsModelResponseTransformer = (
  data: any
) => ItemInventoryLogListResults;

export type ItemInventoryLogModelResponseTransformer = (
  data: any
) => ItemInventoryLog;

export const ItemInventoryLogModelResponseTransformer: ItemInventoryLogModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    if (data?.batchInfo) {
      ItemBatchInfoModelResponseTransformer(data.batchInfo);
    }
    return data;
  };

export const ItemInventoryLogListResultsModelResponseTransformer: ItemInventoryLogListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemInventoryLogModelResponseTransformer);
    }
    return data;
  };

export const ItemInventoryLogResponseTransformer: ItemInventoryLogResponseTransformer =
  async (data) => {
    ItemInventoryLogListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemInventoryDrilldownResponseTransformer = (
  data: any
) => Promise<ItemInventoryDrilldownResponse>;

export type ItemInventoryDrilldownListResultsModelResponseTransformer = (
  data: any
) => ItemInventoryDrilldownListResults;

export type ItemInventoryDrilldownModelResponseTransformer = (
  data: any
) => ItemInventoryDrilldown;

export const ItemInventoryDrilldownModelResponseTransformer: ItemInventoryDrilldownModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const ItemInventoryDrilldownListResultsModelResponseTransformer: ItemInventoryDrilldownListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemInventoryDrilldownModelResponseTransformer);
    }
    return data;
  };

export const ItemInventoryDrilldownResponseTransformer: ItemInventoryDrilldownResponseTransformer =
  async (data) => {
    ItemInventoryDrilldownListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemPricingResponseTransformer = (
  data: any
) => Promise<ItemPricingResponse>;

export type PricelistEntryPerItemUnpagedListResultsModelResponseTransformer = (
  data: any
) => PricelistEntryPerItemUnpagedListResults;

export type PricelistEntryPerItemModelResponseTransformer = (
  data: any
) => PricelistEntryPerItem;

export type PricelistEntryConditionalModelResponseTransformer = (
  data: any
) => PricelistEntryConditional;

export const PricelistEntryConditionalModelResponseTransformer: PricelistEntryConditionalModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export type PricelistUomEntryModelResponseTransformer = (
  data: any
) => PricelistUomEntry;

export const PricelistUomEntryModelResponseTransformer: PricelistUomEntryModelResponseTransformer =
  (data) => {
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const PricelistEntryPerItemModelResponseTransformer: PricelistEntryPerItemModelResponseTransformer =
  (data) => {
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (Array.isArray(data?.conditionalPricing)) {
      data.conditionalPricing.forEach(
        PricelistEntryConditionalModelResponseTransformer
      );
    }
    if (Array.isArray(data?.uomPricing)) {
      data.uomPricing.forEach(PricelistUomEntryModelResponseTransformer);
    }
    return data;
  };

export const PricelistEntryPerItemUnpagedListResultsModelResponseTransformer: PricelistEntryPerItemUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PricelistEntryPerItemModelResponseTransformer);
    }
    return data;
  };

export const ItemPricingResponseTransformer: ItemPricingResponseTransformer =
  async (data) => {
    PricelistEntryPerItemUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemQuickViewResponseTransformer = (
  data: any
) => Promise<ItemQuickViewResponse>;

export type ItemQuickViewResultsListResultsModelResponseTransformer = (
  data: any
) => ItemQuickViewResultsListResults;

export type ItemQuickViewResultsModelResponseTransformer = (
  data: any
) => ItemQuickViewResults;

export const ItemQuickViewResultsModelResponseTransformer: ItemQuickViewResultsModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const ItemQuickViewResultsListResultsModelResponseTransformer: ItemQuickViewResultsListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemQuickViewResultsModelResponseTransformer);
    }
    return data;
  };

export const ItemQuickViewResponseTransformer: ItemQuickViewResponseTransformer =
  async (data) => {
    ItemQuickViewResultsListResultsModelResponseTransformer(data);
    return data;
  };

export type StockSummaryResponseTransformer = (
  data: any
) => Promise<StockSummaryResponse>;

export type ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer =
  (data: any) => ItemInventoryByItemWarehouseUnpagedListResults;

export type ItemInventoryByItemWarehouseModelResponseTransformer = (
  data: any
) => ItemInventoryByItemWarehouse;

export const ItemInventoryByItemWarehouseModelResponseTransformer: ItemInventoryByItemWarehouseModelResponseTransformer =
  (data) => {
    if (data?.lastModified) {
      data.lastModified = new Date(data.lastModified);
    }
    return data;
  };

export const ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer: ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        ItemInventoryByItemWarehouseModelResponseTransformer
      );
    }
    return data;
  };

export const StockSummaryResponseTransformer: StockSummaryResponseTransformer =
  async (data) => {
    ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer(
      data
    );
    return data;
  };

export type StockSummaryDetailedResponseTransformer = (
  data: any
) => Promise<StockSummaryDetailedResponse>;

export type ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer =
  (data: any) => ItemInventoryByItemWarehouseDetailedUnpagedListResults;

export type ItemInventoryByItemWarehouseDetailedModelResponseTransformer = (
  data: any
) => ItemInventoryByItemWarehouseDetailed;

export const ItemInventoryByItemWarehouseDetailedModelResponseTransformer: ItemInventoryByItemWarehouseDetailedModelResponseTransformer =
  (data) => {
    if (data?.lastModified) {
      data.lastModified = new Date(data.lastModified);
    }
    if (data?.batchDetails) {
      ItemBatchInfoModelResponseTransformer(data.batchDetails);
    }
    return data;
  };

export const ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer: ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        ItemInventoryByItemWarehouseDetailedModelResponseTransformer
      );
    }
    return data;
  };

export const StockSummaryDetailedResponseTransformer: StockSummaryDetailedResponseTransformer =
  async (data) => {
    ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer(
      data
    );
    return data;
  };

export type ItemAppCategoriesListResponseTransformer = (
  data: any
) => Promise<ItemAppCategoriesListResponse>;

export type ItemAppCategoryHierarchyUnpagedListResultsModelResponseTransformer =
  (data: any) => ItemAppCategoryHierarchyUnpagedListResults;

export type ItemAppCategoryHierarchyModelResponseTransformer = (
  data: any
) => ItemAppCategoryHierarchy;

export const ItemAppCategoryHierarchyModelResponseTransformer: ItemAppCategoryHierarchyModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.categories)) {
      data.categories.forEach(ItemAppCategoryHierarchyModelResponseTransformer);
    }
    return data;
  };

export const ItemAppCategoryHierarchyUnpagedListResultsModelResponseTransformer: ItemAppCategoryHierarchyUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ItemAppCategoryHierarchyModelResponseTransformer);
    }
    return data;
  };

export const ItemAppCategoriesListResponseTransformer: ItemAppCategoriesListResponseTransformer =
  async (data) => {
    ItemAppCategoryHierarchyUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type MarketplaceDetailsResponseTransformer = (
  data: any
) => Promise<MarketplaceDetailsResponse>;

export type MarketplaceDetailsResponseDataModelResponseTransformer = (
  data: any
) => MarketplaceDetailsResponseData;

export const MarketplaceDetailsResponseDataModelResponseTransformer: MarketplaceDetailsResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      MarketplaceDetailsModelResponseTransformer(data.data);
    }
    return data;
  };

export const MarketplaceDetailsResponseTransformer: MarketplaceDetailsResponseTransformer =
  async (data) => {
    MarketplaceDetailsResponseDataModelResponseTransformer(data);
    return data;
  };

export type AmazonInboundPlacementTransportListResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlacementTransportListResponse>;

export type InboundPlanTransportationOptionsResponseResponseDataResponseModelResponseTransformer =
  (data: any) => InboundPlanTransportationOptionsResponseResponseDataResponse;

export type InboundPlanTransportationOptionsResponseModelResponseTransformer = (
  data: any
) => InboundPlanTransportationOptionsResponse;

export type InboundTransportationOptionModelResponseTransformer = (
  data: any
) => InboundTransportationOption;

export type DateRangeOffsetModelResponseTransformer = (
  data: any
) => DateRangeOffset;

export const DateRangeOffsetModelResponseTransformer: DateRangeOffsetModelResponseTransformer =
  (data) => {
    if (data?.start) {
      data.start = new Date(data.start);
    }
    if (data?.end) {
      data.end = new Date(data.end);
    }
    return data;
  };

export type InboundTransportationQuoteModelResponseTransformer = (
  data: any
) => InboundTransportationQuote;

export const InboundTransportationQuoteModelResponseTransformer: InboundTransportationQuoteModelResponseTransformer =
  (data) => {
    if (data?.expiration) {
      data.expiration = new Date(data.expiration);
    }
    if (data?.voidableUntil) {
      data.voidableUntil = new Date(data.voidableUntil);
    }
    return data;
  };

export const InboundTransportationOptionModelResponseTransformer: InboundTransportationOptionModelResponseTransformer =
  (data) => {
    if (data?.carrierAppointment) {
      DateRangeOffsetModelResponseTransformer(data.carrierAppointment);
    }
    if (data?.quote) {
      InboundTransportationQuoteModelResponseTransformer(data.quote);
    }
    return data;
  };

export type InboundTransportationDeliveryWindowModelResponseTransformer = (
  data: any
) => InboundTransportationDeliveryWindow;

export const InboundTransportationDeliveryWindowModelResponseTransformer: InboundTransportationDeliveryWindowModelResponseTransformer =
  (data) => {
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.validUntil) {
      data.validUntil = new Date(data.validUntil);
    }
    return data;
  };

export const InboundPlanTransportationOptionsResponseModelResponseTransformer: InboundPlanTransportationOptionsResponseModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.transportationOptions)) {
      data.transportationOptions.forEach(
        InboundTransportationOptionModelResponseTransformer
      );
    }
    if (Array.isArray(data?.deliveryWindowOptions)) {
      data.deliveryWindowOptions.forEach(
        InboundTransportationDeliveryWindowModelResponseTransformer
      );
    }
    return data;
  };

export const InboundPlanTransportationOptionsResponseResponseDataResponseModelResponseTransformer: InboundPlanTransportationOptionsResponseResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      InboundPlanTransportationOptionsResponseModelResponseTransformer(
        data.data
      );
    }
    return data;
  };

export const AmazonInboundPlacementTransportListResponseTransformer: AmazonInboundPlacementTransportListResponseTransformer =
  async (data) => {
    InboundPlanTransportationOptionsResponseResponseDataResponseModelResponseTransformer(
      data
    );
    return data;
  };

export type AmazonInboundPlanPlacementOptionsDetailedListResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlanPlacementOptionsDetailedListResponse>;

export type InboundPlanShipmentPlacementDetailsResponseUnpagedListResultsModelResponseTransformer =
  (data: any) => InboundPlanShipmentPlacementDetailsResponseUnpagedListResults;

export type InboundPlanShipmentPlacementDetailsResponseModelResponseTransformer =
  (data: any) => InboundPlanShipmentPlacementDetailsResponse;

export const InboundPlanShipmentPlacementDetailsResponseModelResponseTransformer: InboundPlanShipmentPlacementDetailsResponseModelResponseTransformer =
  (data) => {
    if (data?.expiration) {
      data.expiration = new Date(data.expiration);
    }
    return data;
  };

export const InboundPlanShipmentPlacementDetailsResponseUnpagedListResultsModelResponseTransformer: InboundPlanShipmentPlacementDetailsResponseUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        InboundPlanShipmentPlacementDetailsResponseModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlanPlacementOptionsDetailedListResponseTransformer: AmazonInboundPlanPlacementOptionsDetailedListResponseTransformer =
  async (data) => {
    InboundPlanShipmentPlacementDetailsResponseUnpagedListResultsModelResponseTransformer(
      data
    );
    return data;
  };

export type AmazonInboundPlanPlacementOptionsDetailsResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlanPlacementOptionsDetailsResponse>;

export type InboundPlanShipmentPlacementDetailsResponseResponseDataResponseModelResponseTransformer =
  (
    data: any
  ) => InboundPlanShipmentPlacementDetailsResponseResponseDataResponse;

export const InboundPlanShipmentPlacementDetailsResponseResponseDataResponseModelResponseTransformer: InboundPlanShipmentPlacementDetailsResponseResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      InboundPlanShipmentPlacementDetailsResponseModelResponseTransformer(
        data.data
      );
    }
    return data;
  };

export const AmazonInboundPlanPlacementOptionsDetailsResponseTransformer: AmazonInboundPlanPlacementOptionsDetailsResponseTransformer =
  async (data) => {
    InboundPlanShipmentPlacementDetailsResponseResponseDataResponseModelResponseTransformer(
      data
    );
    return data;
  };

export type AmazonInboundPlanShipmentsListResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlanShipmentsListResponse>;

export type UnpagedListResults_1UnpagedListResultsModelResponseTransformer = (
  data: any
) => UnpagedListResults_1UnpagedListResults;

export type FbaShipmentTempUnpagedListResultsModelResponseTransformer = (
  data: any
) => FbaShipmentTempUnpagedListResults;

export type FbaShipmentTempModelResponseTransformer = (
  data: any
) => FbaShipmentTemp;

export type SpApiFulfillmentInboundShipmentModelResponseTransformer = (
  data: any
) => SpApiFulfillmentInboundShipment;

export type SpApiFulfillmentInboundDatesModelResponseTransformer = (
  data: any
) => SpApiFulfillmentInboundDates;

export type SpApiFulfillmentInboundWindowModelResponseTransformer = (
  data: any
) => SpApiFulfillmentInboundWindow;

export const SpApiFulfillmentInboundWindowModelResponseTransformer: SpApiFulfillmentInboundWindowModelResponseTransformer =
  (data) => {
    if (data?.editableUntil) {
      data.editableUntil = new Date(data.editableUntil);
    }
    if (data?.end) {
      data.end = new Date(data.end);
    }
    if (data?.start) {
      data.start = new Date(data.start);
    }
    return data;
  };

export const SpApiFulfillmentInboundDatesModelResponseTransformer: SpApiFulfillmentInboundDatesModelResponseTransformer =
  (data) => {
    if (data?.readyToShipWindow) {
      SpApiFulfillmentInboundWindowModelResponseTransformer(
        data.readyToShipWindow
      );
    }
    return data;
  };

export type SpApiFulfillmentInboundSelectedDeliveryWindowModelResponseTransformer =
  (data: any) => SpApiFulfillmentInboundSelectedDeliveryWindow;

export const SpApiFulfillmentInboundSelectedDeliveryWindowModelResponseTransformer: SpApiFulfillmentInboundSelectedDeliveryWindowModelResponseTransformer =
  (data) => {
    if (data?.editableUntil) {
      data.editableUntil = new Date(data.editableUntil);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    return data;
  };

export type SpApiFulfillmentInboundSelfShipAppointmentDetailsModelResponseTransformer =
  (data: any) => SpApiFulfillmentInboundSelfShipAppointmentDetails;

export type SpApiFulfillmentInboundAppointmentSlotTimeModelResponseTransformer =
  (data: any) => SpApiFulfillmentInboundAppointmentSlotTime;

export const SpApiFulfillmentInboundAppointmentSlotTimeModelResponseTransformer: SpApiFulfillmentInboundAppointmentSlotTimeModelResponseTransformer =
  (data) => {
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    return data;
  };

export const SpApiFulfillmentInboundSelfShipAppointmentDetailsModelResponseTransformer: SpApiFulfillmentInboundSelfShipAppointmentDetailsModelResponseTransformer =
  (data) => {
    if (data?.appointmentSlotTime) {
      SpApiFulfillmentInboundAppointmentSlotTimeModelResponseTransformer(
        data.appointmentSlotTime
      );
    }
    return data;
  };

export const SpApiFulfillmentInboundShipmentModelResponseTransformer: SpApiFulfillmentInboundShipmentModelResponseTransformer =
  (data) => {
    if (data?.dates) {
      SpApiFulfillmentInboundDatesModelResponseTransformer(data.dates);
    }
    if (data?.selectedDeliveryWindow) {
      SpApiFulfillmentInboundSelectedDeliveryWindowModelResponseTransformer(
        data.selectedDeliveryWindow
      );
    }
    if (Array.isArray(data?.selfShipAppointmentDetails)) {
      data.selfShipAppointmentDetails.forEach(
        SpApiFulfillmentInboundSelfShipAppointmentDetailsModelResponseTransformer
      );
    }
    return data;
  };

export const FbaShipmentTempModelResponseTransformer: FbaShipmentTempModelResponseTransformer =
  (data) => {
    if (data?.shipment) {
      SpApiFulfillmentInboundShipmentModelResponseTransformer(data.shipment);
    }
    return data;
  };

export const FbaShipmentTempUnpagedListResultsModelResponseTransformer: FbaShipmentTempUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(FbaShipmentTempModelResponseTransformer);
    }
    return data;
  };

export const UnpagedListResults_1UnpagedListResultsModelResponseTransformer: UnpagedListResults_1UnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        FbaShipmentTempUnpagedListResultsModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlanShipmentsListResponseTransformer: AmazonInboundPlanShipmentsListResponseTransformer =
  async (data) => {
    UnpagedListResults_1UnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type AmazonInboundPlanTransportListResponseTransformer = (
  data: any
) => Promise<AmazonInboundPlanTransportListResponse>;

export type TransportationOptionUnpagedListResultsModelResponseTransformer = (
  data: any
) => TransportationOptionUnpagedListResults;

export type SpApiFulfillmentInboundTransportationOptionModelResponseTransformer =
  (data: any) => SpApiFulfillmentInboundTransportationOption;

export type SpApiFulfillmentInboundCarrierAppointmentModelResponseTransformer =
  (data: any) => SpApiFulfillmentInboundCarrierAppointment;

export const SpApiFulfillmentInboundCarrierAppointmentModelResponseTransformer: SpApiFulfillmentInboundCarrierAppointmentModelResponseTransformer =
  (data) => {
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    return data;
  };

export type SpApiFulfillmentInboundQuoteModelResponseTransformer = (
  data: any
) => SpApiFulfillmentInboundQuote;

export const SpApiFulfillmentInboundQuoteModelResponseTransformer: SpApiFulfillmentInboundQuoteModelResponseTransformer =
  (data) => {
    if (data?.expiration) {
      data.expiration = new Date(data.expiration);
    }
    if (data?.voidableUntil) {
      data.voidableUntil = new Date(data.voidableUntil);
    }
    return data;
  };

export const SpApiFulfillmentInboundTransportationOptionModelResponseTransformer: SpApiFulfillmentInboundTransportationOptionModelResponseTransformer =
  (data) => {
    if (data?.carrierAppointment) {
      SpApiFulfillmentInboundCarrierAppointmentModelResponseTransformer(
        data.carrierAppointment
      );
    }
    if (data?.quote) {
      SpApiFulfillmentInboundQuoteModelResponseTransformer(data.quote);
    }
    return data;
  };

export const TransportationOptionUnpagedListResultsModelResponseTransformer: TransportationOptionUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(
        SpApiFulfillmentInboundTransportationOptionModelResponseTransformer
      );
    }
    return data;
  };

export const AmazonInboundPlanTransportListResponseTransformer: AmazonInboundPlanTransportListResponseTransformer =
  async (data) => {
    TransportationOptionUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type AmazonInboundDocumentListResponseTransformer = (
  data: any
) => Promise<AmazonInboundDocumentListResponse>;

export type AmazonInboundDocumentListResultsModelResponseTransformer = (
  data: any
) => AmazonInboundDocumentListResults;

export type AmazonInboundDocumentModelResponseTransformer = (
  data: any
) => AmazonInboundDocument;

export const AmazonInboundDocumentModelResponseTransformer: AmazonInboundDocumentModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const AmazonInboundDocumentListResultsModelResponseTransformer: AmazonInboundDocumentListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(AmazonInboundDocumentModelResponseTransformer);
    }
    return data;
  };

export const AmazonInboundDocumentListResponseTransformer: AmazonInboundDocumentListResponseTransformer =
  async (data) => {
    AmazonInboundDocumentListResultsModelResponseTransformer(data);
    return data;
  };

export type CarrierDocumentsResponseTransformer = (
  data: any
) => Promise<CarrierDocumentsResponse>;

export type CarrierDocumentsResponseDataResponseModelResponseTransformer = (
  data: any
) => CarrierDocumentsResponseDataResponse;

export type CarrierDocumentsModelResponseTransformer = (
  data: any
) => CarrierDocuments;

export type CarrierManifestDocumentModelResponseTransformer = (
  data: any
) => CarrierManifestDocument;

export type CarrierShipmentModelResponseTransformer = (
  data: any
) => CarrierShipment;

export const CarrierShipmentModelResponseTransformer: CarrierShipmentModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const CarrierManifestDocumentModelResponseTransformer: CarrierManifestDocumentModelResponseTransformer =
  (data) => {
    if (data?.pickup) {
      data.pickup = new Date(data.pickup);
    }
    if (Array.isArray(data?.shipments)) {
      data.shipments.forEach(CarrierShipmentModelResponseTransformer);
    }
    return data;
  };

export const CarrierDocumentsModelResponseTransformer: CarrierDocumentsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.manifests)) {
      data.manifests.forEach(CarrierManifestDocumentModelResponseTransformer);
    }
    if (Array.isArray(data?.shipments)) {
      data.shipments.forEach(CarrierShipmentModelResponseTransformer);
    }
    return data;
  };

export const CarrierDocumentsResponseDataResponseModelResponseTransformer: CarrierDocumentsResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      CarrierDocumentsModelResponseTransformer(data.data);
    }
    return data;
  };

export const CarrierDocumentsResponseTransformer: CarrierDocumentsResponseTransformer =
  async (data) => {
    CarrierDocumentsResponseDataResponseModelResponseTransformer(data);
    return data;
  };

export type GetOutboundDocumentSoDocumentidTrendsResponseTransformer = (
  data: any
) => Promise<GetOutboundDocumentSoDocumentidTrendsResponse>;

export type CustomerPeriodicSalesResultsResponseDataModelResponseTransformer = (
  data: any
) => CustomerPeriodicSalesResultsResponseData;

export type CustomerPeriodicSalesResultsModelResponseTransformer = (
  data: any
) => CustomerPeriodicSalesResults;

export type CustomerPeriodicSalesPeriodModelResponseTransformer = (
  data: any
) => CustomerPeriodicSalesPeriod;

export const CustomerPeriodicSalesPeriodModelResponseTransformer: CustomerPeriodicSalesPeriodModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    return data;
  };

export const CustomerPeriodicSalesResultsModelResponseTransformer: CustomerPeriodicSalesResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.periods)) {
      data.periods.forEach(CustomerPeriodicSalesPeriodModelResponseTransformer);
    }
    return data;
  };

export const CustomerPeriodicSalesResultsResponseDataModelResponseTransformer: CustomerPeriodicSalesResultsResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      CustomerPeriodicSalesResultsModelResponseTransformer(data.data);
    }
    return data;
  };

export const GetOutboundDocumentSoDocumentidTrendsResponseTransformer: GetOutboundDocumentSoDocumentidTrendsResponseTransformer =
  async (data) => {
    CustomerPeriodicSalesResultsResponseDataModelResponseTransformer(data);
    return data;
  };

export type GetPackingDocumentResponseTransformer = (
  data: any
) => Promise<GetPackingDocumentResponse>;

export type PackingDocumentResponseDataModelResponseTransformer = (
  data: any
) => PackingDocumentResponseData;

export type Packing_PackingDocumentModelResponseTransformer = (
  data: any
) => Packing_PackingDocument;

export type Packing_DocumentDetailsModelResponseTransformer = (
  data: any
) => Packing_DocumentDetails;

export const Packing_DocumentDetailsModelResponseTransformer: Packing_DocumentDetailsModelResponseTransformer =
  (data) => {
    if (data?.documentDate) {
      data.documentDate = new Date(data.documentDate);
    }
    if (data?.deliveryDateFrom) {
      data.deliveryDateFrom = new Date(data.deliveryDateFrom);
    }
    if (data?.deliveryDateTo) {
      data.deliveryDateTo = new Date(data.deliveryDateTo);
    }
    return data;
  };

export type Packing_PackageInfoModelResponseTransformer = (
  data: any
) => Packing_PackageInfo;

export const Packing_PackageInfoModelResponseTransformer: Packing_PackageInfoModelResponseTransformer =
  (data) => {
    if (data?.packDate) {
      data.packDate = new Date(data.packDate);
    }
    return data;
  };

export type Packing_PackingDocumentDetailModelResponseTransformer = (
  data: any
) => Packing_PackingDocumentDetail;

export type ItemOnOrderDetailModelResponseTransformer = (
  data: any
) => ItemOnOrderDetail;

export const ItemOnOrderDetailModelResponseTransformer: ItemOnOrderDetailModelResponseTransformer =
  (data) => {
    if (data?.expectedDate) {
      data.expectedDate = new Date(data.expectedDate);
    }
    return data;
  };

export type Packing_PackageContentLineModelResponseTransformer = (
  data: any
) => Packing_PackageContentLine;

export type PartDetailsModelResponseTransformer = (data: any) => PartDetails;

export const PartDetailsModelResponseTransformer: PartDetailsModelResponseTransformer =
  (data) => {
    if (data?.itemExpectedDate) {
      data.itemExpectedDate = new Date(data.itemExpectedDate);
    }
    if (Array.isArray(data?.itemOnOrderDetails)) {
      data.itemOnOrderDetails.forEach(
        ItemOnOrderDetailModelResponseTransformer
      );
    }
    return data;
  };

export const Packing_PackageContentLineModelResponseTransformer: Packing_PackageContentLineModelResponseTransformer =
  (data) => {
    if (data?.batchExpiryDate) {
      data.batchExpiryDate = new Date(data.batchExpiryDate);
    }
    if (data?.batchManufacturingDate) {
      data.batchManufacturingDate = new Date(data.batchManufacturingDate);
    }
    if (data?.partDetails) {
      PartDetailsModelResponseTransformer(data.partDetails);
    }
    return data;
  };

export type Packing_PackingInventoryDetailModelResponseTransformer = (
  data: any
) => Packing_PackingInventoryDetail;

export const Packing_PackingInventoryDetailModelResponseTransformer: Packing_PackingInventoryDetailModelResponseTransformer =
  (data) => {
    if (data?.batchDate) {
      data.batchDate = new Date(data.batchDate);
    }
    return data;
  };

export type Common_ProductBatchDetailsModelResponseTransformer = (
  data: any
) => Common_ProductBatchDetails;

export const Common_ProductBatchDetailsModelResponseTransformer: Common_ProductBatchDetailsModelResponseTransformer =
  (data) => {
    if (data?.expiryDate) {
      data.expiryDate = new Date(data.expiryDate);
    }
    if (data?.manufacturingDate) {
      data.manufacturingDate = new Date(data.manufacturingDate);
    }
    return data;
  };

export const Packing_PackingDocumentDetailModelResponseTransformer: Packing_PackingDocumentDetailModelResponseTransformer =
  (data) => {
    if (data?.itemExpectedDate) {
      data.itemExpectedDate = new Date(data.itemExpectedDate);
    }
    if (Array.isArray(data?.itemOnOrderDetails)) {
      data.itemOnOrderDetails.forEach(
        ItemOnOrderDetailModelResponseTransformer
      );
    }
    if (Array.isArray(data?.packingContent)) {
      data.packingContent.forEach(
        Packing_PackageContentLineModelResponseTransformer
      );
    }
    if (Array.isArray(data?.inventoryDetails)) {
      data.inventoryDetails.forEach(
        Packing_PackingInventoryDetailModelResponseTransformer
      );
    }
    if (Array.isArray(data?.batches)) {
      data.batches.forEach(Common_ProductBatchDetailsModelResponseTransformer);
    }
    if (Array.isArray(data?.alternatives)) {
      data.alternatives.forEach(
        Packing_PackingDocumentDetailModelResponseTransformer
      );
    }
    return data;
  };

export const Packing_PackingDocumentModelResponseTransformer: Packing_PackingDocumentModelResponseTransformer =
  (data) => {
    if (data?.document) {
      Packing_DocumentDetailsModelResponseTransformer(data.document);
    }
    if (Array.isArray(data?.packs)) {
      data.packs.forEach(Packing_PackageInfoModelResponseTransformer);
    }
    if (Array.isArray(data?.lines)) {
      data.lines.forEach(Packing_PackingDocumentDetailModelResponseTransformer);
    }
    if (data?.newPackageInfo) {
      Packing_PackageInfoModelResponseTransformer(data.newPackageInfo);
    }
    if (Array.isArray(data?.unlisted)) {
      data.unlisted.forEach(
        Packing_PackingDocumentDetailModelResponseTransformer
      );
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    return data;
  };

export const PackingDocumentResponseDataModelResponseTransformer: PackingDocumentResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      Packing_PackingDocumentModelResponseTransformer(data.data);
    }
    return data;
  };

export const GetPackingDocumentResponseTransformer: GetPackingDocumentResponseTransformer =
  async (data) => {
    PackingDocumentResponseDataModelResponseTransformer(data);
    return data;
  };

export type PackagesUnassignListResponseTransformer = (
  data: any
) => Promise<PackagesUnassignListResponse>;

export type UnassignPackageUnpagedListResultsModelResponseTransformer = (
  data: any
) => UnassignPackageUnpagedListResults;

export type UnassignPackageModelResponseTransformer = (
  data: any
) => UnassignPackage;

export const UnassignPackageModelResponseTransformer: UnassignPackageModelResponseTransformer =
  (data) => {
    if (data?.packingDate) {
      data.packingDate = new Date(data.packingDate);
    }
    if (data?.dueDate) {
      data.dueDate = new Date(data.dueDate);
    }
    return data;
  };

export const UnassignPackageUnpagedListResultsModelResponseTransformer: UnassignPackageUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(UnassignPackageModelResponseTransformer);
    }
    return data;
  };

export const PackagesUnassignListResponseTransformer: PackagesUnassignListResponseTransformer =
  async (data) => {
    UnassignPackageUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type SalesOrderGetResponseTransformer = (
  data: any
) => Promise<SalesOrderGetResponse>;

export type SalesOrderDocumentResponseDataModelResponseTransformer = (
  data: any
) => SalesOrderDocumentResponseData;

export type SalesOrderDocumentModelResponseTransformer = (
  data: any
) => SalesOrderDocument;

export type SalesOrderDocumentHeaderModelResponseTransformer = (
  data: any
) => SalesOrderDocumentHeader;

export type SalesOrderDocumentDispatchModelResponseTransformer = (
  data: any
) => SalesOrderDocumentDispatch;

export const SalesOrderDocumentDispatchModelResponseTransformer: SalesOrderDocumentDispatchModelResponseTransformer =
  (data) => {
    if (data?.dispatchDate) {
      data.dispatchDate = new Date(data.dispatchDate);
    }
    if (data?.dueDate) {
      data.dueDate = new Date(data.dueDate);
    }
    return data;
  };

export const SalesOrderDocumentHeaderModelResponseTransformer: SalesOrderDocumentHeaderModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    if (data?.dispatch) {
      SalesOrderDocumentDispatchModelResponseTransformer(data.dispatch);
    }
    if (data?.document) {
      DocumentPropertiesModelResponseTransformer(data.document);
    }
    return data;
  };

export type SalesOrderDocumentLineModelResponseTransformer = (
  data: any
) => SalesOrderDocumentLine;

export const SalesOrderDocumentLineModelResponseTransformer: SalesOrderDocumentLineModelResponseTransformer =
  (data) => {
    if (data?.batch) {
      ItemBatchInfoModelResponseTransformer(data.batch);
    }
    return data;
  };

export type Packing_PackageModelResponseTransformer = (
  data: any
) => Packing_Package;

export const Packing_PackageModelResponseTransformer: Packing_PackageModelResponseTransformer =
  (data) => {
    if (data?.packageInfo) {
      Packing_PackageInfoModelResponseTransformer(data.packageInfo);
    }
    if (Array.isArray(data?.innerPacks)) {
      data.innerPacks.forEach(Packing_PackageInfoModelResponseTransformer);
    }
    if (Array.isArray(data?.lines)) {
      data.lines.forEach(Packing_PackageContentLineModelResponseTransformer);
    }
    return data;
  };

export const SalesOrderDocumentModelResponseTransformer: SalesOrderDocumentModelResponseTransformer =
  (data) => {
    if (data?.header) {
      SalesOrderDocumentHeaderModelResponseTransformer(data.header);
    }
    if (Array.isArray(data?.lines)) {
      data.lines.forEach(SalesOrderDocumentLineModelResponseTransformer);
    }
    if (Array.isArray(data?.packages)) {
      data.packages.forEach(Packing_PackageModelResponseTransformer);
    }
    return data;
  };

export const SalesOrderDocumentResponseDataModelResponseTransformer: SalesOrderDocumentResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      SalesOrderDocumentModelResponseTransformer(data.data);
    }
    return data;
  };

export const SalesOrderGetResponseTransformer: SalesOrderGetResponseTransformer =
  async (data) => {
    SalesOrderDocumentResponseDataModelResponseTransformer(data);
    return data;
  };

export type PckActiveListResponseTransformer = (
  data: any
) => Promise<PckActiveListResponse>;

export type PckActiveUnpagedListResultsModelResponseTransformer = (
  data: any
) => PckActiveUnpagedListResults;

export type PckActiveModelResponseTransformer = (data: any) => PckActive;

export const PckActiveModelResponseTransformer: PckActiveModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    if (data?.claimedDate) {
      data.claimedDate = new Date(data.claimedDate);
    }
    return data;
  };

export const PckActiveUnpagedListResultsModelResponseTransformer: PckActiveUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PckActiveModelResponseTransformer);
    }
    return data;
  };

export const PckActiveListResponseTransformer: PckActiveListResponseTransformer =
  async (data) => {
    PckActiveUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ListInvoicesResponseTransformer = (
  data: any
) => Promise<ListInvoicesResponse>;

export type PortalAccountInvoiceUnpagedListResultsModelResponseTransformer = (
  data: any
) => PortalAccountInvoiceUnpagedListResults;

export type PortalAccountInvoiceModelResponseTransformer = (
  data: any
) => PortalAccountInvoice;

export const PortalAccountInvoiceModelResponseTransformer: PortalAccountInvoiceModelResponseTransformer =
  (data) => {
    if (data?.invoiceDate) {
      data.invoiceDate = new Date(data.invoiceDate);
    }
    return data;
  };

export const PortalAccountInvoiceUnpagedListResultsModelResponseTransformer: PortalAccountInvoiceUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PortalAccountInvoiceModelResponseTransformer);
    }
    return data;
  };

export const ListInvoicesResponseTransformer: ListInvoicesResponseTransformer =
  async (data) => {
    PortalAccountInvoiceUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ListOrdersResponseTransformer = (
  data: any
) => Promise<ListOrdersResponse>;

export type PortalAccountOrderUnpagedListResultsModelResponseTransformer = (
  data: any
) => PortalAccountOrderUnpagedListResults;

export type PortalAccountOrderModelResponseTransformer = (
  data: any
) => PortalAccountOrder;

export const PortalAccountOrderModelResponseTransformer: PortalAccountOrderModelResponseTransformer =
  (data) => {
    if (data?.orderDate) {
      data.orderDate = new Date(data.orderDate);
    }
    return data;
  };

export const PortalAccountOrderUnpagedListResultsModelResponseTransformer: PortalAccountOrderUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PortalAccountOrderModelResponseTransformer);
    }
    return data;
  };

export const ListOrdersResponseTransformer: ListOrdersResponseTransformer =
  async (data) => {
    PortalAccountOrderUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type CatalogResponseTransformer = (
  data: any
) => Promise<CatalogResponse>;

export type PortalCatalogResponseResponseDataResponseModelResponseTransformer =
  (data: any) => PortalCatalogResponseResponseDataResponse;

export type PortalCatalogResponseModelResponseTransformer = (
  data: any
) => PortalCatalogResponse;

export type PortalCatalogItemModelResponseTransformer = (
  data: any
) => PortalCatalogItem;

export type PortalCatalogPromoModelResponseTransformer = (
  data: any
) => PortalCatalogPromo;

export const PortalCatalogPromoModelResponseTransformer: PortalCatalogPromoModelResponseTransformer =
  (data) => {
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    return data;
  };

export const PortalCatalogItemModelResponseTransformer: PortalCatalogItemModelResponseTransformer =
  (data) => {
    if (data?.leadTime) {
      data.leadTime = new Date(data.leadTime);
    }
    if (Array.isArray(data?.subItems)) {
      data.subItems.forEach(PortalCatalogItemModelResponseTransformer);
    }
    if (Array.isArray(data?.promos)) {
      data.promos.forEach(PortalCatalogPromoModelResponseTransformer);
    }
    return data;
  };

export const PortalCatalogResponseModelResponseTransformer: PortalCatalogResponseModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.items)) {
      data.items.forEach(PortalCatalogItemModelResponseTransformer);
    }
    return data;
  };

export const PortalCatalogResponseResponseDataResponseModelResponseTransformer: PortalCatalogResponseResponseDataResponseModelResponseTransformer =
  (data) => {
    if (data?.data) {
      PortalCatalogResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const CatalogResponseTransformer: CatalogResponseTransformer = async (
  data
) => {
  PortalCatalogResponseResponseDataResponseModelResponseTransformer(data);
  return data;
};

export type CatalogItemsResponseTransformer = (
  data: any
) => Promise<CatalogItemsResponse>;

export type PortalCatalogItemUnpagedListResultsModelResponseTransformer = (
  data: any
) => PortalCatalogItemUnpagedListResults;

export const PortalCatalogItemUnpagedListResultsModelResponseTransformer: PortalCatalogItemUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(PortalCatalogItemModelResponseTransformer);
    }
    return data;
  };

export const CatalogItemsResponseTransformer: CatalogItemsResponseTransformer =
  async (data) => {
    PortalCatalogItemUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type WidgetTypesResponseTransformer = (
  data: any
) => Promise<WidgetTypesResponse>;

export type ConfigurationObjectUnpagedListResultsModelResponseTransformer = (
  data: any
) => ConfigurationObjectUnpagedListResults;

export const ConfigurationObjectUnpagedListResultsModelResponseTransformer: ConfigurationObjectUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ConfigurationObjectModelResponseTransformer);
    }
    return data;
  };

export const WidgetTypesResponseTransformer: WidgetTypesResponseTransformer =
  async (data) => {
    ConfigurationObjectUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type GetReportsListTypesResponseTransformer = (
  data: any
) => Promise<GetReportsListTypesResponse>;

export type ReportTypeConfigurationUnpagedListResultsModelResponseTransformer =
  (data: any) => ReportTypeConfigurationUnpagedListResults;

export type ReportTypeConfigurationModelResponseTransformer = (
  data: any
) => ReportTypeConfiguration;

export const ReportTypeConfigurationModelResponseTransformer: ReportTypeConfigurationModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.parameters)) {
      data.parameters.forEach(ConfigurationPropertyModelResponseTransformer);
    }
    return data;
  };

export const ReportTypeConfigurationUnpagedListResultsModelResponseTransformer: ReportTypeConfigurationUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ReportTypeConfigurationModelResponseTransformer);
    }
    return data;
  };

export const GetReportsListTypesResponseTransformer: GetReportsListTypesResponseTransformer =
  async (data) => {
    ReportTypeConfigurationUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ItemSalesDrillDownResponseTransformer = (
  data: any
) => Promise<ItemSalesDrillDownResponse>;

export type SalesReportDrillDownQtyListResultsModelResponseTransformer = (
  data: any
) => SalesReportDrillDownQtyListResults;

export type SalesReportDrillDownQtyModelResponseTransformer = (
  data: any
) => SalesReportDrillDownQty;

export const SalesReportDrillDownQtyModelResponseTransformer: SalesReportDrillDownQtyModelResponseTransformer =
  (data) => {
    if (data?.date) {
      data.date = new Date(data.date);
    }
    return data;
  };

export const SalesReportDrillDownQtyListResultsModelResponseTransformer: SalesReportDrillDownQtyListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(SalesReportDrillDownQtyModelResponseTransformer);
    }
    return data;
  };

export const ItemSalesDrillDownResponseTransformer: ItemSalesDrillDownResponseTransformer =
  async (data) => {
    SalesReportDrillDownQtyListResultsModelResponseTransformer(data);
    return data;
  };

export type SalesOverviewSummaryResponseTransformer = (
  data: any
) => Promise<SalesOverviewSummaryResponse>;

export type SalesOverviewRangedResponseDataModelResponseTransformer = (
  data: any
) => SalesOverviewRangedResponseData;

export type SalesOverviewRangedModelResponseTransformer = (
  data: any
) => SalesOverviewRanged;

export type DateRangesModelResponseTransformer = (data: any) => DateRanges;

export type DateOnlyRangeModelResponseTransformer = (
  data: any
) => DateOnlyRange;

export const DateOnlyRangeModelResponseTransformer: DateOnlyRangeModelResponseTransformer =
  (data) => {
    if (data?.start) {
      data.start = new Date(data.start);
    }
    if (data?.end) {
      data.end = new Date(data.end);
    }
    return data;
  };

export const DateRangesModelResponseTransformer: DateRangesModelResponseTransformer =
  (data) => {
    if (data?.range1) {
      DateOnlyRangeModelResponseTransformer(data.range1);
    }
    if (data?.range2) {
      DateOnlyRangeModelResponseTransformer(data.range2);
    }
    return data;
  };

export const SalesOverviewRangedModelResponseTransformer: SalesOverviewRangedModelResponseTransformer =
  (data) => {
    if (data?.dateRanges) {
      DateRangesModelResponseTransformer(data.dateRanges);
    }
    return data;
  };

export const SalesOverviewRangedResponseDataModelResponseTransformer: SalesOverviewRangedResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      SalesOverviewRangedModelResponseTransformer(data.data);
    }
    return data;
  };

export const SalesOverviewSummaryResponseTransformer: SalesOverviewSummaryResponseTransformer =
  async (data) => {
    SalesOverviewRangedResponseDataModelResponseTransformer(data);
    return data;
  };

export type ScheduledReportsListResponseTransformer = (
  data: any
) => Promise<ScheduledReportsListResponse>;

export type ReportScheduleEntityUnpagedListResultsModelResponseTransformer = (
  data: any
) => ReportScheduleEntityUnpagedListResults;

export type ReportScheduleEntityModelResponseTransformer = (
  data: any
) => ReportScheduleEntity;

export const ReportScheduleEntityModelResponseTransformer: ReportScheduleEntityModelResponseTransformer =
  (data) => {
    if (data?.nextOccurring) {
      data.nextOccurring = new Date(data.nextOccurring);
    }
    return data;
  };

export const ReportScheduleEntityUnpagedListResultsModelResponseTransformer: ReportScheduleEntityUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(ReportScheduleEntityModelResponseTransformer);
    }
    return data;
  };

export const ScheduledReportsListResponseTransformer: ScheduledReportsListResponseTransformer =
  async (data) => {
    ReportScheduleEntityUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type ScheduledReportsGetResponseTransformer = (
  data: any
) => Promise<ScheduledReportsGetResponse>;

export type ReportScheduleEntityResponseDataModelResponseTransformer = (
  data: any
) => ReportScheduleEntityResponseData;

export const ReportScheduleEntityResponseDataModelResponseTransformer: ReportScheduleEntityResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ReportScheduleEntityModelResponseTransformer(data.data);
    }
    return data;
  };

export const ScheduledReportsGetResponseTransformer: ScheduledReportsGetResponseTransformer =
  async (data) => {
    ReportScheduleEntityResponseDataModelResponseTransformer(data);
    return data;
  };

export type GetReportsSoCustomerPeriodicSoidResponseTransformer = (
  data: any
) => Promise<GetReportsSoCustomerPeriodicSoidResponse>;

export const GetReportsSoCustomerPeriodicSoidResponseTransformer: GetReportsSoCustomerPeriodicSoidResponseTransformer =
  async (data) => {
    CustomerPeriodicSalesResultsResponseDataModelResponseTransformer(data);
    return data;
  };

export type GetReportsSystemAlertsGroupsResponseTransformer = (
  data: any
) => Promise<GetReportsSystemAlertsGroupsResponse>;

export type GroupedUnpagedListResultsModelResponseTransformer = (
  data: any
) => GroupedUnpagedListResults;

export type GroupedModelResponseTransformer = (data: any) => Grouped;

export const GroupedModelResponseTransformer: GroupedModelResponseTransformer =
  (data) => {
    if (data?.lastAlertDate) {
      data.lastAlertDate = new Date(data.lastAlertDate);
    }
    return data;
  };

export const GroupedUnpagedListResultsModelResponseTransformer: GroupedUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(GroupedModelResponseTransformer);
    }
    return data;
  };

export const GetReportsSystemAlertsGroupsResponseTransformer: GetReportsSystemAlertsGroupsResponseTransformer =
  async (data) => {
    GroupedUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type GetReportsSystemAlertsMessagesResponseTransformer = (
  data: any
) => Promise<GetReportsSystemAlertsMessagesResponse>;

export type MessageUnpagedListResultsModelResponseTransformer = (
  data: any
) => MessageUnpagedListResults;

export type MessageModelResponseTransformer = (data: any) => Message;

export const MessageModelResponseTransformer: MessageModelResponseTransformer =
  (data) => {
    if (data?.alertDate) {
      data.alertDate = new Date(data.alertDate);
    }
    if (data?.dismissedDate) {
      data.dismissedDate = new Date(data.dismissedDate);
    }
    return data;
  };

export const MessageUnpagedListResultsModelResponseTransformer: MessageUnpagedListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(MessageModelResponseTransformer);
    }
    return data;
  };

export const GetReportsSystemAlertsMessagesResponseTransformer: GetReportsSystemAlertsMessagesResponseTransformer =
  async (data) => {
    MessageUnpagedListResultsModelResponseTransformer(data);
    return data;
  };

export type SalesOrdersListResponseTransformer = (
  data: any
) => Promise<SalesOrdersListResponse>;

export type SalesOrderListResultCursorListResultsModelResponseTransformer = (
  data: any
) => SalesOrderListResultCursorListResults;

export type SalesOrderListResultModelResponseTransformer = (
  data: any
) => SalesOrderListResult;

export const SalesOrderListResultModelResponseTransformer: SalesOrderListResultModelResponseTransformer =
  (data) => {
    if (data?.document) {
      DocumentPropertiesModelResponseTransformer(data.document);
    }
    if (data?.date) {
      data.date = new Date(data.date);
    }
    if (data?.generatedDate) {
      data.generatedDate = new Date(data.generatedDate);
    }
    if (data?.dispatchStart) {
      data.dispatchStart = new Date(data.dispatchStart);
    }
    if (data?.dispatchDue) {
      data.dispatchDue = new Date(data.dispatchDue);
    }
    if (data?.dispatchDueTime) {
      data.dispatchDueTime = new Date(data.dispatchDueTime);
    }
    return data;
  };

export const SalesOrderListResultCursorListResultsModelResponseTransformer: SalesOrderListResultCursorListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(SalesOrderListResultModelResponseTransformer);
    }
    return data;
  };

export const SalesOrdersListResponseTransformer: SalesOrdersListResponseTransformer =
  async (data) => {
    SalesOrderListResultCursorListResultsModelResponseTransformer(data);
    return data;
  };

export type ApiTokenCreateResponseTransformer = (
  data: any
) => Promise<ApiTokenCreateResponse>;

export type ApiTokenCreateResponseResponseDataModelResponseTransformer = (
  data: any
) => ApiTokenCreateResponseResponseData;

export type ApiTokenCreateResponseModelResponseTransformer = (
  data: any
) => ApiTokenCreateResponse;

export const ApiTokenCreateResponseModelResponseTransformer: ApiTokenCreateResponseModelResponseTransformer =
  (data) => {
    if (data?.expires) {
      data.expires = new Date(data.expires);
    }
    return data;
  };

export const ApiTokenCreateResponseResponseDataModelResponseTransformer: ApiTokenCreateResponseResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ApiTokenCreateResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const ApiTokenCreateResponseTransformer: ApiTokenCreateResponseTransformer =
  async (data) => {
    ApiTokenCreateResponseResponseDataModelResponseTransformer(data);
    return data;
  };

export type ApiTokenDetailsResponseTransformer = (
  data: any
) => Promise<ApiTokenDetailsResponse>;

export type ApiTokenDetailsResponseResponseDataModelResponseTransformer = (
  data: any
) => ApiTokenDetailsResponseResponseData;

export type ApiTokenDetailsResponseModelResponseTransformer = (
  data: any
) => ApiTokenDetailsResponse;

export const ApiTokenDetailsResponseModelResponseTransformer: ApiTokenDetailsResponseModelResponseTransformer =
  (data) => {
    if (data?.expires) {
      data.expires = new Date(data.expires);
    }
    return data;
  };

export const ApiTokenDetailsResponseResponseDataModelResponseTransformer: ApiTokenDetailsResponseResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      ApiTokenDetailsResponseModelResponseTransformer(data.data);
    }
    return data;
  };

export const ApiTokenDetailsResponseTransformer: ApiTokenDetailsResponseTransformer =
  async (data) => {
    ApiTokenDetailsResponseResponseDataModelResponseTransformer(data);
    return data;
  };

export type QueuedMessagesResponseTransformer = (
  data: any
) => Promise<QueuedMessagesResponse>;

export type QueuedMessageListResultsModelResponseTransformer = (
  data: any
) => QueuedMessageListResults;

export type QueuedMessageModelResponseTransformer = (
  data: any
) => QueuedMessage;

export const QueuedMessageModelResponseTransformer: QueuedMessageModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    if (data?.updatedDate) {
      data.updatedDate = new Date(data.updatedDate);
    }
    return data;
  };

export const QueuedMessageListResultsModelResponseTransformer: QueuedMessageListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(QueuedMessageModelResponseTransformer);
    }
    return data;
  };

export const QueuedMessagesResponseTransformer: QueuedMessagesResponseTransformer =
  async (data) => {
    QueuedMessageListResultsModelResponseTransformer(data);
    return data;
  };

export type NotificationsResponseTransformer = (
  data: any
) => Promise<NotificationsResponse>;

export type NotificationListResultsModelResponseTransformer = (
  data: any
) => NotificationListResults;

export type NotificationModelResponseTransformer = (data: any) => Notification;

export const NotificationModelResponseTransformer: NotificationModelResponseTransformer =
  (data) => {
    if (data?.createdDate) {
      data.createdDate = new Date(data.createdDate);
    }
    return data;
  };

export const NotificationListResultsModelResponseTransformer: NotificationListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(NotificationModelResponseTransformer);
    }
    return data;
  };

export const NotificationsResponseTransformer: NotificationsResponseTransformer =
  async (data) => {
    NotificationListResultsModelResponseTransformer(data);
    return data;
  };

export type SupportTicketGetResponseTransformer = (
  data: any
) => Promise<SupportTicketGetResponse>;

export type TicketWithConversationsResponseDataModelResponseTransformer = (
  data: any
) => TicketWithConversationsResponseData;

export type TicketWithConversationsModelResponseTransformer = (
  data: any
) => TicketWithConversations;

export type TicketConversationModelResponseTransformer = (
  data: any
) => TicketConversation;

export const TicketConversationModelResponseTransformer: TicketConversationModelResponseTransformer =
  (data) => {
    if (data?.created_at) {
      data.created_at = new Date(data.created_at);
    }
    if (data?.updated_at) {
      data.updated_at = new Date(data.updated_at);
    }
    return data;
  };

export const TicketWithConversationsModelResponseTransformer: TicketWithConversationsModelResponseTransformer =
  (data) => {
    if (data?.created) {
      data.created = new Date(data.created);
    }
    if (data?.updated) {
      data.updated = new Date(data.updated);
    }
    if (Array.isArray(data?.conversations)) {
      data.conversations.forEach(TicketConversationModelResponseTransformer);
    }
    return data;
  };

export const TicketWithConversationsResponseDataModelResponseTransformer: TicketWithConversationsResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      TicketWithConversationsModelResponseTransformer(data.data);
    }
    return data;
  };

export const SupportTicketGetResponseTransformer: SupportTicketGetResponseTransformer =
  async (data) => {
    TicketWithConversationsResponseDataModelResponseTransformer(data);
    return data;
  };

export type SupportTicketsListResponseTransformer = (
  data: any
) => Promise<SupportTicketsListResponse>;

export type TicketListResponseDataModelResponseTransformer = (
  data: any
) => TicketListResponseData;

export type TicketListModelResponseTransformer = (data: any) => TicketList;

export type TicketModelResponseTransformer = (data: any) => Ticket;

export const TicketModelResponseTransformer: TicketModelResponseTransformer = (
  data
) => {
  if (data?.created) {
    data.created = new Date(data.created);
  }
  if (data?.updated) {
    data.updated = new Date(data.updated);
  }
  return data;
};

export const TicketListModelResponseTransformer: TicketListModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.tickets)) {
      data.tickets.forEach(TicketModelResponseTransformer);
    }
    return data;
  };

export const TicketListResponseDataModelResponseTransformer: TicketListResponseDataModelResponseTransformer =
  (data) => {
    if (data?.data) {
      TicketListModelResponseTransformer(data.data);
    }
    return data;
  };

export const SupportTicketsListResponseTransformer: SupportTicketsListResponseTransformer =
  async (data) => {
    TicketListResponseDataModelResponseTransformer(data);
    return data;
  };

export type WarehouseBinsSearchResponseTransformer = (
  data: any
) => Promise<WarehouseBinsSearchResponse>;

export type WarehouseBinListResultsModelResponseTransformer = (
  data: any
) => WarehouseBinListResults;

export type WarehouseBinModelResponseTransformer = (data: any) => WarehouseBin;

export const WarehouseBinModelResponseTransformer: WarehouseBinModelResponseTransformer =
  (data) => {
    if (data?.lastBinCount) {
      data.lastBinCount = new Date(data.lastBinCount);
    }
    return data;
  };

export const WarehouseBinListResultsModelResponseTransformer: WarehouseBinListResultsModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(WarehouseBinModelResponseTransformer);
    }
    return data;
  };

export const WarehouseBinsSearchResponseTransformer: WarehouseBinsSearchResponseTransformer =
  async (data) => {
    WarehouseBinListResultsModelResponseTransformer(data);
    return data;
  };
